{
  "app": {
    "language": "Sprache",
    "openMenu": "Menü öffnen",
    "closeMenu": "Menü schließen",
    "brandLogoAlt": "BCS HR Software",
    "footerAdmin": "BCS Learning — Admin",
    "footerTenant": "BCS Learning — {tenant}",
    "footerTenantFallback": "BCS Learning",
    "superadmin": {
      "title": "Superadmin"
    },
    "tenant": {
      "title": "Ihr Arbeitsbereich"
    }
  },
  "nav": {
    "catalog": "Katalog",
    "myEnrollments": "Meine Anmeldungen",
    "myQuestionnaires": "Meine Fragebögen",
    "myQualifications": "Meine Qualifikationen",
    "dashboard": "Dashboard",
    "tenants": "Tenants",
    "platformAssets": "Medienbibliothek",
    "platformLocales": "Sprachen",
    "superadmins": "Superadmins",
    "settings": "Einstellungen",
    "users": "Benutzer",
    "orgUnits": "Organisationseinheiten",
    "localeOverrides": "Texte",
    "mailOutbox": "Postausgang",
    "sendMessage": "Nachricht senden",
    "mailTemplates": "E-Mail-Texte",
    "workflows": "Workflows",
    "platformWorkflows": "Plattform-Workflows",
    "approvals": "Genehmigungen",
    "approvalsOverview": "Alle Genehmigungen",
    "badgePending": "{count} ausstehend",
    "mainNavigation": "Hauptnavigation",
    "logout": "Abmelden",
    "changeLanguage": "Sprache ändern",
    "themeDark": "Dunkler Modus",
    "themeLight": "Heller Modus",
    "openAdminConsole": "Verwaltung öffnen",
    "openApp": "Zur App",
    "cancellationReasons": "Stornierungsgründe",
    "questionnaires": "Fragebögen",
    "locations": "Trainingsstandorte",
    "externalPeople": "Externe Personen",
    "externalCompanies": "Externe Unternehmen",
    "approvalFlows": "Genehmigungsabläufe",
    "roles": "Rollen & Rechte",
    "attendance": "Anwesenheit",
    "auditLog": "Protokoll",
    "accessGroups": "Zugriffsgruppen",
    "ltiProviders": "LTI-Verbindungen",
    "groupUsersOrg": "Benutzer & Organisation",
    "groupCatalogs": "Kataloge",
    "groupLearning": "Lernangebot",
    "groupMessaging": "E-Mail & Nachrichten",
    "tests": "Tests",
    "grading": "Korrigieren",
    "results": "Ergebnisse",
    "qualifications": "Qualifikationen",
    "externalRequestTypes": "Externe Weiterbildung (Einrichtung)",
    "themes": "Kategorien",
    "media": "Medienbibliothek",
    "groupResources": "Ressourcen",
    "documentTemplates": "Dokumentvorlagen"
  },
  "myEnrollments": {
    "title": "Meine Anmeldungen",
    "description": "Eine Übersicht der Aktivitäten, für die Sie angemeldet sind, und deren Status.",
    "empty": "Sie haben noch keine Anmeldungen.",
    "emptyCta": "Katalog durchsuchen",
    "error": "Wir konnten Ihre Anmeldungen nicht laden.",
    "retry": "Erneut versuchen",
    "untitled": "Unbenannte Aktivität",
    "controlsLabel": "Sortieren und filtern",
    "sortLabel": "Sortieren",
    "sort": {
      "dateAsc": "Startdatum (aufsteigend)",
      "dateDesc": "Startdatum (absteigend)"
    },
    "filter": {
      "showHistory": "Verlauf anzeigen"
    },
    "groupActive": "Aktiv",
    "groupHistory": "Verlauf",
    "noActive": "Sie haben keine aktiven Anmeldungen.",
    "noHistory": "Sie haben noch keine abgeschlossenen oder stornierten Anmeldungen.",
    "partOf": "Teil von {title}",
    "certificate": {
      "filename": "zertifikat",
      "download": "Zertifikat herunterladen",
      "inProgress": "Zertifikat wird noch erstellt",
      "downloadFailed": "Das Zertifikat konnte nicht heruntergeladen werden. Bitte versuchen Sie es später erneut.",
      "revoked": "Widerrufen"
    }
  },
  "myLearningPath": {
    "notFound": "Wir konnten diesen Lernpfad nicht finden.",
    "error": "Wir konnten Ihren Lernpfad nicht laden.",
    "retry": "Erneut versuchen",
    "progressTitle": "Fortschritt",
    "progress": "{done} von {total} Pflichtteilen abgeschlossen",
    "noRequired": "Dieser Lernpfad hat keine Pflichtteile.",
    "sequentialHint": "Sie durchlaufen die Teile der Reihe nach. Ein Teil wird freigeschaltet, sobald der vorherige abgeschlossen ist.",
    "partsTitle": "Teile",
    "noParts": "Dieser Lernpfad hat noch keine Teile.",
    "reference": "Nachschlagewerk",
    "completedOn": "Abgeschlossen am {date}",
    "state": {
      "to_schedule": "Noch zu planen",
      "locked": "Gesperrt",
      "not_started": "Nicht begonnen",
      "in_progress": "In Bearbeitung",
      "completed": "Abgeschlossen",
      "previously_completed": "Bereits erreicht",
      "exempted": "Befreit",
      "not_passed": "Nicht bestanden",
      "expired": "Abgelaufen",
      "cancelled": "Storniert"
    },
    "detail": {
      "completedOn": "Abgeschlossen am {date}",
      "previouslyCompletedOn": "Abgeschlossen am {date}, bereits zuvor erreicht",
      "lockedBy": "Wird freigeschaltet, sobald Sie {title} abgeschlossen haben.",
      "toSchedule": "Für diesen Teil wählen Sie eine Durchführung mit einem Termin. Das ist hier bald möglich.",
      "notPassed": "Sie haben diesen Teil abgeschlossen, aber nicht bestanden.",
      "expired": "Sie hatten diesen Teil erreicht, aber er ist nicht mehr gültig."
    }
  },
  "catalog": {
    "structural": {
      "locked": {
        "enrollments": "Nicht mehr änderbar: Für diese Schulung gibt es bereits Anmeldungen.",
        "attempts": "Nicht mehr änderbar: Dieses E-Learning wurde bereits gestartet.",
        "completions": "Nicht mehr änderbar: Für diese Schulung gibt es bereits Abschlüsse."
      },
      "warnTitle": "Diese Schulung ist bereits veröffentlicht",
      "warnBody": "Sie ändern etwas, das bestimmt, was eine Anmeldung oder ein Abschluss bedeutet. Es gibt noch keine Anmeldungen, daher ist es noch möglich. Sobald sich jemand anmeldet, liegt es fest.",
      "warnConfirm": "Trotzdem speichern",
      "field": {
        "composition": "Die Zusammensetzung",
        "type": "Der Typ",
        "source_kind": "Die Quelle",
        "source_url": "Der Link",
        "source_package_id": "Das E-Learning-Paket",
        "source_lti_provider_id": "Der LTI-Anbieter",
        "tracking_mode": "Aktivität oder Nachschlagematerial",
        "completion_rule": "Die Abschlussregel",
        "completion_threshold": "Der Prozentsatz der Abschlussregel",
        "sources": "Das Material in einer anderen Sprache",
        "items": "Die Bestandteile oder welche davon Pflicht sind"
      }
    },
    "detail": {
      "back": "Zurück zum Katalog",
      "backToMyEnrollments": "Zurück zu meinen Anmeldungen",
      "duration": "Dauer",
      "durationMinutes": "{count} Min.",
      "category": "Kategorie",
      "contentManagers": "Verwalter",
      "occurrences": "Geplante Durchführungen",
      "noOccurrences": "Es gibt noch keine geplanten Durchführungen.",
      "items": "Komponenten",
      "noItems": "Es gibt noch keine Komponenten.",
      "notFound": "Aktivität nicht gefunden",
      "ctaSoon": "Demnächst verfügbar",
      "studyLoad": "Lernaufwand",
      "description": "Beschreibung",
      "details": "Details",
      "language": "Sprache",
      "themes": "Kategorien",
      "tags": "Schlagwörter",
      "tracking": "Nachverfolgt",
      "trackingYes": "Ja — zählt als zu erledigen und erledigt",
      "trackingNo": "Nein — Nachschlagematerial",
      "planned_one": "{count} Termin geplant",
      "planned_other": "{count} Termine geplant",
      "spotsTotal_one": "{count} Platz frei",
      "spotsTotal_other": "{count} Plätze frei",
      "chooseBelow": "wählen Sie unten einen Termin, um sich anzumelden",
      "approvalHint": "Nach der Anmeldung bittet das System Ihre Führungskraft um Genehmigung; Sie erhalten eine Bestätigung per E-Mail.",
      "directHint": "Sie erhalten sofort eine Bestätigung per E-Mail.",
      "approval": "Genehmigung",
      "approvalRequired": "Erforderlich",
      "approvalNotRequired": "Nicht erforderlich",
      "spotsOf": "{left} von {total} Plätzen frei",
      "fullWaitlist": "Ausgebucht — Warteliste",
      "days_one": "{count} Tag",
      "days_other": "{count} Tage",
      "dayN": "Tag {n}",
      "enrollUntil": "Anmeldung bis {date}",
      "itemsOrdered": "Teile (in Reihenfolge)",
      "itemsOrderedHint": "Jeder Teil wird freigeschaltet, sobald der vorherige abgeschlossen ist.",
      "itemsFreeHint": "Keine feste Reihenfolge — bearbeiten Sie die Teile, wie es Ihnen passt.",
      "openInLanguage": "In einer anderen Sprache öffnen",
      "ownLanguage": "Meine eigene Sprache"
    },
    "error": {
      "title": "Etwas ist schiefgelaufen",
      "retry": "Erneut versuchen"
    },
    "launch": {
      "start": "Starten",
      "resume": "Fortfahren",
      "review": "Erneut ansehen",
      "open": "Öffnen",
      "error": "Das Öffnen ist fehlgeschlagen.",
      "restart": "Neu starten",
      "restartTitle": "Neu starten?",
      "restartBody": "Sie beginnen diese Schulung wieder von vorne. Ihr Fortschritt in der Schulung wird gelöscht; Ihr Ergebnis bleibt erhalten."
    },
    "enroll": {
      "action": "Anmelden",
      "full": "Ausgebucht",
      "closed": "Anmeldung geschlossen",
      "success": "Sie sind angemeldet.",
      "requested": "Ihre Anfrage wurde eingereicht. Sie erhalten eine Nachricht, sobald eine Entscheidung getroffen wurde.",
      "waitlisted": "Sie stehen auf der Warteliste. Sie sind noch nicht angemeldet — Sie erhalten eine Nachricht, sobald ein Platz frei wird.",
      "error": "Die Anmeldung ist fehlgeschlagen.",
      "elsewhere": "Sie sind bereits angemeldet am {date}",
      "waitlistedElsewhere": "Sie stehen bereits auf der Warteliste für den {date}",
      "spotsLeft": "{count} Plätze frei",
      "awaitingApproval": "Wartet auf Genehmigung",
      "joinWaitlist": "Auf die Warteliste setzen",
      "onWaitlist": "Auf der Warteliste",
      "offerPending": "Ein Platz ist frei — nehmen Sie Ihr Angebot an",
      "offerAcceptBy": "Ein Platz ist frei — nehmen Sie ihn vor {date} an",
      "acceptOffer": "Annehmen",
      "declineOffer": "Ablehnen"
    },
    "cancel": {
      "button": "Stornieren",
      "requestButton": "Stornierung beantragen",
      "pending": "Stornierung in Bearbeitung",
      "confirmTitle": "Anmeldung stornieren?",
      "confirmBody": "Möchten Sie Ihre Anmeldung wirklich stornieren? Dies kann nicht rückgängig gemacht werden.",
      "reasonLabel": "Grund (optional)",
      "confirm": "Ja, stornieren",
      "keep": "Behalten",
      "cancelled": "Storniert — Grund: {reason}",
      "reasonSelectLabel": "Grund",
      "reasonSelectPlaceholder": "— Grund wählen —",
      "cancelledReason": "Grund: {reason}",
      "cancelledNote": "Storniert — Grund:"
    },
    "cancellationMode": {
      "self": "Selbst stornieren",
      "needs_approval": "Mit Genehmigung",
      "not_allowed": "Nicht erlaubt"
    },
    "waitlistPromotionMode": {
      "auto_enter": "Automatisch nachrücken",
      "invite": "Platz anbieten"
    },
    "enrollmentLimit": {
      "one": "1 (Standard)",
      "multiple": "Mehrere"
    },
    "deliveryMode": {
      "klassikaal": "Präsenz",
      "virtual_classroom": "Virtuelles Klassenzimmer",
      "blended": "Blended"
    },
    "enrollmentStatus": {
      "enrolled": "Angemeldet",
      "pending": "In Bearbeitung",
      "offered": "Platz angeboten",
      "waitlisted": "Auf Warteliste",
      "rejected": "Abgelehnt",
      "cancelled": "Storniert",
      "expired": "Abgelaufen",
      "finalized": "Verarbeitet"
    },
    "heading": "Katalogverwaltung",
    "intro": "Verwalten Sie alle Lernaktivitäten.",
    "new": "Neue Aktivität",
    "settingsLink": "Einstellungen",
    "empty": "Noch keine Lernaktivitäten — legen Sie eine an.",
    "backToList": "Zurück zum Katalog",
    "filter": {
      "search": "Nach Titel oder Zusammenfassung suchen…",
      "status": "Status",
      "all": "Alle",
      "searchPlaceholder": "Katalog durchsuchen",
      "themes": "Kategorie",
      "type": "Typ",
      "composition": "Form",
      "tracking": "Art",
      "category": "Kategorie",
      "sort": "Sortieren",
      "reset": "Filter zurücksetzen",
      "activeLabel": "Aktive Filter",
      "removeFilter": "Filter entfernen: {filter}",
      "completionRule": "Abschlussregel",
      "completionRuleMissing": "Keine Regel hinterlegt",
      "heading": "Filter",
      "language": "Sprache",
      "clear": "Zurücksetzen",
      "onlyWith": "Nur mit {name}"
    },
    "presentation": {
      "activiteit": "Aktivität",
      "naslag": "Nachschlagewerk"
    },
    "type": {
      "e_learning": "E-Learning",
      "assessment": "Test",
      "meeting": "Veranstaltung",
      "content": "Content/Medien",
      "social": "Sozial",
      "workplace": "Arbeitsplatz",
      "external": "Externe Weiterbildung"
    },
    "composition": {
      "single": "Aktivität",
      "learning_path": "Lernpfad",
      "bundle": "Bündel"
    },
    "source": {
      "manual": "Manuell",
      "file": "Datei",
      "link": "Link",
      "scorm_xapi": "E-Learning-Paket (SCORM)",
      "lti": "LTI",
      "session": "Sitzung / Anwesenheit"
    },
    "status": {
      "concept": "Entwurf",
      "published": "Veröffentlicht",
      "hidden": "Verborgen",
      "archived": "Archiviert"
    },
    "unavailable": {
      "ltiProviderInactive": "Nicht im Angebot: Verbindung deaktiviert"
    },
    "columns": {
      "title": "Titel",
      "composition": "Zusammensetzung",
      "type": "Typ",
      "soort": "Art",
      "status": "Status",
      "actions": "Aktionen",
      "completionRule": "Abschluss",
      "themes": "Kategorien"
    },
    "actions": {
      "edit": "Bearbeiten",
      "changeStatus": "Status ändern…",
      "duplicate": "Duplizieren",
      "delete": "Löschen",
      "planning": "Planung",
      "export": "Exportieren ({count})"
    },
    "bulk": {
      "label": "Massenaktionen",
      "selected": "{count} ausgewählt",
      "selectAllMatching": "Alle {count} auswählen, die diesem Filter entsprechen",
      "allMatchingSelected": "Alle {count}, die diesem Filter entsprechen",
      "limitToSelection": "Auf die markierten Zeilen beschränken"
    },
    "confirm": {
      "archiveTitle": "Aktivität(en) archivieren?",
      "archiveBody": "Dies archiviert {count} Aktivität(en); sie verlassen den Katalog, bleiben aber in den Datensätzen.",
      "deleteTitle": "Entwurf löschen?",
      "deleteBody": "\"{title}\" wird endgültig gelöscht. Dies kann nicht rückgängig gemacht werden.",
      "bulkTitle": "Status ändern?",
      "allMatchingBody": "Damit werden {count} Aktivität(en) auf „{status}“ gesetzt – auch die, die derzeit nicht angezeigt werden."
    },
    "feedback": {
      "statusChanged": "{count} Aktivität(en) → {status}.",
      "duplicated": "\"{title}\" als Entwurf dupliziert.",
      "deleted": "\"{title}\" gelöscht.",
      "bulkDuplicated": "{count} Kopie(n) erstellt.",
      "archivedPartlyHidden": "{count} Aktivität(en) verarbeitet; {hidden} davon sind Verborgen, weil noch Durchführungen liefen."
    },
    "fields": {
      "title": "Titel",
      "summary": "Zusammenfassung",
      "description": "Beschreibung",
      "category": "Kategorie",
      "durationMinutes": "Dauer (Minuten)",
      "image": "Bild",
      "imagePreviewAlt": "Vorschau des gewählten Bildes",
      "imageHelp": "Wählen Sie ein Bild aus der Mediathek, holen Sie eines über eine Adresse oder Pexels, oder laden Sie eines von Ihrem Computer hoch. Ohne eigenes Bild zeigt das Element das Standardbild der Umgebung.",
      "removeImage": "Bild entfernen",
      "sourceUrl": "Webadresse",
      "sourceUrlHelp": "Wohin der Teilnehmer gelangt.",
      "neededToPublish": "Zum Veröffentlichen nötig; ein Entwurf kommt ohne aus.",
      "sourceFile": "Die Datei",
      "sourceFileHelp": "Das Dokument, das der Teilnehmer öffnet. Nur wer die Schulung sehen darf, kann es herunterladen.",
      "sourceFileSaveFirst": "Speichern Sie diese Schulung zuerst als Entwurf; danach können Sie die Datei hinzufügen. Zum Veröffentlichen ist eine Datei erforderlich.",
      "ltiProvider": "LTI-Anbieter",
      "ltiProviderHelp": "Bei welchem Anbieter diese Schulung läuft.",
      "ltiProviderNew": "Neuen Anbieter hinzufügen",
      "ltiLaunchUrl": "Adresse des Kurses",
      "ltiLaunchUrlHelp": "Die Adresse genau dieses Kurses beim Anbieter. Lassen Sie das Feld leer, verwenden wir die Standardadresse des Anbieters — das stimmt nur, wenn dieser Anbieter einen einzigen Kurs hat. Zum Veröffentlichen ist eines von beiden erforderlich.",
      "ltiPickCourse": "Kurs beim Anbieter auswählen",
      "ltiPickCourseSaveFirst": "Sie können den Kurs beim Anbieter auswählen, sobald diese Schulung gespeichert ist. Für die Auswahl verlassen Sie diesen Bildschirm, speichern Sie sie daher zuerst als Entwurf — sonst geht verloren, was Sie gerade eingeben.",
      "ltiPickCourseConfirmTitle": "Für diese Schulung liegen bereits Ergebnisse vor",
      "ltiPickCourseConfirmBody_one": "Für den derzeit verknüpften Kurs ist bereits {count} Ergebnis erfasst. Es bleibt erhalten: Wer die Schulung abgeschlossen hat, behält das. Ab jetzt belegen neue Teilnehmende den Kurs, den Sie gleich auswählen.",
      "ltiPickCourseConfirmBody_other": "Für den derzeit verknüpften Kurs sind bereits {count} Ergebnisse erfasst. Sie bleiben erhalten: Wer die Schulung abgeschlossen hat, behält das. Ab jetzt belegen neue Teilnehmende den Kurs, den Sie gleich auswählen.",
      "ltiPickCourseConfirmAction": "Kurs auswählen",
      "sourceFileReplaceConfirmTitle": "Mit der aktuellen Datei wurde bereits abgeschlossen",
      "sourceFileReplaceConfirmBody_one": "{count} Person hat diese Aktivität bereits mit der vorherigen Datei abgeschlossen; dieser Abschluss bleibt bestehen. Wer die Aktivität ab jetzt öffnet, erhält die neue Datei.",
      "sourceFileReplaceConfirmBody_other": "{count} Personen haben diese Aktivität bereits mit der vorherigen Datei abgeschlossen; ihre Abschlüsse bleiben bestehen. Wer die Aktivität ab jetzt öffnet, erhält die neue Datei.",
      "sourceFileReplaceConfirmAction": "Datei ersetzen",
      "ltiProviderNoAccess": "Sie dürfen die Integrationen dieser Umgebung nicht einsehen. Bitten Sie eine Administration, den Anbieter auszuwählen.",
      "ltiProviderInactive": "{name} (deaktiviert)",
      "package": "Die E-Learning-Datei",
      "packageHint": "Eine Zip-Datei, so wie Sie sie vom Anbieter erhalten. Zum Veröffentlichen nötig.",
      "packageHintWithMax": "Eine Zip-Datei, so wie Sie sie vom Anbieter erhalten, bis {max} MB. Zum Veröffentlichen nötig.",
      "packageChoose": "Datei auswählen",
      "packageReplace": "Andere Datei hochladen",
      "packageTry": "Ausprobieren",
      "packageTryHint": "Öffnet den Kurs in einem neuen Tab, genau so, wie ihn ein Teilnehmer sieht. Es wird nichts erfasst: kein Fortschritt, kein Ergebnis, kein Abschluss.",
      "packageTryBlocked": "Ihr Browser hat den neuen Tab blockiert. Erlauben Sie Pop-ups für diese Seite und versuchen Sie es erneut.",
      "packageTryFailed": "Der Kurs konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.",
      "packagePresent": "Eine Datei ist hinterlegt",
      "packageUploading": "Wird hochgeladen",
      "packageProgress": "Wird hochgeladen — {percent} %",
      "packageInspecting": "Die Datei wird geprüft…",
      "packageAccepted": "Eine Schulung gefunden: {title}",
      "packageAcceptedUntitled": "Eine Schulung gefunden. Die Datei enthält selbst keinen Titel.",
      "packageNotes": "Was an dieser Datei angepasst oder weggelassen wurde:",
      "packageRejected": "Diese Datei kann so nicht verwendet werden:",
      "packageNeedsChoice": "Diese Datei enthält mehr als ein E-Learning:",
      "completionRule": "Wann gilt das als abgeschlossen?",
      "completionRuleHint": "Es gibt bewusst keine Vorgabe: Legen Sie selbst fest, wann diese Schulung abgeschlossen ist. Solange hier nichts steht, schließt sie niemand ab.",
      "completionRuleProgressUnavailable": "Ein Abschluss über den durchlaufenen Prozentsatz ist hier nicht möglich: Diese Datei hält nicht fest, wie weit jemand gekommen ist.",
      "completionRuleNone": "Noch nicht gewählt",
      "completionRuleFixed": "Bei dieser Quelle gibt es nichts zu wählen: abgeschlossen bedeutet hier {rule}.",
      "completionThreshold": "Prozentsatz",
      "completionThresholdHint": "Eine Zahl zwischen 1 und 100.",
      "progressResetDays": "Gültigkeit des Abschlusses",
      "progressResetDaysHint": "Leer = läuft nie ab.",
      "progressResetDaysHelp": "Nach wie vielen Tagen ein Abschluss abläuft und die Schulung erneut absolviert werden muss. Die Frist beginnt mit dem Abschluss.",
      "choose": "Auswählen…",
      "summaryHint": "Höchstens drei Zeilen, bis zu 200 Zeichen.",
      "summaryHelp": "Ein kurzer Text für die Karte und oben im Artikel.",
      "contentManagers": "Content-Verwalter",
      "contentManagersPlaceholder": "Person suchen",
      "contentManagersHint": "Dürfen diese Aktivität pflegen: die Basisdaten und die Quelle/das Material. Die Rolle Content-Verwalter erteilt die Rechte.",
      "contentManagerNoRole": "{name} hat die Rolle Content-Verwalter nicht und kann diese Aktivität daher nicht bearbeiten.",
      "educators": "Anbieter",
      "educatorsPlaceholder": "Anbieter wählen",
      "educatorsHint": "Bestimmt, welche Lehrkräfte Sie bei der Planung wählen können. Leer bedeutet keine Einschränkung.",
      "educatorInternal": "Intern",
      "translationHint": "Wenn Sie einen Text in dieser Sprache leer lassen, sieht der Leser ihn in der Sprache der Umgebung.",
      "languageInUse_one": "{language} wird noch von 1 Durchführung verwendet ({dates}). Ohne Titel entfällt diese Sprache; das ist erst möglich, wenn Sie dort zuerst eine andere Sprache wählen.",
      "languageInUse_other": "{language} wird noch von {count} Durchführungen verwendet ({dates}). Ohne Titel entfällt diese Sprache; das ist erst möglich, wenn Sie dort zuerst eine andere Sprache wählen."
    },
    "version": {
      "breaking": "Der Kurs wurde grundlegend geändert",
      "breakingHint": "Laufende Teilnahmen werden abgeschlossen und beginnen neu. Erforderlich, wenn Teile entfernt oder neu angeordnet wurden — sonst kehrt jemand an eine Stelle zurück, die es nicht mehr gibt.",
      "closedAttempts": "Version gewechselt. {count} laufende Teilnahme(n) abgeschlossen; diese Personen beginnen neu.",
      "compatibilityLegend": "Was bedeutet diese Version für laufende Teilnahmen?",
      "compatible": "Der Kurs ist weitgehend gleich",
      "compatibleHint": "Wer mitten drin ist, macht dort weiter, wo er war. Wählen Sie dies nur, wenn sich der Aufbau des Kurses nicht geändert hat.",
      "heading": "Neue Version",
      "intro": "Diese E-Learning ist bereits mit einem Paket veröffentlicht. Eine neue Datei ersetzt die Version für alle. Geben Sie daher zuerst an, was die Änderung für Personen bedeutet, die gerade mitten drin sind.",
      "noAttemptsClosed": "Version gewechselt. Es gab keine laufenden Teilnahmen.",
      "restartConfirm": "Neu beginnen lassen",
      "restartOpen": "Teilnahmen neu beginnen lassen",
      "restartReason": "Grund",
      "restartWarning": "Damit schließen Sie alle laufenden Teilnahmen an der aktuellen Version. Fortschritt und Lesezeichen gehen verloren; abgeschlossene Ergebnisse bleiben erhalten.",
      "switch": "Version wechseln",
      "viewResults": "Ergebnisse ansehen"
    },
    "elearningResults": {
      "actions": "Aktionen",
      "back": "Zurück zur Lernaktivität",
      "correctError": "Die Korrektur konnte nicht gespeichert werden.",
      "correctFor": "Ergebnis von {name} korrigieren",
      "correctedNote": "Korrigiert am {date}",
      "effective": "Gilt jetzt",
      "empty": "Niemand hat diese E-Learning begonnen.",
      "failed": "Nicht bestanden",
      "heading": "Ergebnisse",
      "intro": "Wer diese E-Learning begonnen hat, wie weit die Person ist und welches Ergebnis gilt. Eine manuelle Korrektur steht neben dem, was der Kurs gemeldet hat — beides bleibt sichtbar.",
      "lastActivity": "Zuletzt aktiv",
      "loadError": "Die Ergebnisse konnten nicht geladen werden.",
      "next": "Weiter",
      "pageOf": "Seite {page} von {total}",
      "pagination": "Seitennavigation",
      "passed": "Bestanden",
      "person": "Person",
      "prev": "Zurück",
      "reason": "Grund",
      "reasonHint": "Wird protokolliert und ist die Antwort auf „warum steht hier diese Note?“.",
      "reported": "Gemeldet",
      "resetConfirm": "Fortschritt zurücksetzen",
      "resetError": "Der Fortschritt konnte nicht zurückgesetzt werden.",
      "resetFor": "Fortschritt von {name} zurücksetzen",
      "resetKeepsCompletion": "Der Abschluss von {name} bleibt bestehen: Er wurde in einer anderen Sprache erreicht.",
      "resetLanguage": "Sprache",
      "resetLanguageHint": "Nur der Fortschritt in dieser Sprache wird zurückgesetzt. Vorausgewählt ist die Sprache, in der {name} zuletzt gearbeitet hat.",
      "resetPreviewError": "Es konnte nicht geladen werden, was das Zurücksetzen bewirkt. Bitte versuchen Sie es erneut.",
      "resetReason": "Grund",
      "resetReasonHint": "Erscheint im Protokoll von {name} und ist die Antwort, die diese Person später erhalten kann.",
      "resetWarn": "Der Fortschritt von {name} in diesem E-Learning wird geschlossen. Der Zugang bleibt bestehen; {name} kann danach neu beginnen.",
      "resetWarnLanguage": "Der Fortschritt von {name} in der Sprache {language} wird geschlossen; andere Sprachen bleiben erhalten. Der Zugang bleibt bestehen; {name} kann danach neu beginnen.",
      "resetWarnLanguageWithCompletion": "{name} hat dieses E-Learning in der Sprache {language} abgeschlossen. Dieser Abschluss wird widerrufen — er bleibt als widerrufen nachvollziehbar, zählt ab jetzt aber nicht mehr. Andere Sprachen bleiben erhalten; der Zugang bleibt bestehen.",
      "resetWarnWithCompletion": "{name} hat dieses E-Learning abgeschlossen. Dieser Abschluss wird zurückgenommen — er bleibt als zurückgenommen auffindbar, zählt ab jetzt aber nicht mehr. Der Zugang bleibt bestehen; {name} kann danach neu beginnen.",
      "save": "Korrektur speichern",
      "scoreHint": "Leer lassen, wenn Sie nur die Bewertung ändern.",
      "scorePercent": "Punktzahl (%)",
      "scoreRange": "Geben Sie eine Zahl von 0 bis 100 ein.",
      "status": "Status",
      "statuses": {
        "closed": "Beendet",
        "completed": "Abgeschlossen",
        "in_progress": "In Bearbeitung"
      },
      "superseded": {
        "admin_reset": "Von einer Administration zurückgesetzt",
        "breaking_version": "Durch eine neue, grundlegend geänderte Version beendet",
        "forced_restart": "Durch einen erzwungenen Neustart beendet",
        "learner_restart": "Von der Teilnehmerin oder dem Teilnehmer selbst neu begonnen",
        "progress_reset": "Abgelaufen — der Abschluss war nicht mehr gültig"
      },
      "unknownUser": "Unbekannter Benutzer",
      "verdict": "Bewertung",
      "verdictNone": "Keine Bewertung"
    },
    "wizard": {
      "newTitle": "Neue Lernaktivität",
      "editTitle": "Lernaktivität bearbeiten",
      "needType": "Wählen Sie einen Typ.",
      "needTitle": "Titel ist erforderlich.",
      "needSummary": "Geben Sie eine Zusammenfassung ein.",
      "needDescription": "Geben Sie eine Beschreibung ein.",
      "occurrencesFollowTitle": "Auch die Durchführungen mit dem alten Titel umbenennen ({n})",
      "occurrencesFollowTitleHelp": "Durchführungen, die jetzt „{title}“ heißen, erhalten den neuen Titel. Durchführungen mit einem eigenen Thema bleiben unverändert.",
      "source": "Quelle / Material",
      "sourceNone": "— keine —",
      "tracking": "Verfolgung",
      "ready": "Bereit zum Veröffentlichen.",
      "publish": "Veröffentlichen",
      "saveConcept": "Als Entwurf speichern",
      "save": "Speichern",
      "next": "Weiter",
      "published": "\"{title}\" veröffentlicht.",
      "savedConcept": "\"{title}\" als Entwurf gespeichert.",
      "publishAt": "Veröffentlichen am (optional)",
      "publishAtHint": "Leer: Sie veröffentlichen selbst.",
      "publishAtHelp": "Mit einem Zeitpunkt bleibt die Aktivität ein Entwurf und wird zu diesem Zeitpunkt automatisch veröffentlicht, mit denselben Prüfungen wie beim sofortigen Veröffentlichen.",
      "publishAtPast": "Wählen Sie einen Zeitpunkt in der Zukunft.",
      "schedule": "Einplanen",
      "scheduled": "„{title}“ ist eingeplant: Veröffentlichung am {date}.",
      "grantsFailed": "„{title}“ wurde angelegt, aber eine oder mehrere Qualifikationen konnten nicht verknüpft werden. Verknüpfen Sie sie unten erneut.",
      "saved": "\"{title}\" gespeichert.",
      "saveInvalid": "Speichern hat nicht geklappt: Ein oder mehrere Felder stimmen nicht. Die Schritte mit einem Ausrufezeichen zeigen, was nicht stimmt.",
      "statusInListHint": "Veröffentlichen, Verbergen und Archivieren erfolgen in der Liste über \"Status ändern\".",
      "step": {
        "type": "Typ",
        "bron": "Quelle / Material",
        "resultaten": "Ergebnisse",
        "basis": "Grunddaten",
        "details": "Details",
        "controle": "Prüfen & veröffentlichen",
        "compositie": "Zusammenstellung",
        "zichtbaarheid": "Sichtbarkeit",
        "inschrijven": "Anmeldung",
        "onderdelen": "Komponenten"
      },
      "section": {
        "classificatie": "Einordnung",
        "people": "Beteiligte",
        "fields": "Merkmale",
        "what": "Was es ist",
        "texts": "Texte",
        "time": "Zeit",
        "material": "Material",
        "completion": "Abschluss",
        "anonymous": "Ohne Anmeldung",
        "enrolling": "Anmeldung",
        "waitlist": "Warteliste",
        "deadlines": "Fristen und Stornierung",
        "certificate": "Zertifikat"
      },
      "finished": {
        "question": "Möchten Sie jetzt planen oder zurück zur Liste?",
        "planNow": "Weiter zur Planung",
        "backToList": "Zurück zur Liste"
      },
      "sourceHint": "Die Quelle bestimmt, was verfolgt werden kann; nur zum Typ passende Quellen sind wählbar.",
      "trackingHint": "Aktivität = zu erledigen/erledigt (kann für PE zählen); Nachschlagewerk = nur ansehen.",
      "compositionHint": "Aktivität = einzelne Lernaktivität · Lernpfad = geordnet (kann ein Zertifikat freischalten) · Bündel = ungeordnete Gruppe.",
      "needOnderdeel": "Ein Lernpfad/Bündel benötigt mindestens eine Komponente.",
      "basicsOnlyNotice": "Sie sind Content-Verwalter dieser Aktivität: Sie ändern die Basisdaten und die Quelle/das Material. Sichtbarkeit, Anmeldung, Ergebnisse und Planung verwaltet jemand mit Verwaltungsrechten für die gesamte Umgebung.",
      "required": {
        "heading": "Mindestens erforderlich zum Veröffentlichen",
        "legend": "Mit * gekennzeichnete Felder sind Pflichtfelder.",
        "done": "(ausgefüllt)",
        "missing": "(fehlt noch)",
        "onePart": "Mindestens ein Bestandteil"
      },
      "fieldShowToLearner": "{name} dem Teilnehmer anzeigen"
    },
    "plannen": {
      "problem": {
        "needsDay": "Es gibt noch keinen Tag. Fügen Sie mindestens einen Tag hinzu.",
        "needsDate_one": "Tag {days} hat noch kein Datum. Tragen Sie für jeden Tag ein Datum ein.",
        "needsDate_other": "Die Tage {days} haben noch kein Datum. Tragen Sie für jeden Tag ein Datum ein.",
        "needsStartTime": "Tag 1 hat noch keine Startzeit. Tragen Sie für den ersten Tag eine Startzeit ein."
      },
      "problemFor": "Termin {n}: {problem}",
      "uitvoering": "Durchführung {n}",
      "removeUitvoering": "Durchführung entfernen",
      "minParticipants": "Min. Teilnehmer",
      "maxParticipants": "Max. Teilnehmer",
      "minParticipantsHelp": "Unter dieser Zahl findet die Durchführung in der Regel nicht statt. Die Planung warnt, wenn das Minimum nicht erreicht wird; bestätigen oder absagen tun Sie selbst.",
      "maxParticipantsHelp": "So viele Plätze gibt es. Ist die Durchführung voll, kommen neue Anmeldungen auf die Warteliste, sofern sie eingeschaltet ist. Leer = kein Maximum.",
      "deadline": "Anmeldeschluss",
      "deadlineHelp": "Bis einschließlich zu diesem Tag können sich Teilnehmende anmelden. Die Frist wird aus dem ersten Tag berechnet; tragen Sie selbst ein Datum ein, bleibt dieses bestehen.",
      "description": "Zusätzliche Beschreibung",
      "descriptionHint": "Höchstens 5000 Zeichen.",
      "descriptionHelp": "Zusätzliche Informationen zu dieser Durchführung für die Teilnehmenden, etwa was sie mitbringen oder wie sie den Raum finden. Sie stehen bei der Durchführung im Katalog; in einer Kalendereinladung erscheinen sie ohne Formatierung.",
      "occurrenceTitle": "Titel der Durchführung",
      "occurrenceTitleHint": "Lassen Sie das Feld leer oder gleich der Aktivität, wenn es kein eigenes Thema gibt.",
      "occurrenceTitleHelp": "Das Thema dieser Sitzung, wenn die Aktivität ein Sammelname ist. Die Teilnehmenden sehen es unter dem Titel der Aktivität.",
      "day": "Tag {n}",
      "removeDay": "Tag entfernen",
      "date": "Datum",
      "dateMissing": "Tragen Sie ein Datum ein.",
      "startTimeMissing": "Tragen Sie eine Startzeit ein.",
      "from": "Von",
      "to": "Bis",
      "location": "Trainingsstandort",
      "locationPlaceholder": "Wählen oder tippen…",
      "locationEntity": "Trainingsstandort (aus Liste)",
      "locationNone": "Kein Trainingsstandort",
      "locationCapacityWarning": "Max. Teilnehmerzahl ({max}) liegt über der Kapazität dieses Standorts ({capacity}). Wählen Sie einen größeren Standort oder senken Sie das Maximum.",
      "deliveryMode": "Durchführungsform",
      "deliveryModeNone": "Keine Auswahl",
      "trainer": "Trainer",
      "trainerNone": "Kein Trainer",
      "trainerExternalGroup": "Externe Personen",
      "trainerInternalGroup": "Interne Mitarbeitende",
      "lunch": "Mittagessen",
      "diner": "Abendessen",
      "overnight": "Übernachtung",
      "addDay": "+ Tag hinzufügen",
      "maxEnrollments": "Anzahl Anmeldungen",
      "maxEnrollmentsHint": "Wie oft jemand gleichzeitig aktiv für diese Aktivität angemeldet sein darf (über alle Durchführungen hinweg).",
      "maxWaitlistRegistrations": "Anzahl Wartelisten-Einträge",
      "maxWaitlistRegistrationsHint": "Wie viele Wartelisten-Plätze jemand gleichzeitig für diese Aktivität belegen darf. Sobald ein Platz vergeben wird, wird der Wartelisten-Platz wieder frei.",
      "waitlistEnabled": "Warteliste",
      "waitlistEnabledHint": "Wenn eine Durchführung ausgebucht ist, können sich Lernende auf die Warteliste setzen. Wird ein Platz frei, wird er nach der von Ihnen gewählten Methode vergeben. Umgebung folgen: Es gilt der Standard aus den Katalogeinstellungen, auch wenn er sich später ändert.",
      "waitlistFollowDefaultOn": "Umgebung folgen (derzeit ein)",
      "waitlistFollowDefaultOff": "Umgebung folgen (derzeit aus)",
      "promotionMode": "Wenn ein Platz frei wird",
      "offerWindowHours": "Annahmefrist (Stunden)",
      "offerWindowHoursHint": "Wie viele Stunden ein angebotener Platz reserviert bleibt, bevor das Angebot verfällt. Leer lassen für den Systemstandard (48 Stunden).",
      "offerWindowHoursPlaceholder": "48",
      "waitlistCap": "Wartelisten-Limit",
      "waitlistCapHint": "Maximale Anzahl Wartender pro Durchführung. Leer lassen = unbegrenzt.",
      "waitlistCapPlaceholder": "Unbegrenzt",
      "waitlistCapUnlimited": "Unbegrenzt",
      "occurrenceWaitlist": "Warteliste (diese Durchführung)",
      "occurrenceWaitlistHelp": "Aktivität folgen: Es gilt die Wartelisten-Einstellung der Aktivität. Ein oder Aus weicht nur für diese Durchführung ab.",
      "occurrenceWaitlistInherit": "Aktivität folgen",
      "occurrenceWaitlistOn": "Ein",
      "occurrenceWaitlistOff": "Aus",
      "manageWaitlist": "Warteliste verwalten",
      "cancellationDeadline": "Stornierungsfrist",
      "cancellationDeadlineHelp": "Bis einschließlich zu diesem Tag können Teilnehmende selbst stornieren. Die Frist wird aus dem ersten Tag berechnet; tragen Sie selbst ein Datum ein, bleibt dieses bestehen.",
      "enrollmentDeadlineDays": "Anmeldung möglich bis (Tage vor dem ersten Tag)",
      "deadlineDaysHint": "Leer = Standard der Umgebung. 0 = bis zum ersten Tag selbst.",
      "deadlineDaysHelp": "Die Anzahl Kalendertage vor dem ersten Tag. Das Datum je Durchführung berechnet der Server daraus; je Durchführung können Sie es überschreiben.",
      "deadlineCalculated": "Aus dem ersten Tag berechnet",
      "deadlineOverridden": "Manuell festgelegt",
      "deadlineNone": "Keine Frist",
      "deadlineBackToCalculated": "Zurück zum berechneten Wert",
      "noDate": "Kein Datum",
      "expandDay": "Bearbeiten",
      "collapseDay": "Einklappen",
      "deadlineDaysBefore_one": "{count} Tag vor dem ersten Tag",
      "deadlineDaysBefore_other": "{count} Tage vor dem ersten Tag",
      "deadlineSameDay": "Bis zum ersten Tag selbst",
      "deadlineInherited": "{days} (Standard der Umgebung)",
      "cancellationApprovalFlow": "Genehmigungsablauf für Stornierungen",
      "cancellationApprovalFlowHelp": "Wer über eine Stornierungsanfrage entscheidet, wenn die Stornierungsbedingungen eine Genehmigung verlangen. Genehmigt heißt storniert; abgelehnt bleibt der Teilnehmer angemeldet.",
      "opleider": "Bildungsanbieter",
      "opleiderHelp": "Ein Bildungsanbieter beschränkt die Trainerliste auf die Trainer dieses Unternehmens. Das ist nur ein Filter; er wird nicht gespeichert.",
      "opleiderNone": "— Keiner / eigener Dozent —",
      "capacity": "Kapazität",
      "enrolledBadge": "Hat Anmeldungen",
      "enrolledReadOnly": "Diese Durchführung hat Anmeldungen und ist hier schreibgeschützt. Ändern Sie Datum, Dozent, Trainingsstandort oder Teilnehmende auf der Planungsseite.",
      "managePlanningLink": "Auf der Planungsseite verwalten",
      "approvalFlow": "Genehmigung",
      "approvalFlowNone": "Keine Genehmigung — direkt anmelden",
      "approvalFlowHint": "Wählen Sie einen Genehmigungsablauf oder lassen Sie es bei keiner Genehmigung. Warteliste, Kapazität und Anmeldefenster gelten weiterhin.",
      "cancellationPolicy": "Stornierungsbedingungen",
      "cancellationPolicyHelp": "Bis wann und zu welchen Bedingungen ein Teilnehmer storniert. Sie wählen einen Satz aus den Einstellungen; ein Termin kann einen anderen wählen.",
      "cancellationPolicyDefault": "{name} (Standard)",
      "cancellationApprovalFlowNone": "Kein Ablauf",
      "occurrenceCancellationPolicy": "Stornierungsbedingungen",
      "occurrenceCancellationPolicyHelp": "Ein anderer Satz als der der Aktivität, nur für diesen Termin. Die Stornierungsfrist folgt dann der Frist dieses Satzes.",
      "occurrenceCancellationPolicyInherit": "Wie die Aktivität ({name})",
      "occurrenceCancellationPolicyInheritPlain": "Wie die Aktivität"
    },
    "inschrijven": {
      "intro": "Das sind die Standardeinstellungen für die Anmeldung zu dieser Aktivität. Die Durchführungen planen Sie anschließend auf der Planungsseite; jede Durchführung kann davon abweichen."
    },
    "waitlist": {
      "heading": "Warteliste",
      "intro": "Die Reihenfolge bestimmt, wer einen frei gewordenen Platz zuerst erhält. Ordnen Sie die Wartenden mit den Schaltflächen neu.",
      "back": "Zurück zu den Durchführungen",
      "empty": "Für diese Durchführung steht niemand auf der Warteliste.",
      "loadError": "Die Warteliste konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
      "moveError": "Die Reihenfolge konnte nicht geändert werden. Bitte versuchen Sie es erneut.",
      "unknownUser": "Unbekannter Benutzer",
      "joinedAt": "Angemeldet am {date}",
      "toTop": "Nach oben",
      "moveUp": "{name} einen Platz nach oben",
      "moveDown": "{name} einen Platz nach unten",
      "moveTop": "{name} ganz nach oben"
    },
    "panel": {
      "title": "Was Sie erstellen"
    },
    "classificatie": {
      "themes": "Kategorien",
      "noThemes": "Noch keine Kategorien verwaltet — fügen Sie sie später in der Kategorienverwaltung hinzu.",
      "themesPlaceholder": "Kategorien suchen und wählen",
      "tags": "Schlagwörter",
      "tagPlaceholder": "Schlagwort eingeben…",
      "addTag": "Neues Schlagwort: „{tag}“",
      "duration": "Dauer",
      "language": "Sprache",
      "choose": "— wählen —",
      "formCategory": "Lernform",
      "formCategoryHelp": "Eine Kennzeichnung für die Lernenden, ausgewählt aus der Liste dieser Umgebung. Anhand des Typs vorausgefüllt.",
      "formCategoryOption": {
        "formal_digital": "Formal – digital",
        "formal_classroom": "Formal – präsenz",
        "formal_supporting": "Formal – unterstützend",
        "social_learning": "Soziales Lernen",
        "workplace_experience": "Arbeitsplatz & Erfahrung",
        "self_directed": "Selbstgesteuertes Lernen"
      },
      "languagePerOccurrence": "Die Sprache wählen Sie pro Termin in der Planung. Die Aktivität wird dann in den Sprachen ihrer Termine angeboten."
    },
    "duration": {
      "kort": "Kurz (< 30 Min.)",
      "uur": "Etwa eine Stunde",
      "dagdeel": "Halbtags",
      "meerdaags": "Mehrtägig"
    },
    "language": {
      "nl": "Niederländisch",
      "en": "Englisch",
      "de": "Deutsch",
      "fr": "Französisch"
    },
    "visibility": {
      "everyone": "Alle",
      "lead": "Wer darf diese Lernaktivität sehen?",
      "ruleset": "Eine gespeicherte Zugriffsgruppe",
      "closedUntilGroup": "Achtung: Solange hier keine Zugriffsgruppe hinterlegt ist, sieht niemand diese Lernaktivität — außer denjenigen, die sie bearbeiten dürfen. Wählen Sie „Alle“, wenn Sie sie öffnen möchten.",
      "chooseGroup": "Zugriffsgruppe",
      "noGroupChosen": "Noch keine Gruppe gewählt",
      "groupOption": "{name} ({count} Personen)",
      "noGroupsYet": "Es gibt noch keine Zugriffsgruppen. Legen Sie eine unter Zugriffsgruppen an — dort bestimmen Sie, wer dazugehört, und diese Gruppe können Sie dann hier und an anderen Stellen wählen."
    },
    "onderdelen": {
      "pathLead": "Stellen Sie die geordneten Komponenten zusammen (die Reihenfolge bestimmt die Freischaltung).",
      "bundleLead": "Gruppieren Sie die Komponenten (ungeordnet).",
      "sequentieel": "Verbindliche Reihenfolge (streng sequentiell)",
      "required": "Erforderlich (zählt zur Freischaltung)",
      "remove": "entfernen",
      "empty": "Noch keine Komponenten.",
      "addExisting": "+ Bestehende Aktivität hinzufügen…",
      "searchLabel": "Suchen Sie eine Aktivität, die Sie als Komponente hinzufügen möchten",
      "moveUp": "Nach oben",
      "moveDown": "Nach unten"
    },
    "title": "Katalog",
    "description": "Durchsuchen und filtern Sie alle Lernaktivitäten und öffnen Sie eine, um sich anzumelden.",
    "results_one": "{count} Aktivität",
    "results_other": "{count} Aktivitäten",
    "loadMore": "Mehr laden",
    "sort": {
      "newest": "Neueste zuerst",
      "title_asc": "Titel A–Z",
      "title_desc": "Titel Z–A"
    },
    "emptyState": {
      "title": "Nichts gefunden",
      "body": "Passen Sie Ihre Filter oder Suche an.",
      "reset": "Filter zurücksetzen"
    },
    "occurrenceStatus": {
      "concept": "Entwurf",
      "planned": "Geplant",
      "confirmed": "Bestätigt",
      "completed": "Abgeschlossen",
      "cancelled": "Storniert"
    },
    "planning": {
      "heading": "Planung",
      "intro": "Verwalten Sie die Durchführungen dieser Lernaktivität.",
      "backToWizard": "Zurück zur Aktivität",
      "openLink": "Planung öffnen",
      "loadError": "Die Planung konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
      "drift": {
        "title": "Fristen weichen von der Tageanzahl ab",
        "body": "Bei {n} Durchführung(en) stimmt die berechnete Frist nicht mehr mit der Tageanzahl der Aktivität oder der Umgebung überein.",
        "withEnrolments": "Bei {n} davon sind bereits Personen angemeldet; sie bleiben unverändert, sofern Sie sie nicht ausdrücklich einbeziehen.",
        "recalculate": "Neu berechnen (ohne Anmeldungen)",
        "recalculateAll": "Auch mit Anmeldungen neu berechnen"
      },
      "statusError": "Der Status konnte nicht geändert werden. Bitte versuchen Sie es erneut.",
      "empty": "Diese Aktivität hat noch keine Durchführungen.",
      "filterStatus": "Status",
      "statsLabel": "Statistiken",
      "stats": {
        "completed": "Durchgeführt",
        "totalEnrolled": "Eingeschrieben gesamt",
        "concept": "Entwurf",
        "planned": "Geplant",
        "confirmed": "Bestätigt",
        "cancelled": "Storniert"
      },
      "columns": {
        "title": "Thema",
        "datetime": "Datum & Zeit",
        "trainer": "Trainer",
        "location": "Trainingsstandort",
        "bezetting": "Belegung",
        "status": "Status",
        "deadline": "Anmeldeschluss",
        "actions": "Aktionen"
      },
      "transition": {
        "planned": "Freigeben",
        "confirmed": "Bestätigen",
        "completed": "Abschließen",
        "cancelled": "Stornieren"
      },
      "detailLink": "Teilnehmer",
      "confirmCancelTitle": "Durchführung stornieren",
      "confirmCancelBody": "Möchten Sie diese Durchführung wirklich stornieren? Alle Teilnehmer sowie alle Personen auf der Warteliste werden storniert und automatisch benachrichtigt. Dies kann nicht rückgängig gemacht werden.",
      "confirmCancelConfirm": "Durchführung stornieren",
      "confirmCancelKeep": "Nicht stornieren",
      "cancelReasonLabel": "Grund (optional)",
      "addOccurrence": "Durchführung hinzufügen",
      "editRow": "Bearbeiten",
      "belowMinimum": "Mindestzahl nicht erreicht",
      "belowMinimumHint": "Es liegen weniger Anmeldungen vor als die Mindestzahl von {min}. Sie können die Durchführung bestätigen (trotzdem durchführen), stornieren oder das Datum verschieben.",
      "editor": {
        "addTitle": "Durchführung hinzufügen",
        "editTitle": "Durchführung neu planen",
        "intro": "Füllen Sie die Angaben zur Durchführung aus. Bestehende Anmeldungen bleiben erhalten.",
        "loadError": "Die Durchführungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
        "saveError": "Die Durchführung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
        "backToPlanning": "← Zurück zur Planung",
        "sectionBasis": "Grunddaten",
        "sectionCapacity": "Kapazität und Anmeldung",
        "sectionDays": "Tage",
        "summary": "Zusammenfassung",
        "summaryFirstDay": "Erster Tag",
        "summaryDays": "Anzahl Tage",
        "summaryCapacity": "Teilnehmende",
        "notFound": "Diese Durchführung existiert nicht mehr.",
        "conceptNotice": "Diese Durchführung ist noch ein Entwurf: Teilnehmende sehen sie nicht und können sich nicht anmelden. Prüfen Sie die Tage und geben Sie sie danach frei.",
        "saveAndOpen": "Speichern und freigeben",
        "openError": "Die Durchführung wurde gespeichert, konnte aber nicht freigegeben werden. Geben Sie sie in der Planung frei.",
        "sectionLanguage": "Sprache",
        "language": "Sprache dieses Termins",
        "languageHint": "Wählen Sie aus den Sprachen, in denen die Aktivität ihre Texte hat.",
        "languageHelp": "Die Aktivität erscheint im Katalog in den Sprachen ihrer Durchführungen.",
        "sectionFields": "Merkmale",
        "fieldsHint": "Füllen Sie nur aus, was bei dieser Durchführung anders ist. Leer bedeutet: wie bei der Aktivität.",
        "fieldFromActivity": "Bei der Aktivität: {value}",
        "fieldInherit": "Wie bei der Aktivität",
        "sectionCertificate": "Zertifikat"
      },
      "duplicateRow": "Duplizieren",
      "bulkEdit": "Alle bearbeiten",
      "duplicate": {
        "title": "Durchführung duplizieren",
        "intro": "Die Kopie übernimmt Tage, Zeiten, Orte, Trainer und Einstellungen und verschiebt sich mit dem neuen Startdatum. Teilnehmende werden nie mitkopiert.",
        "opensNow": "Die Kopie ist sofort für Anmeldungen geöffnet.",
        "startsAsConcept": "Das Original hat {days} Tage. Die Kopie beginnt deshalb als Entwurf: Teilnehmende sehen sie noch nicht. Prüfen Sie die anderen Tage und geben Sie sie danach in der Planung frei.",
        "currentStart": "Erster Tag des Originals: {date}",
        "startDate": "Neues Startdatum",
        "startDateHelp": "Alle Tage behalten denselben Abstand zueinander.",
        "confirm": "Duplizieren",
        "error": "Die Durchführung konnte nicht dupliziert werden. Bitte versuchen Sie es erneut."
      },
      "bulk": {
        "title": "Durchführungen gesammelt bearbeiten",
        "intro": "Alle Durchführungen dieser Aktivität in einer Tabelle. Ändern Sie, was nötig ist, und speichern Sie alles auf einmal.",
        "backToPlanning": "← Zurück zur Planung",
        "loadError": "Die Durchführungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
        "empty": "Diese Aktivität hat noch keine Durchführungen zum Bearbeiten.",
        "saveError": "Die Änderungen konnten nicht gespeichert werden. Es wurde nichts geändert.",
        "saved": "Die Änderungen wurden gespeichert.",
        "dirty": "Es gibt Änderungen, die noch nicht gespeichert wurden.",
        "tableLabel": "Durchführungen und ihre Tage",
        "col": {
          "select": "Auswählen",
          "day": "Tag"
        },
        "field": "{field} ({row})",
        "rowLabel": "{occurrence}, Tag {day}",
        "selectRow": "{row} auswählen",
        "selectOccurrence": "{occurrence} mit allen Tagen auswählen",
        "collapse": "{occurrence} einklappen",
        "expand": "{occurrence} ausklappen",
        "lockedEnrollments": "Hat Anmeldungen: Tage, Zeiten und Orte stehen fest. Umplanen ist auf der Seite der Durchführung möglich.",
        "lockedFinished": "Abgeschlossen oder storniert: nicht mehr bearbeitbar.",
        "trainers": "Trainer: {names}",
        "collision": "Gleiches Datum und gleiche Startzeit wie eine andere Durchführung dieser Aktivität.",
        "collisionSummary": "Für {count} Tage gilt: gleiches Datum und gleiche Startzeit wie eine andere Durchführung dieser Aktivität. Das ist erlaubt, aber prüfen Sie, ob es beabsichtigt ist.",
        "saveCollisionTitle": "Gleiches Datum und gleiche Startzeit",
        "saveCollisionBody": "Es gibt Tage ({count}) mit gleichem Datum und gleicher Startzeit wie eine andere Durchführung dieser Aktivität. Möchten Sie trotzdem speichern?",
        "saveCollisionConfirm": "Trotzdem speichern",
        "saveCollisionBack": "Zurück zur Tabelle",
        "apply": {
          "title": "Auf ausgewählte Zeilen anwenden",
          "selected": "Ausgewählt: {days} Tage, {occurrences} Durchführungen",
          "location": "Trainingsstandort für die ausgewählten Tage",
          "locationPlaceholder": "Standort wählen",
          "locationButton": "Standort anwenden",
          "trainers": "Trainer für die ausgewählten Durchführungen",
          "trainersHelp": "Ersetzt die Trainer der ausgewählten Durchführungen.",
          "trainersButton": "Trainer anwenden",
          "nothingSelected": "Wählen Sie zuerst Zeilen in der Tabelle aus.",
          "done": "Auf {count} Zeilen angewendet. Noch nicht gespeichert."
        }
      },
      "cancelReasonHint": "Die Teilnehmenden lesen diesen Grund bei ihrer Anmeldung und in der Stornierungs-E-Mail. Fett, kursiv, Listen und Links sind möglich; höchstens 1000 Zeichen.",
      "cancelledOn": "Storniert am {date}",
      "conceptHint": "Für Teilnehmende nicht sichtbar"
    },
    "occurrenceDetail": {
      "heading": "Durchführungsdetail",
      "intro": "Verwalten Sie die Teilnehmer und die Warteliste dieser Durchführung.",
      "backToPlanning": "← Zurück zur Planung",
      "metaLabel": "Durchführungsdaten",
      "meta": {
        "title": "Thema",
        "datetime": "Datum & Uhrzeit",
        "trainer": "Trainer",
        "location": "Trainingsstandort",
        "capacity": "Kapazität (Min.–Max.)",
        "deadline": "Anmeldeschluss",
        "status": "Status",
        "bezetting": "Belegung"
      },
      "participantsHeading": "Teilnehmer",
      "participantsEmpty": "Für diese Durchführung sind noch keine Teilnehmer angemeldet.",
      "columns": {
        "name": "Name",
        "department": "Abteilung",
        "status": "Status",
        "actions": "Aktionen",
        "enrolledBy": "Angemeldet von"
      },
      "unknownUser": "Unbekannter Benutzer",
      "cancelAction": "Stornieren",
      "transfer": {
        "action": "Verschieben",
        "title": "Teilnehmer verschieben",
        "body": "{name} in eine andere Durchführung dieser Lernaktivität verschieben.",
        "targetLabel": "Neue Durchführung",
        "targetPlaceholder": "Wählen Sie eine Durchführung",
        "hint": "Der Platz in der aktuellen Durchführung wird frei und geht an die erste wartende Person. Ist die neue Durchführung ausgebucht, kommt der Teilnehmer dort auf die Warteliste.",
        "willWaitlist": "ausgebucht, wird Warteliste",
        "noDate": "ohne Datum",
        "noTargets": "Diese Lernaktivität hat keine andere geplante oder bestätigte Durchführung, in die verschoben werden kann.",
        "confirm": "Verschieben",
        "error": "Der Teilnehmer konnte nicht verschoben werden. Bitte versuchen Sie es erneut."
      },
      "cancelError": "Die Anmeldung konnte nicht storniert werden. Bitte versuchen Sie es erneut.",
      "confirmCancelTitle": "Anmeldung stornieren",
      "confirmCancelBody": "Möchten Sie die Anmeldung von {name} wirklich stornieren? Der Platz wird frei und die Warteliste rückt automatisch nach.",
      "confirmCancelConfirm": "Anmeldung stornieren",
      "completion": {
        "heading": "Zertifikat & Evaluation",
        "soon": "Ein Zertifikat ausstellen und die Durchführung evaluieren lassen folgt in Kürze."
      },
      "loadError": "Die Durchführung konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
      "onBehalf": {
        "action": "Teilnehmende anmelden",
        "title": "Teilnehmende anmelden",
        "body": "Wählen Sie, wen Sie anmelden möchten. Sie sehen zuerst, was für jede Person geschieht; erst danach melden Sie an.",
        "peopleLabel": "Personen",
        "peoplePlaceholder": "Nach Name oder E-Mail suchen",
        "check": "Prüfen",
        "back": "Zurück",
        "confirm": "Anmelden",
        "close": "Schließen",
        "previewHeading": "Was geschehen wird",
        "doneHeading": "Was geschehen ist",
        "nothingToDo": "Keine dieser Personen kann derzeit angemeldet werden.",
        "error": "Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "overridesHeading": "Trotzdem fortfahren?",
        "overridesIntro": "Bei einer oder mehreren Personen steht eine Regel im Weg. Sie können sie übergehen; das wird bei der Anmeldung mit Ihrem Namen festgehalten.",
        "adminOnly": "Nur eine Administratorin oder ein Administrator kann diese Regel übergehen.",
        "applied": "Übergangen: {gates}",
        "unknownPerson": "Unbekannte Person",
        "override": {
          "capacity": "Über die maximale Teilnehmerzahl hinaus anmelden",
          "deadline": "Nach der Anmeldefrist anmelden",
          "approval": "Ohne Genehmigung anmelden"
        },
        "gate": {
          "capacity": "Maximum",
          "deadline": "Anmeldefrist",
          "approval": "Genehmigung"
        },
        "preview": {
          "enrolled": "Wird angemeldet",
          "pending": "Wartet danach auf Genehmigung",
          "waitlisted": "Kommt auf die Warteliste",
          "blocked": "Kann nicht angemeldet werden",
          "not_found": "Nicht gefunden oder außerhalb Ihres Bereichs"
        },
        "done": {
          "enrolled": "Angemeldet",
          "pending": "Wartet auf Genehmigung",
          "waitlisted": "Auf der Warteliste",
          "blocked": "Nicht angemeldet",
          "not_found": "Nicht gefunden oder außerhalb Ihres Bereichs"
        },
        "reason": {
          "deadline_passed": "Die Anmeldefrist ist abgelaufen.",
          "full": "Die Durchführung ist ausgebucht und hat keine Warteliste.",
          "waitlist_full": "Die Durchführung und die Warteliste sind voll.",
          "already_enrolled_here": "Ist bereits für diese Durchführung angemeldet.",
          "already_enrolled_elsewhere": "Ist bereits für eine andere Durchführung dieser Lernaktivität angemeldet.",
          "not_visible": "Diese Lernaktivität ist nicht für diese Person bestimmt.",
          "suspended": "Das Konto dieser Person ist gesperrt."
        }
      },
      "cancelCosts": {
        "before": "Vor der Stornierungsfrist kostet eine Stornierung {amount}.",
        "after": "Nach der Stornierungsfrist kostet eine Stornierung {amount}.",
        "charge": "Kosten berechnen",
        "waiverReason": "Grund für den Erlass",
        "waiverReasonRequired": "Geben Sie einen Grund an, warum die Kosten erlassen werden.",
        "managerHint": "Nur ein Administrator mit Rechten für die gesamte Umgebung kann die Kosten erlassen."
      }
    },
    "archiveLive": {
      "title": "Archivieren: es sind noch Durchführungen geplant",
      "body": "{activities} Aktivität(en) aus dieser Auswahl haben {occurrences} Durchführung(en), die noch stattfinden müssen, mit {enrollments} aktiven Anmeldung(en). Die erste ist am {date}. Bitte wählen Sie, was damit geschehen soll.",
      "choose": "Was geschieht mit den laufenden Durchführungen?",
      "keep_running": "Nicht mehr anbieten, aber zu Ende führen",
      "keep_runningHint": "Diese Aktivitäten werden Verborgen statt Archiviert: sie verschwinden aus dem Katalog, wer angemeldet ist, führt die Durchführung jedoch zu Ende. An den Anmeldungen ändert sich nichts.",
      "cancel_enrollments": "Alle abmelden und archivieren",
      "cancel_enrollmentsHint": "Die Durchführungen werden abgesagt und alle Teilnehmenden sowie Warteliste-Registrierungen werden zurückgezogen. Alle Betroffenen werden benachrichtigt. Dies kann nicht rückgängig gemacht werden.",
      "confirmKeep": "Verbergen",
      "confirmCancel": "Abmelden und archivieren"
    },
    "anonymous": {
      "label": "Ohne Anmeldung öffnen",
      "help": "Alle mit dem Link können den Kurs absolvieren, auch ohne Konto. Gedacht, um zu zeigen, was ein Kurs ist — nicht, damit jemand ihn abschließt.",
      "warning": "Achtung: Bei einem Kurs, der ohne Anmeldung gestartet wird, speichern wir weder Fortschritt noch Ergebnis — es gibt keine Teilnehmerin oder keinen Teilnehmer, dem das zugeordnet werden könnte. Und die Zielgruppe oben gilt für diesen Link nicht: Wer ihn hat, kommt herein.",
      "linkLabel": "Link zum Teilen"
    },
    "completionRule": {
      "completed": "Der Kurs meldet selbst, dass er abgeschlossen ist",
      "progress_percentage": "Einen Teil der Inhalte durchlaufen",
      "minimum_score": "Eine Mindestpunktzahl erreichen",
      "opened": "Geöffnet gilt als abgeschlossen",
      "attendance": "Anwesend laut Anwesenheitsliste",
      "declaration": "Jemand bestätigt, dass es erledigt ist"
    },
    "completionRuleBulk": {
      "action": "Abschlussregel festlegen",
      "title": "Abschlussregel festlegen",
      "scopeSelection": "Für die {count} ausgewählten Schulungen.",
      "scopeAll": "Für alle {count} Schulungen, die dem Filter entsprechen.",
      "choose": "Was möchten Sie festlegen?",
      "determined": "Eintragen, was feststeht",
      "determinedHint": "Bei einer Veranstaltung, einem Link, einer Datei oder einer manuellen Erfassung ist nur eine Regel möglich. Diese trägt das System ein. Schulungen mit einer echten Auswahl bleiben unberührt.",
      "explicit": "Diese Regel festlegen",
      "explicitHint": "Für E-Learning und LTI, wo drei Regeln möglich sind. Schulungen mit einer anderen Quelle fallen heraus.",
      "preview": "Was bewirkt das?",
      "previewResult": "{count} Schulungen erhalten eine Abschlussregel",
      "skipLine": "{count} × {reason}",
      "confirm": "Festlegen",
      "done": "{updated} aktualisiert, {skipped} übersprungen.",
      "skip": {
        "already_set": "hatte bereits eine",
        "needs_choice": "hier müssen Sie selbst wählen",
        "source_forbids": "passt nicht zur Quelle",
        "package_cannot_measure": "die Datei misst das nicht"
      }
    },
    "rules": {
      "evaluationsTitle": "Evaluationen",
      "testsTitle": "Tests",
      "evaluationsIntro": "Fragebögen, die Teilnehmende zu dieser Aktivität ausfüllen. Eine Regel gilt für alle Durchführungen.",
      "testsIntro": "Tests, die eine Lehrkraft korrigiert. Eine Regel gilt für alle Durchführungen. Zählt ein Test für das Bestehen, folgt der Abschluss — und damit die Qualifikation — erst, wenn der Test korrigiert und bestanden ist.",
      "add": "Regel hinzufügen",
      "empty": "Noch keine Regeln.",
      "emptyNew": "Noch keine Regeln. Was Sie hier hinzufügen, wird gespeichert, sobald Sie die Aktivität anlegen.",
      "draftBadge": "Entwurf",
      "external": "Extern",
      "pendingNote": "Wird gespeichert, sobald Sie die Aktivität anlegen.",
      "needsSource": "Wählen Sie zuerst einen Typ, dann können Sie hier Regeln hinzufügen.",
      "failedAfterCreate": "„{title}“ wurde angelegt, aber eine oder mehrere Regeln konnten nicht gespeichert werden. Fügen Sie sie unten erneut hinzu.",
      "mandatory": "Zählt für das Bestehen",
      "removed": "Die Regel wurde gelöscht.",
      "archivedInstead": "Die Regel wurde gestoppt: es wurde bereits etwas versendet, daher kann sie nicht gelöscht werden.",
      "removeTitle": "Regel löschen?",
      "removeBody": "Die Regel und alles, was noch für Teilnehmende bereitlag, verschwindet. Wurde bereits etwas versendet, wird die Regel stattdessen gestoppt.",
      "saveFirstNeeds": "Um eine Regel hinzuzufügen, wird die Aktivität zuerst als Entwurf gespeichert. Bitte zuerst ausfüllen:",
      "referenceNote": "Nachschlagematerial wird nie abgeschlossen. Daran können keine Qualifikation und kein Test hängen; eine Evaluation schon. Hängen bereits Qualifikationen oder Tests daran, werden sie beim Speichern entfernt.",
      "testsNeedSessions": "Ein Test kann nur zu einer Präsenzaktivität mit Terminen hinzugefügt werden.",
      "createTest": "Neuen Test erstellen",
      "createEvaluation": "Neue Evaluation erstellen"
    },
    "links": {
      "qualifications": "Qualifikationen",
      "evaluations": "Evaluationen",
      "tests": "Tests"
    },
    "list": {
      "publishPlanned": "Geplant: {date}",
      "publishFailed": "Veröffentlichung fehlgeschlagen"
    },
    "earlyClose": {
      "title": "Diese Durchführung ist noch nicht beendet",
      "notStarted": "Diese Durchführung beginnt am {date}. Es hat noch kein Tag stattgefunden.",
      "partial": "Es stehen noch Tage aus: {remaining} von {total} Tagen sind noch nicht vorbei. Wer nicht an allen Tagen anwesend war, bleibt ohne Ergebnis.",
      "confirm": "Trotzdem abschließen",
      "keep": "Nicht abschließen"
    },
    "view": {
      "label": "Ansicht",
      "cards": "Karten",
      "list": "Liste"
    },
    "card": {
      "parts_one": "{count} Teil",
      "parts_other": "{count} Teile"
    },
    "sources": {
      "heading": "Material pro Sprache",
      "help": "Für eine andere Sprache können Sie ein eigenes Paket, einen Link oder eine Kursadresse hinzufügen. Lernende erhalten standardmäßig ihre eigene Sprache und können eine andere wählen.",
      "primaryLanguages": "Sprachen dieses Materials",
      "languages": "Sprachen",
      "other": "Material für eine andere Sprache ({n})",
      "add": "Material für eine andere Sprache hinzufügen",
      "notForThisKind": "Eine Datei pro Sprache ist noch nicht möglich; wählen Sie oben die Sprachen, die diese Datei abdeckt."
    },
    "help": {
      "completionRule": "Wann ein Teilnehmer diese Schulung abgeschlossen hat: wenn der Inhalt sie als abgeschlossen meldet, ab einer Mindestpunktzahl, ab einem durchlaufenen Prozentsatz oder sobald er sie geöffnet hat. Welche Regeln es gibt, hängt von der Quelle ab.",
      "accessGroup": "Eine Zugriffsgruppe legt einmal fest, wer etwas sehen darf, und lässt sich an mehreren Stellen verwenden. Sie erstellen sie unter Zugriff › Zugriffsgruppen; hier wählen Sie eine aus.",
      "promotionMode": "Was passiert, wenn ein Platz frei wird: Die erste Person auf der Warteliste wird sofort angemeldet oder erhält den Platz angeboten und entscheidet selbst innerhalb der Bedenkzeit.",
      "studyLoad": "Die Dauer ist die Länge der Schulung selbst. Die Lernzeit ist die gesamte Zeit, die ein Teilnehmer dafür aufwendet, einschließlich Vorbereitung, Hausaufgaben und Tests."
    },
    "occurrences": {
      "results_one": "{count} Durchführung",
      "results_other": "{count} Durchführungen",
      "notPlanned": "Noch kein Datum",
      "moreDays_one": "+ {count} Tag",
      "moreDays_other": "+ {count} Tage"
    },
    "notFound": {
      "title": "Diesen Katalog gibt es nicht",
      "body": "Der Link stimmt nicht mehr, oder dieser Katalog ist nicht für Sie bestimmt. Fragen Sie Ihre Administratorin oder Ihren Administrator, wenn Sie ihn sehen sollten.",
      "back": "Zum Katalog"
    },
    "certificate": {
      "label": "Zertifikat",
      "loading": "Zertifikatsvorlagen werden geladen…",
      "loadError": "Die Zertifikatsvorlagen konnten nicht geladen werden.",
      "asActivity": "Wie die Aktivität",
      "unavailableTemplate": "Nicht mehr wählbare Vorlage",
      "none": "Kein Zertifikat",
      "help": {
        "activity": "Wählen Sie die Vorlage für das Zertifikat. Das Zertifikat entsteht automatisch, wenn jemand diese Aktivität abschließt. Standardmäßig folgt die Aktivität der Wahl der Umgebung (Einstellungen → Zertifikate).",
        "occurrence": "Standardmäßig erhält ein Teilnehmer das Zertifikat, das die Aktivität wählt. Wählen Sie hier nur etwas anderes, wenn diese Durchführung abweichen soll."
      },
      "archivedWarning": "Diese Vorlage ist archiviert oder nicht mehr wählbar. Es werden noch Zertifikate damit erstellt; wählen Sie eine andere Vorlage, wenn das nicht beabsichtigt ist."
    }
  },
  "catalogSettings": {
    "heading": "Katalog-Einstellungen",
    "intro": "Legen Sie hier die Standardwerte für den Katalog und die Anmeldungen fest. Neue Aktivitäten und Durchführungen greifen auf diese Werte zurück.",
    "saved": "Einstellungen gespeichert.",
    "waitlist": {
      "legend": "Warteliste",
      "enabledByDefault": "Warteliste standardmäßig aktiviert",
      "enabledByDefaultHint": "Neue Durchführungen aktivieren die Warteliste standardmäßig, wenn eine Durchführung ausgebucht ist.",
      "promotionMode": "Nachrück-Modus",
      "offerWindowHours": "Angebotsfenster (Stunden)",
      "offerWindowHoursHint": "Wie viele Stunden eine nachgerückte wartende Person Zeit hat, um einen angebotenen Platz anzunehmen.",
      "cap": "Wartelisten-Limit",
      "capHint": "Leer lassen für eine unbegrenzte Warteliste.",
      "capPlaceholder": "Unbegrenzt"
    },
    "deadlines": {
      "legend": "Fristen",
      "hint": "Die Standardanzahl an Kalendertagen vor dem ersten Tag einer Durchführung. Eine Aktivität kann eine eigene Anzahl wählen; leer bedeutet kein Standard.",
      "enrollmentDays": "Anmeldung möglich bis (Tage vor dem ersten Tag)"
    },
    "enrollment": {
      "legend": "Anmeldung",
      "hint": "Wie oft jemand gleichzeitig an einer Aktivität teilnehmen oder auf der Warteliste stehen darf. Neue Aktivitäten starten mit diesen Werten.",
      "maxEnrollments": "Anzahl Anmeldungen",
      "maxWaitlistRegistrations": "Anzahl Wartelisten-Einträge",
      "cancellationFlow": "Genehmigungsablauf für Stornierungen",
      "cancellationFlowHint": "Wer bei einer neuen Aktivität über eine Stornierungsanfrage entscheidet, wenn die Stornierungsbedingungen eine Genehmigung verlangen. Getrennt vom Ablauf für die Anmeldung: Er darf derselbe sein, ist es aber nicht von selbst.",
      "cancellationFlowNone": "Keiner"
    },
    "visibility": {
      "legend": "Sichtbarkeit",
      "mode": "Sichtbarkeitsmodus"
    },
    "durationPresets": {
      "legend": "Bevorzugte Dauern",
      "hint": "Die Auswahlliste für die Dauer einer Schulung. Jede Auswahl steht für eine Anzahl Minuten (ein halber Tag sind 240). Eine Schulung kann jederzeit davon abweichen.",
      "empty": "Ohne eigene Auswahl gilt die Standardliste.",
      "add": "Bevorzugte Dauer hinzufügen",
      "restore": "Standardliste wiederherstellen",
      "rowTitle": "Bevorzugte Dauer {n}",
      "minutes": "Minuten"
    },
    "learningForms": {
      "legend": "Lernformen",
      "hint": "Eine Kennzeichnung für die Lernenden bei jeder Schulung, mit einer Farbe. Bei einer Schulung wählen Sie aus dieser Liste.",
      "add": "Lernform hinzufügen",
      "rowTitle": "Lernform {n}",
      "color": "Farbe",
      "preview": "So sehen es die Lernenden",
      "inUse": "Wird von einer Aktivität verwendet: kann nicht entfernt werden.",
      "colorOption": {
        "primary": "Primär",
        "accent": "Akzent",
        "success": "Grün",
        "warning": "Orange",
        "error": "Rot",
        "info": "Blau",
        "neutral": "Grau"
      }
    },
    "lists": {
      "nameIn": "Name auf {language}",
      "up": "Nach oben",
      "down": "Nach unten",
      "remove": "Entfernen",
      "upFor": "Nach oben: {name}",
      "downFor": "Nach unten: {name}",
      "removeFor": "Entfernen: {name}"
    },
    "activityFields": {
      "legend": "Merkmale",
      "hint": "Eigene Felder für jede Aktivität: Freitext, eine Auswahlliste oder Ja/Nein. Eine Auswahlliste oder Ja/Nein kann ein Filter im Katalog sein; das ist standardmäßig aus.",
      "rowTitle": "Merkmal {n}",
      "kindLabel": "Art",
      "kind": {
        "text": "Freitext",
        "choice": "Auswahlliste",
        "boolean": "Ja/Nein"
      },
      "active": "Aktiv",
      "filterable": "Als Filter im Katalog anzeigen",
      "options": "Optionen",
      "optionTitle": "Option {n}",
      "addOption": "Option hinzufügen",
      "add": "Merkmal hinzufügen",
      "inUse_one": "Wird bei {count} Aktivität verwendet.",
      "inUse_other": "Wird bei {count} Aktivitäten verwendet.",
      "kindLocked": "Die Art steht fest, sobald Werte vorhanden sind.",
      "removeTitle": "Merkmal löschen?",
      "removeBody_one": "„{name}“ wird bei {count} Aktivität verwendet. Beim Löschen verschwindet dieser Wert, sobald Sie speichern. Wenn Sie es nur ausblenden möchten, schalten Sie es aus.",
      "removeBody_other": "„{name}“ wird bei {count} Aktivitäten verwendet. Beim Löschen verschwinden diese Werte, sobald Sie speichern. Wenn Sie es nur ausblenden möchten, schalten Sie es aus.",
      "saved": "Die Merkmale wurden gespeichert.",
      "empty": "Noch keine Merkmale."
    },
    "summary": {
      "waitlistOff": "aus",
      "waitlistOnOffer": "an, Angebot {hours} Std.",
      "waitlistOnAuto": "an, rückt automatisch nach",
      "waitlistCap": "max. {cap}",
      "daysBefore_one": "{count} Tag vorher",
      "daysBefore_other": "{count} Tage vorher",
      "noDeadline": "kein Standard",
      "enrollment": "Anmeldungen: {enrollments}, Warteliste: {waitlist}",
      "durationPresets_one": "{count} Dauer",
      "durationPresets_other": "{count} Dauern",
      "learningForms_one": "{count} Lernform",
      "learningForms_other": "{count} Lernformen",
      "activityFields_one": "{count} aktives Merkmal",
      "activityFields_other": "{count} aktive Merkmale",
      "activityFieldsNone": "noch keine",
      "deadlinesEnrollment": "Anmeldung: {enrollment}"
    },
    "unsaved": {
      "title": "Änderungen speichern?",
      "body": "Sie haben unter {section} etwas geändert, das noch nicht gespeichert ist.",
      "discard": "Nicht speichern"
    }
  },
  "settingsHub": {
    "heading": "Einstellungen",
    "intro": "Richten Sie hier Ihre Umgebung ein. Wählen Sie einen Bereich.",
    "readOnly": "Sie können diese Einstellungen ansehen, aber nicht ändern.",
    "tabs": {
      "catalog": "Katalog",
      "approvals": "Genehmigungen",
      "messages": "Nachrichten",
      "questionnaires": "Fragebögen",
      "retention": "Aufbewahrung",
      "catalogs": "Kataloge",
      "cancellation": "Stornierungsbedingungen",
      "languages": "Inhaltssprachen",
      "documents": "Zertifikate"
    },
    "empty": "Hier gibt es nichts, das Sie einrichten dürfen.",
    "breadcrumb": "Brotkrümelnavigation",
    "pages": {
      "catalog": "Katalogeinstellungen"
    },
    "themes": {
      "catalog": "Katalog",
      "processes": "Prozesse",
      "textsMessages": "Texte und Nachrichten",
      "evaluationData": "Evaluation und Daten",
      "integrations": "Anbindungen"
    },
    "descriptions": {
      "catalog": "Standardwerte für ein neues Training: Warteliste, Anmeldung, Fristen, Lernformen und Merkmale.",
      "catalogs": "Die Kataloge, was sie enthalten und wer sie öffnen darf.",
      "themes": "Die Kategorien, in die Sie Trainings einordnen.",
      "cancellationReasons": "Die Gründe, aus denen Sie beim Stornieren wählen.",
      "approvals": "Welcher Genehmigungsablauf standardmäßig gilt.",
      "approvalFlows": "Wer was genehmigt, und in welcher Reihenfolge.",
      "workflows": "Was nach einem Ereignis automatisch geschieht.",
      "texts": "Eigene Formulierungen für die Texte der Plattform.",
      "messages": "Wie oft die Sammel-E-Mail versendet wird.",
      "questionnaires": "Antwortfrist, Erinnerungen und Skala.",
      "retention": "Wie lange Lernhistorie und andere Daten aufbewahrt werden.",
      "lti": "Externe Lernumgebungen über LTI.",
      "cancellation": "Bis wann storniert werden kann, wer entscheidet und was es kostet.",
      "languages": "In welchen Sprachen Ihre Schulungen und deren Material verfügbar sind.",
      "documentTemplates": "Die Vorlagen für Zertifikate, mit ihren Versionen.",
      "documents": "Wie die Zertifikatsnummer beginnt und ob die BCS-Vorlagen wählbar sind."
    }
  },
  "questionBank": {
    "heading": "Fragebögen",
    "heading_test": "Tests",
    "intro": "Fragen, Kategorien und Formulare sind die Bausteine eines Fragebogens. Eine Frage kann in mehreren Kategorien stehen, eine Kategorie in mehreren Formularen und ein Formular in mehreren Regeln.",
    "intro_test": "Fragen, Kategorien und Tests gehören zusammen. Eine Frage kann in mehreren Kategorien stehen, eine Kategorie in mehreren Tests und ein Test in mehreren Regeln eines Trainings.",
    "tabs": {
      "questions": "Fragen",
      "categories": "Kategorien",
      "forms": "Formulare",
      "forms_test": "Tests",
      "surveys": "Eigenständige Fragebögen",
      "assignments": "Evaluationsregeln",
      "assignments_test": "Testregeln"
    },
    "status": {
      "filter": "Anzeigen",
      "active": "Aktiv",
      "archived": "Archiviert",
      "all": "Alle"
    },
    "type": {
      "open": "Offene Frage",
      "scale": "Skala",
      "multiple_choice": "Mehrfachauswahl",
      "yes_no": "Ja/Nein"
    },
    "typeHint": {
      "scale": "Skala {min}–{max}",
      "multiple_choice_one": "Mehrfachauswahl, {count} Option",
      "multiple_choice_other": "Mehrfachauswahl, {count} Optionen"
    },
    "archivedBadge": "Archiviert",
    "changeHint": "Eine Änderung gilt für Einladungen, die ab jetzt entstehen. Was bereits versendet wurde, bleibt unverändert.",
    "fixErrors": "Das Speichern ist fehlgeschlagen. Bitte prüfen Sie die markierten Felder.",
    "saveFailed": "Das Speichern ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "actionFailed": "Das hat nicht funktioniert. Bitte versuchen Sie es erneut.",
    "actions": {
      "edit": "Bearbeiten",
      "view": "Ansehen",
      "copy": "Kopieren",
      "archive": "Archivieren",
      "restore": "Wiederherstellen",
      "delete": "Löschen",
      "editNamed": "{name} bearbeiten",
      "viewNamed": "{name} ansehen",
      "copyNamed": "{name} kopieren"
    },
    "text": {
      "tabsLabel": "Sprache der Texte",
      "tabsHint": "Schreiben Sie die Texte pro Sprache. {language} ist die Standardsprache und erforderlich; eine Sprache ohne Text greift auf die Standardsprache zurück.",
      "tabIncomplete": "{language} (unvollständig)",
      "tabError": "{language} (Fehler)",
      "hiddenLocale": "{language} (ausgeschaltet):",
      "hiddenNotice": "Einige Texte stehen in einer Sprache, die für diese Umgebung ausgeschaltet ist: {languages}. Sie bleiben gespeichert, werden aber nicht angezeigt, und sind wieder da, sobald die Sprache wieder eingeschaltet wird. Sie können sie pro Feld entfernen.",
      "removeHidden": "Text auf {language} aus {field} entfernen"
    },
    "questions": {
      "count_one": "{count} Frage",
      "count_other": "{count} Fragen",
      "new": "Neue Frage",
      "empty": "In der Fragenbank stehen noch keine Fragen.",
      "emptyFiltered": "Keine Fragen mit diesem Status.",
      "loadError": "Die Fragen konnten nicht geladen werden.",
      "column": {
        "prompt": "Frage",
        "type": "Typ",
        "categories": "In Kategorien",
        "forms": "In Formularen",
        "forms_test": "In Tests",
        "actions": "Aktionen"
      }
    },
    "question": {
      "newTitle": "Neue Frage",
      "texts": "Texte",
      "editTitle": "Frage bearbeiten",
      "viewTitle": "Frage ansehen",
      "backToList": "Zurück zu den Fragen",
      "loadError": "Diese Frage konnte nicht geladen werden.",
      "saved": "Die Frage wurde gespeichert.",
      "copied": "Dies ist die Kopie. Passen Sie sie nach Belieben an: Bei einer Kopie ist die Form wieder frei.",
      "readOnly": "Sie können diese Frage ansehen, aber nicht ändern.",
      "archivedNotice": "Diese Frage ist archiviert. Sie kommt in keine neue Kategorie mehr; wo sie bereits steht, bleibt sie stehen.",
      "locked": {
        "title": "Die Form dieser Frage steht fest",
        "body": "Sie wurde bereits beantwortet oder steht in einer Einladung, die noch ausgefüllt werden kann. Der Typ, der Bereich, eine oder mehrere Antworten und die vorhandenen Optionen bleiben deshalb, wie sie sind. Den Text, den Hilfetext, die Pflichtangabe und eine neue Option können Sie weiterhin ändern. Brauchen Sie eine andere Form, kopieren Sie die Frage."
      },
      "fields": {
        "type": "Art der Frage",
        "prompt": "Frage",
        "helpText": "Hilfetext",
        "helpTextHint": "Steht unter der Frage.",
        "required": "Antwort erforderlich",
        "placeholder": "Beispieltext im Feld",
        "minChars": "Mindestanzahl Zeichen",
        "maxChars": "Höchstanzahl Zeichen",
        "testimonial": "Antworten dürfen als Zitat verwendet werden",
        "testimonialHint": "Wird später auf der Seite der Schulung angezeigt.",
        "requiredQuoteReason": "Eine Frage, deren Antworten als Zitat verwendet werden dürfen, kann nicht erforderlich sein.",
        "minValue": "Niedrigster Wert",
        "maxValue": "Höchster Wert",
        "scaleDisplay": "Darstellung",
        "scaleLabels": "Text pro Punkt",
        "scaleLabelsHint": "Optional. Ohne Text sieht die teilnehmende Person zum Beispiel „3 von 5“.",
        "scaleLabelsTooMany": "Einen Text pro Punkt können Sie bei einer Skala mit höchstens {max} Punkten angeben.",
        "scalePoint": "Punkt {point}",
        "options": "Antwortoptionen",
        "noOptions": "Es gibt noch keine Optionen.",
        "option": "Option {n}",
        "addOption": "Option hinzufügen",
        "moveOptionUp": "Option {n} nach oben",
        "moveOptionDown": "Option {n} nach unten",
        "removeOption": "Option {n} entfernen",
        "allowsMultiple": "Mehr als eine Antwort möglich",
        "allowsOther": "„Sonstiges, nämlich“ anbieten",
        "allowsOtherHint": "Neben den anderen Auswahlmöglichkeiten, nicht an ihrer Stelle."
      },
      "choiceLimits": {
        "hint": "Lassen Sie eine Grenze leer, wenn es keine gibt. Das Minimum liegt mindestens um eins unter der Anzahl der Optionen ({count}, „Sonstiges, nämlich“ mitgezählt), das Maximum passt hinein. Eine Pflichtfrage verlangt immer mindestens eine Antwort.",
        "min": "Mindestanzahl der Auswahl",
        "max": "Höchstanzahl der Auswahl",
        "minTooHigh": "Das Minimum muss mindestens um eins niedriger sein als die Anzahl der Optionen ({count}).",
        "maxTooHigh": "Das Maximum darf nicht höher sein als die Anzahl der Optionen ({count}).",
        "backwards": "Das Maximum ist niedriger als das Minimum.",
        "notAWholeNumber": "Geben Sie eine ganze Zahl ab 1 ein."
      },
      "scaleDisplay": {
        "numbers": "Zahlen",
        "stars": "Sterne"
      },
      "usage": {
        "title": "Wo diese Frage steht",
        "categories": "Kategorien",
        "forms": "Formulare",
        "forms_test": "Tests",
        "assignments": "Laufende Zuweisungen",
        "unused": "Diese Frage steht noch nirgends."
      },
      "delete": {
        "title": "Frage löschen",
        "body": "Die Frage verschwindet aus der Fragenbank. Das kann nicht rückgängig gemacht werden.",
        "confirm": "Löschen"
      }
    },
    "categories": {
      "count_one": "{count} Kategorie",
      "count_other": "{count} Kategorien",
      "new": "Neue Kategorie",
      "empty": "Es gibt noch keine Kategorien.",
      "emptyFiltered": "Keine Kategorien mit diesem Status.",
      "loadError": "Die Kategorien konnten nicht geladen werden.",
      "column": {
        "title": "Titel",
        "questions": "Fragen",
        "forms": "In Formularen",
        "forms_test": "In Tests",
        "actions": "Aktionen"
      }
    },
    "category": {
      "newTitle": "Neue Kategorie",
      "editTitle": "Kategorie bearbeiten",
      "viewTitle": "Kategorie ansehen",
      "backToList": "Zurück zu den Kategorien",
      "loadError": "Diese Kategorie konnte nicht geladen werden.",
      "saved": "Die Kategorie wurde gespeichert.",
      "copied": "Dies ist die Kopie, mit denselben Fragen. Soll auch eine Frage abweichen, kopieren Sie sie separat.",
      "readOnly": "Sie können diese Kategorie ansehen, aber nicht ändern.",
      "archivedNotice": "Diese Kategorie ist archiviert. Sie kommt in kein neues Formular mehr; wo sie bereits steht, bleibt sie stehen.",
      "archivedNotice_test": "Diese Kategorie ist archiviert. Sie erscheint in keinem neuen Test mehr; wo sie bereits steht, bleibt sie bestehen.",
      "fields": {
        "title": "Titel",
        "description": "Beschreibung"
      },
      "questions": {
        "title": "Fragen in dieser Kategorie",
        "hint": "In dieser Reihenfolge stehen sie im Formular.",
        "hint_test": "In dieser Reihenfolge stehen sie im Test.",
        "empty": "In dieser Kategorie stehen noch keine Fragen.",
        "add": "Frage hinzufügen",
        "search": "Frage in der Fragenbank suchen",
        "noResults": "Keine Fragen gefunden.",
        "moveUp": "„{question}“ nach oben",
        "moveDown": "„{question}“ nach unten",
        "remove": "„{question}“ aus der Kategorie entfernen"
      },
      "usage": {
        "title": "Wo diese Kategorie steht",
        "forms": "Formulare",
        "forms_test": "Tests",
        "assignments": "Laufende Zuweisungen",
        "unused": "Diese Kategorie steht noch in keinem Formular.",
        "unused_test": "Diese Kategorie steht noch in keinem Test."
      },
      "delete": {
        "title": "Kategorie löschen",
        "body": "Die Kategorie verschwindet. Die Fragen darin bleiben in der Fragenbank. Das kann nicht rückgängig gemacht werden.",
        "confirm": "Löschen"
      },
      "actions": {
        "saveAndNewQuestion": "Speichern und neue Frage erstellen"
      }
    },
    "forms": {
      "count_one": "{count} Formular",
      "count_test_one": "{count} Test",
      "count_other": "{count} Formulare",
      "count_test_other": "{count} Tests",
      "new": "Neues Formular",
      "new_test": "Neuer Test",
      "empty": "Es gibt noch keine Formulare.",
      "empty_test": "Es gibt noch keine Tests.",
      "emptyFiltered": "Keine Formulare mit diesem Status.",
      "emptyFiltered_test": "Keine Tests mit diesem Status.",
      "loadError": "Die Formulare konnten nicht geladen werden.",
      "loadError_test": "Die Tests konnten nicht geladen werden.",
      "filter": {
        "current": "Entwurf und veröffentlicht",
        "draft": "Entwurf",
        "published": "Veröffentlicht",
        "archived": "Archiviert",
        "all": "Alle"
      },
      "column": {
        "title": "Titel",
        "status": "Status",
        "assignments": "Zuweisungen",
        "actions": "Aktionen"
      }
    },
    "form": {
      "newTitle": "Neues Formular",
      "newTitle_test": "Neuer Test",
      "editTitle": "Formular bearbeiten",
      "editTitle_test": "Test bearbeiten",
      "viewTitle": "Formular ansehen",
      "viewTitle_test": "Test ansehen",
      "backToList": "Zurück zu den Formularen",
      "backToList_test": "Zurück zu den Tests",
      "loadError": "Dieses Formular konnte nicht geladen werden.",
      "loadError_test": "Dieser Test konnte nicht geladen werden.",
      "saved": "Das Formular wurde gespeichert.",
      "saved_test": "Der Test wurde gespeichert.",
      "copied": "Dies ist die Kopie: ein neuer Entwurf mit denselben Kategorien. Soll eine Kategorie abweichen, kopieren Sie sie separat.",
      "published": "Das Formular wurde veröffentlicht und kann jetzt einer Schulung zugewiesen werden.",
      "published_test": "Der Test wurde veröffentlicht und kann jetzt einem Training zugewiesen werden.",
      "publishFailed": "Das Veröffentlichen ist fehlgeschlagen. Bitte prüfen Sie die markierten Felder.",
      "readOnly": "Sie können dieses Formular ansehen, aber nicht ändern.",
      "readOnly_test": "Sie können diesen Test ansehen, aber nicht ändern.",
      "archivedNotice": "Dieses Formular ist archiviert und kann keiner Schulung mehr zugewiesen werden. Stellen Sie es wieder her, um daraus wieder einen Entwurf zu machen.",
      "archivedNotice_test": "Dieser Test ist archiviert und kann keinem Training mehr zugewiesen werden. Stellen Sie ihn wieder her, um daraus wieder einen Entwurf zu machen.",
      "status": {
        "draft": "Entwurf",
        "published": "Veröffentlicht",
        "archived": "Archiviert"
      },
      "statusPanel": {
        "title": "Status",
        "new": "Ein neues Formular wird als Entwurf gespeichert.",
        "new_test": "Ein neuer Test wird als Entwurf gespeichert.",
        "draft": "Ein Entwurf kann noch keiner Schulung zugewiesen werden. Veröffentlichen Sie ihn, wenn er fertig ist; dann wird geprüft, ob alles stimmt.",
        "published": "Das Formular kann Schulungen zugewiesen werden. Es bleibt bearbeitbar, solange es veröffentlichungsfähig bleibt.",
        "published_test": "Der Test kann Trainings zugewiesen werden. Er bleibt bearbeitbar, solange er veröffentlichungsfähig bleibt.",
        "archived": "Das Formular liegt im Archiv. Durch Wiederherstellen wird es wieder ein Entwurf.",
        "archived_test": "Der Test befindet sich im Archiv. Beim Wiederherstellen wird wieder ein Entwurf daraus."
      },
      "fields": {
        "title": "Titel",
        "description": "Beschreibung",
        "descriptionHint": "Steht unter dem Titel.",
        "headerText": "Kopftext",
        "headerTextHint": "Steht über den Fragen, zum Beispiel eine Begrüßung.",
        "footerText": "Fußtext",
        "footerTextHint": "Steht unter den Fragen, zum Beispiel ein Dankeschön.",
        "allowRemarks": "Platz für eine Bemerkung am Ende",
        "allowRemarksHint": "Teilnehmende können eine freie Bemerkung hinterlassen, unabhängig von den Fragen."
      },
      "categories": {
        "title": "Kategorien in diesem Formular",
        "title_test": "Kategorien in diesem Test",
        "hint": "In dieser Reihenfolge stehen sie im Fragebogen. Eine Frage steht nur einmal in einem Formular.",
        "hint_test": "In dieser Reihenfolge stehen sie im Test. Eine Frage steht nur einmal in einem Test.",
        "empty": "In diesem Formular stehen noch keine Kategorien.",
        "empty_test": "In diesem Test stehen noch keine Kategorien.",
        "add": "Kategorie hinzufügen",
        "search": "Kategorie suchen",
        "noResults": "Keine Kategorien gefunden.",
        "questionCount_one": "{count} Frage",
        "questionCount_other": "{count} Fragen",
        "moveUp": "„{category}“ nach oben",
        "moveDown": "„{category}“ nach unten",
        "remove": "„{category}“ aus dem Formular entfernen",
        "remove_test": "„{category}“ aus dem Test entfernen"
      },
      "actions": {
        "publish": "Veröffentlichen",
        "saveAndNewCategory": "Speichern und neue Kategorie erstellen"
      },
      "delete": {
        "title": "Formular löschen",
        "title_test": "Test löschen",
        "body": "Das Formular wird entfernt. Die Kategorien und Fragen darin bleiben in der Fragenbank. Dies kann nicht rückgängig gemacht werden.",
        "body_test": "Der Test wird gelöscht. Die Kategorien und Fragen darin bleiben in der Bank. Das kann nicht rückgängig gemacht werden.",
        "confirm": "Löschen"
      },
      "assignments": {
        "title": "Zuweisungen",
        "unused": "Dieses Formular ist noch keiner Schulung zugewiesen.",
        "unused_test": "Dieser Test ist noch keinem Training zugewiesen.",
        "total": "In Verwendung",
        "pausable": "Pausierbar",
        "pausedViaForm": "Über dieses Formular pausiert",
        "pausedSeparately": "Einzeln pausiert, bleibt beim Fortsetzen pausiert",
        "held_one": "{count} Zuweisung ist über dieses Formular pausiert. Es wird nichts versendet, bis Sie fortsetzen.",
        "held_other": "{count} Zuweisungen sind über dieses Formular pausiert. Es wird nichts versendet, bis Sie fortsetzen.",
        "hint": "Möchten Sie das Formular verbessern, während es verwendet wird? Pausieren Sie zuerst alle Zuweisungen, passen Sie es an und setzen Sie sie dann fort. Bereits versendete Links funktionieren weiter.",
        "listTitle": "Pro Zuweisung",
        "unknownTraining": "Schulung ohne Namen",
        "openNamed": "Einladungen zu {training}",
        "invitations_one": "{count} Einladung",
        "invitations_other": "{count} Einladungen"
      },
      "pause": {
        "open": "Alle Zuweisungen pausieren",
        "title": "Alle Zuweisungen pausieren",
        "body_one": "Die laufende Zuweisung dieses Formulars wird pausiert. Bis Sie fortsetzen, wird nichts versendet: Wer in dieser Zeit abschließt, erhält die Einladung erst beim Fortsetzen, wenn Sie sich dann für das Übernehmen entscheiden. Bereits versendete Links funktionieren weiter.",
        "body_other": "Die {count} laufenden Zuweisungen dieses Formulars werden pausiert. Bis Sie fortsetzen, wird nichts versendet: Wer in dieser Zeit abschließt, erhält die Einladung erst beim Fortsetzen, wenn Sie sich dann für das Übernehmen entscheiden. Bereits versendete Links funktionieren weiter.",
        "confirm": "Pausieren",
        "done_one": "{count} Zuweisung ist jetzt pausiert.",
        "done_other": "{count} Zuweisungen sind jetzt pausiert."
      },
      "resume": {
        "open": "Fortsetzen…",
        "title": "Zuweisungen fortsetzen",
        "loadError": "Die bereitliegenden Einladungen konnten nicht geladen werden.",
        "intro": "Während der Pause wurde nichts versendet. Pro Schulung liegt Folgendes bereit: Einladungen von vor der Pause und von Personen, die während der Pause abgeschlossen haben.",
        "nothingHeld": "Es liegt nichts bereit. Das Fortsetzen schaltet die Zuweisungen wieder ein; wer danach abschließt, erhält das Formular in seiner dann aktuellen Fassung.",
        "table": {
          "caption": "Bereitliegende Einladungen pro Schulung",
          "training": "Schulung",
          "before": "Von vor der Pause",
          "during": "Während der Pause",
          "oldest": "Älteste",
          "beyond": "Verfällt durch die Grenze",
          "total": "Gesamt",
          "days_one": "{count} Tag",
          "days_other": "{count} Tage",
          "none": "keine",
          "unknownTraining": "Schulung ohne Namen"
        },
        "choice": {
          "legend": "Was passiert mit den bereitliegenden Einladungen?",
          "pickUp": "Übernehmen",
          "pickUpHint": "Sie werden doch noch versendet, alle mit dem Formular in seiner jetzigen Fassung. Ist ihr Zeitpunkt bereits vorbei, gehen sie jetzt hinaus; die Antwortfrist beginnt mit dem Versand.",
          "decline": "Nicht übernehmen",
          "declineHint": "Sie verfallen, und wer während der Pause abgeschlossen hat, erhält keine.",
          "required": "Bitte wählen Sie, ob Sie die bereitliegenden Einladungen übernehmen."
        },
        "limit": {
          "label": "Altersgrenze in Tagen",
          "hint": "Optional: Nur Einladungen, die jünger als diese Anzahl Tage sind, werden übernommen; ältere verfallen. Leer lassen, um alles zu übernehmen.",
          "beyond_one": "Mit dieser Grenze verfällt {count} von {total} bereitliegenden Einladungen; der Rest wird übernommen.",
          "beyond_other": "Mit dieser Grenze verfallen {count} von {total} bereitliegenden Einladungen; der Rest wird übernommen.",
          "checkFailed": "Die Grenze konnte nicht geprüft werden."
        },
        "confirm": "Fortsetzen",
        "done_one": "{count} Zuweisung läuft wieder. Übernommen: {refrozen}, verfallen: {withdrawn}.",
        "done_other": "{count} Zuweisungen laufen wieder. Übernommen: {refrozen}, verfallen: {withdrawn}."
      },
      "backToWizard": "Zurück zur Schulung",
      "fromWizardHint": "Sie kommen aus der Schulung, die Sie gerade erstellen. Veröffentlichen Sie dieses Formular, um es dort auszuwählen; Sie kehren dann automatisch zurück. Ihre Eingaben in der Schulung bleiben erhalten."
    },
    "gradingLink": "Zum Korrigieren"
  },
  "questionnaireSettings": {
    "intro": "Die Standardwerte, mit denen neue Einladungen und Skalenfragen beginnen. Lassen Sie ein Feld leer, gilt der Standardwert der Plattform.",
    "followsPlatform": "Sie haben hier noch nichts Eigenes eingestellt: Überall gelten die Standardwerte der Plattform.",
    "window": {
      "legend": "Antwortfrist",
      "hint": "Wie lange eine Einladung nach dem Versand ausgefüllt werden kann, sofern die Zuweisung nichts anderes festlegt. Eine Änderung gilt für Einladungen, die ab jetzt versendet werden.",
      "label": "Anzahl Tage",
      "platform_one": "Leer: {count} Tag, der Standardwert der Plattform.",
      "platform_other": "Leer: {count} Tage, der Standardwert der Plattform."
    },
    "reminder": {
      "legend": "Erinnerungen",
      "hint": "Wie viele Tage eine Einladung offen sein muss, bevor „Alle erinnern“ und die automatische Erinnerung sie berücksichtigen. So erhält niemand direkt nach der Einladung eine Erinnerung. Eine von Hand an eine einzelne Person gesendete Erinnerung hält sich nicht daran.",
      "zero": "0: kein Minimum.",
      "label": "Mindestanzahl Tage nach dem Versand",
      "platform_one": "Leer: {count} Tag, der Standard der Plattform.",
      "platform_other": "Leer: {count} Tage, der Standard der Plattform."
    },
    "scale": {
      "legend": "Skalenbereich",
      "hint": "Der Bereich, mit dem eine neue Skalenfrage beginnt. Sie können ihn pro Frage anpassen; bestehende Fragen behalten ihren eigenen Bereich.",
      "pairRule": "Geben Sie beide Werte an oder lassen Sie beide leer.",
      "min": "Niedrigster Wert",
      "max": "Höchster Wert",
      "platform": "Leer: {value}, der Standardwert der Plattform."
    },
    "saved": "Die Einstellungen wurden gespeichert.",
    "saveFailed": "Das Speichern ist fehlgeschlagen."
  },
  "retentionSettings": {
    "intro": "Wie lange die Lernhistorie Ihrer Umgebung aufbewahrt wird, je Art von Datensatz und gerechnet ab dem Datum des Datensatzes. Ist die Frist abgelaufen, löscht der nächtliche Aufbewahrungslauf den Datensatz — den Datensatz, nicht die Person. Lassen Sie ein Feld leer, bleibt der Datensatz erhalten.",
    "keepHint": "Leer: aufbewahren. Das ist der Standard.",
    "defaultHint_one": "Standard: {count} Monat. Leer: aufbewahren.",
    "defaultHint_other": "Standard: {count} Monate. Leer: aufbewahren.",
    "keepPlaceholder": "Aufbewahren",
    "types": {
      "enrollment": "Anmeldungen (Monate)",
      "attendance": "Anwesenheit (Monate)",
      "attempt": "E-Learning-Versuche (Monate)",
      "completion": "Abschlüsse (Monate)",
      "qualification": "Qualifikationen (Monate nach Ende oder Ablauf)",
      "certificate": "Zertifikate (Monate)",
      "evaluation_response": "Evaluationen (Monate nach dem Absenden)",
      "import_raw_data": "Rohe Importdaten (Monate)"
    },
    "history": {
      "legend": "Lernhistorie",
      "hint": "Abschlüsse, Qualifikationen und Zertifikate werden standardmäßig aufbewahrt: Sie belegen, was jemand erreicht hat. Eine Anmeldung oder ein Abschluss, an dem noch etwas hängt, das aufbewahrt wird, wird übersprungen, bis auch das abgelaufen ist. Eine noch gültige Qualifikation wird nie gelöscht."
    },
    "evaluation": {
      "legend": "Evaluationen",
      "hint": "Ausgefüllte Evaluationen und andere Meinungen. Ein Wissenstest hat keine eigene Frist: Er wird zusammen mit dem zugehörigen Abschluss gelöscht.",
      "action": "Nach Ablauf der Frist",
      "actions": {
        "anonymise": "Anonymisieren: Die Antworten bleiben für Berichte erhalten, ohne Namen",
        "delete": "Löschen: Die Antwort und ihre Einzelantworten werden entfernt"
      }
    },
    "imports": {
      "legend": "Rohe Importdaten",
      "hint": "Die aus einer HR-Datei eingelesenen Zeilen, etwa mit Namen und Geburtsdaten. Nach Ablauf der Frist werden sie geleert; die Übersicht des Imports bleibt erhalten."
    },
    "fixed": {
      "legend": "Feste Fristen",
      "personalData_one": "Die personenbezogenen Daten eines gelöschten Benutzers werden {count} Tag nach dem Löschen unkenntlich gemacht. Diese Frist legt BCS für Ihre Umgebung fest.",
      "personalData_other": "Die personenbezogenen Daten eines gelöschten Benutzers werden {count} Tage nach dem Löschen unkenntlich gemacht. Diese Frist legt BCS für Ihre Umgebung fest.",
      "mailOutbox_one": "Gesendete E-Mails werden nach {count} Tag gelöscht (eine Frist der Plattform).",
      "mailOutbox_other": "Gesendete E-Mails werden nach {count} Tagen gelöscht (eine Frist der Plattform)."
    },
    "lastRun": {
      "legend": "Zuletzt angewendet",
      "none": "Die Aufbewahrungsfristen wurden noch nicht angewendet. Das geschieht jede Nacht.",
      "summary": "Am {date}: {erased} Benutzer unkenntlich gemacht, {records} Datensätze verarbeitet und {shells} leere Konten entfernt."
    },
    "saved": "Die Aufbewahrungsfristen wurden gespeichert.",
    "saveFailed": "Das Speichern ist fehlgeschlagen."
  },
  "questionnaireStatus": {
    "heading": "Stand der Regel",
    "heading_test": "Stand der Testregel",
    "backToForm": "Zum Formular",
    "backToForm_test": "Zum Test",
    "backToSurveys": "Zu den eigenständigen Fragebögen",
    "backToTraining": "Zur Schulung",
    "subject": "{form} zu {training}",
    "subjectWithoutTraining": "Fragebogen {form}",
    "subjectWithoutTraining_test": "Test {form}",
    "anonymous": "Anonym",
    "anonymousNote": "Diese Regel ist anonym: Sie sehen, wie viele Einladungen sich in welchem Stand befinden, aber nicht, von wem. Einzelne Personen erinnern oder erneut senden ist daher nicht möglich; alle noch Offenen erinnern schon.",
    "anonymousBelowFloor": "Das Ergebnis bleibt verborgen, bis {floor} Antworten vorliegen, über alle Durchführungen hinweg. Bisher: {counted} von {floor}.",
    "loadError": "Diese Regel konnte nicht geladen werden.",
    "loadError_test": "Diese Testregel konnte nicht geladen werden.",
    "notFound": "Diese Regel existiert nicht (mehr).",
    "notFound_test": "Diese Testregel gibt es nicht (mehr).",
    "actionFailed": "Das hat nicht geklappt. Bitte versuchen Sie es erneut.",
    "backToRule": "Zur Regel",
    "backToRule_test": "Zur Testregel",
    "occurrence": {
      "heading": "Zuweisung: {date}, {location}",
      "headingNoLocation": "Zuweisung: {date}",
      "headingLoading": "Zuweisung",
      "notFound": "Diese Zuweisung existiert nicht (mehr).",
      "loadError": "Diese Zuweisung konnte nicht geladen werden."
    },
    "occurrences": {
      "title": "Zuweisungen",
      "hint": "Pro Durchführung der Schulung: Wer eingeladen wurde und wie weit die Personen sind. Öffnen Sie eine Zuweisung, um die Personen zu sehen.",
      "empty": "Für diese Regel wurde noch nichts eingeladen.",
      "empty_test": "Für diese Testregel wurde noch niemand eingeladen.",
      "loadError": "Die Zuweisungen konnten nicht geladen werden.",
      "future_one": "{count} zukünftige Durchführung, noch nichts versendet.",
      "future_other": "{count} zukünftige Durchführungen, noch nichts versendet.",
      "column": {
        "date": "Durchführung",
        "location": "Ort",
        "trainers": "Trainer",
        "sent": "Versendet",
        "submitted": "Ausgefüllt",
        "open": "Offen",
        "expired": "Abgelaufen",
        "actions": "Aktionen"
      },
      "sentOf": "{sent} von {invited}",
      "submittedOf": "{count} ({percent}%)",
      "view": "Ansehen",
      "viewNamed": "Zuweisung von {name} ansehen",
      "noDate": "Kein Datum",
      "none": "–"
    },
    "assignment": {
      "active": "Läuft",
      "paused": "Pausiert",
      "archived": "Archiviert"
    },
    "notRunning": {
      "paused": "Diese Regel ist pausiert. Erinnern und erneut senden ist wieder möglich, sobald sie fortgesetzt wird; bereits versendete Links funktionieren weiter.",
      "paused_test": "Diese Testregel ist pausiert. Es wird nichts versendet, bis sie fortgesetzt wird.",
      "archived": "Diese Regel ist archiviert. Erinnern und erneut senden ist nicht mehr möglich; bereits versendete Links funktionieren weiter, bis sie ablaufen.",
      "archived_test": "Diese Testregel ist archiviert und versendet nichts mehr."
    },
    "counts": {
      "title": "Zahlen",
      "loadError": "Die Zahlen konnten nicht geladen werden.",
      "empty": "Aus dieser Regel sind noch keine Einladungen entstanden.",
      "mailFailed": "E-Mail fehlgeschlagen",
      "mailFailedHint": "Bei einer fehlgeschlagenen E-Mail steht die Einladung auf versendet, aber die E-Mail ist nicht angekommen. Erneut senden verschickt sie noch einmal: mit einem neuen Link oder mit der Adresse unter Meine Fragebögen, wenn sich der Fragebogen nur in der App öffnen lässt.",
      "submittedOf": "von {total} ({percent} %)",
      "submittedHint": "Einladungen, für die der Fragebogen ausgefüllt wurde.",
      "submittedHint_test": "Einladungen, zu denen der Test abgegeben wurde.",
      "open": "Offen",
      "openHint": "Versendet und noch auszufüllen.",
      "expiredHint": "Die Ausfüllfrist ist ohne Antwort abgelaufen. Erneut senden öffnet die Einladung wieder.",
      "moreDetail": "Mehr: was noch versendet wird und was nicht stattfindet",
      "lessDetail": "Weniger anzeigen",
      "toSend": "Noch zu versenden",
      "toSendHint": "Noch nicht versendet: geplant, wartet auf Anwesenheit, wartet auf einen endgültigen Abschluss oder während einer Pause zurückgehalten.",
      "notGoingAhead": "Findet nicht statt",
      "notGoingAheadHint": "Zurückgezogen oder nicht mehr zu versenden, mit Angabe des Grundes."
    },
    "state": {
      "waiting": "Wartet auf Versand",
      "held": "Liegt bereit",
      "waiting_for_attendance": "Wartet auf Anwesenheit",
      "waiting_for_completion": "Wartet, bis der Abschluss endgültig ist",
      "sent": "Versendet",
      "submitted": "Ausgefüllt",
      "expired": "Abgelaufen",
      "cancelled": "Zurückgezogen",
      "recipient_inactive": "Empfänger nicht aktiv",
      "waitingReady": "Bereit zum Versand"
    },
    "reason": {
      "completion_withdrawn": "Abschluss zurückgezogen",
      "condition_not_met": "Bedingung nicht erfüllt",
      "pause_declined": "Nach der Pause nicht aufgenommen",
      "archived": "Zuweisung archiviert",
      "recipient_inactive": "Empfänger nicht aktiv",
      "session_removed": "Termin entfernt",
      "occurrence_cancelled": "Durchführung abgesagt",
      "enrollment_cancelled": "Anmeldung storniert",
      "unknown": "Unbekannter Grund"
    },
    "list": {
      "title": "Einladungen",
      "loadError": "Die Einladungen konnten nicht geladen werden.",
      "empty": "Es gibt noch keine Einladungen.",
      "column": {
        "respondent": "Empfänger",
        "state": "Stand",
        "sent": "Versendet",
        "expires": "Läuft ab",
        "reminded": "Letzte Erinnerung",
        "actions": "Aktionen"
      },
      "erased": "Gelöschter Benutzer",
      "anonymousRespondent": "Anonym",
      "scheduled": "Geplant am {date}",
      "submittedOn": "Ausgefüllt am {date}",
      "withdrawnOn": "{reason}, am {date}",
      "cycle": "Runde {cycle}",
      "notYet": "Noch nicht",
      "waitingUntil": "Wird am {date} versendet",
      "waitingNextRound": "Wird in der nächsten Versandrunde versendet",
      "sendingOff": "Der Versand ist für diese Umgebung ausgeschaltet; die Einladung geht hinaus, sobald er wieder eingeschaltet ist",
      "emptyFiltered": "Keine Einladungen in der Gruppe „{name}“."
    },
    "actions": {
      "remind": "Jetzt erinnern",
      "remindNamed": "{name} jetzt erinnern",
      "resend": "Erneut senden",
      "resendNamed": "Erneut an {name} senden",
      "reminded": "Eine Erinnerung an {name} ist zum Versand bereit.",
      "resent": "Ein neuer Link an {name} ist zum Versand bereit.",
      "reopened": "Ein neuer Link an {name} ist zum Versand bereit. Die Einladung war abgelaufen und ist bis {date} wieder geöffnet; frühere Links bleiben geschlossen.",
      "resentInApp": "Eine E-Mail zu Meine Fragebögen ist zum Versand an {name} bereit.",
      "reopenedInApp": "Eine E-Mail zu Meine Fragebögen ist zum Versand an {name} bereit. Die Einladung war abgelaufen und ist bis {date} wieder geöffnet."
    },
    "filter": {
      "active": "Filter: {name}",
      "clear": "Filter entfernen: {name}"
    },
    "remindOpen": {
      "open": "Alle noch Offenen erinnern",
      "title": "Alle erinnern, die noch offen sind",
      "body_one": "{count} Einladung ist offen. Wer noch nicht ausgefüllt hat, erhält eine Erinnerung: mit einem neuen Link, oder mit der Adresse in Meine Fragebögen, wenn der Fragebogen nur in der App geöffnet wird. Ein zuvor versendeter Link funktioniert weiter. Wer kürzlich bereits erinnert wurde, wird übersprungen.",
      "body_other": "{count} Einladungen sind offen. Wer noch nicht ausgefüllt hat, erhält eine Erinnerung: mit einem neuen Link, oder mit der Adresse in Meine Fragebögen, wenn der Fragebogen nur in der App geöffnet wird. Ein zuvor versendeter Link funktioniert weiter. Wer kürzlich bereits erinnert wurde, wird übersprungen.",
      "confirm": "Erinnerungen senden",
      "nothingOpen": "Derzeit ist keine Einladung offen, an die erinnert werden kann.",
      "done_one": "{count} Erinnerung zum Versand bereitgestellt.",
      "done_other": "{count} Erinnerungen zum Versand bereitgestellt.",
      "previewWill_one": "{count} Erinnerung wird versendet.",
      "previewWill_other": "{count} Erinnerungen werden versendet.",
      "previewSkipped_one": "{count} übersprungen ({reason}).",
      "previewSkipped_other": "{count} übersprungen ({reason}).",
      "daysAgo_one": "vor weniger als {count} Tag eingeladen",
      "daysAgo_other": "vor weniger als {count} Tagen eingeladen",
      "skip": {
        "reminded_recently": "Kürzlich bereits erinnert: {count}",
        "too_soon_after_send": "Zu kurz zuvor eingeladen: {count}",
        "mail_on_its_way": "Eine E-Mail war bereits unterwegs: {count}",
        "recipient_inactive": "Empfänger nicht aktiv: {count}",
        "no_address": "Keine E-Mail-Adresse: {count}",
        "not_queued": "E-Mail konnte nicht bereitgestellt werden: {count}",
        "closed": "Inzwischen ausgefüllt, zurückgezogen oder abgelaufen: {count}"
      }
    },
    "openResults": "Ergebnisse ansehen"
  },
  "auditLog": {
    "heading": "Protokoll",
    "intro": "Wer hat wann was geändert. Filtern Sie pro Spalte; standardmäßig ist kein Filter gesetzt, Sie sehen also alles, das Neueste zuerst.",
    "export": "Exportieren (CSV)",
    "empty": "Im Protokoll steht noch nichts.",
    "emptyFiltered": "Keine Einträge entsprechen diesen Filtern.",
    "filterError": "Dieser Filter kann nicht angewendet werden. Passen Sie ihn an und versuchen Sie es erneut.",
    "pagination": "Seitennavigation Protokoll",
    "prev": "Zurück",
    "next": "Weiter",
    "pageOf": "Seite {page} von {pages}",
    "diffShow": "Details",
    "diffHide": "Ausblenden",
    "diffBefore": "Alter Wert",
    "diffAfter": "Neuer Wert",
    "diffContext": "Daten",
    "badge": {
      "bcs": "im Auftrag von BCS Learning"
    },
    "cols": {
      "when": "Wann",
      "category": "Kategorie",
      "action": "Vorgang",
      "actor": "Wer",
      "target": "Woran",
      "detail": "Detail"
    },
    "filters": {
      "from": "Ab Datum",
      "to": "Bis einschließlich Datum",
      "category": "Kategorie",
      "categoryAll": "Alle Kategorien",
      "action": "Vorgang",
      "actionPlaceholder": "Nach Vorgang suchen",
      "actor": "Person",
      "actorAll": "Alle Personen",
      "bcsOnly": "Nur Vorgänge im Auftrag von BCS Learning",
      "clearAll": "Alle Filter zurücksetzen",
      "none": "Diese Spalte hat keinen Filter",
      "targetActive": "Sie sehen den Verlauf eines einzelnen Elements. Löschen Sie die Filter, um das ganze Protokoll zu sehen."
    },
    "categories": {
      "inschrijvingen": "Anmeldungen",
      "catalogus": "Katalog",
      "rechten": "Berechtigungen",
      "berichten": "Nachrichten",
      "inloggen": "Anmeldung",
      "instellingen": "Einstellungen",
      "organisatie": "Organisation",
      "beveiliging": "Sicherheit",
      "overig": "Sonstiges"
    },
    "diffField": "Feld",
    "redacted": "verborgen",
    "reference": {
      "erasedUser": "Gelöschter Benutzer",
      "erasedExternalPerson": "Gelöschte externe Person",
      "removed": "entfernt"
    },
    "actorSystem": "System",
    "actorSystemNamed": "System ({name})",
    "history": {
      "heading": "Verlauf",
      "openFullLog": "Im Protokoll ansehen",
      "empty": "Hierzu wurde noch nichts festgehalten.",
      "notFound": "Dieses Element gibt es hier nicht (mehr), daher kann kein Verlauf angezeigt werden.",
      "pagination": "Seitennavigation Verlauf",
      "show": "Verlauf",
      "enrollmentTitle": "Verlauf der Anmeldung von {name}"
    },
    "archive": {
      "periodArchived": "Dieser Zeitraum wurde archiviert.",
      "periodArchivedHint": "Diese Einträge stehen nicht mehr im Protokoll selbst, sondern im Archiv. Exportieren Sie den Monat oder holen Sie ihn vorübergehend zurück, um ihn hier zu durchsuchen.",
      "olderArchived": "Das Protokoll bis einschließlich {month} wurde archiviert. Wählen Sie in der Spalte Wann einen Zeitraum, um ihn anzusehen oder zurückzuholen.",
      "monthLabel": "{month} ({rows} Einträge)",
      "export": "Exportieren",
      "restore": "Diesen Zeitraum zurückholen",
      "restoring": "{month} wird zurückgeholt…",
      "restored": "{month} wurde bis {date} zurückgeholt.",
      "failed": "Das Zurückholen von {month} ist fehlgeschlagen: Die Archivdatei stimmte nicht oder war nicht lesbar.",
      "restoreError": "Das Zurückholen konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
      "noRight": "Zurückholen oder exportieren kann nur, wer das Recht hat, das Protokoll zu exportieren.",
      "historyArchived": "Der ältere Verlauf wurde archiviert.",
      "historyRestored": "Der ältere Verlauf wurde bis {date} zurückgeholt."
    },
    "fields": {
      "title": "Titel",
      "summary": "Zusammenfassung",
      "description": "Beschreibung",
      "status": "Status",
      "type": "Art",
      "name": "Name",
      "category": "Kategorie",
      "first_name": "Vorname",
      "last_name": "Nachname",
      "email": "E-Mail-Adresse",
      "phone": "Telefonnummer",
      "locale": "Sprache",
      "external_id": "Externer Schlüssel",
      "attributes": "Zusätzliche Angaben",
      "manager_user_id": "Vorgesetzte Person",
      "hire_date": "Eintrittsdatum",
      "end_date": "Austrittsdatum",
      "account_valid_from": "Konto gültig ab",
      "account_valid_until": "Konto gültig bis",
      "last_login_at": "Zuletzt angemeldet",
      "profile_picture_url": "Profilfoto",
      "password": "Passwort",
      "user_id": "Teilnehmende Person",
      "learning_activity_id": "Lernaktivität",
      "occurrence_id": "Durchführung",
      "waitlist_position": "Platz auf der Warteliste",
      "cancelled_at": "Storniert am",
      "cancel_reason": "Erläuterung zur Stornierung",
      "cancel_reason_id": "Stornierungsgrund",
      "cancel_requested_at": "Stornierung beantragt am",
      "transferred_from_enrollment_id": "Verschoben von Anmeldung",
      "offer_expires_at": "Angebot läuft ab am",
      "composition": "Zusammensetzung",
      "tracking_mode": "Fortschrittsverfolgung",
      "source_kind": "Quelle",
      "source_file": "Quelldatei",
      "completion_rule": "Abschlussregel",
      "completion_threshold": "Abschlussprozentsatz",
      "duration": "Dauer",
      "duration_minutes": "Dauer (Minuten)",
      "language": "Sprache",
      "labels": "Schlagwörter",
      "tags": "Schlagwörter",
      "visibility_mode": "Sichtbarkeit",
      "access_group_id": "Zugriffsgruppe",
      "allow_anonymous": "Anonym zugänglich",
      "max_enrollments": "Anzahl der Anmeldungen",
      "max_waitlist_registrations": "Anzahl der Wartelisteneinträge",
      "approval_flow_id": "Genehmigungskette",
      "waitlist_enabled": "Warteliste",
      "waitlist_promotion_mode": "Vergabe bei freiem Platz",
      "offer_window_hours": "Angebotsfenster (Stunden)",
      "waitlist_cap": "Obergrenze der Warteliste",
      "cancellation_deadline": "Stornierungsfrist",
      "cancel_before": "Stornieren vor der Frist",
      "cancel_after": "Stornieren nach der Frist",
      "min_participants": "Min. Teilnehmende",
      "max_participants": "Max. Teilnehmende",
      "enrollment_deadline": "Anmeldeschluss",
      "delivery_mode": "Durchführungsform",
      "timezone": "Zeitzone",
      "waitlist_enabled_by_default": "Warteliste standardmäßig aktiv",
      "waitlist_offer_window_hours": "Angebotsfenster (Stunden)",
      "cancel_before_default": "Standard: Stornieren vor der Frist",
      "cancel_after_default": "Standard: Stornieren nach der Frist",
      "visibility_mode_default": "Standardsichtbarkeit",
      "approval_flow_id_default": "Standard-Genehmigungskette",
      "max_enrollments_default": "Standardanzahl der Anmeldungen",
      "max_waitlist_registrations_default": "Standardanzahl der Wartelisteneinträge",
      "enabled": "Aktiv",
      "frequency": "Häufigkeit",
      "send_time": "Versandzeit",
      "send_weekday": "Versandtag",
      "response_window_days": "Antwortfrist (Tage)",
      "scale_min": "Niedrigster Skalenwert",
      "scale_max": "Höchster Skalenwert",
      "anonymity_floor": "Anonymitätsschwelle",
      "reminder_min_days_after_send": "Erinnerung nach (Tagen)",
      "enrollment_months": "Aufbewahrung der Anmeldungen (Monate)",
      "attendance_months": "Aufbewahrung der Anwesenheit (Monate)",
      "attempt_months": "Aufbewahrung der Versuche (Monate)",
      "completion_months": "Aufbewahrung der Abschlüsse (Monate)",
      "qualification_months": "Aufbewahrung der Qualifikationen (Monate)",
      "certificate_months": "Aufbewahrung der Zertifikate (Monate)",
      "evaluation_response_months": "Aufbewahrung der Evaluationsantworten (Monate)",
      "evaluation_response_action": "Nach der Frist mit Evaluationsantworten",
      "import_raw_data_months": "Aufbewahrung der Importdaten (Monate)"
    }
  },
  "approvalsOverview": {
    "heading": "Alle Genehmigungen",
    "intro": "Jede Genehmigung, die in dieser Umgebung noch offen ist — mit der zuständigen Person und der bisherigen Wartezeit. Bleibt etwas liegen, können Sie es übertragen oder selbst entscheiden.",
    "empty": "Zurzeit ist nichts offen.",
    "cols": {
      "applicant": "Antragsteller",
      "course": "Aktivität",
      "assignee": "Zuständig",
      "waiting": "Wartet seit"
    },
    "kind": {
      "enrollment": "Anmeldung",
      "cancellation": "Stornierung",
      "external_request": "Externe Weiterbildung",
      "other": "Sonstiges"
    },
    "unknownApplicant": "Unbekannt",
    "noAssignee": "Bei niemandem",
    "waitingDays_one": "{count} Tag",
    "waitingDays_other": "{count} Tage",
    "remind": "Erinnern",
    "reminded": "Erinnert",
    "remindFailed": "Die Erinnerung wurde nicht gesendet. Möglicherweise wurde der Antrag inzwischen bearbeitet oder zurückgezogen.",
    "move": "Übertragen",
    "approve": "Genehmigen",
    "reject": "Ablehnen",
    "moveTitle": "Genehmigung übertragen",
    "moveBody": "Der Antrag von {applicant} liegt derzeit bei {assignee}. Wählen Sie, wer ihn übernimmt.",
    "moveConfirm": "Übertragen",
    "movePickerLabel": "Neue zuständige Person",
    "movePickerPlaceholder": "Nach Name oder E-Mail-Adresse suchen",
    "moveFailed": "Das Übertragen ist fehlgeschlagen.",
    "rejectTitle": "Antrag ablehnen",
    "rejectComment": "Hinweis für den Antragsteller",
    "decideFailed": "Die Entscheidung ist nicht durchgegangen. Möglicherweise wurde der Antrag inzwischen bearbeitet oder zurückgezogen."
  },
  "approvalFlows": {
    "heading": "Genehmigungsabläufe",
    "intro": "Ein Genehmigungsablauf ist eine Kette von Genehmigern. Sie wählen pro Lernaktivität, welcher Ablauf gilt.",
    "new": "Neuer Ablauf",
    "empty": "Es gibt noch keine Genehmigungsabläufe.",
    "noSteps": "keine Schritte",
    "stepCount": "{n} Schritt(e)",
    "platformBadge": "Standard",
    "ownBadge": "Eigener",
    "platformReadOnly": "Dies ist ein Standardablauf der Plattform. Sie können ihn auswählen und ansehen, aber nicht ändern.",
    "filterOwner": "Eigentümer",
    "stepsHeading": "Schritte (in Reihenfolge)",
    "stepN": "Schritt {n}",
    "addStep": "Schritt hinzufügen",
    "choose": "Wählen...",
    "singlePerson": "Diese Route ergibt immer eine Person.",
    "deadlineEscalates": "Läuft die Frist ab, wird ein zusätzlicher Schritt für die Personalabteilung ergänzt.",
    "dependsOnApplicant": "Wer das ist, hängt vom Antragsteller ab.",
    "nobodyFallsBackToHr": "Niemand gefunden — greift auf die Personalabteilung zurück.",
    "deleteTitle": "Ablauf löschen",
    "deleteBody": "Möchten Sie {name} wirklich löschen?",
    "deleteFailed": "Löschen nicht möglich. Wird dieser Ablauf noch verwendet?",
    "saveFailed": "Speichern nicht möglich. Bitte prüfen Sie die Schritte.",
    "cols": {
      "name": "Name",
      "chain": "Kette"
    },
    "owner": {
      "all": "Alle",
      "platform": "Standard (Plattform)",
      "own": "Eigene Abläufe"
    },
    "mode": {
      "any": "Eine Zustimmung genügt",
      "all": "Alle müssen zustimmen"
    },
    "fields": {
      "name": "Name",
      "description": "Beschreibung",
      "expiresAfterDays": "Entscheidungsfrist (Tage)",
      "expiresAfterDaysHint": "Leer lassen, damit ein Antrag nie verfällt. Mit einer Frist verfällt ein Antrag, den niemand bearbeitet, und der Platz wird für jemand anderen frei.",
      "warnDaysBefore": "Warnen (Tage vorher)",
      "warnDaysBeforeHint": "So viele Tage vor dem Verfall erhält die antragstellende Person eine Nachricht und kann ihre genehmigende Person noch erinnern.",
      "route": "Wer entscheidet",
      "role": "Rolle",
      "orgLevel": "Ebene",
      "orgField": "Rollenfeld",
      "decisionMode": "Bei mehreren Personen",
      "deadline": "Entscheidungsfrist",
      "deadlineHours": "Stunden",
      "person": "Person"
    },
    "route": {
      "own_manager": "Eigene Führungskraft",
      "org_role": "Rolle einer Organisationseinheit",
      "tenant_role": "Rolle in dieser Umgebung",
      "fixed_person": "Bestimmte Person"
    },
    "settingsHeading": "Genehmigungen",
    "settingsIntro": "Wählen Sie, welcher Genehmigungsablauf bei einer neuen Lernaktivität vorbelegt wird.",
    "settingsNone": "Keine Genehmigung — direkt anmelden",
    "defaultLabel": "Standard für neue Aktivitäten",
    "defaultHint": "Nur eine Vorbelegung: bestehende Aktivitäten ändern sich nicht mit, und eine Aktivität ohne Genehmigung wird nie überschrieben.",
    "manageLink": "Genehmigungsabläufe verwalten",
    "editor": {
      "inspector": "Inspektor",
      "selectHint": "Wählen Sie einen Schritt in der Kette aus, um ihn zu bearbeiten, oder fügen Sie einen Schritt hinzu.",
      "removeStep": "Schritt entfernen",
      "moveUp": "Schritt früher in der Kette",
      "moveDown": "Schritt später in der Kette"
    },
    "node": {
      "request": "Antrag",
      "requestTitle": "Jemand beantragt eine Genehmigung",
      "outcome": "Ergebnis",
      "outcomeTitle": "Genehmigt",
      "allOf": "alle müssen zustimmen",
      "deadline": "{n} Stunden"
    }
  },
  "workflows": {
    "heading": "Workflows",
    "intro": "Automatisieren Sie Aktionen bei Ereignissen: Auslöser → Bedingung → Schritte.",
    "new": "Neuer Workflow",
    "empty": "Noch keine Workflows.",
    "on": "Ein",
    "off": "Aus",
    "system": "Standard",
    "custom": "Benutzerdefiniert",
    "locked": "Gesperrt",
    "lockedHint": "Durch die Plattform gesperrt — Sie können ihn nur ansehen, nicht deaktivieren, bearbeiten oder löschen.",
    "unavailable": "Übersprungen",
    "unavailableHint": "Dieser Workflow verwendet etwas, das in dieser Umgebung nicht verfügbar ist, und wird daher übersprungen. Er bleibt erhalten.",
    "unavailableNotice": "Ein oder mehrere Workflows werden übersprungen: Sie verwenden etwas, das in dieser Umgebung nicht verfügbar ist. Sie bleiben erhalten.",
    "systemHint": "Von der Plattform bereitgestellter Standard-Workflow. Sie können ihn deaktivieren, aber nicht löschen (durch Bearbeiten entsteht eine eigene Kopie).",
    "confirmDelete": "Workflow löschen?",
    "confirmDeleteBody": "Dies löscht \"{name}\" endgültig.",
    "cols": {
      "name": "Name",
      "trigger": "Auslöser",
      "enabled": "Aktiv",
      "origin": "Typ"
    },
    "fields": {
      "name": "Name",
      "key": "Schlüssel",
      "keyHint": "Stabiler, eindeutiger Schlüssel innerhalb Ihres Tenants (Kleinbuchstaben, Bindestriche).",
      "trigger": "Auslöser",
      "description": "Beschreibung",
      "enabled": "Sofort aktivieren"
    },
    "schedule": {
      "heading": "Auslöse-Zeitpunkt",
      "offsetDays": "Tage-Versatz",
      "offsetHint": "Negativ = vor dem Datum (z. B. -7 für Pre-Boarding), 0 = am Tag selbst, positiv = danach.",
      "offsetHintAfter": "Anzahl Tage nach der Anmeldung. 0 = am selben Tag, 7 = eine Woche später.",
      "time": "Uhrzeit (Tenant-Zeitzone)"
    },
    "editor": {
      "inspector": "Inspektor",
      "selectHint": "Wählen Sie einen Block aus, um ihn zu bearbeiten, oder fügen Sie einen Schritt hinzu.",
      "actionTitle": "Aktion",
      "actionKind": "Art der Aktion",
      "actionNoSettings": "Diese Aktion hat keine Einstellungen.",
      "approvalTitle": "Genehmigung",
      "addAction": "Aktion",
      "addApproval": "Genehmigung",
      "removeStep": "Block entfernen",
      "addMail": "+ E-Mail",
      "subject": "Betreff",
      "body": "Inhalt",
      "dueHours": "Fällig nach (Stunden)",
      "saved": "Gespeichert.",
      "lockedNotice": "Dieser Workflow ist durch die Plattform gesperrt. Sie können ihn ansehen, aber nicht ändern.",
      "systemNotice": "Dies ist ein Standard-Workflow. Wenn Sie die Definition bearbeiten und speichern, wird daraus eine eigene Kopie (losgelöst vom globalen Set).",
      "recipient": {
        "label": "Empfänger",
        "subjectUser": "Der betroffene Benutzer",
        "fixed": "Feste Adresse",
        "orgUnitRole": "Org-Unit-Rolle",
        "address": "E-Mail-Adresse",
        "orgUnitManager": "Führungskraft der Organisationseinheit",
        "contentOwner": "Verwalter der Schulung",
        "occurrenceTrainers": "Trainer(in) der Durchführung"
      },
      "unit": {
        "label": "Org-Unit",
        "subjectUnit": "Die Unit des Benutzers",
        "orgRoot": "Organisation (Root)",
        "fieldKey": "Feldschlüssel (z. B. ceo, teamlead)"
      },
      "branch": {
        "on_approve": "Bei Genehmigung",
        "on_reject": "Bei Ablehnung",
        "on_timeout": "Bei Zeitüberschreitung"
      },
      "node": {
        "trigger": "Auslöser",
        "action": "Aktion",
        "approval": "Genehmigung",
        "email": "E-Mail",
        "digestLine": "Zeile in der Sammel-E-Mail",
        "confirmEnrollment": "Anmeldung bestätigen",
        "rejectEnrollment": "Anmeldung ablehnen",
        "confirmCancellation": "Stornierung bestätigen",
        "rejectCancellation": "Stornierung ablehnen",
        "materializeExternalRequest": "Externe Weiterbildung erfassen",
        "rejectExternalRequest": "Antrag auf externe Weiterbildung ablehnen",
        "approvalTitle": "Prüfung"
      }
    },
    "help": {
      "link": "Hilfe",
      "backToList": "Zurück zu den Workflows",
      "inEditor": "So sieht es im Editor aus",
      "title": "So funktionieren Workflows",
      "intro": "Workflows automatisieren Aktionen bei Ereignissen auf der Plattform. Jeder Workflow folgt demselben Muster: Ein Auslöser startet ihn, optionale Bedingungen filtern, wann er tatsächlich läuft, und Schritte führen Aktionen aus — zum Beispiel eine E-Mail senden oder eine Genehmigung anfordern.",
      "conceptsHeading": "Die Bausteine",
      "concepts": {
        "trigger": {
          "title": "Auslöser",
          "body": "Das Ereignis, das den Workflow startet, z. B. 'Benutzer erstellt' oder 'Einschreibung angefragt'. Jeder Workflow hat genau einen Auslöser."
        },
        "scheduling": {
          "title": "Zeitpunkt bei Datums-Auslösern",
          "body": "Datums-Auslöser (Eintrittsdatum, Austrittsdatum, Kontogültigkeit) feuern an einem Tag, den Sie selbst festlegen: Wählen Sie, wie viele Tage vor oder nach dem Datum (z. B. 7 Tage vor dem Eintrittsdatum für das Pre-Boarding oder 0 am Tag selbst) und zu welcher Uhrzeit (in 15-Minuten-Schritten, in der Zeitzone des Mandanten). So können Sie morgens eine Willkommens-E-Mail und nachmittags eine Erinnerung senden. Ein neuer Workflow feuert nie rückwirkend: Er feuert nur für Daten am oder nach dem Erstelldatum, sodass bereits beschäftigte Personen ihn nicht nachträglich erhalten."
        },
        "condition": {
          "title": "Bedingung (optional)",
          "body": "Ein Filter, der entscheidet, ob der Workflow tatsächlich läuft, z. B. nur wenn eine Einschreibung im Self-Service erfolgt. Keine Bedingung bedeutet: immer ausführen."
        },
        "steps": {
          "title": "Schritte",
          "body": "Was passiert, in welcher Reihenfolge. Ein Schritt ist entweder eine Aktion (etwas tun) oder eine Genehmigung (auf die Entscheidung einer Person warten)."
        },
        "actionEmail": {
          "title": "Aktion: E-Mail",
          "body": "Sendet automatisch eine E-Mail. Sie wählen Empfänger, Betreff und Inhalt. Der Text kann Variablen wie {tpl} verwenden, die pro Empfänger ausgefüllt werden."
        },
        "approval": {
          "title": "Genehmigung",
          "body": "Pausiert den Workflow, bis jemand genehmigt oder ablehnt. Sie legen fest, wer entscheidet, innerhalb wie vieler Stunden, und was bei Genehmigung, Ablehnung oder Zeitüberschreitung passiert."
        },
        "recipient": {
          "title": "Empfänger über Org-Rolle",
          "body": "'An wen' eine E-Mail oder Genehmigung geht, ist keine feste Person, sondern ein Verweis auf ein Rollenfeld einer Org-Unit (z. B. teamlead oder ceo), relativ zum betroffenen Benutzer. Voraussetzung: Das Feld ist auf der richtigen Ebene der Organisationsstruktur ausgefüllt."
        },
        "enabling": {
          "title": "Aktivieren und Deaktivieren",
          "body": "Ein Workflow läuft nur, wenn er eingeschaltet ist. Von der Plattform bereitgestellte Standard-Workflows können Sie ein- oder ausschalten; sobald Sie die Schritte bearbeiten und speichern, wird daraus eine eigene Kopie, losgelöst vom globalen Set."
        },
        "locked": {
          "title": "Gesperrte Workflows",
          "body": "Einige Workflows sind durch die Plattform gesperrt (Schloss-Symbol): Als Administrator können Sie sie ansehen, aber nicht deaktivieren, bearbeiten oder löschen. Superadmins verwalten sie zentral und verteilen Änderungen über 'An Tenants synchronisieren'."
        }
      },
      "examplesHeading": "Beispiele",
      "resultLabel": "Ergebnis",
      "examples": {
        "welcome": {
          "title": "Willkommens-E-Mail für einen neuen Benutzer",
          "scenario": "Auslöser 'Benutzer erstellt' → E-Mail-Aktion an den betroffenen Benutzer, mit Betreff 'Willkommen, {tpl}'. Möchten Sie stattdessen HR informieren? Wählen Sie als Empfänger eine feste Adresse, z. B. hr@firma.de.",
          "result": "Jeder neue Benutzer erhält automatisch eine Willkommens-E-Mail, ohne dass ein Administrator etwas tun muss.",
          "flow": {
            "trigger": "Benutzer erstellt",
            "action": "E-Mail senden",
            "actionSub": "an den Benutzer"
          }
        },
        "approval": {
          "title": "Manager-Genehmigung bei Selbsteinschreibung",
          "scenario": "Auslöser 'Einschreibung angefragt' → Bedingung 'Self-Service' → Genehmigung durch den Teamlead der Unit des Benutzers (fällig nach 72 Stunden). Bei Genehmigung: Bestätigungs-E-Mail an den Benutzer. Bei Ablehnung: Ablehnungs-E-Mail. Bei Zeitüberschreitung: eine Erinnerung.",
          "result": "Selbsteinschreibungen gehen zuerst über den Teamlead, bevor sie endgültig werden — mit automatischer Nachverfolgung.",
          "flow": {
            "trigger": "Einschreibung angefragt",
            "condition": "Nur bei Selbsteinschreibung",
            "approval": "Genehmigung durch Teamlead",
            "approvalSub": "fällig nach 72 Stunden",
            "onApprove": "Bestätigungs-E-Mail",
            "onReject": "Ablehnungs-E-Mail",
            "onTimeout": "Erinnerung"
          }
        }
      }
    }
  },
  "platformWorkflows": {
    "heading": "Plattform-Workflows",
    "intro": "Globale Workflows, die in jeden Tenant geklont werden. Gesperrte Workflows können Tenant-Administratoren nicht ändern.",
    "new": "Neuer Plattform-Workflow",
    "empty": "Noch keine Plattform-Workflows.",
    "sync": "An Tenants synchronisieren",
    "syncStarted": "Synchronisierung gestartet — Änderungen werden im Hintergrund an alle Tenants verteilt.",
    "keyHint": "Stabiler, eindeutiger Schlüssel plattformweit (Kleinbuchstaben, Bindestriche).",
    "lockedField": "Sperren (Administratoren können ihn nicht ändern)",
    "lockedHint": "Ein gesperrter Workflow ist für Tenants schreibgeschützt; auch den Ein/Aus-Zustand steuert die Plattform.",
    "lockedYes": "Gesperrt",
    "lockedNo": "Offen",
    "cols": {
      "locked": "Zugriff"
    },
    "confirmDelete": "Plattform-Workflow löschen?",
    "confirmDeleteBody": "Dies entfernt \"{name}\" aus dem Plattform-Set. Bereits geklonte Tenant-Kopien bleiben bestehen.",
    "editorNotice": "Änderungen hier erreichen bestehende Tenants erst nach einer Synchronisierung; neue Tenants erhalten bei der Erstellung den aktuellen Stand.",
    "sync_status": {
      "col": "Rollout",
      "none": "Keine Tenants",
      "notRolledOut": "Nicht ausgerollt",
      "coverage": "{synced}/{total} Tenants",
      "inSync": "Aktuell",
      "outdated": "{count} veraltet",
      "outdatedHint": "Diese Tenants verwenden noch eine ältere Version — synchronisieren Sie, um sie zu aktualisieren.",
      "overridden": "{count} angepasst",
      "overriddenHint": "Diese Tenants haben den Workflow selbst angepasst; eine Synchronisierung lässt sie unberührt.",
      "syncOne": "Synchronisieren",
      "syncOneHint": "Nur diesen Workflow an alle Tenants synchronisieren"
    }
  },
  "approvals": {
    "heading": "Genehmigungen",
    "intro": "Offene Genehmigungen, die auf Ihre Entscheidung warten.",
    "empty": "Keine ausstehenden Genehmigungen.",
    "due": "Fällig",
    "approve": "Genehmigen",
    "reject": "Ablehnen",
    "unknownWorkflow": "Workflow",
    "rejectTitle": "Ablehnen?",
    "rejectBody": "Sie lehnen \"{name}\" ab.",
    "reason": "Grund (optional)",
    "count": "{count} zu erledigen",
    "nothingToDo": "Nichts zu erledigen.",
    "applicant": "Antragsteller",
    "noIndependentTitle": "Keine unabhängige prüfende Person: {name} hat dies selbst beantragt",
    "noIndependentBody": "Fügen Sie der Kette eine prüfende Person hinzu oder lassen Sie eine Verwaltungsperson mit dem Recht, Anträge zu verwalten, ihn bearbeiten.",
    "cannotDecideOwn": "Über Ihren eigenen Antrag entscheiden Sie nicht.",
    "course": "Kurs",
    "bulk": {
      "selectAll": "Alle auswählen",
      "selectRow": "\"{name}\" auswählen",
      "selectedCount": "{count} ausgewählt",
      "approveSelected": "Auswahl genehmigen",
      "rejectSelected": "Auswahl ablehnen",
      "confirmApproveTitle": "Auswahl genehmigen?",
      "confirmApproveBody": "Sie genehmigen {count} Anträge auf einmal. Die Antragsteller werden benachrichtigt.",
      "confirmRejectTitle": "Auswahl ablehnen?",
      "confirmRejectBody": "Sie lehnen {count} Anträge auf einmal ab. Der von Ihnen angegebene Grund gilt für alle abgelehnten Anträge.",
      "resultSummary": "{decided} von {requested} bearbeitet.",
      "outcome": {
        "already_handled": "{count} waren bereits bearbeitet.",
        "forbidden": "{count} waren nicht Ihnen zugewiesen.",
        "not_found": "{count} existierten nicht mehr."
      }
    },
    "kind": {
      "enrollment": "Anmeldungen",
      "cancellation": "Stornierungen",
      "external_request": "Externe Weiterbildung",
      "other": "Sonstige"
    }
  },
  "mailOutbox": {
    "title": "Postausgang",
    "empty": "Noch keine E-Mails gesendet.",
    "forwardTo": "An Benutzer weiterleiten",
    "forwardPlaceholder": "Wählen Sie einen oder mehrere Benutzer…",
    "filterStatus": "Nach Status filtern",
    "filterAll": "Alle Status",
    "retentionNotice": "Sie sehen hier die E-Mails der letzten {days} Tage.",
    "recipients_one": "{count} Empfänger",
    "recipients_other": "{count} Empfänger",
    "openedOf": "{opened} / {total}",
    "expand": "Empfänger anzeigen",
    "collapse": "Empfänger ausblenden",
    "batchMore": "Erste {shown} von {total} Empfängern — grenzen Sie mit der Suche oder dem Statusfilter ein.",
    "cols": {
      "status": "Status",
      "to": "Empfänger",
      "subject": "Betreff",
      "scheduled": "Geplant / gesendet",
      "opens": "Öffnungen"
    },
    "status": {
      "scheduled": "Geplant",
      "sending": "Wird gesendet",
      "sent": "Gesendet",
      "failed": "Fehlgeschlagen",
      "cancelled": "Storniert",
      "suppressed": "Nicht gesendet"
    },
    "actions": {
      "view": "Anzeigen",
      "cancel": "Stornieren",
      "resend": "Erneut senden",
      "forward": "Weiterleiten"
    },
    "detail": {
      "title": "E-Mail anzeigen",
      "recipient": "Empfänger",
      "body": "Inhalt",
      "attachments": "Anhänge",
      "noBody": "Für diese E-Mail wurde kein Inhalt gespeichert.",
      "error": "Fehlermeldung:",
      "attachmentNotAllowed": "Sie können diesen Anhang nicht öffnen. Nur der Absender oder ein Empfänger der Nachricht darf das."
    }
  },
  "mailTemplates": {
    "title": "E-Mail-Texte",
    "intro": "Passen Sie die Texte der System-E-Mails für Ihre Organisation an. Die Standardtexte werden von der Plattform verwaltet; Sie erfassen pro Sprache nur Ihre Abweichungen.",
    "searchPlaceholder": "Nach Name oder Kontext suchen…",
    "empty": "Keine E-Mail-Vorlagen gefunden.",
    "edit": "Bearbeiten",
    "notTranslated": "Diese Sprache wurde noch nicht übersetzt. Empfänger erhalten den Text in der Ausweichsprache — dieser wird unten angezeigt.",
    "badge": {
      "locked": "Gesperrt",
      "customized": "Angepasst",
      "global": "Standard"
    },
    "preview": {
      "title": "Vorschau",
      "subject": "Betreff",
      "error": "Die Vorschau konnte nicht erstellt werden."
    },
    "tags": {
      "intro": "Klicken Sie auf ein Tag, um es an der Cursorposition einzufügen.",
      "scope": {
        "context": "Kontext",
        "global": "Allgemein",
        "link": "Links"
      }
    },
    "editor": {
      "back": "Zurück zur Übersicht",
      "lockedNote": "Diese Vorlage ist von der Plattform gesperrt und kann nicht angepasst werden.",
      "footerHint": "Dieser Text erscheint als Fußzeile am Ende jeder E-Mail. Leer lassen, um keine Fußzeile anzuzeigen.",
      "lockedBody": "Der Inhalt wird in der Vorschau daneben angezeigt.",
      "subject": "Betreff",
      "preheader": "Preheader",
      "preheaderHint": "Kurze Zusammenfassung, die manche Mail-Clients neben dem Betreff anzeigen.",
      "body": "Inhalt",
      "save": "Speichern",
      "saved": "Gespeichert.",
      "saveErrorTitle": "Der Text enthält Fehler",
      "reset": "Auf Standard zurücksetzen",
      "resetLoaded": "Standardtext geladen — klicken Sie auf Speichern, um zu bestätigen.",
      "customized": "Für Ihre Organisation angepasst.",
      "testTitle": "Test-E-Mail senden",
      "testTo": "An E-Mail-Adresse",
      "testSend": "Test senden",
      "testOk": "Test-E-Mail gesendet."
    }
  },
  "centralMailTemplates": {
    "title": "Globale E-Mail-Texte",
    "intro": "Verwalten Sie die Standardtexte der System-E-Mails pro Sprache. Diese Texte erbt jeder Tenant; sperren Sie eine Vorlage, um die Anpassung pro Tenant zu blockieren.",
    "searchPlaceholder": "Nach Name oder Kontext suchen…",
    "empty": "Keine E-Mail-Vorlagen gefunden.",
    "badge": {
      "locked": "Gesperrt",
      "missing": "Unvollständig",
      "customized": "{count} angepasst"
    },
    "customizedTooltip": "Tenants mit eigenem Text:",
    "notTranslated": "Diese Sprache wurde noch nicht übersetzt. Empfänger erhalten den Text in der Ausweichsprache — klicken Sie auf Bearbeiten, um die Übersetzung hinzuzufügen.",
    "edit": "Bearbeiten",
    "editor": {
      "back": "Zurück zur Übersicht"
    },
    "locked": "Für Tenants gesperrt",
    "footerHint": "Dieser Text erscheint als Fußzeile am Ende jeder E-Mail. Leer lassen, um keine Fußzeile anzuzeigen.",
    "subject": "Betreff",
    "preheader": "Preheader",
    "body": "Inhalt",
    "save": "Speichern",
    "saved": "Gespeichert.",
    "reset": "Auf Standardtext zurücksetzen",
    "resetLoaded": "Standardtext geladen — klicken Sie auf Speichern, um zu bestätigen.",
    "saveErrorTitle": "Der Text enthält Fehler"
  },
  "centralMailOutbox": {
    "title": "Postausgang (alle Tenants)",
    "intro": "Schreibgeschützte Übersicht der über alle Tenants gesendeten E-Mails. Inhalte und Aktionen werden pro Tenant verwaltet.",
    "empty": "Keine E-Mails gefunden.",
    "filterStatus": "Status",
    "allStatuses": "Alle Status",
    "filterTenant": "Tenant",
    "allTenants": "Alle Tenants",
    "cols": {
      "tenant": "Tenant"
    }
  },
  "elearning": {
    "backToCatalog": "Zurück zum Katalog",
    "completion": {
      "completed": "abgeschlossen",
      "incomplete": "noch nicht abgeschlossen",
      "unknown": "noch nichts übermittelt"
    },
    "contentHostMissing": "Dieser Kurs kann noch nicht geöffnet werden: der Umgebung fehlt der Host, über den Kursinhalte ausgeliefert werden. Bitte melden Sie dies der Administration.",
    "loadError": "Dieser Kurs konnte nicht geladen werden.",
    "outdatedVersion": "Dieser Kurs wurde aktualisiert, nachdem Sie begonnen haben. Sie setzen in der Version fort, in der Sie gearbeitet haben, damit nichts verloren geht. Möchten Sie lieber neu in der neuesten Version beginnen?",
    "registered": "Erfasst: {status}",
    "saveProgress": "Fortschritt jetzt speichern",
    "score": "Ergebnis {score} %",
    "start": "Kurs starten",
    "startHint": "Der Kurs öffnet sich unten. Ihr Fortschritt wird zwischendurch gespeichert, Sie können also später dort weitermachen, wo Sie aufgehört haben.",
    "startNewestVersion": "In der neuesten Version neu beginnen",
    "starting": "Der Kurs wird geöffnet…",
    "anonymous": {
      "fallbackTitle": "E-Learning",
      "startHint": "Dieser Kurs ist frei zugänglich: Sie müssen sich nicht anmelden, um ihn zu absolvieren.",
      "notRecorded": "Ihr Fortschritt und Ihr Ergebnis werden nicht gespeichert. Wenn Ihr Abschluss zählen soll, melden Sie sich an und starten Sie den Kurs aus dem Katalog.",
      "unavailable": "Dieser Kurs ist nicht mehr frei zugänglich. Bitten Sie die Administration um einen neuen Link, oder melden Sie sich an."
    },
    "restartHint": "Sie beginnen diese Schulung wieder von vorne.",
    "backToLearningPath": "Zurück zu Ihrem Lernpfad",
    "superseded": {
      "title": "Sie beginnen neu"
    }
  },
  "myQuestionnaires": {
    "title": "Meine Fragebögen",
    "description": "Fragebögen, die für Sie offen sind. Sie können sie hier ausfüllen oder über den Link in Ihrer E-Mail: Es ist derselbe Fragebogen.",
    "loading": "Fragebögen werden geladen…",
    "loadError": "Ihre Fragebögen konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "emptyTitle": "Für Sie ist nichts offen",
    "emptyBody": "Wenn ein Fragebogen für Sie bereitsteht, sehen Sie ihn hier.",
    "untitled": "Fragebogen ohne Titel",
    "openUntil": "Offen bis {date}",
    "back": "Zurück zu meinen Fragebögen",
    "closedTitle": "Dieser Fragebogen ist nicht mehr offen",
    "closedBody": "Wenn Sie ihn bereits ausgefüllt haben, zum Beispiel über den Link in Ihrer E-Mail, wurden Ihre Antworten gespeichert.",
    "submittedBody": "Ihre Antworten wurden gesendet.",
    "testBadge": "Test",
    "state": {
      "awaiting_grading": "Wartet auf Korrektur",
      "graded": "Korrigiert"
    },
    "submittedOn": "Abgeschickt am {date}",
    "viewResult": "Ergebnis ansehen",
    "viewResultNamed": "Ergebnis für {title} ansehen",
    "resultHidden": "Das Ergebnis dieses Tests wird nicht angezeigt."
  },
  "myQualifications": {
    "title": "Meine Qualifikationen",
    "description": "Welche Qualifikationen Sie haben, bis wann sie gelten und worauf sie beruhen. Was abgelaufen ist oder nicht mehr gilt, steht im Verlauf.",
    "loading": "Qualifikationen werden geladen…",
    "loadError": "Ihre Qualifikationen konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "emptyTitle": "Sie haben noch keine Qualifikationen",
    "emptyBody": "Wenn Sie eine Schulung abschließen, die eine Qualifikation vergibt, sehen Sie sie hier.",
    "holds": "Gültig",
    "notHolding": "Derzeit nicht gültig",
    "notHoldingBody": "Derzeit ist keine Erfassung dieser Qualifikation gültig.",
    "validUntil": "Gültig bis {date}",
    "openEnded": "Gültig, ohne Enddatum",
    "expiresIn_one": "Läuft in {count} Tag ab",
    "expiresIn_other": "Läuft in {count} Tagen ab",
    "expiresToday": "Läuft heute ab",
    "renewalStopped": "Wird nicht verlängert",
    "groundsLabel": "Warum dies gilt",
    "groundWindowUntil": "bis {date}",
    "groundWindowOpen": "ohne Enddatum",
    "originCompletionNamed": "Abschluss von {title}",
    "origin": {
      "completion": "Abschluss einer Schulung",
      "external_training": "Externe Schulung",
      "self_declared": "Eigene Erklärung",
      "administrative": "Administrativ erfasst"
    },
    "evidence": {
      "trusted": "Automatisch erfasst",
      "verifiable": "Vorläufig vergeben, kann nachträglich korrigiert werden",
      "declaration": "Auf eigene Erklärung"
    },
    "history_one": "Verlauf ({count} frühere Erfassung)",
    "history_other": "Verlauf ({count} frühere Erfassungen)",
    "historyWindow": "{from} bis einschließlich {until}",
    "historyWindowOpen": "Ab {from}, ohne Enddatum",
    "endedOn": "Beendet am {date}",
    "status": {
      "valid": "Gültig",
      "not_yet_valid": "Noch nicht begonnen",
      "expired": "Abgelaufen",
      "ended_by_choice": "Beendet",
      "superseded": "Ersetzt",
      "corrected": "Korrigiert",
      "withdrawn": "Zurückgezogen",
      "never_valid": "Nie gültig gewesen"
    },
    "reason": {
      "superseded": "Durch eine neuere Erfassung ersetzt",
      "corrected": "Korrigiert: die Gültigkeit war falsch erfasst",
      "withdrawn_from_now": "Zurückgezogen: ab diesem Zeitpunkt gilt sie nicht mehr",
      "never_valid": "Zurückgezogen: Sie haben sie nie gehabt"
    }
  },
  "myExternalRequests": {
    "title": "Meine Anträge",
    "description": "Ihre Anträge für Weiterbildungen, die nicht im Katalog stehen, und ihr aktueller Stand.",
    "new": "Neuer Antrag",
    "newTitle": "Neuer Antrag auf externe Weiterbildung",
    "back": "Zurück zu Meine Anträge",
    "loading": "Anträge werden geladen…",
    "loadError": "Ihre Anträge konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "emptyTitle": "Noch keine Anträge",
    "emptyBody": "Möchten Sie eine Weiterbildung besuchen, die nicht im Katalog steht? Beantragen Sie sie hier.",
    "emptyBodyNoTypes": "Derzeit kann nichts beantragt werden.",
    "noTypesTitle": "Nichts zu beantragen",
    "notFoundTitle": "Antrag nicht gefunden",
    "notFoundBody": "Dieser Antrag existiert nicht oder gehört nicht Ihnen.",
    "untitled": "Antrag ohne Titel",
    "continue": "Weiter ausfüllen",
    "open": "Ansehen",
    "submittedOn": "eingereicht am {date}",
    "withdrawnOn": "zurückgezogen am {date}",
    "rejectedTitle": "Ihr Antrag wurde abgelehnt",
    "rejectedNoComment": "Es wurde keine Begründung angegeben.",
    "runningNotice": "Ihr Antrag wurde genehmigt. Die Weiterbildung ist auf Ihren Namen eingetragen.",
    "awaitingManagement": "In Bearbeitung – wartet auf eine Entscheidung der Verwaltung",
    "withdraw": "Antrag zurückziehen",
    "withdrawTitle": "Antrag zurückziehen?",
    "withdrawBody": "Über Ihren Antrag wurde noch nicht entschieden. Wenn Sie ihn zurückziehen, wird er nicht geprüft. Dies kann nicht rückgängig gemacht werden.",
    "discardTitle": "Entwurf verwerfen?",
    "discardBody": "Der Entwurf und alle Ihre Eingaben werden entfernt. Dies kann nicht rückgängig gemacht werden.",
    "cancel": "Abbrechen",
    "status": {
      "concept": "Entwurf",
      "submitted": "Eingereicht",
      "in_approval": "In Bearbeitung",
      "rejected": "Abgelehnt",
      "withdrawn": "Zurückgezogen",
      "running": "Läuft"
    },
    "reason": {
      "form_updated": "Das Formular wurde aktualisiert, seit Sie begonnen haben. Ihre Eingaben sind bei den Feldern, die geblieben sind, noch vorhanden; bitte prüfen Sie es und reichen Sie es erneut ein.",
      "request_not_concept": "Dieser Antrag wurde bereits eingereicht und kann nicht mehr geändert werden.",
      "request_not_withdrawable": "Dieser Antrag kann nicht mehr zurückgezogen werden.",
      "type_not_live": "Diese Antragsart ist nicht mehr geöffnet.",
      "unknown": "Das ist für diesen Antrag nicht mehr möglich.",
      "attachments_full": "Dieser Antrag hat bereits die höchste Anzahl an Anhängen."
    },
    "form": {
      "type": "Antragsart",
      "typePlaceholder": "Wählen Sie eine Art",
      "submit": "Einreichen",
      "save": "Als Entwurf speichern",
      "discard": "Entwurf verwerfen",
      "submitHint": "Nach dem Einreichen können Sie den Antrag nicht mehr ändern, aber zurückziehen, solange noch nicht entschieden wurde.",
      "otherProvider": "Ein anderer Anbieter",
      "providerChoice": "Anbieter",
      "providerPlaceholder": "Wählen Sie einen Anbieter",
      "providerName": "Name des Anbieters",
      "didYouMean": "Meinen Sie einen dieser Anbieter?",
      "teacherName": "Name der Lehrkraft oder des Coaches",
      "teacherNameHint": "Optional.",
      "firstDay": "Erster Tag",
      "lastDay": "Letzter Tag",
      "day": "Tag {number}",
      "removeDay": "Tag entfernen",
      "addDay": "Tag hinzufügen",
      "price": "{name}: Preis",
      "quantity": "{name}: Anzahl",
      "costHint": "Die Summe wird beim Einreichen berechnet.",
      "saved": "Ihr Entwurf wurde gespeichert.",
      "submitted": "Ihr Antrag wurde eingereicht. Sie erhalten eine Bestätigung per E-Mail.",
      "checkFields": "Nicht alles wurde korrekt ausgefüllt. Bitte prüfen Sie die markierten Felder.",
      "failed": "Das hat nicht geklappt. Bitte versuchen Sie es erneut."
    },
    "detail": {
      "heading": "Was Sie beantragt haben",
      "provider": "Anbieter",
      "period": "Zeitraum",
      "costs": "Kosten",
      "costLine": "Kostenposten",
      "excl": "Ohne MwSt.",
      "incl": "Inkl. MwSt.",
      "total": "Summe",
      "vatUnknown": "unbekannt",
      "empty": "–",
      "yes": "Ja",
      "no": "Nein"
    },
    "tiles": {
      "heading": "Nicht das Richtige dabei?",
      "body": "Beantragen Sie eine Weiterbildung, die nicht im Katalog steht."
    },
    "attachments": {
      "heading": "Anhänge",
      "none": "Keine Anhänge.",
      "hint": "Zum Beispiel ein Angebot oder ein Programm. PDF, JPG oder PNG, höchstens {max} Dateien.",
      "full": "Dieser Antrag hat die höchste Anzahl an Anhängen ({max}). Entfernen Sie einen, um einen anderen hinzuzufügen.",
      "remove": "Entfernen",
      "removeNamed": "Anhang {name} entfernen",
      "failed": "Der Anhang konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.",
      "unnamed": "Anhang",
      "saveFirst": "Anhänge können Sie hinzufügen, nachdem Sie den Antrag als Entwurf gespeichert haben."
    }
  },
  "questionnaireInvite": {
    "loading": "Der Fragebogen wird geöffnet …",
    "loadError": "Der Fragebogen konnte nicht geöffnet werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "retry": "Erneut versuchen",
    "closedTitle": "Dieser Link funktioniert nicht mehr",
    "closedBody": "Wenn Sie den Fragebogen bereits ausgefüllt haben, wurde Ihre Antwort gespeichert.",
    "empty": "Dieser Fragebogen enthält keine Fragen, es gibt also nichts auszufüllen.",
    "language": "Sprache",
    "subject": "Dieser Fragebogen bezieht sich auf {title}.",
    "subjectWithDates": "Dieser Fragebogen bezieht sich auf {title} ({dates}).",
    "anonymous": "Ihr Name wird nicht zusammen mit Ihren Antworten angezeigt.",
    "requiredNote": "Fragen mit * sind Pflichtfragen.",
    "yes": "Ja",
    "no": "Nein",
    "other": "Sonstiges, und zwar",
    "charsBetween": "Verwenden Sie mindestens {min} und höchstens {max} Zeichen.",
    "charsMin": "Verwenden Sie mindestens {min} Zeichen.",
    "charsMax": "Verwenden Sie höchstens {max} Zeichen.",
    "choicesBetween": "Wählen Sie mindestens {min} und höchstens {max}.",
    "choicesMin": "Wählen Sie mindestens {min}.",
    "choicesMax": "Wählen Sie höchstens {max}.",
    "star": "{value} von {max} Sternen",
    "starLabelled": "{value} von {max} Sternen: {label}",
    "remarks": "Anmerkungen",
    "remarksHint": "Möchten Sie noch etwas mitteilen, das nicht in die Fragen passt? Das können Sie hier tun.",
    "submit": "Absenden",
    "submitFailed": "Das Absenden hat nicht geklappt. Ihre Antworten sind noch da; bitte versuchen Sie es erneut.",
    "fixErrors": "Noch ist nicht alles richtig ausgefüllt. Bitte sehen Sie sich die markierten Fragen an.",
    "submittedTitle": "Vielen Dank fürs Ausfüllen",
    "submittedBody": "Ihre Antworten wurden gesendet. Sie können dieses Fenster jetzt schließen."
  },
  "questionnaireAssignments": {
    "open": "Fragebögen",
    "openFor": "Fragebögen für {training}",
    "heading": "Regeln für Fragebögen zu {training}",
    "heading_test": "Regeln für Tests zu {training}",
    "headingGeneric": "Regeln für Fragebögen zu diesem Training",
    "headingGeneric_test": "Regeln für Tests zu diesem Training",
    "add": "Regel hinzufügen",
    "add_test": "Test hinzufügen",
    "intro": "Eine Regel steht fest: Dieser Fragebogen geht zu diesem Zeitpunkt an alle, die die Bedingungen erfüllen. Ein Training kann mehrere Regeln haben, auch mit demselben Fragebogen — zum Beispiel zur Halbzeit und am Ende.",
    "intro_test": "Eine Regel steht fest: Dieser Test geht zu diesem Zeitpunkt an alle, die die Bedingungen erfüllen. Ein Training kann mehrere Regeln haben, auch mit demselben Test — zum Beispiel zur Halbzeit und am Ende.",
    "notFound": "Dieses Training existiert nicht (mehr).",
    "loadError": "Die Regeln für dieses Training konnten nicht geladen werden.",
    "loadError_test": "Die Testregeln zu diesem Training konnten nicht geladen werden.",
    "empty": "Für dieses Training gibt es noch keine Regel für einen Fragebogen.",
    "empty_test": "Für dieses Training gibt es noch keinen Test.",
    "showArchived_one": "Archivierte Regel anzeigen ({count})",
    "showArchived_test_one": "Archivierte Testregel anzeigen ({count})",
    "showArchived_other": "Archivierte Regeln anzeigen ({count})",
    "showArchived_test_other": "Archivierte Testregeln anzeigen ({count})",
    "onlyArchived": "Alle Regeln dieses Trainings sind archiviert.",
    "onlyArchived_test": "Alle Testregeln dieses Trainings sind archiviert.",
    "unknownForm": "Fragebogen ohne Namen",
    "unknownForm_test": "Test ohne Namen",
    "panel": {
      "title": "Regeln für Fragebögen",
      "title_test": "Tests",
      "empty": "Für diese Schulung gibt es noch keine Regeln für Fragebögen.",
      "add": "Regel hinzufügen",
      "mandatory": "Verpflichtend: {answer}"
    },
    "name": "{form} — {moment}; {conditions}",
    "anonymous": "Anonym",
    "actionFailed": "Das hat nicht geklappt. Bitte versuchen Sie es erneut.",
    "table": {
      "caption": "Regeln dieses Trainings",
      "caption_test": "Testregeln dieses Trainings",
      "form": "Fragebogen",
      "form_test": "Test",
      "moment": "Zeitpunkt",
      "conditions": "Bedingungen",
      "status": "Status",
      "invitations": "Einladungen",
      "actions": "Aktionen",
      "invitationCount_one": "{count} Einladung",
      "invitationCount_other": "{count} Einladungen",
      "invitationsNamed_one": "{count} Einladung zu {name}: Stand ansehen",
      "invitationsNamed_other": "{count} Einladungen zu {name}: Stand ansehen"
    },
    "status": {
      "active": "Läuft",
      "paused": "Pausiert",
      "archived": "Archiviert"
    },
    "actions": {
      "edit": "Ändern",
      "editNamed": "{name} ändern",
      "pause": "Pausieren",
      "pauseNamed": "{name} pausieren",
      "resume": "Fortsetzen…",
      "resumeNamed": "{name} fortsetzen",
      "archive": "Archivieren",
      "archiveNamed": "{name} archivieren",
      "delete": "Löschen",
      "deleteNamed": "{name} löschen"
    },
    "pause": {
      "title": "Regel pausieren",
      "title_test": "Testregel pausieren",
      "body": "Eine pausierte Regel versendet nichts. Einladungen entstehen trotzdem und liegen bereit; beim Fortsetzen wählen Sie, ob sie doch noch versendet werden. Bereits versendete Links funktionieren weiter.",
      "body_test": "Eine pausierte Regel versendet nichts. Einladungen entstehen trotzdem und liegen bereit; beim Fortsetzen wählen Sie, ob sie doch noch versendet werden.",
      "confirm": "Pausieren",
      "done": "Die Regel ist pausiert.",
      "done_test": "Die Testregel wurde pausiert."
    },
    "archive": {
      "title": "Regel archivieren",
      "title_test": "Testregel archivieren",
      "body": "Archivieren beendet diese Regel endgültig. Noch nicht versendete Einladungen verfallen. Bereits versendete Links funktionieren weiter, bis sie ablaufen.",
      "body_test": "Das Archivieren beendet diese Regel endgültig. Einladungen, die noch nicht versendet wurden, verfallen.",
      "confirm": "Archivieren",
      "done": "Die Regel ist archiviert.",
      "done_test": "Die Testregel wurde archiviert."
    },
    "delete": {
      "title": "Regel löschen",
      "title_test": "Testregel löschen",
      "body": "Aus dieser Regel wurde noch nichts versendet, daher kann sie gelöscht werden.",
      "bodyWithInvitations_one": "Aus dieser Regel wurde noch nichts versendet, daher kann sie gelöscht werden. Die {count} bereitliegende Einladung wird mitgelöscht; niemand hat sie gesehen.",
      "bodyWithInvitations_other": "Aus dieser Regel wurde noch nichts versendet, daher kann sie gelöscht werden. Die {count} bereitliegenden Einladungen werden mitgelöscht; niemand hat sie gesehen.",
      "confirm": "Löschen",
      "done": "Die Regel ist gelöscht.",
      "done_test": "Die Testregel wurde gelöscht."
    },
    "resume": {
      "title": "Regel fortsetzen",
      "title_test": "Testregel fortsetzen",
      "confirm": "Fortsetzen",
      "loadError": "Was bereitliegt, konnte nicht geladen werden.",
      "nothingHeld": "Es liegt nichts bereit. Fortsetzen schaltet die Regel wieder ein; wer danach abschließt, erhält den Fragebogen in seiner dann aktuellen Fassung.",
      "nothingHeld_test": "Es liegt nichts bereit. Fortsetzen schaltet die Regel wieder ein; wer danach abschließt, erhält den Test in seiner dann aktuellen Fassung.",
      "done": "Die Regel läuft wieder. Aufgegriffen: {refrozen}, verfallen: {withdrawn}.",
      "done_test": "Die Testregel läuft wieder. Aufgenommen: {refrozen}, verfallen: {withdrawn}."
    },
    "duplicate": {
      "existing": "Das ist die bestehende Regel: {name}.",
      "existing_test": "Dies ist die bestehende Testregel: {name}.",
      "existingUnknown": "Die bestehende Regel steht nicht in dieser Liste. Laden Sie die Seite neu, um sie zu sehen.",
      "existingUnknown_test": "Die bestehende Testregel steht nicht in dieser Liste. Laden Sie die Seite neu, um sie zu sehen.",
      "marker": "Existiert bereits mit demselben Zeitpunkt und denselben Bedingungen",
      "toList": "Bestehende Regel in der Liste anzeigen",
      "toList_test": "Bestehende Testregel in der Liste anzeigen"
    },
    "errors": {
      "wholeNumber": "Geben Sie eine ganze Zahl ein, 0 oder größer."
    },
    "saved": {
      "created": "Die Regel ist hinzugefügt.",
      "created_test": "Die Testregel wurde hinzugefügt.",
      "updated": "Die Regel ist gespeichert.",
      "updated_test": "Die Testregel wurde gespeichert.",
      "replaced": "Die neue Regel ist angelegt und die alte archiviert.",
      "replaced_test": "Die neue Testregel ist angelegt und die alte archiviert.",
      "replacedArchiveFailed": "Die neue Regel ist angelegt, aber die alte konnte nicht archiviert werden. Archivieren Sie sie selbst, sonst laufen beide.",
      "replacedArchiveFailed_test": "Die neue Testregel wurde angelegt, die alte konnte jedoch nicht archiviert werden. Archivieren Sie sie selbst, sonst laufen beide weiter."
    },
    "editor": {
      "newTitle": "Regel hinzufügen",
      "newTitle_test": "Test hinzufügen",
      "editTitle": "Regel ändern",
      "editTitle_test": "Testregel ändern",
      "replaceTitle": "Neue Regel anstelle dieser",
      "replaceTitle_test": "Neue Testregel anstelle dieser",
      "replaceConfirm": "Anlegen und die alte archivieren",
      "backToList": "Zurück zu den Regeln des Trainings",
      "backToList_test": "Zurück zu den Tests des Trainings",
      "asideTitle": "Was das bedeutet",
      "nothingSkipped": "Bei diesem Zeitpunkt wird nichts übersprungen.",
      "notFound": "Diese Regel gibt es bei diesem Training nicht (mehr).",
      "notFound_test": "Diese Testregel gibt es bei diesem Training nicht (mehr).",
      "archived": "Diese Regel ist archiviert und kann nicht mehr geändert werden. Legen Sie eine neue an, wenn Sie etwas ändern möchten.",
      "archived_test": "Diese Testregel ist archiviert und kann nicht mehr geändert werden. Legen Sie eine neue an, wenn Sie etwas ändern möchten.",
      "fromNow": "Eine Änderung gilt für Einladungen, die ab jetzt entstehen.",
      "locked_one": "Aus dieser Regel ist bereits {count} Einladung entstanden. Fragebogen, Rolle, Zeitpunkt und Bedingungen liegen daher fest. Die Antwortfrist, die Einleitung, die Erinnerung und das Einschalten der Anonymität können Sie noch ändern.",
      "locked_test_one": "Aus dieser Regel ist bereits {count} Einladung entstanden. Test, Rolle, Zeitpunkt und Bedingungen liegen daher fest. Die Antwortfrist, die Einleitung, den Korrektor und das Ergebnis für den Teilnehmer können Sie noch ändern.",
      "locked_other": "Aus dieser Regel sind bereits {count} Einladungen entstanden. Fragebogen, Rolle, Zeitpunkt und Bedingungen liegen daher fest. Die Antwortfrist, die Einleitung, die Erinnerung und das Einschalten der Anonymität können Sie noch ändern.",
      "locked_test_other": "Aus dieser Regel sind bereits {count} Einladungen entstanden. Test, Rolle, Zeitpunkt und Bedingungen liegen daher fest. Die Antwortfrist, die Einleitung, den Korrektor und das Ergebnis für den Teilnehmer können Sie noch ändern.",
      "replace": "Neu anlegen und diese archivieren",
      "replacing": "Sie legen eine neue Regel auf Grundlage von {name} an. Nach dem Speichern wird diese archiviert: Was dort noch bereitliegt, verfällt; bereits versendete Links funktionieren weiter.",
      "replacing_test": "Sie legen eine neue Testregel auf Grundlage von {name} an. Nach dem Speichern wird diese archiviert: Was dort noch bereitliegt, verfällt."
    },
    "field": {
      "form": "Fragebogen",
      "form_test": "Test",
      "formPlaceholder": "Wählen Sie einen veröffentlichten Fragebogen",
      "formPlaceholder_test": "Wählen Sie einen veröffentlichten Test",
      "noForms": "Es gibt noch keinen veröffentlichten Fragebogen.",
      "noForms_test": "Es gibt noch keinen veröffentlichten Test.",
      "formsError": "Die Fragebögen zur Auswahl konnten nicht geladen werden.",
      "formsError_test": "Die zur Auswahl stehenden Tests konnten nicht geladen werden.",
      "toForms": "Zu den Fragebögen",
      "toForms_test": "Zu den Tests",
      "role": "Wer füllt ihn aus?",
      "moment": "Wann wird er versendet?",
      "conditions": "Bedingungen",
      "attendance": "Mindestanwesenheit (%)",
      "attendanceHint": "Leer: keine Bedingung.",
      "attendanceHelp": "Der Anteil der Termine, an denen jemand teilgenommen hat. Termine, für die jemand entschuldigt ist, zählen nicht mit.",
      "attendanceBeforeEnd": "Nicht möglich bei einem Zeitpunkt vor dem Ende des Termins: Dann ist die Anwesenheit noch nicht bekannt.",
      "outcome": "Ergebnis",
      "outcomeAfterFinalise": "Bestanden oder nicht bestanden ist nur beim Zeitpunkt nach dem Abschluss möglich: Vorher gibt es noch kein Ergebnis.",
      "sending": "Versand",
      "mailIntro": "Eigene Einleitung in der Einladung",
      "mailIntroHint": "Leer: der Standardtext der Einladung.",
      "anonymous": "Anonym: keine Namen bei den Antworten anzeigen",
      "anonymousHint": "Sie sehen dann je Status, wie viele Einladungen es gibt, aber nicht, von wem.",
      "anonymousLocked": "Kann nicht mehr ausgeschaltet werden: Es gibt bereits Einladungen mit diesem Versprechen.",
      "anonymousWarning": "Achtung: Antworten werden nur gemeinsam angezeigt, und erst, sobald mindestens {floor} Personen über alle Durchführungen dieses Trainings hinweg geantwortet haben. Bei kleinen Gruppen kann das mehrere Durchführungen dauern.",
      "delayAmount": "Wie viel später",
      "delayHint": "0 ist direkt beim Abschluss.",
      "delayUnit": "Einheit",
      "session": "Welcher Termin",
      "sessionHint": "Nach Datum und Beginn; Termine ohne Datum zählen nicht mit.",
      "sessionNumber": "Nummer des Termins",
      "offsetAmount": "Wie viel",
      "offsetHint": "0 ist beim Ende des Termins.",
      "offsetUnit": "Einheit",
      "offsetDirection": "Bezogen auf das Ende",
      "afterLastDays": "Anzahl Tage nach dem letzten Termin",
      "afterLastDaysHint": "0 ist beim Ende.",
      "afterLastDaysHelp": "In Kalendertagen, ab dem Ende des letzten Termins.",
      "fixedAt": "Datum und Uhrzeit",
      "fixedAtHint": "In Ihrer eigenen Zeit. Ein Zeitpunkt, der bereits vorbei ist, ist nicht möglich.",
      "mandatory": "Verpflichtend für das Bestehen",
      "mandatoryHint": "Die Schulung gilt erst als bestanden, wenn dieser Fragebogen ausgefüllt ist. Er wird nach der Anmeldung unter Meine Fragebögen ausgefüllt, ohne Link, und läuft nicht ab.",
      "delivery": "Wie wird der Test abgenommen?",
      "deliveryDigital": "Digital",
      "deliveryDigitalHint": "Die teilnehmende Person macht den Test in der App; die Lehrkraft korrigiert ihn.",
      "deliveryExternal": "Extern",
      "deliveryExternalHint": "Der Test wird außerhalb des Systems abgenommen und korrigiert. Hier halten Sie nur das Ergebnis fest, je Person im Anwesenheitsraster. Es wird keine Einladung versendet.",
      "deliveryExternalGrading": "Sie halten das Ergebnis im Anwesenheitsraster fest, beim Abschluss der Durchführung.",
      "externalTestTitle": "Externer Test",
      "mandatory_test": "Zählt für das Bestehen",
      "mandatoryHint_test": "Die Schulung ist erst bestanden, wenn der Test abgegeben, korrigiert und bestanden ist. Eine an die Schulung geknüpfte Qualifikation wird erst dann vergeben — nicht durch die Anwesenheit. Ein nicht bestandener Test lässt die Teilnehmenden auf „nicht bestanden“, bis die Lehrkraft anders entscheidet.",
      "mandatoryNeedsMoment": "Nur mit einem Zeitpunkt vor dem Abschluss möglich: Ein Fragebogen nach dem Abschluss kann einen bereits erfolgten Abschluss nicht mehr zurückhalten.",
      "mandatoryNotEach": "Nicht bei jedem Termin möglich: Dann wäre unklar, welche Einladung das Bestehen zurückhält.",
      "mandatoryNoAttendance": "Nicht mit einer Anwesenheitsbedingung kombinierbar: Wer sie nicht erfüllt, erhält den Fragebogen nie und kann dann nicht mehr bestehen.",
      "attendanceMandatory": "Bei einem verpflichtenden Fragebogen nicht möglich: Wer die Bedingung nicht erfüllt, könnte dann nie mehr bestehen.",
      "reminderMandatory": "Ein verpflichtender Fragebogen schließt nicht an einem Datum, eine Erinnerung vorab hat daher keinen Zeitpunkt. Erinnern Sie über die Übersicht der Regel.",
      "grading": "Korrigieren",
      "grader": "Korrektor",
      "graderPlaceholder": "Korrektor wählen (optional)",
      "graderHint": "Leer: Die Dozenten der Durchführung korrigieren.",
      "showAnswers": "Antworten dem Teilnehmer anzeigen",
      "showAnswersHint": "Ein: Nach der Korrektur sieht der Teilnehmer auch die Fragen mit seinen Antworten und die Kommentare zu den Antworten. Aus: Er sieht nur das Ergebnis, die Punktzahl und den allgemeinen Kommentar. Diese sieht er immer."
    },
    "role": {
      "participant": "Teilnehmende",
      "teacher": "Lehrkraft",
      "manager": "Führungskraft",
      "later": "Kommt später: Lehrkräfte und Führungskräfte füllen angemeldet aus."
    },
    "moment": {
      "after_finalise": "Nach dem Abschluss",
      "after_finaliseHint": "Beim Erfassen des Abschlusses, sofort oder später.",
      "at_session": "Bei einem Termin",
      "at_sessionHint": "Rund um das Ende eines Termins — zum Beispiel zur Halbzeit des Trainings.",
      "after_last_session": "Nach dem letzten Termin",
      "after_last_sessionHint": "Einige Tage nach dem Ende des letzten Termins, unabhängig vom Abschluss.",
      "fixed_datetime": "An einem festen Datum",
      "fixed_datetimeHint": "Ein Zeitpunkt für alle, die dann angemeldet oder abgeschlossen sind."
    },
    "outcome": {
      "any": "Egal",
      "passed": "Nur wer bestanden hat",
      "not_passed": "Nur wer nicht bestanden hat"
    },
    "unit": {
      "minutes": "Minuten",
      "hours": "Stunden",
      "days": "Tage"
    },
    "selector": {
      "number": "Termin Nummer…",
      "last": "Der letzte",
      "each": "Jeder Termin"
    },
    "direction": {
      "after": "nach dem Ende",
      "before": "vor dem Ende"
    },
    "skipped": {
      "counting": "Es wird gezählt, was bereits vorbei ist…",
      "failed": "Es konnte nicht gezählt werden, wie viele Zeitpunkte bereits vorbei sind.",
      "nothingPlanned": "Im Plan steht noch kein Termin mit Datum, auf den dieser Zeitpunkt fällt.",
      "sessionsNone_one": "{count} Termin geplant, noch in der Zukunft.",
      "sessionsNone_other": "{count} Termine geplant, alle noch in der Zukunft.",
      "occurrencesNone_one": "{count} Durchführung geplant; dort liegt dieser Zeitpunkt noch in der Zukunft.",
      "occurrencesNone_other": "{count} Durchführungen geplant; bei allen liegt dieser Zeitpunkt noch in der Zukunft.",
      "sessions_one": "{past} von {count} Termin ist bereits vorbei; dafür wird nichts versendet.",
      "sessions_other": "{past} von {count} Terminen sind bereits vorbei; dafür wird nichts versendet.",
      "occurrences_one": "Bei {past} von {count} Durchführung ist dieser Zeitpunkt bereits vorbei; dort wird nichts versendet.",
      "occurrences_other": "Bei {past} von {count} Durchführungen ist dieser Zeitpunkt bereits vorbei; dort wird nichts versendet.",
      "rule": "Eine Regel versendet nur zu Zeitpunkten, die noch kommen, gerechnet ab dem Speichern."
    },
    "duration": {
      "minutes_one": "{count} Minute",
      "minutes_other": "{count} Minuten",
      "hours_one": "{count} Stunde",
      "hours_other": "{count} Stunden",
      "days_one": "{count} Tag",
      "days_other": "{count} Tage"
    },
    "summary": {
      "afterFinaliseNow": "Direkt nach dem Abschluss",
      "afterFinaliseLater": "{delay} nach dem Abschluss",
      "sessionNumber": "von Termin {number}",
      "session_last": "des letzten Termins",
      "session_each": "jedes Termins",
      "atSessionEnd": "Am Ende {session}",
      "beforeSessionEnd": "{offset} vor dem Ende {session}",
      "afterSessionEnd": "{offset} nach dem Ende {session}",
      "afterLastSessionSameDay": "Am Ende des letzten Termins",
      "afterLastSession": "{days} nach dem letzten Termin",
      "fixed": "Am {date}",
      "noMoment": "Ohne Zeitpunkt",
      "attendance": "mindestens {percent} % anwesend",
      "passed": "nur bestanden",
      "notPassed": "nur nicht bestanden",
      "noConditions": "keine Bedingungen",
      "mandatory": "verpflichtend für das Bestehen"
    }
  },
  "questionnaireOverview": {
    "intro": "Alle Evaluationsregeln für Fragebögen an einem Ort: die Regeln eines Trainings und die eigenständigen Fragebögen. Ohne Auswahl sehen Sie die laufenden und pausierten Evaluationsregeln; wählen Sie unter Status die Option Alle, um auch die archivierten anzuzeigen.",
    "intro_test": "Alle Testregeln an einem Ort: die Regeln eines Trainings. Ohne Auswahl sehen Sie die laufenden und pausierten Testregeln; wählen Sie unter Status die Option Alle, um auch die archivierten anzuzeigen.",
    "empty": "Es gibt noch keine Evaluationsregeln.",
    "empty_test": "Es gibt noch keine Testregeln.",
    "noMatch": "Keine Evaluationsregeln entsprechen diesen Filtern.",
    "noMatch_test": "Keine Testregeln, die zu diesen Filtern passen.",
    "loadError": "Die Evaluationsregeln konnten nicht geladen werden.",
    "loadError_test": "Die Testregeln konnten nicht geladen werden.",
    "unknownForm": "Fragebogen ohne Namen",
    "unknownForm_test": "Test ohne Namen",
    "unknownTraining": "Unbekanntes Training",
    "anonymous": "Anonym",
    "survey": "Eigenständiger Fragebogen",
    "name": "{form} — {target}",
    "cols": {
      "form": "Fragebogen",
      "form_test": "Test",
      "target": "Training oder Zielgruppe",
      "moment": "Zeitpunkt",
      "status": "Status",
      "mandatory": "Verpflichtend",
      "sent": "Versendet",
      "submitted": "Ausgefüllt",
      "open": "Offen",
      "actions": "Aktionen"
    },
    "filters": {
      "status": "Status",
      "statusDefault": "Laufend und pausiert",
      "statusAll": "Alle",
      "kind": "Art",
      "kindTraining": "Zu einem Training",
      "kindSurvey": "Eigenständiger Fragebogen",
      "form": "Fragebogen",
      "form_test": "Test",
      "training": "Training",
      "all": "Alle"
    },
    "actions": {
      "status": "Status ansehen",
      "statusNamed": "Status von {name} ansehen",
      "training": "Training",
      "trainingNamed": "Die Regeln des Trainings zu {name} öffnen",
      "edit": "Bearbeiten",
      "editNamed": "{name} bearbeiten"
    }
  },
  "questionnaireWindow": {
    "field": {
      "window": "Antwortfrist in Tagen",
      "windowHint": "Wie lange der Link nach dem Versand geöffnet bleibt. Standard {days} Tage, nie länger als {ceiling} Tage. 0 bedeutet: so lange wie zulässig.",
      "windowZero": "Keine feste Frist: Der Link bleibt so lange wie zulässig geöffnet, höchstens {ceiling} Tage (bei Versand {from}: bis {date}).",
      "windowCapped": "Das ist länger als das Maximum: Der Link schließt nach {ceiling} Tagen (bei Versand {from}: am {date}).",
      "reminder": "Erinnerung vor dem Schließen, in Tagen",
      "reminderHint": "So viele Tage vor dem Schließen des Links erhält die Person eine Erinnerung mit einem neuen Link; der erste Link funktioniert weiter. Leer: keine Erinnerung.",
      "reminderAt_one": "Erinnerung {count} Tag vor dem Schließen, am {date} (bei Versand {from}).",
      "reminderAt_other": "Erinnerung {count} Tage vor dem Schließen, am {date} (bei Versand {from}).",
      "reminderOutside_one": "Eine Erinnerung {count} Tag vor dem Schließen liegt nicht innerhalb der Antwortfrist von {window} Tagen. Wählen Sie weniger Tage.",
      "reminderOutside_other": "Eine Erinnerung {count} Tage vor dem Schließen liegt nicht innerhalb der Antwortfrist von {window} Tagen. Wählen Sie weniger Tage.",
      "today": "heute",
      "onDate": "am {date}",
      "afterSend": "Erinnerung {number} nach dem Versand, in Tagen",
      "afterSendHint_one": "So viele Tage nach dem Versand erhält die Person eine Erinnerung mit einem neuen Link; der erste Link funktioniert weiter. Höchstens {max}, aufsteigend. Die erste ist frühestens nach {count} Tag möglich.",
      "afterSendHint_other": "So viele Tage nach dem Versand erhält die Person eine Erinnerung mit einem neuen Link; der erste Link funktioniert weiter. Höchstens {max}, aufsteigend. Die erste ist frühestens nach {count} Tagen möglich.",
      "afterSendAdd": "Erinnerung nach dem Versand hinzufügen",
      "afterSendRemove": "Erinnerung {number} nach dem Versand entfernen",
      "afterSendRemoveLabel": "Entfernen"
    }
  },
  "questionnaireSurveyRecipients": {
    "back": "Zurück zu den eigenständigen Fragebögen",
    "heading": "Empfänger",
    "note": "Dies ist die Zielgruppe, wie sie jetzt aussieht. Die endgültige Liste wird im Moment des Versands bestimmt, zum eingestellten Versanddatum.",
    "notFound": "Dieser eigenständige Fragebogen existiert nicht (mehr).",
    "loadError": "Die Empfänger konnten nicht geladen werden.",
    "empty": "Die Zielgruppe enthält noch nichts, was angezeigt werden könnte.",
    "total_one": "{count} Empfänger insgesamt",
    "total_other": "{count} Empfänger insgesamt",
    "duplicates_one": "{count} Person gehört zu mehr als einem Teil und wird einmal gezählt.",
    "duplicates_other": "{count} Personen gehören zu mehr als einem Teil und werden einmal gezählt.",
    "countsOnly": "Sie sehen nur Anzahlen: Namen und E-Mail-Adressen sind für Personen, die Benutzer ansehen dürfen.",
    "treeLabel": "Teile der Zielgruppe",
    "subUnitsLabel": "Einheiten unter {name}",
    "count_one": "{count} Person",
    "count_other": "{count} Personen",
    "directly": "Direkt in {name}: {count}",
    "expandNamed": "{name} aufklappen",
    "collapseNamed": "{name} zuklappen",
    "branch": {
      "everyone": "Alle (alle aktiven Benutzer)",
      "individuals": "Ausgewählte Personen"
    },
    "people": {
      "name": "Name",
      "email": "E-Mail-Adresse",
      "empty": "Hier ist jetzt niemand mehr.",
      "forbidden": "Sie dürfen die Namen nicht sehen: dafür ist das Recht erforderlich, Benutzer anzusehen.",
      "loadError": "Die Personen in {name} konnten nicht geladen werden."
    }
  },
  "questionnaireSurveys": {
    "intro": "Ein eigenständiger Fragebogen hängt nicht an einem Training: Sie senden einen veröffentlichten Fragebogen an eine Zielgruppe, jetzt oder zu einem festen Datum. Wer dazugehört, wird im Moment des Versands gezählt.",
    "new": "Neuer eigenständiger Fragebogen",
    "loadError": "Die eigenständigen Fragebögen konnten nicht geladen werden.",
    "empty": "Es gibt noch keine eigenständigen Fragebögen.",
    "onlyArchived": "Es gibt nur archivierte eigenständige Fragebögen.",
    "showArchived_one": "Archivierten Fragebogen anzeigen ({count})",
    "showArchived_other": "Archivierte Fragebögen anzeigen ({count})",
    "unknownForm": "Unbekannter Fragebogen",
    "anonymous": {
      "chooseAudience": "Ob Anonymität möglich ist, hängt von der Größe der Zielgruppe ab. Wählen Sie zuerst eine Zielgruppe.",
      "unknown": "Ob Anonymität möglich ist, lässt sich erst sagen, wenn die Zielgruppe gezählt ist.",
      "unavailable_one": "Anonymität ist nicht möglich: Diese Zielgruppe zählt {count} Person, weniger als die Untergrenze von {floor}. So verspricht der Fragebogen nichts, was er nicht halten kann.",
      "unavailable_other": "Anonymität ist nicht möglich: Diese Zielgruppe zählt {count} Personen, weniger als die Untergrenze von {floor}. So verspricht der Fragebogen nichts, was er nicht halten kann.",
      "willDrop": "Dieser Fragebogen war auf anonym gestellt; beim Speichern entfällt das."
    },
    "name": "{form}, {date}",
    "actionFailed": "Das hat nicht geklappt. Bitte versuchen Sie es erneut.",
    "sentTo_one": "an {count} Person",
    "sentTo_other": "an {count} Personen",
    "heldReason_one": "Nicht versendet: Anonymität war zugesagt, aber beim Versand zählte die Zielgruppe {count} Person, weniger als die Untergrenze. Bearbeiten Sie ihn, um ihn erneut einzuplanen.",
    "heldReason_other": "Nicht versendet: Anonymität war zugesagt, aber beim Versand zählte die Zielgruppe {count} Personen, weniger als die Untergrenze. Bearbeiten Sie ihn, um ihn erneut einzuplanen.",
    "state": {
      "scheduled": "Geplant",
      "sent": "Versendet",
      "held": "Zurückgehalten",
      "archived": "Archiviert"
    },
    "table": {
      "caption": "Eigenständige Fragebögen mit Zielgruppe, Zeitpunkt und Stand",
      "form": "Fragebogen",
      "audience": "Zielgruppe",
      "moment": "Zeitpunkt",
      "state": "Stand",
      "invitations": "Einladungen",
      "actions": "Aktionen",
      "invitationCount_one": "{count} Einladung",
      "invitationCount_other": "{count} Einladungen",
      "invitationsNamed_one": "{count} Einladung zu {name}: Stand ansehen",
      "invitationsNamed_other": "{count} Einladungen zu {name}: Stand ansehen",
      "recipientsNow": "Empfänger (jetzt {count})",
      "recipientsNamed": "Empfänger von {name}: jetzt {count}, ansehen, wer das ist"
    },
    "actions": {
      "edit": "Bearbeiten",
      "editNamed": "{name} bearbeiten",
      "archive": "Archivieren",
      "archiveNamed": "{name} archivieren",
      "delete": "Löschen",
      "deleteNamed": "{name} löschen"
    },
    "archive": {
      "title": "Eigenständigen Fragebogen archivieren",
      "body": "Archivieren beendet diesen Fragebogen endgültig. Bereits versendete Links funktionieren weiter, bis sie ablaufen.",
      "confirm": "Archivieren",
      "done": "Der eigenständige Fragebogen ist archiviert."
    },
    "delete": {
      "title": "Eigenständigen Fragebogen löschen",
      "body": "Aus diesem Fragebogen wurde noch nichts versendet, daher kann er gelöscht werden.",
      "confirm": "Löschen",
      "done": "Der eigenständige Fragebogen ist gelöscht."
    },
    "saved": {
      "now_one": "Der Fragebogen geht direkt nach Ihrer Bestätigung an {count} Person.",
      "now_other": "Der Fragebogen geht direkt nach Ihrer Bestätigung an {count} Personen. Bei einer großen Gruppe kann es einige Minuten dauern, bis alle ihn erhalten haben.",
      "date_one": "Der Fragebogen geht am {date} hinaus; die Zielgruppe zählt jetzt {count} Person. Wer dazugehört, wird zu diesem Zeitpunkt erneut gezählt.",
      "date_other": "Der Fragebogen geht am {date} hinaus; die Zielgruppe zählt jetzt {count} Personen. Wer dazugehört, wird zu diesem Zeitpunkt erneut gezählt."
    },
    "audience": {
      "everyone": "Alle",
      "units_one": "{count} Einheit",
      "units_other": "{count} Einheiten",
      "roles_one": "{count} Rolle",
      "roles_other": "{count} Rollen",
      "people_one": "{count} Person",
      "people_other": "{count} Personen",
      "none": "Keine Zielgruppe"
    },
    "editor": {
      "newTitle": "Neuer eigenständiger Fragebogen",
      "editTitle": "Eigenständigen Fragebogen bearbeiten",
      "backToList": "Zu den eigenständigen Fragebögen",
      "notFound": "Dieser eigenständige Fragebogen existiert nicht (mehr).",
      "loadError": "Der eigenständige Fragebogen konnte nicht geladen werden.",
      "closedSent_one": "Dieser Fragebogen wurde am {date} an {count} Person versendet. Bearbeiten ist nicht mehr möglich; archivieren können Sie ihn in der Liste.",
      "closedSent_other": "Dieser Fragebogen wurde am {date} an {count} Personen versendet. Bearbeiten ist nicht mehr möglich; archivieren können Sie ihn in der Liste.",
      "closedArchived": "Dieser Fragebogen ist archiviert und kann nicht mehr bearbeitet werden.",
      "toInvitations": "Zu den Einladungen",
      "review": "Prüfen und bestätigen",
      "heldNotice_one": "Dieser Fragebogen wurde nicht versendet: Er war anonym, aber beim Versand zählte die Zielgruppe {count} Person, weniger als die Untergrenze. Wählen Sie eine größere Zielgruppe oder verzichten Sie auf Anonymität; Speichern plant ihn erneut ein.",
      "heldNotice_other": "Dieser Fragebogen wurde nicht versendet: Er war anonym, aber beim Versand zählte die Zielgruppe {count} Personen, weniger als die Untergrenze. Wählen Sie eine größere Zielgruppe oder verzichten Sie auf Anonymität; Speichern plant ihn erneut ein."
    },
    "field": {
      "form": "Fragebogen",
      "formPlaceholder": "Wählen Sie einen veröffentlichten Fragebogen",
      "formsError": "Die Fragebögen zur Auswahl konnten nicht geladen werden.",
      "noForms": "Es gibt noch keinen veröffentlichten Fragebogen.",
      "audience": "Zielgruppe",
      "audienceHint": "Wählen Sie Einheiten, Rollen, Personen oder alle. Wer unter mehrere Zeilen fällt, erhält eine Einladung. Nur aktive Personen zählen.",
      "addSegment": "Zeile hinzufügen",
      "moment": "Wann geht er hinaus?",
      "fixedAt": "Datum und Uhrzeit",
      "fixedAtHint": "In Ihrer eigenen Zeit. Ein Zeitpunkt, der bereits vorbei ist, ist nicht möglich.",
      "sending": "Versand",
      "anonymous": "Anonym: keine Namen bei den Antworten anzeigen",
      "anonymousHint": "Sie sehen dann je Status, wie viele Einladungen es gibt, aber nicht, von wem. Möglich ab {floor} Personen."
    },
    "moment": {
      "now": "Jetzt",
      "nowHint": "Direkt nach Ihrer Bestätigung. Bei einer großen Gruppe kann es einige Minuten dauern, bis alle ihn erhalten haben.",
      "date": "Zu einem festen Datum",
      "dateHint": "Wer zu diesem Zeitpunkt zur Zielgruppe gehört, erhält ihn."
    },
    "segment": {
      "label": "Zeile {number} der Zielgruppe",
      "type": "Art, Zeile {number}",
      "org_units": "Organisationseinheiten",
      "roles": "Rollen",
      "individuals": "Ausgewählte Personen",
      "everyone": "Alle",
      "everyoneHint": "Alle aktiven Personen in dieser Umgebung.",
      "includeSubUnits": "Auch die untergeordneten Einheiten",
      "remove": "Entfernen",
      "removeNamed": "Zeile {number} entfernen"
    },
    "picker": {
      "units": "Einheit suchen",
      "unitsNamed": "Einheiten, Zeile {number}",
      "roles": "Rolle suchen",
      "rolesNamed": "Rollen, Zeile {number}",
      "people": "Nach Name oder E-Mail-Adresse suchen",
      "peopleNamed": "Personen, Zeile {number}",
      "loadError": "Die Auswahlliste konnte nicht geladen werden."
    },
    "preview": {
      "title": "Empfänger",
      "nothing": "Wählen Sie eine Zielgruppe; dann sehen Sie hier, wie viele Personen sie jetzt zählt.",
      "counting": "Wird gezählt…",
      "updating": "Wird aktualisiert…",
      "count_one": "{count} Person",
      "count_other": "{count} Personen",
      "failed": "Die Anzahl konnte nicht gezählt werden.",
      "rule": "Nur aktive Personen zählen. Beim Versand wird die Zielgruppe erneut gezählt."
    },
    "errors": {
      "noAudience": "Wählen Sie mindestens eine Zielgruppe.",
      "segmentIncomplete": "Wählen Sie, wer unter diese Zeile fällt, oder entfernen Sie die Zeile.",
      "nobody": "Diese Zielgruppe zählt derzeit niemanden: Es würde nichts versendet.",
      "countFailed": "Die Anzahl der Empfänger konnte nicht gezählt werden. Bitte versuchen Sie es erneut."
    },
    "confirm": {
      "title": "Versand bestätigen",
      "count_one": "Dieser Fragebogen geht an {count} Person.",
      "count_other": "Dieser Fragebogen geht an {count} Personen.",
      "form": "Fragebogen",
      "when": "Wann",
      "anonymous": "Anonym",
      "yes": "Ja",
      "no": "Nein",
      "now": "Sobald Sie bestätigen",
      "nowHint": "Er geht sofort hinaus; bei einer großen Gruppe kann es einige Minuten dauern, bis alle ihn erhalten haben. Danach können Sie ihn nicht mehr bearbeiten, nur noch archivieren.",
      "dateHint": "Bis zu diesem Zeitpunkt können Sie ihn bearbeiten. Wer dazugehört, wird dann erneut gezählt; die Anzahl kann abweichen.",
      "sendNow": "Bestätigen und versenden",
      "schedule": "Bestätigen und einplanen",
      "changed_one": "Die Anzahl hat sich geändert: Die Zielgruppe zählt jetzt {count} Person statt {previous}. Bitte bestätigen Sie erneut.",
      "changed_other": "Die Anzahl hat sich geändert: Die Zielgruppe zählt jetzt {count} Personen statt {previous}. Bitte bestätigen Sie erneut."
    }
  },
  "assetLimits": {
    "uploadHint": "{types} — max. {max} MB",
    "fileTooLarge": "Diese Datei ist {size} MB groß. Das Maximum beträgt {max} MB.",
    "fileTypeRejected": "Dieser Dateityp ist nicht zulässig. Zulässig sind: {types}."
  },
  "uploadLimits": {
    "platformDescription": "Diese Werte gelten für jede Umgebung, die keinen eigenen Wert hat. Kunden können sie nicht selbst ändern: eine Dateityp-Liste ist eine Sicherheitseinstellung.",
    "tenantDescription": "Was Sie hier festlegen, gilt nur für diese Umgebung. Lassen Sie ein Feld leer, um auf den Wert zurückzufallen, der für alle Umgebungen gilt.",
    "storageUsage": "Diese Umgebung nutzt derzeit {used} von {quota} MB ({percent} %) für eigene Inhalte.",
    "sources": {
      "tenant": "Eigener Wert für diese Umgebung",
      "platform": "Plattformweit festgelegt",
      "fallback": "Standard"
    },
    "units": {
      "kilobytes": "Wert (MB)",
      "megabytes": "Wert (MB)",
      "count": "Wert"
    },
    "types": "Zulässige Dateitypen",
    "addType": "Typ hinzufügen",
    "add": "Hinzufügen",
    "removeType": "{type} entfernen",
    "forbiddenHint": "Diese Typen können nicht zugelassen werden, da sie Skripte enthalten können: {types}.",
    "ceilingHint": "Höchstens {max} MB — mehr lässt der Webserver nicht durch.",
    "overCeiling": "Die Grenze darf {max} MB nicht überschreiten.",
    "mustBeNumber": "Geben Sie eine positive Zahl ein.",
    "notOverridable": "Diese Grenze gilt für alle Umgebungen und kann hier nicht geändert werden.",
    "clearOverride": "Zurück zum Standard",
    "fallbackNote": "Ohne eigenen Wert gilt hier {value}.",
    "saved": "Die Grenzen wurden gespeichert.",
    "nothingChanged": "Es wurde nichts geändert, es gibt also nichts zu speichern.",
    "loadError": "Die Upload-Grenzen konnten nicht geladen werden."
  },
  "platformSettings": {
    "title": "Globale Einstellungen",
    "sections": {
      "general": "Allgemein",
      "mail": "E-Mail",
      "files": "Dateien"
    },
    "general": {
      "empty": "Noch keine globalen Einstellungen unter diesem Thema."
    },
    "mail": {
      "transportTitle": "Absender & Transport (Standard)",
      "mode": "Versandmodus",
      "modeRelay": "Plattform-Relay (empfohlen)",
      "modeSmtp": "Eigener SMTP-Server",
      "fromAddress": "Absenderadresse",
      "fromName": "Absendername",
      "replyTo": "Reply-To",
      "smtpHost": "SMTP-Host",
      "smtpPort": "SMTP-Port",
      "smtpEncryption": "Verschlüsselung",
      "smtpUsername": "SMTP-Benutzername",
      "smtpPassword": "SMTP-Passwort",
      "passwordSet": "Ein Passwort ist hinterlegt — leer lassen, um es unverändert zu behalten.",
      "connectionTest": "Verbindung testen",
      "connectionHint": "Testet die gespeicherten Transport-Einstellungen, ohne eine E-Mail zu senden. Bitte zuerst speichern.",
      "connectionOk": "Verbindung erfolgreich.",
      "testTitle": "Test-E-Mail",
      "testHint": "Sendet eine Test-E-Mail über den Plattform-Transport, außerhalb jedes Tenants.",
      "testTo": "Testadresse",
      "testToInvalid": "Geben Sie eine gültige E-Mail-Adresse ein.",
      "testSend": "Test senden",
      "testOk": "Test-E-Mail gesendet.",
      "dnsTitle": "DNS-Prüfung (SPF/DKIM/DMARC)",
      "dnsHint": "Prüft die E-Mail-Authentifizierungs-Records der From-Domain der Plattform. Bitte zuerst speichern.",
      "dnsCheck": "DNS prüfen",
      "dnsDomain": "Domain",
      "dkimSelector": "DKIM-Selektor (optional)",
      "dkimSelectorHint": "DKIM-Selektor, z. B. 'default' oder 's1' — erforderlich, um den richtigen DKIM-Record abzufragen.",
      "dnsExpected": "Fügen Sie auf {host} einen TXT-Record hinzu, der Folgendes enthält:",
      "spfNoRelay": "enthält unser Relay nicht",
      "dnsStatus": {
        "ok": "OK",
        "warn": "Warnung",
        "missing": "fehlt",
        "skipped": "nicht geprüft"
      },
      "lifecycleTitle": "Versand & Aufbewahrung (Standard)",
      "sendingEnabled": "E-Mails tatsächlich senden",
      "openTracking": "Öffnungs-Tracking (Pixel)",
      "storeTransactionalBody": "Inhalt transaktionaler E-Mails speichern",
      "delayMinutes": "Verzögerung (Minuten)",
      "retentionDays": "Aufbewahrung (Tage)"
    }
  },
  "common": {
    "filePicker": {
      "drop": "Ziehen Sie eine Datei hierher oder klicken Sie zum Auswählen",
      "choose": "Datei auswählen",
      "replace": "Ersetzen",
      "remove": "Entfernen"
    },
    "dropzone": {
      "primary": "Dateien hierher ziehen oder klicken zum Auswählen",
      "secondary": "Mehrere Dateien gleichzeitig sind möglich (max. 10 MB pro Datei)"
    },
    "cancel": "Abbrechen",
    "close": "Schließen",
    "copy": "Kopieren",
    "copied": "Kopiert!",
    "create": "Erstellen",
    "save": "Speichern",
    "saved": "Gespeichert",
    "loading": "Wird geladen …",
    "error": "Etwas ist schiefgelaufen",
    "edit": "Bearbeiten",
    "open": "Öffnen",
    "search": "Suchen",
    "yes": "Ja",
    "no": "Nein",
    "tableEmpty": "Keine Zeilen zum Anzeigen.",
    "tableNoMatch": "Keine Ergebnisse für Ihre Suche.",
    "tableMatchCount": "{matched} von {total}",
    "tableRange": "{from}–{to} von {total}",
    "tablePageSize": "Pro Seite",
    "tablePageOf": "Seite {current} von {total}",
    "tableExport": "CSV exportieren",
    "tableExportHint": "Alle gefilterten Zeilen in der aktuellen Sortierung. Die Aktionsspalte wird weggelassen.",
    "delete": "Löschen",
    "remove": "Entfernen",
    "expand": "Ausklappen",
    "collapse": "Einklappen",
    "unknownError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "fieldRequired": "Dieses Feld ist ein Pflichtfeld.",
    "invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "view": "Ansehen",
    "weekday": {
      "1": "Montag",
      "2": "Dienstag",
      "3": "Mittwoch",
      "4": "Donnerstag",
      "5": "Freitag",
      "6": "Samstag",
      "7": "Sonntag"
    },
    "saving": "Wird gespeichert…",
    "actions": "Aktionen",
    "tableRowNumber": "#",
    "tableSelectAll": "Alle Zeilen auswählen",
    "tableSelectRow": "Zeile {n} auswählen",
    "tableSortAsc": "aufsteigend sortiert",
    "tableSortDesc": "absteigend sortiert",
    "tableScrollRegion": "Tabelle, seitlich scrollbar",
    "tablePreviousPage": "Vorherige Seite",
    "tableNextPage": "Nächste Seite",
    "helpFor": "Erläuterung zu {field}",
    "moveUp": "Nach oben",
    "moveDown": "Nach unten"
  },
  "shadowBanner": {
    "stop": "Schatten-Modus beenden",
    "startedAt": "aktiv seit {time}",
    "userShadow": {
      "heading": "Sie arbeiten als {name}",
      "subline": "Initiiert von {impersonator}",
      "sublineWithOrigin": "Initiiert von {impersonator} (als Schatten-Benutzer von Superadmin {origin})"
    },
    "superadminTenantAdmin": {
      "heading": "Sie arbeiten als Tenant-Admin über einen Superadmin-Schatten",
      "subline": "Ursprünglicher Superadmin: {origin}"
    }
  },
  "localeOverrides": {
    "heading": "Texte",
    "intro": "Überschreiben Sie Texte in der App pro Sprache. Eine leere Überschreibung fällt auf den Standardtext zurück.",
    "searchPlaceholder": "Nach Key oder Text suchen…",
    "colKey": "Key",
    "default": "Standard",
    "override": "Überschreibung",
    "reset": "Zurücksetzen",
    "resetNamespace": "Namespace zurücksetzen",
    "historyAction": "Verlauf",
    "namespaceCount": "{total} Keys · {overridden} überschrieben",
    "requiredPlaceholders": "Verwenden Sie: {list}",
    "confirmResetTitle": "Namespace zurücksetzen?",
    "confirmResetBody": "Alle Überschreibungen in '{namespace}' für diese Sprache löschen. Die Standardtexte werden wieder verwendet.",
    "historyTitle": "Verlauf — {key}",
    "empty": {
      "all": "Noch keine Keys zum Anzeigen.",
      "search": "Keine Ergebnisse für diese Suche."
    },
    "history": {
      "empty": "Keine Änderungen erfasst.",
      "before": "Vorheriger Wert",
      "after": "Neuer Wert",
      "disabledHint": "Kein Verlauf — für diesen Key wurde noch keine Überschreibung gespeichert.",
      "by": "von {actor}",
      "byShadow": "von {impersonator} (als Schatten-Benutzer von {actor})",
      "byShadowFromSuperadmin": "von {impersonator} (als Schatten-Benutzer von {actor}; angemeldet als Superadmin {origin})",
      "bySuperadminShadow": "von {actor} (Superadmin {origin} via Schatten-Benutzer)",
      "action": {
        "created": "Erstellt",
        "updated": "Aktualisiert",
        "deleted": "Gelöscht"
      }
    },
    "errors": {
      "html": "HTML-Tags sind nicht erlaubt.",
      "placeholder": "Fehlende Platzhalter: {list}",
      "saveFailed": "Speichern fehlgeschlagen."
    }
  },
  "auth": {
    "login": {
      "title": "Anmelden",
      "subtitle": "Superadmin-Zugang zur BCS LMS/LXP-Plattform.",
      "email": "E-Mail-Adresse",
      "password": "Passwort",
      "remember": "Angemeldet bleiben",
      "submit": "Anmelden",
      "genericError": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    "mfa": {
      "title": "Zweiter Schritt",
      "subtitle": "Geben Sie den Code aus Ihrer Authenticator-App ein.",
      "code": "Code",
      "submit": "Bestätigen",
      "recoveryHint": "Kein Zugriff auf Ihre App? Verwenden Sie einen Ihrer Wiederherstellungscodes.",
      "noRecoveryHint": "Sie haben keine Wiederherstellungscodes mehr."
    }
  },
  "superadmin": {
    "dashboard": {
      "heading": "Dashboard",
      "intro": "Übersicht über die BCS LMS/LXP-Plattform.",
      "totalTenants": "Tenants gesamt",
      "activeTenants": "Aktive Tenants",
      "imports": {
        "activeImports": "Aktive Importe",
        "allClearTitle": "Importe — alles in Ordnung",
        "allClearBody": "Keine fehlgeschlagenen Importe in den letzten 7 Tagen.",
        "failuresTitle": "Importe — kürzlich fehlgeschlagen",
        "failuresBody": "{failed24h} fehlgeschlagen in den letzten 24 Stunden · {failed7d} in den letzten 7 Tagen."
      },
      "storage": {
        "allClearTitle": "Speicher — alles in Ordnung",
        "allClearBody": "Keine der {count} Umgebungen nähert sich ihrer Speichergrenze.",
        "attentionTitle": "Speicher — erfordert Aufmerksamkeit",
        "attentionBody": "{warn} Umgebungen nähern sich ihrer Grenze · {over} liegen darüber.",
        "usage": "{used} von {quota} MB ({percent} %)"
      }
    },
    "tenants": {
      "heading": "Tenants",
      "new": "Neuer Tenant",
      "edit": "Tenant bearbeiten — {name}",
      "empty": "Noch keine Tenants. Erstellen Sie den ersten, um loszulegen.",
      "confirmDelete": "Tenant löschen?",
      "confirmDeleteBody": "Dies löscht {name} (Soft-Delete). Die Daten bleiben erhalten und können von einem Engineer wiederhergestellt werden.",
      "confirmSlugLabel": "Geben Sie \"{slug}\" ein, um zu bestätigen",
      "confirmSlugHint": "Der Slug des Tenants. Groß-/Kleinschreibung wird beachtet.",
      "confirmDeleteDomainTitle": "Domain entfernen?",
      "confirmDeleteDomainBody": "Dies entfernt {host} dauerhaft. Der Host wird danach nicht mehr aufgelöst und Benutzer können diesen Tenant darüber nicht mehr erreichen.",
      "cols": {
        "name": "Name",
        "slug": "Slug",
        "status": "Status",
        "locale": "Sprache",
        "domains": "Domains"
      },
      "legacyDomainHint": "Verbliebener Host eines früheren Slugs oder einer eigenen Domain. Wird noch zu diesem Tenant aufgelöst; wird für neue Login-URLs nicht mehr verwendet. Verwenden Sie das ×, um ihn zu entfernen.",
      "removeDomain": "{host} entfernen",
      "manageDomainHint": "Verwaltungs-Host — separate Sitzung für die Tenant-Verwaltung (ADR-0028).",
      "contentDomainHint": "Content-Host — hier läuft E-Learning-Material, in einem eigenen Origin (ADR-0033 § 4).",
      "loginUrlTitle": "Einmalige Admin-Login-URL",
      "loginUrlBody": "Senden Sie diese URL an den neuen Tenant-Admin. Sie funktioniert einmalig und läuft nach 15 Minuten ab.",
      "orgStructure": "Org-Struktur",
      "manage": "Verwalten",
      "fields": {
        "adminEmail": "E-Mail des ersten Admins",
        "adminHint": "Optional — erstellen Sie im selben Schritt den ersten Tenant-Admin-Benutzer. Dieser erhält in Kürze eine Login-URL.",
        "adminName": "Name des ersten Admins",
        "availableLocales": "Verfügbare Sprachen",
        "availableLocalesHint": "Sprachen, aus denen Tenant-Benutzer wählen können. Kreuzen Sie mindestens eine an; die Standardsprache muss angekreuzt sein.",
        "availableLocalesRequired": "Mindestens eine Sprache muss verfügbar sein.",
        "bcsNumber": "BCS-Nummer",
        "bcsNumberHint": "Die Kundennummer, die wir innerhalb von BCS für diesen Kunden verwenden. Eindeutig pro Tenant.",
        "contentSlug": "Content-Host-Slug",
        "contentSlugHint": "Der Host, der E-Learning-Inhalte ausliefert, als einzelnes Label unter der zentralen Domain. Leer lassen für content-<slug>. Er muss sich von der Tenant-Slug und der Verwaltungs-Slug unterscheiden — genau diese Trennung ist der Grund für diesen Host. Hinweis: Pro Umgebung ist eine DNS-/Proxy-Regel für diesen Namen erforderlich.",
        "currency": "Währung",
        "currencyHint": "Die Währung, die innerhalb dieses Tenants verwendet wird, zum Beispiel für Preise und Budgets.",
        "customDomain": "Eigene Domain",
        "customDomainHint": "Optional. Ein einzelner Hostname (z. B. leren.acme.nl), unter dem der Tenant zusätzlich erreichbar ist. DNS + TLS liegen in der Verantwortung des Tenants; leer lassen, um nur die Standard-Subdomain zu behalten.",
        "locale": "Standardsprache",
        "localeHint": "Wird auf neue Tenant-Benutzer angewendet, sofern diese nicht selbst eine andere Sprache wählen.",
        "localeNotAvailable": "Die Standardsprache muss ebenfalls in der Liste der verfügbaren Sprachen angekreuzt sein.",
        "manageSlug": "Verwaltungs-Slug",
        "manageSlugHint": "Subdomain der Verwaltungskonsole (ein einzelnes Label unter der Plattform-Domain). Leer lassen für den Standard manage-<slug>.",
        "name": "Anzeigename",
        "noPlatformLocales": "Noch keine Plattform-Sprachen aktiviert — fügen Sie mindestens eine über das Menü Sprachen hinzu.",
        "retentionDays": "Aufbewahrung gelöschter Benutzer (Tage)",
        "retentionDaysHint": "Nach wie vielen Tagen soft-gelöschte Benutzer endgültig (DSGVO) gelöscht werden. Leer = Standard 365 Tage. Wird durch die tägliche Aufbewahrungs-Task durchgesetzt.",
        "slug": "Slug",
        "slugHint": "Kleinbuchstaben, Ziffern und Bindestriche. Bildet die Standard-Subdomain.",
        "status": "Status",
        "themeMode": "Farbschema",
        "themeModeHint": "Legen Sie das Farbschema für diesen Tenant fest: Benutzer wählen lassen (Schalter in der Leiste) oder Hell/Dunkel erzwingen.",
        "themeModes": {
          "dark": "Immer dunkel",
          "light": "Immer hell",
          "switch": "Benutzer wählt (Schalter)"
        },
        "timezone": "Zeitzone",
        "timezoneHint": "Geplante Importe laufen zur lokalen Zeit dieser Zeitzone — ein Tenant in Mexico_City mit Zeitplan 07:00 läuft um 07:00 Uhr Mexiko-Stadt-Zeit, nicht um 07:00 Uhr in den Niederlanden."
      },
      "seed": {
        "hint": "Optional — übernehmen Sie einen ausgewählten Satz Konfiguration aus einem bestehenden Tenant. Nichts auswählen erstellt einen leeren Tenant.",
        "sourceLabel": "Aus Tenant kopieren",
        "sourceBlank": "— leerer Tenant (keine Kopie) —",
        "scopesLegend": "Was kopiert werden soll",
        "toastCopied": "Tenant erstellt. Kopiert:",
        "toastSkipped": "Übersprungen (nichts zu kopieren):",
        "scopes": {
          "org_structure": {
            "label": "Org-Struktur",
            "hint": "Kategorien + deren Hierarchie + benutzerdefinierte Feldschemata. Die eigentlichen Einheiten (Abteilungen, Teams) werden NICHT kopiert."
          },
          "user_field_schema": {
            "label": "Benutzer-Feldschema",
            "hint": "Die vollständige Definition der benutzerdefinierten Felder, die Benutzer in diesem Tenant erhalten."
          },
          "display_name_format": {
            "label": "Anzeigename-Format",
            "hint": "Template, das die Anzeigenamen der Benutzer zusammensetzt. Erzwingt, dass das Benutzer-Feldschema ebenfalls kopiert wird."
          },
          "branding": {
            "label": "Branding",
            "hint": "Farb-Tokens + Logo. Die Logo-Datei wird ebenfalls kopiert."
          },
          "import_sources": {
            "label": "Importquellen",
            "hint": "Die Quell-Zeilen + deren Slot-/Spalten-Mapping. Erzwingt, dass Org-Struktur und Benutzer-Feldschema ebenfalls kopiert werden — das Mapping verweist auf Org-Ebenen + Benutzerfelder. Zugangsdaten werden NIEMALS kopiert; Quellen landen deaktiviert mit leeren Zugangsdaten, sodass der Admin sie vor dem Aktivieren ausfüllt."
          },
          "workflow_templates": {
            "label": "Workflows",
            "hint": "Die Workflow-Definitionen des Quell-Tenants (Trigger → Bedingung → Schritte). Läufe bleiben tenant-spezifisch; nur die Definitionen werden kopiert. Der globale Standard-Satz wird ohnehin in jeden neuen Tenant eingespielt."
          }
        }
      },
      "statusLabels": {
        "implementation": "Implementierung",
        "active": "Aktiv",
        "suspended": "Pausiert",
        "archived": "Archiviert"
      },
      "statusHints": {
        "implementation": "Standard für neu erstellte Tenants. Der Tenant funktioniert für das Implementierungsteam normal, es gehen jedoch keine transaktionalen E-Mails hinaus — stellen Sie auf Aktiv um, sobald die Plattform konfiguriert und bereit ist, echte Benutzer einzuladen.",
        "active": "Live für Endbenutzer. Logins, Mail und sämtliche Funktionen arbeiten normal.",
        "suspended": "Der Tenant ist pausiert. Endbenutzer-Logins werden abgelehnt; bestehende Sitzungen erhalten beim nächsten Request einen 503 und werden abgemeldet. Der Superadmin-Shadow-Login funktioniert weiterhin, sodass Sie den Tenant von innen untersuchen oder wieder freigeben können.",
        "archived": "Der Tenant ist stillgelegt. Die Seite liefert für alle 404 — auch für den Superadmin-Shadow-Login. Die Daten bleiben in der Datenbank; heben Sie zuerst die Archivierung auf, wenn Sie wieder Zugriff benötigen."
      },
      "cards": {
        "general": "Allgemein",
        "generalHint": "Name, Slug, eigene Domain und Status des Tenants.",
        "languages": "Sprachen",
        "languagesHint": "Standardsprache und die Sprachen, aus denen Benutzer dieses Tenants wählen können."
      },
      "sections": {
        "general": "Allgemein",
        "locales": "Sprachen",
        "branding": "Layout",
        "mail": "Mail",
        "pickerLabel": "Bereich",
        "login": "Anmeldung",
        "limits": "Dateien",
        "modules": "Module",
        "documents": "Dokumente"
      },
      "modules": {
        "intro": "Welche Module diese Umgebung hat. Nur BCS schaltet ein Modul ein oder aus; die Administration der Umgebung sieht ein ausgeschaltetes Modul nirgends.",
        "empty": "Es sind noch keine Module registriert. Alles, was die Plattform heute kann, steht jeder Umgebung zur Verfügung.",
        "loadError": "Die Module konnten nicht geladen werden.",
        "retry": "Erneut versuchen",
        "state": {
          "standard": "Standardmäßig vorhanden",
          "sold": "Verkauft",
          "legacy_activatable": "Nicht mehr verkauft, noch aktivierbar",
          "retired": "Läuft aus"
        },
        "on": "Ein",
        "off": "Aus",
        "alwaysOn": "Immer eingeschaltet, kann nicht ausgeschaltet werden.",
        "retiredOff": "Läuft aus: kann nicht mehr eingeschaltet werden.",
        "enable": "Einschalten",
        "disable": "Ausschalten",
        "enabledBy": "Eingeschaltet von {name} am {date}",
        "disabledBy": "Ausgeschaltet von {name} am {date}",
        "removedPerson": "einem entfernten Administrator",
        "unknownPerson": "unbekannt",
        "neverSwitched": "Noch nie ein- oder ausgeschaltet.",
        "confirmRetiredTitle": "Auslaufendes Modul ausschalten?",
        "confirmRetiredBody": "Das Modul {module} läuft aus. Wenn Sie es jetzt ausschalten, kann es nicht wieder eingeschaltet werden. Die Daten bleiben erhalten.",
        "confirmRetired": "Trotzdem ausschalten"
      },
      "mail": {
        "transportTitle": "Absender & Transport",
        "mode": "Versandmodus",
        "modeInherit": "Globaler Standard",
        "modeInheritHint": "Folgt dem globalen Standard: {mode}",
        "modeRelay": "Plattform-Relay (empfohlen)",
        "modeSmtp": "Eigener SMTP-Server",
        "fromAddress": "Absenderadresse",
        "fromName": "Absendername",
        "replyTo": "Antwort an (Reply-To)",
        "smtpHost": "SMTP-Host",
        "smtpPort": "SMTP-Port",
        "smtpEncryption": "Verschlüsselung",
        "smtpUsername": "SMTP-Benutzername",
        "smtpPassword": "SMTP-Passwort",
        "passwordSet": "Ein Passwort ist gesetzt — leer lassen, um es unverändert zu behalten.",
        "lifecycleTitle": "Versand & Aufbewahrung",
        "sendingEnabled": "Mails tatsächlich versenden",
        "openTracking": "Öffnungs-Tracking (Pixel)",
        "storeTransactionalBody": "Inhalt transaktionaler Mails speichern",
        "delayMinutes": "Verzögerung (Minuten)",
        "retentionDays": "Aufbewahrung (Tage)",
        "testTitle": "Test-Mail",
        "testHint": "Sendet eine Test-Mail über den konfigurierten Transport, auch wenn der Versand deaktiviert ist.",
        "testTo": "Testadresse",
        "testToInvalid": "Geben Sie eine gültige E-Mail-Adresse ein.",
        "testSend": "Test senden",
        "testOk": "Test-Mail gesendet.",
        "connectionTest": "Verbindung testen",
        "connectionHint": "Testet die gespeicherten Transport-Einstellungen, ohne eine Mail zu senden. Speichern Sie zuerst.",
        "connectionOk": "Verbindung erfolgreich.",
        "dnsTitle": "DNS-Prüfung (SPF/DKIM/DMARC)",
        "dnsHint": "Prüft die E-Mail-Authentifizierungs-Records der konfigurierten From-Domain. Sagt voraus, ob Mails die Spamfilter der Empfänger passieren. Speichern Sie zuerst.",
        "dnsCheck": "DNS prüfen",
        "dnsDomain": "Domain",
        "dkimSelector": "DKIM-Selector (optional)",
        "dkimSelectorHint": "DKIM-Selector, z. B. 'default' oder 's1' — nötig, um den richtigen DKIM-Record abzufragen.",
        "dnsExpected": "Legen Sie auf {host} einen TXT-Record an mit:",
        "spfNoRelay": "enthält unser Relay nicht",
        "dnsStatus": {
          "ok": "OK",
          "warn": "Warnung",
          "missing": "fehlt",
          "skipped": "nicht geprüft"
        }
      },
      "unsavedConfirm": "Sie haben nicht gespeicherte Änderungen. Ohne Speichern fortfahren?",
      "userFields": {
        "baseHeading": "Basisfelder",
        "baseHint": "Immer bei jedem Benutzer vorhanden. Feste Felder — nur das Label und 'Pflicht' sind änderbar.",
        "requiredLabel": "Pflicht",
        "labelForLocale": "Label ({locale})",
        "schemaHeading": "Zusätzliche Felder",
        "schemaHint": "Jedes hier definierte Feld erscheint in jedem Benutzerprofil. Die verfügbaren Typen sind dieselben wie für Organisationseinheiten.",
        "displayNameHeading": "Anzeigename-Format",
        "displayNameHint": "Setzt das Anzeige-Label des Benutzers aus den einzelnen Namensfeldern zusammen. Tokens in geschweiften Klammern (first_name, last_name, email oder ein beliebiger benutzerdefinierter Feldschlüssel) werden durch den Wert des jeweiligen Benutzers ersetzt. Der Standard ergibt \"Jan Janssen\"; wechseln Sie zu einem Nachname-zuerst-Format für sortierbare Verzeichnisse oder kombinieren Sie es mit einem benutzerdefinierten Feld \"initialen\".",
        "displayNameFormat": "Format-Template",
        "displayNameUnknownTokens": "Unbekannte Tokens im Template — beheben Sie dies, sonst entstehen leere Zeichenketten:",
        "displayNameTokensHeading": "Verfügbare Tokens",
        "displayNamePreview": "Vorschau:"
      },
      "branding": {
        "heading": "Layout",
        "hint": "Passen Sie das Erscheinungsbild des Arbeitsbereichs dieses Tenants an. Änderungen werden beim nächsten Laden der Seite wirksam.",
        "primaryColor": "Markenfarbe",
        "primaryColorHint": "Hex-Wert (z. B. #1a56db). Wird auf Buttons, Links und den aktiven Navigations-Indikator angewendet. Leer lassen für den Plattform-Standard.",
        "accentColor": "Akzentfarbe",
        "accentColorHint": "Hex-Wert (z. B. #13796d). Wird als zweite Farbe im Verlauf primärer Buttons sowie für sekundäre Chips und Icons verwendet. Leer lassen für den Plattform-Standard.",
        "buttonHoverColor": "Button-Hover-Farbe",
        "buttonHoverColorHint": "Hex-Wert. Hintergrund primärer Buttons, wenn der Cursor darauf steht. Leer lassen, um eine etwas dunklere Variante der Markenfarbe zu verwenden.",
        "activeIndicatorColor": "Indikator für aktiven Menüpunkt",
        "activeIndicatorColorHint": "Hex-Wert. Der schmale farbige Balken links neben der aktuell geöffneten Seite in der Seitenleiste. Leer lassen, um der Markenfarbe zu folgen.",
        "sidebarColor": "Seitenleistenfarbe",
        "sidebarColorHint": "Hex-Wert (z. B. #1B1F33). Ersetzt den standardmäßig dunklen Hintergrund der Seitenleiste. Muss dunkel genug sein, damit weißer Text lesbar bleibt — Werte, die die Kontrastprüfung nicht bestehen, werden beim Speichern abgelehnt.",
        "sidebarPreview": "Live-Vorschau der Seitenleiste mit dieser Farbe",
        "nameInUi": "Portalname",
        "nameInUiHint": "Name, der in der Seitenleiste und im Browser-Tab angezeigt wird. Bleibt das Feld leer, wird der Anzeigename des Tenants verwendet.",
        "senderName": "Absendername Weiterbildung",
        "senderNameHint": "Der Name, unter dem die Weiterbildungsfunktion bei diesem Kunden bekannt ist (HR, Personalentwicklung, Weiterbildung). Unterzeichnet Nachrichten rund ums Lernen, zum Beispiel \"HRD — Acme Care\"; unter Konto- und Zugangsnachrichten steht nur der Organisationsname. Das Feld darf leer bleiben — dann erscheint nur der Organisationsname.",
        "logo": "Logo",
        "logoHint": "PNG oder JPG, max. 2 MB. Wird in der Seitenleiste anstelle des Standard-BCS-Logos angezeigt.",
        "logoUpload": "Logo hochladen",
        "logoReplace": "Ersetzen",
        "logoRemove": "Logo entfernen",
        "logoPreview": "Logo-Vorschau",
        "logoInvalid": "Upload fehlgeschlagen. Prüfen Sie den Dateityp (PNG/JPG) und die Größe (max. 2 MB).",
        "logoLayout": "Layout Logo + Name",
        "logoLayoutHint": "Wählen Sie, wie Logo und Portalname in der Seitenleiste und auf dem Anmeldebildschirm kombiniert werden.",
        "logoLayouts": {
          "logo_then_title": "Logo mit dem Namen daneben",
          "logo_above_title": "Logo mit dem Namen darunter",
          "logo_only": "Nur Logo",
          "title_only": "Nur Name"
        },
        "logoAlign": "Ausrichtung des Markenblocks",
        "logoAlignHint": "Ob Logo + Name am Anfang des Seitenleisten-Headers stehen oder horizontal zentriert sind. Gilt für das Layout, das Sie oben gewählt haben.",
        "logoAligns": {
          "left": "Am Anfang ausgerichtet",
          "center": "Zentriert"
        },
        "favicon": "Favicon",
        "faviconHint": "PNG, JPG oder ICO, max. 256 KB. Wird im Browser-Tab anstelle des Standard-BCS-Favicons angezeigt.",
        "faviconUpload": "Favicon hochladen",
        "faviconReplace": "Ersetzen",
        "faviconRemove": "Favicon entfernen",
        "faviconPreview": "Favicon-Vorschau",
        "faviconInvalid": "Upload fehlgeschlagen. Prüfen Sie den Dateityp (PNG/JPG/ICO) und die Größe (max. 256 KB)."
      },
      "bcs": {
        "title": "BCS Login (OIDC)",
        "intro": "Wählen Sie den Anmeldemodus für diesen Mandanten und konfigurieren Sie BCS Login (Keycloak). Client-Secrets werden nie angezeigt; leer lassen, um sie beizubehalten.",
        "mode": "Anmeldemodus",
        "modePassword": "E-Mail & Passwort",
        "modeBcs": "BCS Login (OIDC)",
        "modeDev": "Dev-Anmeldung",
        "baseUrl": "Basis-URL",
        "realm": "Realm",
        "clientId": "Client-ID",
        "customerNr": "Kundennummer",
        "customerNrHint": "Leer = {number}, die BCS-Nummer unter Allgemein. Füllen Sie das Feld nur aus, wenn diese Umgebung eine andere Nummer braucht.",
        "customerNrEmpty": "Noch keine BCS-Nummer unter Allgemein",
        "customerNrMissing": "Ohne Kundennummer lässt sich BCS Login nicht aktivieren — tragen Sie die BCS-Nummer unter Allgemein ein, oder hier eine eigene.",
        "environmentCode": "Umgebungscode",
        "applicationCode": "Anwendungscode",
        "scopes": "Scopes",
        "clientSecret": "Client-Secret",
        "secretSet": "Leer lassen, um das vorhandene Secret zu behalten. Füllen Sie das Feld nur aus, wenn Sie es ersetzen möchten.",
        "secretRequired": "Erforderlich, um BCS Login zu aktivieren.",
        "jitProvision": "Unbekannte Benutzer automatisch anlegen (JIT)",
        "provisioningTitle": "Konten in BCS Login anlegen",
        "provisioningConfigured": "Der Provisioning-Client ist auf dem Server hinterlegt und gilt für alle Umgebungen. Er wird hier nicht angezeigt, weil er zur Produktlinie gehört und nicht zu einem Kunden.",
        "provisioningMissing": "Auf diesem Server ist kein Provisioning-Client hinterlegt, daher werden in BCS Login keine Konten angelegt oder entzogen. Das ist eine Servereinstellung und keine Einstellung dieser Umgebung.",
        "saveFailed": "Speichern fehlgeschlagen",
        "genericError": "Speichern nicht möglich. Prüfen Sie die Angaben und versuchen Sie es erneut.",
        "customerNrNoGeneral": "Unter Allgemein steht noch keine BCS-Nummer. Tragen Sie sie dort ein, oder geben Sie dieser Umgebung hier eine eigene Nummer.",
        "customerNrOverrideTitle": "Eigene Kundennummer für diese Umgebung",
        "customerNrOverride": "Die Anmeldung verwendet {override} statt {general} aus Allgemein. Stimmt das nicht, leeren Sie dieses Feld."
      },
      "documents": {
        "heading": "Dokumente",
        "intro": "Ob die BCS-Zertifikatsvorlagen in dieser Umgebung wählbar sind. Aus hat Vorrang vor der Einstellung des Kunden.",
        "available": "BCS-Vorlagen verfügbar",
        "saveFailed": "Speichern ist fehlgeschlagen.",
        "offNote": "Aus: Der Kunde sieht die BCS-Vorlagen nicht und kann sie nicht selbst aktivieren. Wo bereits eine gewählt ist, werden weiterhin Zertifikate damit erstellt."
      }
    },
    "auditLog": {
      "heading": "Audit-Log",
      "intro": "Schreibgeschützte Historie der Änderungen an diesem Tenant. Neueste zuerst. Filtern Sie nach Aktions-Präfix, Akteur oder Zieltyp, um die Ansicht einzugrenzen.",
      "empty": "Keine Audit-Einträge entsprechen den aktuellen Filtern.",
      "diffShow": "Diff anzeigen",
      "pageOf": "Seite {current} von {total}",
      "filters": {
        "actionPlaceholder": "user.",
        "actorComboPlaceholder": "Nach Name oder E-Mail suchen…",
        "actorComboAria": "Nach Akteur filtern",
        "sectionSuperadmins": "Superadmins",
        "sectionUsers": "Benutzer",
        "targetTypePlaceholder": "User, Tenant…",
        "from": "Von",
        "to": "Bis einschließlich",
        "clearAll": "Alle Filter zurücksetzen"
      },
      "cols": {
        "when": "Wann",
        "actor": "Akteur",
        "action": "Aktion",
        "target": "Ziel",
        "diff": "Diff"
      }
    },
    "superadmins": {
      "heading": "Superadmins",
      "intro": "Verwalten Sie das Plattform-Team. Fügen Sie Kollegen hinzu, benennen Sie sie um oder setzen Sie ihr Passwort zurück, und entfernen Sie sie, wenn sie das Team verlassen.",
      "new": "Superadmin hinzufügen",
      "edit": "Superadmin bearbeiten",
      "empty": "Noch keine Superadmins — das ist ungewöhnlich; der geseedete Superadmin sollte hier stehen.",
      "mfaOn": "MFA aktiviert",
      "mfaOff": "MFA deaktiviert",
      "resetPassword": "Passwort zurücksetzen",
      "resetPasswordSubmit": "Passwort zurücksetzen",
      "resetPasswordBody": "Legen Sie ein neues Passwort für {name} fest. Es muss bei der nächsten Anmeldung verwendet werden.",
      "confirmDelete": "Superadmin entfernen?",
      "confirmDeleteBody": "Soft-Delete von {name}. Die Audit-Log-Einträge bleiben erhalten; die Sitzung wird beim nächsten Request invalidiert.",
      "cols": {
        "name": "Name",
        "email": "E-Mail",
        "mfa": "MFA"
      },
      "fields": {
        "name": "Name",
        "email": "E-Mail",
        "password": "Passwort",
        "passwordHint": "Mindestens 12 Zeichen mit Buchstaben (Groß- und Kleinschreibung) und Ziffern."
      }
    }
  },
  "tenantSetup": {
    "heading": "Tenant-Einrichtung",
    "intro": "Alles, was dieser Tenant für den Start braucht oder später anpassen kann. Wählen Sie einen Bereich aus, um einzusteigen.",
    "comingSoon": "Demnächst verfügbar",
    "impersonate": "Als Tenant-Admin anmelden",
    "impersonateGenericError": "Es konnte keine Anmelde-URL für diesen Tenant erstellt werden.",
    "impersonateUrlTitle": "Einmalige Tenant-Admin-Anmelde-URL",
    "impersonateUrlBody": "Öffnen Sie diese URL in diesem Browser oder kopieren Sie sie, um sie in einem anderen Browser oder Inkognito-Fenster zu verwenden. Sie funktioniert einmalig und läuft nach kurzer Zeit ab.",
    "impersonateUrlOpen": "In neuem Tab öffnen",
    "sections": {
      "orgStructure": {
        "title": "Organisationsstruktur",
        "description": "Definieren Sie die Kategorien, ihre Hierarchie und die benutzerdefinierten Felder, die der Tenant-Admin pro Einheit ausfüllen kann."
      },
      "imports": {
        "title": "Benutzerimporte",
        "description": "CSV-Uploads, SFTP-Feeds oder HR-System-Integrationen (AFAS, YouForce, HR2Day, Polaris)."
      },
      "platformSettings": {
        "title": "Plattform-Einstellungen",
        "description": "Branding, Auth-Driver, Lizenzlimits und weitere tenant-weite Konfiguration."
      },
      "auditLog": {
        "title": "Audit-Log",
        "description": "Schreibgeschützte Historie der Änderungen an diesem Tenant: wer hat was wann geändert. Filtern Sie nach Aktion, Akteur oder Zieltyp."
      }
    }
  },
  "platformAssets": {
    "add": "Bilder hinzufügen",
    "addError": "Das Hinzufügen ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "confirmRemove": "Sind Sie sicher? Das Bild verschwindet für alle, die es verwenden.",
    "empty": "In der Bibliothek ist noch kein Bild vorhanden.",
    "heading": "Plattform-Bibliothek",
    "intro": "Die Bilder, die wir mitliefern. Sie werden nicht in Umgebungen kopiert: Sie liegen hier einmal. Klicken Sie ein Bild an, um zu sehen, wo es steht, es auszurollen oder zurückzuziehen. Nur PNG und JPG; mehrere auf einmal sind möglich.",
    "loadError": "Die Bibliothek konnte nicht geladen werden.",
    "next": "Weiter",
    "pageOf": "Seite {page} von {total}",
    "pagination": "Seitennavigation",
    "prev": "Zurück",
    "push": "Ausrollen",
    "pushConfirm": "An {count} Umgebung(en) ausrollen",
    "pushError": "Das Ausrollen ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "syncError": "Die Aktualisierung der Umgebungen ist fehlgeschlagen.",
    "altError": "Der Alternativtext konnte nicht gespeichert werden.",
    "revokeError": "Das Bild konnte nicht zurückgezogen werden.",
    "pushHas": "Hat es bereits",
    "pushIntro": "Wählen Sie, an welche Umgebungen dieses Bild geht. Bei nicht angehakten Umgebungen passiert nichts.",
    "sourceChangedHint": "Das liegt derzeit bei der Quelle. Wenn Sie es übernehmen, wird es zum Bild — in jeder Umgebung, die es in ihrer Bibliothek hat, überall wo es verwendet wird.",
    "syncDone": "{pushed} Verfügbarkeiten über {tenants} Umgebungen hinzugefügt. Bilder, die eine Administratorin oder ein Administrator entfernt hatte, blieben unangetastet.",
    "sync": "In allen Umgebungen aktualisieren",
    "altHint": "Diesen Text erhält jede Umgebung. Eine Umgebung kann ihn je Sprache durch einen eigenen ersetzen; wo sie das nicht tut, bleibt dieser bestehen.",
    "altHeading": "Mitgelieferter Alternativtext",
    "selectAll": "Alle Umgebungen",
    "rolloutHeading": "An Umgebungen ausrollen",
    "pushLoadError": "Die Umgebungen konnten nicht geladen werden.",
    "pushRemoved": "Vom Kunden entfernt",
    "revokeFor": "Bei {name} zurückziehen",
    "revoke": "Zurückziehen",
    "pushRevoked": "Von uns zurückgezogen",
    "remove": "Entfernen",
    "removeError": "Das Entfernen ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "removeFor": "{name} entfernen"
  },
  "platformLocales": {
    "heading": "Plattform-Sprachen",
    "intro": "Der Katalog der Sprachen, aus denen Tenants wählen können. Deaktivierte Einträge bleiben zur Referenz in der Tabelle, erscheinen aber nicht mehr in Tenant-Formularen. Eine Sprache hier hinzuzufügen liefert noch keine Übersetzung — stellen Sie sicher, dass das passende src/shared/i18n/locales/[code].json-Bundle existiert, sonst sehen Benutzer englische Fallback-Texte.",
    "new": "Sprache hinzufügen",
    "edit": "Sprache bearbeiten",
    "empty": "Noch keine Sprachen. Fügen Sie eine hinzu, damit Tenants sie auswählen können.",
    "on": "Aktiviert",
    "off": "Deaktiviert",
    "cols": {
      "code": "Code",
      "label": "Bezeichnung",
      "enabled": "Aktiviert"
    },
    "confirmDelete": "Sprache entfernen?",
    "confirmDeleteBody": "{label} ({code}) aus dem Katalog entfernen. Tenants, die diesen Code noch in ihren Einstellungen referenzieren, verlieren ihn beim nächsten Speichern stillschweigend.",
    "fields": {
      "code": "Code",
      "codeHint": "Nur eine Sprache, für die die Plattform Texte hat: {codes}.",
      "label": "Eigenbezeichnung",
      "labelHint": "So schreiben Sprecher der Sprache den Namen ihrer eigenen Sprache (Nederlands, Deutsch, Français, …).",
      "position": "Position",
      "positionHint": "Niedrigere Zahlen erscheinen in Tenant-Dropdowns weiter oben.",
      "enabled": "Aktiviert"
    }
  },
  "orgStructure": {
    "userFields": {
      "heading": "Benutzerfelder",
      "intro": "Gilt für alle Benutzer dieses Tenants. Legen Sie das Label der externen ID, zusätzliche Felder (dieselben Typen wie bei Einheiten) und das Format des Anzeigenamens fest."
    },
    "userStructure": {
      "title": "Benutzerstruktur",
      "summary": "{count} zusätzliche Felder · Anzeigename:"
    },
    "heading": "Organisationsstruktur",
    "intro": "Definieren Sie die Kategorien, ihre Hierarchie und die Zusatzfelder, die ein Tenant-Administrator pro Einheit ausfüllen kann. Ziehen Sie Zeilen, um sie neu anzuordnen oder einer anderen übergeordneten Einheit zuzuordnen.",
    "new": "Kategorie hinzufügen",
    "edit": "Kategorie bearbeiten",
    "empty": "Noch keine Kategorien definiert. Fügen Sie die erste hinzu, um zu beginnen.",
    "customFields": "Zusatzfeld(er)",
    "confirmDelete": "Kategorie löschen?",
    "confirmDeleteBody": "Löscht {name}. Einheiten in dieser Kategorie und alle zugehörigen Benutzerzuweisungen werden entfernt — geben Sie {name} zur Bestätigung ein.",
    "confirmDeletePrompt": "Geben Sie den Namen der Kategorie zur Bestätigung ein",
    "moveUpSibling": "Innerhalb der gleichen Ebene nach oben verschieben",
    "moveDownSibling": "Innerhalb der gleichen Ebene nach unten verschieben",
    "moveOutdent": "Eine Ebene höher (aus der übergeordneten Kategorie heraus)",
    "moveIndent": "Eine Ebene tiefer (unter die darüberliegende Kategorie)",
    "dragHint": "Ziehen Sie eine Kategorie: Legen Sie sie auf einer anderen ab, um sie unterzuordnen, oder ober- bzw. unterhalb, um sie auf derselben Ebene neu anzuordnen.",
    "dragHandle": "Zum Verschieben ziehen",
    "badge": {
      "required": "Pflicht",
      "multiple": "Mehrfach"
    },
    "fields": {
      "key": "Schlüssel",
      "keyHint": "Stabiler Identifikator: Kleinbuchstaben/Ziffern/Bindestriche/Unterstriche. Wird später in der HR-Import-Mapping-UI verwendet.",
      "parent": "Gehört unter",
      "parentNone": "Keine (oberste Ebene)",
      "parentHint": "Bestimmt, wo diese Kategorie im Baum hängt — wie das Ziehen, nur präziser.",
      "labelFor": "Label ({locale})",
      "fieldSchema": "Zusatzfelder für Einheiten in dieser Kategorie",
      "fieldSchemaHint": "Aufbau: { \"fields\": [{ \"key\": \"code\", \"type\": \"string\", \"required\": true, \"label\": { \"de\": \"Code\" } }] }. Typen: string, text, email, number, date, boolean, userid.",
      "fieldSchemaHintShort": "Jedes hier definierte Feld wird zu einem typisierten Eingabefeld auf jeder Einheit in dieser Kategorie (in der Tenant-App)."
    },
    "membership": {
      "heading": "Benutzerzugehörigkeit",
      "hint": "Steuert, wie Benutzer Einheiten in dieser Kategorie zugewiesen werden.",
      "membershipRequired": "Jeder Benutzer muss mindestens einer Einheit in dieser Kategorie angehören.",
      "allowMultipleUnits": "Ein Benutzer darf mehreren Einheiten in dieser Kategorie angehören.",
      "allowNesting": "Eine Einheit darf einer anderen Einheit derselben Kategorie untergeordnet werden.",
      "allowNestingHint": "Aktivieren Sie dies, wenn Ihre Struktur zum Beispiel Teams innerhalb von Teams kennt. Ist es deaktiviert, kann eine Einheit nur der übergeordneten Kategorie untergeordnet werden.",
      "ancestorAutoRequiredHint": "Eine Pflichtkategorie macht implizit auch ihre übergeordneten Kategorien verpflichtend — andernfalls könnten Benutzer keine Einheit auswählen.",
      "impactWarn": "{count} bestehende(r) Benutzer haben derzeit keine Einheit in dieser Kategorie — die Konten bleiben aktiv, aber bei der nächsten Bearbeitung ist eine Auswahl erforderlich.",
      "impactSoftValidated": "Diese Kategorie hat noch keine Einheiten; die Pflicht-Einstellung wird erst wirksam, sobald Sie welche hinzufügen."
    },
    "externalIdLabel": {
      "heading": "Label für externe ID",
      "hint": "Das Feld für die externe ID ist auf jeder Einheit in dieser Kategorie immer vorhanden. Hier können Sie das Label umbenennen — zum Beispiel \"Kostenstellencode\". Leer lassen, um das Standardlabel \"Externe ID\" zu verwenden.",
      "labelFor": "Label ({locale})"
    }
  },
  "tenant": {
    "dashboard": {
      "heading": "Mein Dashboard",
      "intro": "Was auf Sie wartet, an einem Ort.",
      "loading": "Ihr Dashboard wird geladen…",
      "loadError": "Ihr Dashboard konnte nicht geladen werden.",
      "retry": "Erneut versuchen",
      "emptyTitle": "Gerade wartet nichts auf Sie",
      "emptyBody": "Sobald eine Aufgabe, eine Genehmigung, eine Schulung oder ein Antrag für Sie vorliegt, erscheint sie hier.",
      "block": {
        "loading": "Wird geladen…",
        "loadError": "Dieser Block konnte nicht geladen werden.",
        "retry": "Erneut versuchen",
        "viewAll": "Alle anzeigen",
        "count_one": "{count} offen",
        "count_other": "{count} offen"
      },
      "tasks": {
        "title": "Meine Aufgaben",
        "empty": "Sie haben keine offenen Aufgaben.",
        "openUntil": "Offen bis {date}",
        "submittedOn": "Eingereicht am {date}",
        "attendanceSince": "Anwesenheit offen seit {date}",
        "untitledActivity": "Schulung ohne Titel",
        "typeLink": "{label} ({count})",
        "kind": {
          "questionnaire": "Fragebogen",
          "grading": "Korrigieren",
          "attendance": "Anwesenheit"
        }
      },
      "approvals": {
        "title": "Offene Genehmigungen",
        "empty": "Es warten keine Genehmigungen auf Sie.",
        "unknownApplicant": "Unbekannte antragstellende Person",
        "decideBefore": "Entscheiden Sie vor dem {date}",
        "kind": {
          "enrollment": "Anmeldung",
          "cancellation": "Stornierung",
          "external_request": "Externe Weiterbildung",
          "other": "Antrag"
        }
      },
      "myCourses": {
        "title": "Meine Schulungen",
        "count_one": "{count} Schulung",
        "count_other": "{count} Schulungen",
        "empty": "Sie sind für nichts angemeldet, das etwas von Ihnen verlangt oder gerade läuft.",
        "progress": "{percent} % abgeschlossen",
        "state": {
          "waiting": "Wartet auf Sie",
          "active": "Läuft",
          "upcoming": "Steht an"
        },
        "action": {
          "respond_offer": "Ihnen wurde ein Platz angeboten: antworten Sie darauf",
          "fill_questionnaire_one": "Ein Fragebogen oder Test wartet auf Sie",
          "fill_questionnaire_other": "{count} Fragebögen oder Tests warten auf Sie",
          "start": "Noch nicht gestartet",
          "continue": "Fortsetzen",
          "attend": "Veranstaltung"
        }
      },
      "nextTraining": {
        "title": "Meine nächste Schulung",
        "empty": "Für Sie ist keine Schulung mehr geplant."
      },
      "myLessons": {
        "title": "Meine Unterrichtseinheiten diese Woche",
        "empty": "Sie unterrichten diese Woche nicht.",
        "count_one": "{count} Einheit",
        "count_other": "{count} Einheiten"
      },
      "session": {
        "inZone": "{when} (Zeitzone {zone})"
      },
      "myRequests": {
        "empty": "Sie haben keine laufenden Anträge.",
        "emptyCanStart": "Beantragen Sie eine Weiterbildung, die nicht im Katalog steht."
      }
    },
    "adminDashboard": {
      "heading": "Dashboard",
      "intro": "Was auf Ihrem Tisch liegt, was heute passiert ist und was es in Ihrer Umgebung gibt.",
      "loading": "Das Dashboard wird geladen…",
      "loadError": "Das Dashboard konnte nicht geladen werden.",
      "retry": "Erneut versuchen",
      "emptyTitle": "Hier gibt es noch nichts für Sie",
      "emptyBody": "Ihre Rechte umfassen keinen der Blöcke des Administrator-Dashboards. Nutzen Sie das Menü, um fortzufahren.",
      "nothingWaiting": "Es wartet nichts auf Sie.",
      "zones": {
        "waiting": "Was auf mich wartet",
        "today": "Was heute passiert ist",
        "now": "Was gerade passiert",
        "environment": "Was es in meiner Umgebung gibt"
      },
      "signals": {
        "title": "Signale",
        "empty": "Keine Signale.",
        "count_one": "{count} Signal",
        "count_other": "{count} Signale",
        "cancelledToday_one": "{count} Stornierung heute",
        "cancelledToday_other": "{count} Stornierungen heute",
        "belowMinimum": "Unter dem Minimum: {taken} von mindestens {minimum} Teilnehmenden",
        "decide": "Findet diese Schulung statt?"
      },
      "logins": {
        "title": "Angemeldet",
        "today": "Heute",
        "yesterday": "Zuletzt gestern"
      },
      "enrollmentsToday": {
        "title": "Anmeldungen heute",
        "enrolled": "Anmeldungen",
        "cancelled": "Stornierungen"
      },
      "logStrip": {
        "title": "Neu im Protokoll",
        "empty": "Noch keine Anmeldungen am System, Schulungsanmeldungen oder Stornierungen im Protokoll.",
        "someone": "Jemand",
        "login": "{name} hat sich angemeldet",
        "enrollment": "{name} hat sich für {course} angemeldet",
        "enrollmentNoCourse": "{name} hat sich angemeldet",
        "cancellation": "{name} hat {course} storniert",
        "cancellationNoCourse": "{name} hat eine Anmeldung storniert",
        "enrollmentByOther": "{actor} hat {participant} für {course} angemeldet",
        "enrollmentByOtherNoCourse": "{actor} hat {participant} angemeldet",
        "enrollmentNoActor": "{participant} wurde für {course} angemeldet",
        "enrollmentNoActorNoCourse": "{participant} wurde angemeldet",
        "cancellationByOther": "{actor} hat die Anmeldung von {participant} für {course} storniert",
        "cancellationByOtherNoCourse": "{actor} hat die Anmeldung von {participant} storniert",
        "cancellationNoActor": "Die Anmeldung von {participant} für {course} wurde storniert",
        "cancellationNoActorNoCourse": "Die Anmeldung von {participant} wurde storniert",
        "erased": "Gelöschter Benutzer"
      },
      "shortcuts": {
        "title": "Schnellzugriffe",
        "empty": "Keine Schnellzugriffe.",
        "users": "Aktive Benutzer",
        "catalog": "Katalog"
      },
      "failedCertificates": {
        "title": "Zertifikate nicht erstellt",
        "count_one": "{count} Zertifikat",
        "count_other": "{count} Zertifikate",
        "empty": "Alle Zertifikate wurden erstellt."
      },
      "documentTemplateUpdates": {
        "title": "Neue Version einer BCS-Vorlage",
        "count_one": "{count} Vorlage",
        "count_other": "{count} Vorlagen",
        "empty": "Keine neuen Versionen.",
        "versions": "Version {from} → {to}",
        "tenant_logo_changed": "Neues Logo der Umgebung",
        "tenant_logo_removed": "Logo der Umgebung entfernt"
      }
    },
    "sendMessage": {
      "title": "Nachricht senden",
      "intro": "Verfassen Sie eine Nachricht und wählen Sie, wer sie erhält. Vor dem Senden sehen Sie, wie viele Benutzer erreicht werden.",
      "subject": "Betreff",
      "body": "Nachricht",
      "audience": "Empfänger",
      "segmentType": "Zielgruppe",
      "types": {
        "individuals": "Einzelne Benutzer",
        "orgUnits": "Organisationseinheiten",
        "orgUnitManagers": "Manager von Einheiten",
        "everyone": "Alle",
        "everyoneHint": "Alle aktiven Benutzer."
      },
      "pickUsers": "Benutzer suchen und auswählen…",
      "pickUnits": "Einheiten suchen und auswählen…",
      "includeDescendants": "Untergeordnete Einheiten einbeziehen",
      "addSegment": "Zielgruppe hinzufügen",
      "attachments": "Anhänge",
      "addAttachment": "Anhang hinzufügen",
      "attachmentError": "Upload fehlgeschlagen — prüfen Sie Dateityp und -größe (max. 10 MB).",
      "timing": "Versandzeitpunkt",
      "when": "Wann senden",
      "whenNow": "Sofort",
      "whenLater": "Für Datum/Uhrzeit planen",
      "scheduledFor": "Senden am",
      "reaches": "Erreicht {count} Benutzer",
      "noAudience": "Noch keine Zielgruppe ausgewählt.",
      "send": "Senden",
      "sent": "Nachricht für {count} Empfänger eingeplant.",
      "confirmTitle": "Nachricht senden?",
      "confirmBody": "Diese Nachricht wird an {count} Benutzer gesendet.",
      "confirmBodyUnknown": "Möchten Sie diese Nachricht wirklich senden?",
      "confirmSend": "Ja, senden",
      "editor": {
        "toolbar": "Formatierung",
        "bold": "Fett",
        "italic": "Kursiv",
        "underline": "Unterstreichen",
        "heading": "Überschrift",
        "bulletList": "Aufzählung",
        "numberList": "Nummerierte Liste",
        "alignLeft": "Linksbündig",
        "alignCenter": "Zentrieren",
        "alignRight": "Rechtsbündig",
        "link": "Link einfügen",
        "linkPrompt": "Geben Sie eine https-URL ein:",
        "linkTitle": "Link einfügen",
        "linkTextLabel": "Text",
        "linkUrlLabel": "URL",
        "linkInsert": "Einfügen",
        "linkInvalid": "Verwenden Sie einen https://- oder mailto:-Link.",
        "linkChipHint": "Der Tag {tag} wird zum klickbaren Link.",
        "linkRemove": "Link entfernen"
      }
    }
  },
  "orgChart": {
    "heading": "Organigramm",
    "coverage": {
      "title": "Wer ist in {name}?",
      "back": "Zur Gruppe zurück",
      "today": "Das sind die Personen, die heute dazugehören. Eine Gruppe arbeitet mit Regeln, morgen können es also andere sein.",
      "ofTotal": "{members} von {total}",
      "emptyUnit": "keine Personen",
      "namedIncluded": "durch die Regel eingeschlossen",
      "namedExcluded": "durch die Regel ausgeschlossen",
      "legendFull": "alle gehören dazu",
      "legendSome": "ein Teil gehört dazu",
      "legendNone": "niemand gehört dazu",
      "legendNamedIncluded": "Regel nennt diese Einheit: einschließen",
      "legendNamedExcluded": "Regel nennt diese Einheit: ausschließen",
      "total": "Insgesamt {count} Personen.",
      "unplaced": "Davon gehören {count} zu keiner Einheit und werden hier nicht angezeigt.",
      "unavailable": "Wir konnten nicht laden, wen diese Gruppe umfasst."
    },
    "hint": "Ziehen Sie einen Block auf seine neue übergeordnete Einheit, um ihn zu verschieben; ziehen Sie den Hintergrund zum Verschieben der Ansicht, scrollen Sie zum Zoomen. Tastatur: Pfeiltasten = navigieren, Enter = Einheit bearbeiten, Leertaste = ein-/ausklappen.",
    "levelFilter": "Kategorien anzeigen",
    "search": "Einheit suchen…",
    "expandAll": "Alles ausklappen",
    "collapseAll": "Alles einklappen",
    "export": "Als Bild exportieren (PNG)",
    "exportPdf": "Als PDF herunterladen — gestochen scharfer Vektortext, auch bei großen Organigrammen",
    "print": "Organigramm drucken",
    "hits_one": "{count} Treffer — Enter springt dorthin",
    "hits_other": "{count} Treffer — Enter springt zum nächsten",
    "back": "Tabellenansicht",
    "fit": "Passend einblenden",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "expand": "Untergeordnete Einheiten ausklappen",
    "collapse": "Untergeordnete Einheiten einklappen",
    "members_one": "{count} Mitglied",
    "members_other": "{count} Mitglieder",
    "empty": "Noch keine Einheiten — legen Sie diese zuerst in der Tabellenansicht an.",
    "toUnits": "Zu den Organisationseinheiten"
  },
  "orgUnitsList": {
    "heading": "Einheiten nach Kategorie",
    "viewChart": "Organigramm",
    "intro": "Übersicht pro Kategorie. Klicken Sie auf einen Tab, um die Kategorie zu wechseln, und auf eine Zeile, um die Detailseite zu öffnen.",
    "level": "Kategorie",
    "searchPlaceholder": "Suche nach Name, externer ID, übergeordneter Einheit oder Attribut…",
    "addFor": "{level} hinzufügen",
    "empty": "Keine Einheiten in dieser Kategorie. Fügen Sie eine hinzu oder passen Sie Ihre Suche an.",
    "unknownUser": "Unbekannter Benutzer",
    "viewMembers": "{count} Mitglieder dieser Einheit anzeigen",
    "col": {
      "name": "Name",
      "parent": "Übergeordnete Einheit",
      "members": "Mitglieder"
    }
  },
  "unitDetail": {
    "loading": "Wird geladen…",
    "detailsHeading": "Details",
    "membersHeading": "Mitglieder",
    "membersNonLeafHint": "Benutzer hängen üblicherweise an der tiefsten Ebene; diese Einheit kann ebenfalls Mitglieder enthalten, das ist jedoch ungewöhnlich.",
    "noMembers": "Noch keine Mitglieder.",
    "childrenHeading": "Untergeordnete Einheiten",
    "noChildren": "Noch keine untergeordneten Einheiten."
  },
  "userProfile": {
    "avatar": {
      "heading": "Profilbild",
      "upload": "Foto hochladen",
      "replace": "Foto ersetzen",
      "remove": "Entfernen",
      "present": "Es ist ein Profilbild hinterlegt",
      "cropTitle": "Foto zuschneiden",
      "cropHint": "Ziehen Sie zum Verschieben und nutzen Sie den Regler zum Zoomen.",
      "cropZoom": "Zoom",
      "cropConfirm": "Übernehmen"
    },
    "loading": "Wird geladen…",
    "openLink": "Profil",
    "detailsHeading": "Profildetails",
    "assignmentsHeading": "Organisationszugehörigkeit",
    "assignmentsHint": "Wählen Sie pro Kategorie die Einheit(en), zu denen dieser Benutzer gehört. Eine Unterkategorie wird verfügbar, sobald die übergeordnete Kategorie ausgefüllt ist.",
    "noCategories": "Keine Kategorien definiert — bitten Sie BCS Learning, die Organisationsstruktur einzurichten.",
    "noUnitsForCategory": "Keine Einheiten in \"{category}\" — fügen Sie zuerst welche über die Organisationsstruktur hinzu.",
    "pickPlaceholder": "Auswählen…",
    "pickerLockedNoParent": "Füllen Sie zuerst \"{parent}\" aus, um diese Auswahl zu aktivieren.",
    "cascadeClearedToast": "Entfernt aus \"{category}\": {names} (übergeordnete Einheit geändert)",
    "save": "Speichern",
    "savedToast": "Zuweisungen gespeichert.",
    "saveError": "Speichern fehlgeschlagen — prüfen Sie die Fehler pro Kategorie.",
    "customFieldsHeading": "Zusätzliche Felder",
    "deletedBanner": "Dieser Benutzer wurde gelöscht. Die Bearbeitung ist deaktiviert — Sie können den Benutzer wiederherstellen oder seine Daten endgültig löschen.",
    "lastLogin": "Zuletzt angemeldet: {when}",
    "lastLoginNever": "Noch nie angemeldet",
    "restore": "Benutzer wiederherstellen",
    "restoreError": "Wiederherstellen fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "gdpr": {
      "heading": "Datenschutz (DSGVO)",
      "intro": "Exportieren Sie alle Daten dieses Benutzers oder löschen Sie sie auf Anfrage endgültig.",
      "export": "Daten exportieren",
      "exportError": "Export fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "erase": "Daten löschen",
      "eraseError": "Löschen fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "eraseConfirmTitle": "Daten endgültig löschen?",
      "eraseConfirmBody": "Dies entfernt {name} unwiderruflich: Profil, Verknüpfungen und Zugehörigkeiten. Für den Audit-Trail bleiben anonymisierte Spuren erhalten. Dies kann nicht rückgängig gemacht werden.",
      "eraseConfirmLabel": "Geben Sie zur Bestätigung die E-Mail-Adresse ein: {email}"
    }
  },
  "tenantUsers": {
    "heading": "Benutzer",
    "impersonate": "Anmelden als",
    "impersonateFailed": "Die Anmeldung als diese Person ist fehlgeschlagen.",
    "new": "Neuer Benutzer",
    "edit": "Benutzer bearbeiten — {name}",
    "empty": "Noch keine Benutzer.",
    "confirmDelete": "Benutzer löschen?",
    "confirmDeleteBody": "{name} wird vorläufig gelöscht (Soft-Delete). Der Audit-Trail bleibt erhalten.",
    "viewDeleted": "Gelöschte Benutzer",
    "backToActive": "Zurück zu aktiven Benutzern",
    "deletedHeading": "Gelöschte Benutzer",
    "deletedListIntro": "Sie sehen gelöschte Benutzer. Öffnen Sie ein Profil, um den Benutzer wiederherzustellen oder seine Daten endgültig zu löschen.",
    "deletedEmpty": "Keine gelöschten Benutzer.",
    "bulkErase": "Endgültig löschen ({count})",
    "bulkEraseTitle": "Benutzer endgültig löschen?",
    "bulkEraseBody": "Sie sind dabei, {count} Benutzer unwiderruflich zu löschen: Profile, Verknüpfungen und Zugehörigkeiten. Für den Audit-Trail bleiben anonymisierte Spuren erhalten. Dies kann nicht rückgängig gemacht werden.",
    "bulkEraseConfirmLabel": "Geben Sie zur Bestätigung die Anzahl ein: {count}",
    "bulkEraseConfirm": "Endgültig löschen",
    "bulkEraseError": "Löschen fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "bulkEraseDone": "{count} Benutzer endgültig gelöscht.",
    "bulkEraseDoneSkipped": "{count} Benutzer endgültig gelöscht; {skipped} übersprungen (letzter Administrator).",
    "bulkEraseDonePartial": "{count} Benutzer endgültig gelöscht. {failed} konnten nicht gelöscht werden und stehen weiterhin in der Liste; der Fehler wurde gemeldet.",
    "bulkEraseDonePartialSkipped": "{count} Benutzer endgültig gelöscht; {skipped} übersprungen (letzter Administrator). {failed} konnten nicht gelöscht werden und stehen weiterhin in der Liste; der Fehler wurde gemeldet.",
    "fields": {
      "name": "Name",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "displayNameLabel": "Anzeigename:",
      "email": "E-Mail",
      "role": "Rolle",
      "status": "Status",
      "isExternal": "Externe Person",
      "isExternalHint": "Kein Beschäftigungsverhältnis mit dieser Organisation — etwa eine prüfende Person, eine freiberufliche Lehrkraft oder ein Subunternehmer. Eine Nachricht an \"alle\" erreicht externe Konten standardmäßig nicht.",
      "isLearner": "Nimmt an Schulungen teil",
      "isLearnerHint": "Diese Person lernt und zählt in der Auswertung abgeschlossener Aktivitäten mit. Unabhängig von extern: ein Subunternehmer ist extern und lernend, eine prüfende Person extern und nicht lernend. Aus bedeutet auch: keine Basisrolle Benutzer.",
      "externalId": "Externe ID",
      "phone": "Telefon",
      "hireDate": "Eintrittsdatum",
      "endDate": "Austrittsdatum",
      "accountValidFrom": "Konto gültig ab",
      "accountValidFromHint": "Vor diesem Datum kann sich die Person noch nicht anmelden. Leer = sofort gültig.",
      "accountValidUntil": "Konto gültig bis",
      "accountValidUntilHint": "Nach diesem Datum kann sich der Benutzer nicht mehr anmelden. Leer = unbegrenzt gültig.",
      "deletedAt": "Gelöscht am",
      "roles": "Rollen"
    },
    "status": {
      "active": "Aktiv",
      "invited": "Eingeladen",
      "suspended": "Gesperrt",
      "expired": "Abgelaufen",
      "not_yet_valid": "Noch nicht gültig"
    },
    "roles": {
      "tenant-admin": "Administrator",
      "user": "Benutzer"
    },
    "filteredByUnit": "Gefiltert auf Mitglieder von \"{unit}\".",
    "clearFilter": "Alle Benutzer anzeigen",
    "baseRoleNote": "Jeder neue Benutzer erhält zusätzlich die Basisrolle Benutzer.",
    "createdButRoleFailed": "Der Benutzer wurde angelegt, aber es konnten nicht alle Rollen zugewiesen werden:",
    "toProfile": "Zum Profil",
    "filteredByRole": "Nur Benutzer mit der Rolle „{role}“.",
    "manageRoles": "Rollen und Geltungsbereich verwalten →",
    "pickRoles": "Wählen Sie eine oder mehrere Rollen"
  },
  "orgUnits": {
    "heading": "Organisationseinheiten",
    "missingParent": "Erforderliche übergeordnete Einheit fehlt",
    "missingParentBanner_one": "{count} Einheit sollte laut aktueller Struktur unter einer übergeordneten Einheit hängen, hat aber keine. Verknüpfen Sie sie über Bearbeiten.",
    "missingParentBanner_other": "{count} Einheiten sollten laut aktueller Struktur unter einer übergeordneten Einheit hängen, haben aber keine. Verknüpfen Sie sie über Bearbeiten.",
    "intro": "Füllen Sie die vom Superadmin definierte Baumstruktur. Fügen Sie untergeordnete Einheiten hinzu, bearbeiten Sie Attribute und weisen Sie Tenant-Benutzer zu.",
    "new": "Einheit hinzufügen",
    "edit": "Einheit bearbeiten",
    "empty": "Noch keine Einheiten. Fügen Sie oben Ihre erste Organisation hinzu.",
    "noLevelsTitle": "Keine Kategorien definiert",
    "noLevelsBody": "Bitten Sie BCS Learning, mindestens eine Kategorie zu definieren, bevor Sie Einheiten hinzufügen können.",
    "confirmDelete": "Einheit löschen?",
    "confirmDeleteBody": "Soft-Delete von {name}. Das ist erst möglich, wenn die Einheit leer ist: keine Mitarbeitenden darin und keine Einheiten darunter.",
    "impactUnavailable": "Wir konnten nicht laden, was von dieser Einheit abhängt. Versuchen Sie es erneut, bevor Sie löschen.",
    "impact": {
      "blockedLead": "Derzeit nicht möglich — die Einheit ist nicht leer:",
      "losingLead": "Das entfällt, sobald Sie löschen:",
      "users": "{count} Mitarbeitende befinden sich noch darin",
      "children": "{count} Einheit(en) liegen darunter",
      "roleAssignments": "{count} Rollenzuweisung(en) mit Geltungsbereich auf dieser Einheit gewähren dann nichts mehr",
      "accessGroups": "{count} Zugriffsgruppe(n) werden defekt und umfassen niemanden mehr",
      "exclusions": "Achtung: {count} Zugriffsgruppe(n) schließen diese Einheit aus. Auch sie werden defekt und umfassen niemanden mehr — bis Sie sie reparieren.",
      "nothingAttached": "Von dieser Einheit hängt sonst nichts ab.",
      "groupNames": "Betroffen sind: {names}."
    },
    "assignTitle": "Benutzer einer Einheit zuweisen",
    "assignBody": "Wählen Sie einen Benutzer, der {name} zugewiesen werden soll. Nur aktive Zuweisungen werden im Benutzerprofil angezeigt.",
    "assign": "Zuweisen",
    "fields": {
      "level": "Kategorie",
      "name": "Name",
      "externalId": "Externe ID",
      "externalIdHint": "Stabile ID aus Ihrem HR-System — wird beim erneuten Import desselben Datensatzes verwendet.",
      "attributes": "Zusätzliche Attribute",
      "attributesHint": "Werte für die zusätzlichen Felder, die im Schema dieser Kategorie definiert sind.",
      "parent": "Übergeordnete Einheit",
      "parentOf": "Übergeordnete {level}",
      "parentHintFree": "Optional. Die Einheit, unter der diese in der Baumstruktur hängt.",
      "parentHintConstrained": "Diese Kategorie hängt unter \"{level}\" — nur Einheiten dieser Kategorie werden angezeigt.",
      "parentRequired": "Diese Kategorie muss unter einer übergeordneten Einheit hängen — wählen Sie eine aus.",
      "pickParent": "wählen Sie eine übergeordnete Einheit",
      "noParent": "— keine übergeordnete Einheit (Root) —",
      "user": "Benutzer"
    }
  },
  "fieldSchema": {
    "empty": "Noch keine zusätzlichen Felder. Klicken Sie auf \"Feld hinzufügen\", um das erste zu definieren.",
    "addField": "Feld hinzufügen",
    "fields": {
      "key": "Schlüssel",
      "type": "Typ",
      "required": "Pflichtfeld",
      "labelFor": "Bezeichnung ({locale})",
      "role": "Rolle"
    },
    "dragHandle": "Zum Sortieren ziehen",
    "labels": {
      "expand": "Bezeichnungen anzeigen",
      "collapse": "Bezeichnungen ausblenden",
      "none": "Keine Bezeichnungen ausgefüllt",
      "collapsedSummary": "Bezeichnungen ausgefüllt für:"
    },
    "errors": {
      "invalidKey": "Verwenden Sie Kleinbuchstaben, Ziffern, Bindestriche oder Unterstriche (z. B. \"cost_center\").",
      "duplicateKey": "Dieser Schlüssel wird in dieser Kategorie bereits verwendet."
    },
    "roles": {
      "none": "Keine Rolle (eigenes Feld)"
    }
  },
  "orgFields": {
    "types": {
      "string": "Text (einzeilig)",
      "text": "Text (mehrzeilig)",
      "email": "E-Mail",
      "number": "Zahl",
      "date": "Datum",
      "boolean": "Ja / Nein",
      "userid": "Benutzer (z. B. Manager)"
    }
  },
  "attributeForm": {
    "noFields": "Diese Kategorie hat keine zusätzlichen Felder.",
    "required": "Dieses Feld ist ein Pflichtfeld.",
    "boolean": {
      "label": "Ja"
    }
  },
  "profile": {
    "prefs": {
      "heading": "Einstellungen",
      "rememberDrafts": "Entwürfe in Formularen merken",
      "rememberDraftsHint": "Speichert Ihre Eingaben lokal auf allen Seiten, damit nichts verloren geht."
    },
    "mfa": {
      "title": "Zwei-Schritt-Verifizierung",
      "intro": "Ein zusätzlicher Schritt beim Anmelden, zusätzlich zu Ihrem Passwort. Sie benötigen dafür eine Authenticator-App.",
      "start": "Einrichten",
      "qrAlt": "QR-Code für Ihre Authenticator-App",
      "secretHint": "Keine Kamera? Geben Sie diesen Schlüssel von Hand ein:",
      "code": "Code aus der App",
      "confirm": "Aktivieren",
      "on": "Die Zwei-Schritt-Verifizierung ist aktiviert.",
      "newCodes": "Neue Wiederherstellungscodes",
      "disable": "Deaktivieren",
      "codesTitle": "Bewahren Sie diese Wiederherstellungscodes auf",
      "codesHint": "Sie sehen sie nur einmal. Bewahren Sie sie außerhalb Ihres Telefons auf — ohne einen dieser Codes kommen Sie nicht mehr hinein, wenn Sie Ihre App verlieren.",
      "genericError": "Das hat nicht geklappt. Bitte versuchen Sie es erneut."
    },
    "heading": "Mein Profil",
    "intro": "Aktualisieren Sie Ihre eigenen Daten. Ihre E-Mail bleibt unverändert — Ihr Audit-Trail ist daran geknüpft.",
    "saved": "Gespeichert.",
    "fields": {
      "email": "E-Mail",
      "name": "Name",
      "locale": "Sprache",
      "localeHint": "Die Sprache, in der die App angezeigt wird."
    }
  },
  "tenantAuth": {
    "title": "Sie werden angemeldet",
    "verifying": "Ihr Anmeldelink wird überprüft…",
    "success": "Angemeldet! Sie werden zu Ihrem Arbeitsbereich weitergeleitet.",
    "failedTitle": "Anmeldung fehlgeschlagen",
    "genericError": "Anmeldung nicht möglich. Bitten Sie Ihren Administrator um einen neuen Anmeldelink.",
    "sessionExpired": "Ihre Sitzung ist abgelaufen. Öffnen Sie Ihre Dev-Login-URL erneut, um sich wieder anzumelden.",
    "needLoginUrl": "Melden Sie sich an, indem Sie die Dev-Login-URL öffnen, die Ihnen Ihr Administrator geschickt hat.",
    "loginUrlHint": "Jede URL funktioniert nur einmal und läuft nach 15 Minuten ab — fordern Sie eine neue an, wenn Sie sie bereits verwendet haben.",
    "backHome": "Zurück zur Startseite",
    "form": {
      "title": "Anmelden",
      "email": "E-Mail-Adresse",
      "password": "Passwort",
      "remember": "Angemeldet bleiben",
      "submit": "Anmelden",
      "forgotLink": "Passwort vergessen?",
      "loading": "Wird geladen…",
      "genericError": "Anmeldung fehlgeschlagen. Bitte prüfen Sie Ihre Angaben und versuchen Sie es erneut."
    },
    "forgot": {
      "title": "Passwort vergessen?",
      "intro": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link, um ein neues Passwort festzulegen.",
      "email": "E-Mail-Adresse",
      "submit": "Reset-Link senden",
      "done": "Falls zu dieser Adresse ein Konto gehört, ist ein Reset-Link unterwegs. Prüfen Sie Ihren Posteingang.",
      "backToLogin": "Zurück zur Anmeldung",
      "genericError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
    },
    "reset": {
      "title": "Neues Passwort festlegen",
      "intro": "Wählen Sie ein neues Passwort für Ihr Konto.",
      "password": "Neues Passwort",
      "passwordConfirmation": "Neues Passwort bestätigen",
      "submit": "Passwort festlegen",
      "success": "Ihr Passwort wurde festgelegt. Sie können sich jetzt anmelden.",
      "toLogin": "Zur Anmeldung",
      "invalid": "Dieser Reset-Link ist ungültig oder abgelaufen. Fordern Sie einen neuen an.",
      "genericError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      "missingToken": "Diese Seite benötigt einen gültigen Reset-Link. Verwenden Sie den Link aus Ihrer E-Mail."
    },
    "bcs": {
      "title": "Anmelden",
      "lead": "Melden Sie sich mit Ihrem BCS-Konto an.",
      "button": "Mit BCS anmelden",
      "failedTitle": "Anmeldung fehlgeschlagen",
      "failedBody": "Bei der Anmeldung mit BCS ist etwas schiefgelaufen. Bitte versuchen Sie es erneut."
    }
  },
  "imports": {
    "heading": "Benutzerimporte",
    "intro": "Konfigurierte Importquellen für diesen Tenant. Jede Quelle beschreibt einen HR-Export-Feed (Datei oder Feed) und wie dessen Spalten auf Plattform-Benutzer + Einheiten abgebildet werden. Aktive Quellen können nach Zeitplan laufen.",
    "sources": {
      "heading": "Importquellen",
      "intro": "Jede Zeile ist ein konfigurierter Feed — Datei-Upload, FTP-Ordner oder API. Öffnen Sie einen Eintrag, um den Assistenten erneut zu durchlaufen.",
      "new": "Neue Importquelle",
      "run": "Ausführen",
      "empty": "Noch keine Importquellen konfiguriert. Klicken Sie auf \"Neue Importquelle\", um den Assistenten zu starten.",
      "confirmDelete": "\"{name}\" löschen? Bereits darüber importierte Benutzer und Einheiten bleiben bestehen — nur die Verknüpfung zur Quelle wird entfernt.",
      "scheduleActive": "Aktiv",
      "scheduleOff": "Zeitplan deaktiviert",
      "scheduleNoTimes": "Aktiv, aber noch keine Uhrzeiten konfiguriert",
      "scheduleAt": "Läuft täglich um {times}",
      "types": {
        "csv_upload": "CSV-Upload",
        "csv_sftp": "FTP / SFTP",
        "api": "API"
      }
    },
    "preview": {
      "results": "Vorschau-Ergebnisse",
      "downloadExcel": "Als Excel herunterladen",
      "columnMismatchBanner": "Eine oder mehrere Dateien stimmen nicht mit der gespeicherten Spaltenzuordnung überein — Felder ohne Spalte bleiben beim Import leer. Prüfen Sie unten pro Slot die Liste der fehlenden Spalten, bevor Sie fortfahren.",
      "missingColumns": "Fehlt in der Datei",
      "extraColumns": "Zusätzlich in der Datei (wird ignoriert)",
      "errorClustersHeading": "Fehlerübersicht ({n} insgesamt) — zum Aufklappen klicken",
      "summary": {
        "rows": "Zeilen",
        "users": "Benutzer",
        "units": "Einheiten",
        "assignments": "Zuweisungen",
        "errors": "Fehler",
        "create": "{n} anlegen",
        "update": "{n} aktualisieren",
        "unchanged": "{n} unverändert",
        "skip": "{n} überspringen",
        "noFile": "Keine Datei für diesen Slot bereitgestellt."
      },
      "table": {
        "row": "#",
        "actions": "Geplante Aktionen",
        "errors": "Fehler",
        "empty": "Nichts anzuzeigen — die Datei enthält keine Zeilen.",
        "capped": "Angezeigt werden die ersten 50 Zeilen + alle Fehlerzeilen. Laden Sie das Excel für die vollständige Liste herunter."
      },
      "ops": {
        "create": "Anlegen",
        "update": "Aktualisieren",
        "skip_unchanged": "Unverändert",
        "skip": "Überspringen",
        "skip_duplicate": "Duplikat",
        "excluded": "Ausgeschlossen",
        "error": "Fehler"
      },
      "opsShort": {
        "create": "neu",
        "update": "aktualisiert",
        "unchanged": "unverändert"
      }
    },
    "run": {
      "title": "Import ausführen",
      "intro": "Legen Sie die Quelldateien für diese Konfiguration ab. Jede Datei wird anhand des Namens einem konfigurierten Slot zugeordnet — prüfen Sie die Treffer, korrigieren Sie Abweichungen und führen Sie einen Dry-Run aus, bevor Sie den Import übernehmen.",
      "dropHere": "CSV-Dateien hierher ziehen",
      "orPick": "oder klicken, um Dateien auszuwählen",
      "filesHeading": "Dateien",
      "filesEmpty": "Noch keine Dateien. Legen Sie oben eine oder mehrere CSV-Dateien ab.",
      "vendorHeading": "Vendor-Import — kein Upload erforderlich",
      "vendorBody": "Datensätze werden live aus der {vendor}-API abgerufen, wenn Sie auf Vorschau oder Ausführen klicken. Die im Zuordnungsschritt konfigurierten Slots werden der Reihe nach abgefragt.",
      "matchedSlot": "Zugeordneter Slot",
      "noMatch": "Kein passender Slot",
      "skip": "Diese Datei überspringen",
      "duplicateMatch": "Zwei Dateien sind demselben Slot zugeordnet — wählen Sie für eine davon einen anderen Slot.",
      "missingSlots": "Für diese konfigurierten Slots liegt noch keine Datei vor: {slots}",
      "headerToggle": "Erste Zeile enthält Spaltentitel",
      "headerToggleHint": "Aus = die erste Zeile wird als Daten behandelt und die Spalten erhalten Buchstaben A/B/C im Excel-Stil.",
      "removeFile": "Entfernen",
      "runPreview": "Vorschau starten",
      "rerun": "Vorschau erneut ausführen",
      "running": "Vorschau läuft…",
      "noFilesPicked": "Wählen Sie mindestens eine CSV-Datei, um die Vorschau auszuführen.",
      "commit": "Import übernehmen",
      "skipExisting": "{n} bereits verknüpft",
      "confirmTitle": "Diesen Import übernehmen?",
      "confirmBody": "Der Dry-Run ist schreibgeschützt; dieser Schritt schreibt alles in die Datenbank. Dieselben Dateien später erneut zu importieren ist sicher — bereits importierte Zeilen werden direkt aktualisiert.",
      "confirmErrorsHint": "Einige Zeilen hatten in der Vorschau Fehler. Diese Zeilen werden bei der Übernahme übersprungen; der Rest wird normal verarbeitet.",
      "confirmGo": "Ja, übernehmen",
      "successTitle": "Import übernommen",
      "successCount": "{n} Zeilen geändert",
      "successDone": "Zurück zur Übersicht",
      "remoteFilesHeading": "Dateien auf dem Server",
      "slotResolveHeading": "Slot → Dateizuordnung",
      "slotResolveNoPattern": "(kein Match-Muster gesetzt; Slot läuft nicht)",
      "slotResolveNoMatch": "(keine passende Datei auf dem Server)",
      "remoteFilesHint": "Aktueller Inhalt von {path} auf dem FTP-Server. Der Import-Job wählt die neueste Datei, die zum Muster des jeweiligen Slots passt.",
      "refreshRemote": "Aktualisieren",
      "remoteEmpty": "Noch keine Dateien im konfigurierten Remote-Ordner.",
      "confirmCommit": "Endgültig übernehmen"
    },
    "runs": {
      "heading": "Letzte Läufe",
      "intro": "Alle Importversuche — laufende Entwürfe, abgeschlossene Läufe und etwaige Fehlschläge.",
      "empty": "Noch keine Läufe für diesen Tenant.",
      "discard": "Verwerfen",
      "confirmDiscard": "Diesen Importlauf verwerfen? Die hochgeladenen Dateien und geparsten Zeilen werden entfernt. Übernommene Läufe können nicht verworfen werden.",
      "unnamedMapping": "(Zuordnung gelöscht)",
      "rowsSummary": "+{created} neu · ~{updated} aktualisiert · {failed} fehlgeschlagen",
      "status": {
        "draft": "Entwurf",
        "dry_run": "Dry-Run",
        "running": "Läuft",
        "succeeded": "Erfolgreich",
        "failed": "Fehlgeschlagen",
        "cancelled": "Abgebrochen"
      }
    },
    "runDetail": {
      "title": "Importlauf",
      "source": "Quelle",
      "noSource": "(unbekannte Quelle)",
      "mapping": "Zuordnung",
      "actor": "Gestartet von",
      "noActor": "(automatisch)",
      "startedAt": "Gestartet",
      "finishedAt": "Abgeschlossen",
      "duration": "Dauer",
      "totalsHeading": "Gesamtwerte",
      "noChange": "Keine Änderungen",
      "slotsHeading": "Pro Datei",
      "errorRowsHeading": "Zeilen mit Fehlern",
      "errorRowsHint": "Aus Speichergründen auf 50 Zeilen begrenzt. Der Excel-Export des Dry-Runs enthält die vollständige Liste.",
      "noDetail": "Dieser Lauf wurde von einem älteren Import-Ablauf erstellt, der keine detaillierte Zusammenfassung gespeichert hat.",
      "failureTitle": "Lauf fehlgeschlagen — es wurden keine Änderungen gespeichert",
      "failureBody": "Die Engine hat einen Fehler ausgelöst und die gesamte Transaktion zurückgerollt. Die Daten sind im Zustand von vor dem Lauf; Sie können die Eingabe korrigieren und einen neuen Lauf starten."
    },
    "wizard": {
      "titleNew": "Neue Importquelle",
      "titleEdit": "Importquelle bearbeiten",
      "stepperLabel": "Assistenten-Schritte",
      "back": "Zurück",
      "nextStep": "Weiter",
      "finish": "Fertigstellen",
      "vendorDocsLink": "{vendor}-Dokumentation →",
      "steps": {
        "type": "Typ & Name",
        "connection": "Verbindung",
        "mapping": "Zuordnung",
        "exclusions": "Ausschlüsse",
        "schedule": "Zeitplan"
      },
      "step1": {
        "heading": "Schritt 1 — Typ & Name",
        "hint": "Wählen Sie, wie dieser Tenant Daten anliefert. Phase 1 umfasst nur den Datei-Upload; FTP und API folgen.",
        "name": "Name",
        "nameRequired": "Geben Sie der Quelle einen wiedererkennbaren Namen.",
        "type": "Quellentyp",
        "types": {
          "csv_upload": "CSV-Upload",
          "csv_uploadHint": "Das Implementierungsteam lädt die Datei(en) jedes Mal manuell hoch.",
          "csv_sftp": "FTP / SFTP",
          "csv_sftpHint": "Dateien werden nach Zeitplan von einem FTP-, SFTP- oder FTPS-Server abgeholt.",
          "api": "API",
          "comingSoon": "Demnächst verfügbar"
        },
        "vendorConfig": "{vendor}-Konfiguration",
        "testVendorConn": "Verbindung testen",
        "testVendorOk": "Verbindung funktioniert! Slot \"{slot}\" getestet, {n} Beispieldatensatz abgerufen.",
        "testVendorFail": "Verbindung fehlgeschlagen"
      },
      "fileBrowser": {
        "heading": "Serverdateien durchsuchen",
        "hint": "Klicken Sie eine Datei an, um sie als Beispiel für diesen Slot zu verwenden. Der Dateiname wird zugleich das Match-Muster des Slots für geplante Läufe (pro Lauf wird die neueste passende Datei gewählt).",
        "empty": "Keine CSV / TXT / TSV-Dateien im konfigurierten Remote-Ordner."
      },
      "connection": {
        "heading": "Verbindungsdaten",
        "hint": "Woher der Import-Job die Dateien abholen soll. Wählen Sie das Protokoll, das Ihr HR-System unterstützt; der Rest des Formulars passt sich dieser Wahl an.",
        "protocol": "Protokoll",
        "protocols": {
          "sftp": "SFTP (SSH)",
          "ftp": "FTP (unverschlüsselt)",
          "ftps_explicit": "FTPS — explizites TLS (Port 21)",
          "ftps_implicit": "FTPS — implizites TLS (Port 990)"
        },
        "host": "Host",
        "port": "Port",
        "portHint": "Leer lassen für den Standardport des Protokolls (22 für SFTP, 21 für FTP/FTPS-explizit, 990 für FTPS-implizit).",
        "remotePath": "Remote-Ordner",
        "remotePathHint": "Wo der Import nach Dateien sucht. Standardmäßig das Home-Verzeichnis des Servers.",
        "username": "Benutzername",
        "password": "Passwort",
        "passwordSftpHint": "Optional bei SFTP — leer lassen, wenn Sie stattdessen Key-basierte Authentifizierung verwenden.",
        "passwordFtpHint": "Erforderlich für FTP / FTPS.",
        "passwordSavedPlaceholder": "(gespeichert — leer lassen, um zu behalten)",
        "privateKey": "Privater SSH-Schlüssel",
        "privateKeyHint": "Wählen Sie die .pem- / .key-Datei. Wir lesen nur den Textinhalt; die Datei selbst wird nie unverändert hochgeladen. Verschlüsselt gespeichert.",
        "privateKeyLoaded": "Schlüssel geladen — wird im nächsten Schritt gespeichert.",
        "privateKeyAlreadySaved": "(gespeichert — neue Datei wählen, um zu ersetzen)",
        "passphrase": "Schlüssel-Passphrase",
        "passphraseHint": "Nur ausfüllen, wenn die SSH-Schlüsseldatei selbst mit einer Passphrase verschlüsselt ist.",
        "passphraseSavedPlaceholder": "(gespeichert — leer lassen, um zu behalten)",
        "hostFingerprint": "Host-Fingerprint (optional)",
        "hostFingerprintHint": "SHA-256-Fingerprint des öffentlichen Host-Schlüssels des Servers. Wenn gesetzt, verweigern wir die Verbindung bei einer Abweichung — nützlich als MITM-Schutz bei lang laufenden Zeitplänen.",
        "testButton": "Verbindung testen",
        "testNeedsSave": "Speichern Sie die Verbindung zuerst, testen Sie danach.",
        "testSuccess": "Verbunden — {n} Datei(en) im Remote-Ordner gefunden.",
        "testFailure": "Verbindung fehlgeschlagen"
      },
      "step2": {
        "heading": "Schritt 2 — Zuordnung",
        "hint": "Pro Datei: Laden Sie eine CSV hoch, um fünf Beispielzeilen zu sehen, und verbinden Sie dann jede Spalte mit einem Plattformfeld. Eine einzelne Zeile kann einen Benutzer PLUS eine oder mehrere Einheiten auf beliebigen Org-Ebenen erzeugen — wählen Sie pro Spalte das richtige Ziel.",
        "hintVendor": "Pro Endpoint: Rufen Sie ein Beispiel vom Vendor ab, um fünf Beispieldatensätze zu sehen, und verbinden Sie dann jedes Feld mit einem Plattformfeld. Eine einzelne Zeile kann einen Benutzer PLUS eine oder mehrere Einheiten auf beliebigen Org-Ebenen erzeugen — wählen Sie pro Spalte das richtige Ziel.",
        "addFile": "Datei hinzufügen",
        "addEndpoint": "Endpoint hinzufügen",
        "empty": "Noch keine Dateien konfiguriert. Klicken Sie auf \"Datei hinzufügen\", um zu beginnen.",
        "slotLabel": "Datei {n}",
        "slotName": "Slot-Name",
        "matchFilename": "Dateinamen-Match (optional)",
        "hasHeaderRow": "Erste Zeile enthält Spaltentitel",
        "uploadSample": "Beispiel-CSV hochladen",
        "replaceSample": "Beispiel ersetzen",
        "pickServerFile": "Datei vom Server wählen",
        "replaceServerFile": "Serverdatei ersetzen",
        "fetchVendorSample": "Beispiel vom Vendor abrufen",
        "refreshVendorSample": "Vendor-Beispiel aktualisieren",
        "slotNameNeededForSample": "Wählen Sie zuerst einen Slot, damit wir wissen, welcher Vendor-Endpoint abgefragt werden soll.",
        "pickVendorSlot": "— Endpoint wählen —",
        "slotLabelInput": "Label (optional)",
        "slotLabelInputHint": "Ein sprechender Name für Laufberichte und Dashboards. Leer lassen, um den Endpoint-Key zu verwenden.",
        "slotLabelPlaceholder": "Mitarbeiter — Zentrale",
        "serverFileSampleNeeded": "noch keine Vorschau — wählen Sie die Datei erneut, um zu aktualisieren",
        "rowCount": "({n} Zeilen)",
        "sampleHeading": "Beispielvorschau (5 über die Datei verteilte Zeilen)",
        "mapHeading": "Spaltenzuordnung",
        "mapHint": "Wählen Sie, welches Plattformfeld jede CSV-Spalte füllt. Lassen Sie \"Überspringen\" stehen, wenn eine Spalte nicht importiert werden soll. Mehrere Spalten können auf unterschiedliche Entitäten zielen (z. B. Benutzerfelder + Abteilungsfelder + Rollenfelder in derselben Zeile).",
        "mapWithoutSampleHint": "Laden Sie die CSV erneut hoch, um die Beispielzeilen zu sehen. Die untenstehende Zuordnung wurde früher gespeichert und gilt weiterhin.",
        "skipColumn": "Diese Spalte überspringen",
        "groupUser": "Benutzer",
        "groupOrgUnit": "Organisationseinheit: {level}",
        "fields": {
          "external_id": "Externe ID",
          "name": "Vollständiger Name",
          "first_name": "Vorname",
          "last_name": "Nachname",
          "email": "E-Mail",
          "locale": "Sprache",
          "status": "Status",
          "parent_external_id": "Übergeordnet (externe ID)",
          "parent_external_id_named": "Übergeordnet: {parent} (externe ID)",
          "parent_same_level_external_id": "Übergeordnete {level} auf derselben Ebene (externe ID)",
          "user_unit_link": "Verknüpfung mit {level} (über externe ID)"
        },
        "transformLabel": "Normalisieren",
        "transforms": {
          "none": "Keine (Rohwert)",
          "trim": "Leerzeichen am Rand entfernen",
          "digits_only": "Nur Ziffern (310.031.100.010 → 310031100010)",
          "strip_dots": "Punkte entfernen (1.234 → 1234)",
          "lowercase": "Kleinbuchstaben",
          "uppercase": "Großbuchstaben"
        },
        "prefixLabel": "Präfix",
        "prefixPlaceholder": "fester Text oder ein Template",
        "idHint": "Identifikator-Spalten können vor dem Abgleich normalisiert + mit einem Präfix versehen werden. Präfix-Templates können andere Zellen derselben Zeile einbeziehen, indem der Spaltentitel in geschweifte Klammern gesetzt wird. Konfigurieren Sie beide Seiten einer dateiübergreifenden Verknüpfung mit demselben Präfix + derselben Transformation — andernfalls behandelt die Engine sie als unterschiedliche IDs."
      },
      "exclusions": {
        "heading": "Ausschlüsse",
        "hint": "Benutzer + Einheiten, die übersprungen werden, auch wenn sie in den Quelldateien vorkommen. Identifikatoren werden gegen den ENDGÜLTIGEN Wert nach Präfix/Transformation abgeglichen, den die Engine schreibt (also dieselbe ID, die Sie auf der Plattform sehen). Ein Eintrag pro Zeile.",
        "unitsLabel": "Auszuschließende Einheiten — {level}",
        "unitsHint": "Externe IDs von Einheiten auf dieser Ebene, die übersprungen werden sollen. Ein Benutzer ohne verbleibende Verknüpfung auf dieser Ebene wird ebenfalls ausgeschlossen.",
        "unitsPlaceholder": "4587\n9999",
        "userIdsLabel": "Auszuschließende Benutzer — nach externer ID",
        "userIdsHint": "Exakter Abgleich mit der external_id inklusive Präfix.",
        "userIdsPlaceholder": "afas:12345",
        "emailsLabel": "Auszuschließende Benutzer — nach E-Mail",
        "emailsHint": "Exakter Abgleich, unabhängig von Groß-/Kleinschreibung. Verwenden Sie ein führendes * für eine Domain-Regel, z. B. *@oudbedrijf.nl",
        "emailsPlaceholder": "foo@old.nl\n*@oudbedrijf.nl"
      },
      "step3": {
        "heading": "Schritt 3 — Zeitplan",
        "hint": "Wann diese Quelle automatisch starten soll. Phase-1-Quellen laufen nur, wenn der Zeitplan aktiv ist UND mindestens eine Uhrzeit gesetzt ist.",
        "uploadHint": "Eine Upload-basierte Quelle läuft nur, wenn das Implementierungsteam die Datei(en) manuell hochlädt und den Lauf startet — es gibt keinen automatischen Zeitplan. Dry-Runs und Übernahmen laufen über die Seite \"Ausführen\" der Quelle.",
        "activate": "Quelle ist aktiv",
        "timesHeading": "Tägliche Ausführungszeiten",
        "timesHint": "Fügen Sie beliebig viele Uhrzeiten hinzu — die Quelle läuft täglich zu jeder davon.",
        "noTimes": "Noch keine Uhrzeiten. Klicken Sie unten, um eine hinzuzufügen.",
        "addTime": "Uhrzeit hinzufügen"
      }
    },
    "editor": {
      "newTitle": "Neue Zuordnung",
      "editTitle": "Zuordnung bearbeiten",
      "intro": "Eine Zuordnung ist eine Liste von Slots. Jeder Slot verweist auf eine CSV-Dateiform (z. B. \"users.csv\") und legt fest, welche Spalte auf welches Plattformfeld abgebildet wird.",
      "name": "Name",
      "description": "Beschreibung",
      "slotsHeading": "Slots",
      "slotsIntro": "Fügen Sie pro CSV-Dateiform einen Slot hinzu. Legen Sie eine Beispiel-CSV ab, um die Spaltentitel automatisch zu erkennen — prüfen Sie die Treffer und passen Sie sie an.",
      "addUserSlot": "Benutzer-Slot",
      "addOrgUnitSlot": "Organisationseinheiten-Slot",
      "noSlots": "Noch keine Slots. Fügen Sie einen Benutzer- oder Organisationseinheiten-Slot hinzu, um mit der Zuordnung zu beginnen.",
      "slotLabel": "Slot {n}",
      "slotName": "Slot-Name",
      "targetUser": "Benutzer",
      "targetOrgUnit": "Organisationseinheiten",
      "targetLevelKey": "Org-Ebene",
      "targetLevelKeyHint": "Zu welcher Kategorie der Organisationsstruktur diese Zeilen gehören.",
      "pickLevel": "— Kategorie wählen —",
      "matchFilename": "Dateinamen-Match (optional)",
      "matchFilenameHint": "Wird beim Upload verwendet, um diesen Slot automatisch zu wählen, wenn der Benutzer eine Datei mit diesem Namen ablegt.",
      "sampleDrop": "Legen Sie hier eine Beispiel-CSV ab, oder klicken Sie zum Durchsuchen.",
      "sampleReplace": "Beispiel-CSV ersetzen",
      "sampleLoaded": "{n} Spalten + {rows} Beispielzeile(n). Das Beispiel wird nicht gespeichert — es dient nur für Zuordnungsvorschläge.",
      "sampleParseError": "Die Datei konnte nicht als CSV gelesen werden. Speichern Sie sie als UTF-8 mit Komma- oder Semikolon-Trennung.",
      "columnsHeading": "Spalten",
      "columnsHint": "Wählen Sie, welche CSV-Spalte jedes Plattformfeld füllt. Pflichtfelder sind mit * markiert.",
      "pickColumn": "Spalte wählen",
      "columnHeaderPlaceholder": "CSV-Spaltentitel eingeben",
      "field": {
        "external_id": "Externe ID",
        "email": "E-Mail",
        "name": "Name",
        "locale": "Sprache",
        "status": "Status",
        "parent_external_id": "Übergeordnet (externe ID)"
      },
      "unitAssignmentsHeading": "Einheiten-Zuweisungen",
      "unitAssignmentsHint": "Pro Kategorie: welche CSV-Spalte angibt, zu welcher Einheit dieser Benutzer gehört.",
      "addUnitAssignment": "Zuweisung hinzufügen",
      "via": {
        "external_id": "über externe ID",
        "email": "über E-Mail",
        "name": "über Name"
      },
      "previewHeading": "Beispielvorschau ({n} Zeile(n))",
      "strategyHeading": "Strategie",
      "strategyHint": "Verwenden Sie \"Anreichern\", wenn diese CSV zusätzliche Felder für Benutzer oder Einheiten enthält, die ein anderer Slot anlegt — z. B. assignments.csv mit Team und Funktion für Benutzer aus users.csv.",
      "strategy": {
        "createOrUpdate": "Neu anlegen oder Bestehende aktualisieren — Abgleich über den identifizierenden Schlüssel; anlegen, wenn nichts übereinstimmt.",
        "enrich": "Nur Bestehende anreichern — Abgleich über die Join-Spalte unten; Zeilen ohne Treffer werden im Dry-Run zu Fehlern."
      },
      "joinOnHint": "Welche CSV-Spalte den Lookup-Schlüssel enthält und mit welchem Plattformfeld er abgeglichen werden soll.",
      "joinOnFrom": "Join-Spalte (diese Datei)",
      "joinOnVia": "Abgleich mit"
    }
  },
  "locations": {
    "heading": "Trainingsstandorte",
    "intro": "Verwalten Sie die Trainingsstandorte, die bei der Planung einer Durchführung pro Tag ausgewählt werden können.",
    "new": "Neuer Trainingsstandort",
    "empty": "Es gibt noch keine Trainingsstandorte. Fügen Sie einen hinzu, um ihn bei der Planung auswählen zu können.",
    "editTitle": "Trainingsstandort bearbeiten",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "confirmDelete": "Trainingsstandort löschen?",
    "confirmDeleteBody": "Möchten Sie „{name}“ wirklich löschen? Durchführungen, die diesen Trainingsstandort verwendet haben, behalten ihren Freitext-Standort.",
    "cols": {
      "name": "Name",
      "city": "Ort",
      "capacity": "Kapazität",
      "position": "Reihenfolge",
      "active": "Aktiv",
      "kind": "Art"
    },
    "fields": {
      "name": "Name",
      "city": "Ort",
      "address": "Adresse",
      "capacity": "Kapazität",
      "capacityHint": "Physische Raumkapazität (informativ). Leer = unbekannt.",
      "position": "Reihenfolge",
      "positionHint": "Niedriger = weiter oben in der Liste.",
      "active": "Aktiv (bei der Planung auswählbar)",
      "isExternal": "Externer Trainingsstandort (von einer anderen Partei bereitgestellt)"
    },
    "internal": "Intern",
    "external": "Extern"
  },
  "externalPeople": {
    "heading": "Externe Personen",
    "intro": "Verwalten Sie die externen Personen (ohne Konto), die Sie bei der Planung als Trainer auswählen können.",
    "new": "Neue externe Person",
    "empty": "Es gibt noch keine externen Personen. Fügen Sie eine hinzu, um sie bei der Planung als Trainer auswählen zu können.",
    "editTitle": "Externe Person bearbeiten",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "confirmDelete": "Externe Person löschen?",
    "confirmDeleteBody": "Möchten Sie „{name}“ wirklich löschen? Sie können diese Person danach nicht mehr als Trainer auswählen. Durchführungen, bei denen sie bereits Trainer ist, behalten sie als Trainer.",
    "cols": {
      "name": "Name",
      "email": "E-Mail",
      "position": "Reihenfolge",
      "active": "Aktiv",
      "company": "Unternehmen",
      "deletedAt": "Gelöscht am"
    },
    "tabs": {
      "current": "Aktuell",
      "deleted": "Gelöscht"
    },
    "deleted": {
      "intro": "Gelöschte externe Personen erscheinen nicht mehr in der Liste und in der Trainerauswahl, ihr Name, ihre E-Mail-Adresse und ihre Anmerkung sind jedoch noch gespeichert. Geht ein Löschantrag ein, löschen Sie ihre Daten hier.",
      "empty": "Es gibt keine gelöschten externen Personen, deren Daten noch gelöscht werden können."
    },
    "fields": {
      "name": "Name",
      "email": "E-Mail",
      "note": "Anmerkung",
      "position": "Reihenfolge",
      "positionHint": "Niedriger = weiter oben in der Liste.",
      "active": "Aktiv (als Trainer auswählbar)",
      "company": "Externes Unternehmen / Bildungsanbieter",
      "companyHint": "Optional. Leer = freier Mitarbeiter."
    },
    "noCompany": "Kein Unternehmen (freiberuflich)",
    "erase": {
      "action": "Daten löschen",
      "actionLabel": "Daten löschen: {name}",
      "title": "Daten der externen Person löschen?",
      "irreversible": "Das Löschen der Daten ist endgültig. Sie können es nicht rückgängig machen.",
      "body": "Name, E-Mail-Adresse und Anmerkung von „{name}“ werden endgültig entfernt, ebenso diese Angaben im Protokoll. Die Person verschwindet aus dieser Liste und kann nicht mehr als Trainer ausgewählt werden.",
      "history": "Der Trainerverlauf bleibt erhalten: Durchführungen, bei denen diese Person Trainer war, behalten ihren Trainer und zeigen ihn künftig als „Gelöschte externe Person“ an.",
      "confirmLabel": "Geben Sie „{name}“ zur Bestätigung ein",
      "confirmHint": "Geben Sie den Namen genau so ein, wie er oben steht.",
      "submit": "Endgültig löschen",
      "done": "Die Daten von „{name}“ wurden gelöscht. Durchführungen, bei denen diese Person Trainer war, zeigen jetzt „Gelöschte externe Person“ an."
    }
  },
  "cancellationReasons": {
    "heading": "Stornierungsgründe",
    "intro": "Verwalten Sie die Gründe, aus denen Lernende bei der Stornierung einer Anmeldung wählen können.",
    "new": "Neuer Grund",
    "empty": "Noch keine Stornierungsgründe. Fügen Sie einen hinzu, um ihn in der Auswahl anzuzeigen.",
    "editTitle": "Grund bearbeiten",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "confirmDelete": "Grund löschen?",
    "confirmDeleteBody": "Möchten Sie „{label}“ wirklich löschen? Bereits stornierte Anmeldungen behalten ihren Grund.",
    "cols": {
      "label": "Grund",
      "position": "Reihenfolge",
      "active": "Aktiv"
    },
    "fields": {
      "label": "Grund",
      "position": "Reihenfolge",
      "positionHint": "Niedriger = weiter oben in der Liste.",
      "active": "Aktiv (Lernenden anzeigen)"
    }
  },
  "externalCompanies": {
    "heading": "Externe Unternehmen",
    "intro": "Verwalten Sie externe Unternehmen (Bildungsanbieter, Lieferanten). Markieren Sie ein Unternehmen als Bildungsanbieter, damit Sie bei der Planung zuerst den Anbieter und dann den Dozenten wählen können.",
    "new": "Neues externes Unternehmen",
    "empty": "Es gibt noch keine externen Unternehmen. Fügen Sie eines hinzu, um sie zu verwenden.",
    "editTitle": "Externes Unternehmen bearbeiten",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "confirmDelete": "Externes Unternehmen löschen?",
    "confirmDeleteBody": "Möchten Sie \"{name}\" wirklich löschen? Dozenten dieses Unternehmens werden wieder freie Mitarbeiter.",
    "cols": {
      "name": "Name",
      "email": "E-Mail",
      "educator": "Bildungsanbieter",
      "position": "Reihenfolge",
      "active": "Aktiv",
      "origin": "Herkunft"
    },
    "fields": {
      "name": "Name",
      "email": "E-Mail",
      "phone": "Telefon",
      "note": "Notiz",
      "position": "Reihenfolge",
      "positionHint": "Niedriger = weiter oben in der Liste.",
      "isEducator": "Ist Bildungsanbieter (erscheint in der Trainerauswahl)",
      "active": "Aktiv (bei der Planung auswählbar)"
    },
    "promote": "In die verwaltete Liste übernehmen",
    "origin": {
      "admin": "Administrator",
      "request": "Antrag"
    },
    "suggestions": {
      "heading": "Meinen Sie vielleicht eines dieser Unternehmen?",
      "hint": "Steht das Unternehmen oben bereits? Verwenden Sie dann dieses, statt ein zweites anzulegen."
    }
  },
  "roles": {
    "heading": "Rollen & Rechte",
    "intro": "Eine Rolle ist ein Bündel von Rechten. Was jemand darf, ergibt sich aus der Rolle; wo er es darf, wählen Sie bei der Zuweisung. Rollen gehören Ihrer Organisation: Sie dürfen sie anpassen, duplizieren und eigene anlegen.",
    "empty": "In dieser Umgebung gibt es noch keine Rollen.",
    "loading": "Rollen werden geladen…",
    "loadError": "Die Rollen konnten nicht geladen werden.",
    "new": "+ Neue Rolle",
    "column": {
      "role": "Rolle",
      "rank": "Rang",
      "origin": "Herkunft",
      "permissions": "Rechte",
      "assigned": "Zugewiesen an",
      "actions": "Aktionen"
    },
    "permissionCount": "{held} von {total}",
    "origin": {
      "standard": "Standard",
      "standard_customised": "Standard · angepasst",
      "self_made": "Selbst erstellt"
    },
    "action": {
      "view": "Ansehen",
      "edit": "Bearbeiten",
      "duplicate": "Duplizieren",
      "delete": "Löschen"
    },
    "rankHint": "Höhere Zahl = weniger Autorität",
    "readOnlyBanner": "Diese Rolle hat Rang {rank}. Sie können nur Rollen mit einer höheren Zahl als Ihrem eigenen Rang ({own}) bearbeiten.",
    "readOnlyBannerNoRank": "Diese Rolle hat Rang {rank}. Sie haben selbst keine Rolle mit einem Rang und können daher keine Rollen bearbeiten.",
    "rankRangeHint": "Von {min} bis {max}. Höhere Zahl = weniger Autorität",
    "rankFixedHint": "Der Rang dieser Rolle ist festgelegt",
    "rankOutOfRange": "Wählen Sie einen Rang von {min} bis {max}.",
    "newAtoms": {
      "title_one": "Es ist ein neues Recht hinzugekommen",
      "title_other": "Es sind {count} neue Rechte hinzugekommen",
      "body": "Sie sind noch keiner Rolle zugeordnet. Neue Rechte werden niemals automatisch aktiviert.",
      "show": "Ansehen, was neu ist"
    },
    "delete": {
      "title": "Rolle löschen?",
      "body": "Die Rolle {label} wird gelöscht. Zuweisungen zu dieser Rolle verschwinden mit ihr.",
      "confirm": "Löschen",
      "inUse": "Diese Rolle wird von einem Genehmigungsablauf verwendet und kann nicht gelöscht werden: {flows}"
    },
    "builder": {
      "newHeading": "Neue Rolle",
      "name": "Name der Rolle",
      "nameHint": "Was Benutzer sehen. Pro Sprache anpassbar; der interne Schlüssel ändert sich nicht mit.",
      "otherLanguages": "Andere Sprachen",
      "rank": "Rang",
      "search": "Rechte durchsuchen…",
      "onlyEnabled": "Nur was aktiv ist",
      "expandAll": "Alle ausklappen",
      "collapseAll": "Alle einklappen",
      "moduleCount": "{held} von {total}",
      "summary": "Was Sie ändern",
      "summaryOn": "Rechte aktiv",
      "summaryRequired": "Als Voraussetzung mitgekommen",
      "summaryUnavailable": "Für Sie nicht verfügbar",
      "summaryPeople": "Personen mit dieser Rolle",
      "lockedBy": "Kommt mit: {atoms}",
      "notYours": "Sie halten dieses Recht selbst nicht, also können Sie es nicht vergeben.",
      "dangerous": "Gefährlich",
      "indispensable": "Unverzichtbar",
      "impact_one": "Diese Änderung betrifft {count} Person.",
      "impact_other": "Diese Änderung betrifft {count} Personen.",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "saving": "Speichern…",
      "saved": "Die Rolle wurde gespeichert.",
      "templateDiff_one": "Es gibt {count} Recht aus dem Standard, das diese Rolle noch nicht hat.",
      "templateDiff_other": "Es gibt {count} Rechte aus dem Standard, die diese Rolle noch nicht hat.",
      "addFromTemplate": "Hinzufügen",
      "viewPeople_one": "Die Person mit dieser Rolle ansehen",
      "viewPeople_other": "Die {count} Personen mit dieser Rolle ansehen"
    },
    "confirm": {
      "title": "Sind Sie sicher?",
      "added": "Rechte hinzugefügt",
      "removed": "Rechte entfernt",
      "dangerousAdded_one": "{count} davon ist gefährlich",
      "dangerousAdded_other": "{count} davon sind gefährlich",
      "impact_one": "Dies betrifft {count} Person mit dieser Rolle.",
      "impact_other": "Dies betrifft {count} Personen mit dieser Rolle.",
      "nothing": "An den Rechten ändert sich nichts.",
      "confirm": "Speichern",
      "back": "Zurück"
    },
    "count_one": "{count} Rolle",
    "count_other": "{count} Rollen"
  },
  "roleAssignment": {
    "heading": "Rolle an {name} vergeben",
    "userLoadError": "Dieser Benutzer konnte nicht geladen werden.",
    "intro": "Was jemand darf, ergibt sich aus der Rolle. Wo es gilt, wählen Sie hier.",
    "backToProfile": "← Zurück zum Profil",
    "revoke": "Entziehen",
    "includeSubtree": "Auch die untergeordneten Einheiten",
    "subtreeHint": "Ohne dieses Häkchen gilt die Rolle nur in der gewählten Einheit selbst.",
    "pickRole": "Rolle wählen",
    "pickOrgUnit": "Einheit suchen",
    "current": {
      "heading": "Aktuelle Rollen",
      "empty": "Dieser Benutzer hat noch keine Rolle.",
      "loadError": "Die Rollen dieses Benutzers konnten nicht geladen werden."
    },
    "add": {
      "heading": "Rolle vergeben",
      "submit": "Vergeben"
    },
    "fields": {
      "role": "Rolle",
      "scope": "Wo gilt diese Rolle?",
      "orgUnit": "Organisationseinheit"
    },
    "blocked": {
      "rank": "Sie dürfen diese Rolle nicht vergeben",
      "delta": "Sie halten selbst nicht: {atoms}"
    },
    "scopeOption": {
      "tenant_wide": "Die gesamte Umgebung",
      "org_unit": "Eine Organisationseinheit",
      "ownership": "Nur was mit dieser Person verknüpft ist",
      "direct_reports": "Nur die direkten Mitarbeitenden dieser Person"
    },
    "scopeHint": {
      "tenant_wide": "Die Rolle gilt überall in dieser Umgebung.",
      "org_unit": "Die Rolle gilt innerhalb der gewählten Einheit.",
      "ownership": "Die Rolle gilt für das, womit diese Person verknüpft ist — etwa Kurse, deren Inhalt sie verantwortet, oder Durchführungen, die sie als Trainerin leitet.",
      "direct_reports": "Die Rolle gilt nur für die Personen, deren Führungskraft diese Person ist. Hat niemand diese Person als Führungskraft hinterlegt, sieht sie niemanden. Durchführungen und der Katalog fallen nicht unter diesen Bereich: Eine Führungskraft arbeitet in Mein Team in der App."
    },
    "scope": {
      "tenant_wide": "Die gesamte Umgebung",
      "ownership": "Nur was mit dieser Person verknüpft ist",
      "direct_reports": "Nur die direkt unterstellten Mitarbeitenden dieser Person",
      "orgUnitWithSubtree": "{unit} und alles darunter",
      "orgUnitOnly": "Nur {unit}"
    },
    "preview": {
      "heading": "Was das umfasst",
      "pickRoleFirst": "Wählen Sie zuerst eine Rolle — ohne Rolle gibt es nichts zu berechnen.",
      "calculating": "Wird berechnet…",
      "failed": "Die Berechnung ist fehlgeschlagen. Sie können trotzdem speichern; Ihnen fehlt nur die Vorschau.",
      "tenantWide": "Diese Rolle gilt überall in dieser Umgebung.",
      "ownership": "Heute bedeutet das: Kurse, für die diese Person verantwortlich ist · Durchführungen, die sie leitet · die eigenen Anmeldungen · das eigene Profil.",
      "directReports": "Heute bedeutet das: die Benutzer, Anmeldungen, Teilnahmen und Qualifikationen der Personen, die diese Person direkt führt. Nicht deren Führungskräfte und nicht die Durchführungen oder der Katalog.",
      "units_one": "{count} Organisationseinheit",
      "units_other": "{count} Organisationseinheiten",
      "people_one": "{count} Person fällt darunter",
      "people_other": "{count} Personen fallen darunter",
      "widerThanChosen": "Achtung: Sie haben eine Einheit gewählt, durch die untergeordneten Einheiten umfasst dies jedoch mehr."
    }
  },
  "effectiveAccess": {
    "heading": "Was diese Person darf",
    "heldCount_one": "{count} von {total} Recht",
    "heldCount_other": "{count} von {total} Rechten",
    "search": "Rechte durchsuchen",
    "searchPlaceholder": "Zum Beispiel: Anmeldung",
    "showUnheld": "Auch anzeigen, was diese Person nicht darf",
    "noMatch": "Keine Rechte passen dazu.",
    "moduleCount": "{count} von {total}",
    "dangerous": "Gefährlich",
    "notHeld": "Hat diese Person nicht.",
    "via": "über {role} — {scope} — {surface}",
    "impliedBy": "(kam mit {atom} hinzu)",
    "surface": {
      "app": "gilt in der App",
      "manage": "gilt in der Verwaltung"
    }
  },
  "attendance": {
    "title": "Anwesenheit",
    "myTeaching": "Meine Termine",
    "myTeachingEmpty": "Du bist noch keinem Termin als Dozent zugeordnet.",
    "openBadge": "Anwesenheit offen",
    "participant": "Teilnehmer",
    "day": "Tag",
    "save": "Anwesenheit speichern",
    "saved": "Anwesenheit gespeichert.",
    "noParticipants": "Für diesen Termin hat noch niemand einen Platz.",
    "noDays": "Für diesen Termin sind noch keine Tage geplant.",
    "status": {
      "not_recorded": "Noch nicht erfasst",
      "present": "Anwesend",
      "absent": "Abwesend",
      "excused": "Entschuldigt abwesend",
      "substituted": "Ersetzt"
    },
    "completion": {
      "label": "Abgeschlossen",
      "true": "Ja",
      "false": "Nein",
      "null": "Noch nicht zu sagen",
      "explainNull": "Mindestens ein Tag ist noch nicht erfasst, daher lässt sich dazu noch nichts sagen."
    },
    "loadError": "Die Anwesenheit konnte nicht geladen werden.",
    "saveError": "Die Anwesenheit konnte nicht gespeichert werden.",
    "closeOut": {
      "action": "Termin abschließen",
      "achievedOn": "Erreicht am",
      "achievedOnHint": "Standardmäßig heute. Nicht in der Zukunft und nicht vor einem früheren Abschluss derselben Person in dieser Aktivität.",
      "achievedOnInFuture": "Das Datum des Abschlusses kann nicht in der Zukunft liegen.",
      "outcome": "Ergebnis",
      "outcomeFor": "Ergebnis für {name}",
      "skip": "Überspringen",
      "passed": "Bestanden",
      "failed": "Nicht bestanden",
      "reason": "Grund für die Abweichung",
      "reasonHint": "Dieses Ergebnis weicht von der erfassten Anwesenheit ab. Der Grund wird daneben festgehalten.",
      "reasonRequired": "Es gibt noch eine Abweichung ohne Grund. Tragen Sie ihn ein, bevor Sie abschließen.",
      "needsForce": "Es ist noch ein Tag offen, daher lässt sich nichts ableiten. Nur wer das Recht hat, ein Ergebnis zu erzwingen, kann hier eines setzen.",
      "notOpen": "Nicht abschließbar",
      "notOpenExplain": "Diese Anmeldung läuft nicht mehr. Sie steht noch in der Übersicht, weil dafür Anwesenheit erfasst wurde.",
      "alreadyDone": "Bereits abgeschlossen",
      "alreadyDoneOn": "Abgeschlossen am {date}",
      "wasDeviation": "Von der Anwesenheit abgewichen",
      "confirmTitle": "Termin abschließen?",
      "confirmBody": "{finalized} Teilnehmer erhalten jetzt ein Ergebnis; {skipped} werden übersprungen und können später noch abgeschlossen werden.",
      "confirmTerminal": "Der Termin wird danach auf abgeschlossen gesetzt. Das lässt sich nicht rückgängig machen.",
      "done": "Abgeschlossen. {finalized} Teilnehmer abgeschlossen, {skipped} übersprungen.",
      "error": "Der Termin konnte nicht abgeschlossen werden.",
      "withdraw": "Zurücknehmen",
      "withdrawTitle": "Abschluss für {name} zurücknehmen",
      "withdrawExplain": "Der Abschluss bleibt erhalten, samt der Person, die ihn erfasst hat, und dem Grund der Rücknahme — er zählt nur nirgends mehr mit. Das Feld ist danach wieder offen, sodass Sie erneut abschließen können.",
      "withdrawReason": "Warum nehmen Sie dies zurück?",
      "withdrawReasonHint": "Später ist dies die einzige Erklärung, die noch vorliegt.",
      "withdrawError": "Das Zurücknehmen ist fehlgeschlagen. Versuchen Sie es erneut oder laden Sie die Seite neu.",
      "withdrawKind": "Was gilt ab jetzt?",
      "withdrawKindPlaceholder": "Treffen Sie eine Auswahl",
      "withdrawKindFromNow": "Er hatte ihn — ab jetzt nicht mehr",
      "withdrawKindNeverValid": "Das Ergebnis war falsch — er hatte ihn nie",
      "withdrawKindHint": "Dies bestimmt, wie ein Bericht über einen früheren Zeitraum aussieht. Die erste Option lässt diese Historie bestehen; die zweite besagt, dass ein früherer Bericht falsch war."
    },
    "cellLabel": "{name} am {day} — {status}",
    "notes": {
      "column": "Notizen",
      "title": "Notizen zu {name}",
      "open": "Notizen zu {name} ({count})",
      "empty": "Zu diesem Teilnehmer wurde noch nichts festgehalten.",
      "new": "Neue Notiz",
      "newHint": "Nur Sie sehen das, außer Sie geben es unten frei.",
      "add": "Notiz speichern",
      "share": "Für die Führungskraft dieses Teilnehmers sichtbar",
      "sharedMarker": "mit der Führungskraft geteilt",
      "by": "{author} — {date}",
      "unknownAuthor": "Unbekannt",
      "error": "Die Notiz konnte nicht gespeichert werden.",
      "delete": "Entfernen",
      "edit": "Notiz bearbeiten",
      "editAction": "Bearbeiten",
      "editedMarker": "bearbeitet"
    },
    "showCancelled": "Auch {count} stornierte Teilnehmer anzeigen",
    "markAllPresent": "Alle anwesend",
    "markAllRow": "Ganzer Tag",
    "external": {
      "column": "Externer Test",
      "choose": "Ergebnis des externen Tests für {participant}",
      "placeholder": "Ergebnis",
      "record": "Festhalten",
      "error": "Das Ergebnis konnte nicht festgehalten werden.",
      "outcome": {
        "passed": "Bestanden",
        "not_passed": "Nicht bestanden"
      },
      "resultLabel": "Ergebnis der externen Stelle für {participant} (Prozentsatz oder Note)",
      "resultPlaceholder": "z. B. 72 % oder 2,5"
    }
  },
  "accessGroups": {
    "heading": "Zugriffsgruppen",
    "lead": "Eine Beschreibung von wem, an mehreren Stellen verwendbar. Eine Gruppe beschreibt Personen mit Regeln — nicht mit einer Namensliste — und stimmt daher auch noch, wenn jemand die Abteilung wechselt.",
    "new": "Neue Zugriffsgruppe",
    "empty": "Es gibt noch keine Zugriffsgruppen. Legen Sie eine an, sobald eine Lernaktivität für eine bestimmte Gruppe gedacht sein soll.",
    "loadError": "Die Zugriffsgruppen konnten nicht geladen werden.",
    "backToList": "Zurück zur Übersicht",
    "memberCount": "{count} Personen",
    "showOnChart": "Im Organigramm zeigen, wo diese Personen sitzen",
    "usedByCount": "von {count} Lernaktivitäten verwendet",
    "usage": {
      "title": "Von {count} Schulung(en) verwendet",
      "nowhere": "Diese Gruppe wird nirgends verwendet.",
      "hidden": "Und {count} Schulung(en), die Sie nicht sehen dürfen.",
      "unavailable": "Wir konnten nicht laden, wo diese Gruppe verwendet wird."
    },
    "impact": {
      "title": "Was ändert sich?",
      "lead": "Diese Gruppe bestimmt die Sichtbarkeit von {count} Schulung(en). Ihre Änderung gilt dort sofort.",
      "gaining": "{count} Person(en) erhalten Zugang, den sie heute nicht haben.",
      "losing": "{count} Person(en) verlieren Zugang, den sie heute haben.",
      "nobodyChanges": "Für niemanden ändert sich etwas — die Gruppe umfasst dieselben Personen.",
      "totals": "Derzeit {current} Mitglied(er), danach {proposed}.",
      "confirm": "Trotzdem speichern",
      "unavailable": "Wir konnten nicht berechnen, was diese Änderung bedeutet. Bitte versuchen Sie es erneut."
    },
    "columns": {
      "name": "Name",
      "members": "Umfang",
      "usedBy": "Verwendet von"
    },
    "fields": {
      "name": "Name",
      "description": "Beschreibung"
    },
    "branch": {
      "include": "Wer dazugehört",
      "includeHint": "Wer einer dieser Gruppen entspricht, gehört dazu.",
      "exclude": "Wer herausfällt",
      "excludeHint": "Ausschluss gewinnt: Wer dem entspricht, fällt heraus — auch wenn er oben passt."
    },
    "addGroup": "Gruppe hinzufügen",
    "removeGroup": "Gruppe entfernen",
    "noGroups": "Noch keine Gruppen.",
    "allOf": "Entspricht allem hierunter",
    "and": "und",
    "or": "oder",
    "emptyGroupMatchesNobody": "Diese Gruppe hat noch keine Bedingung und umfasst daher niemanden.",
    "addCondition": "Bedingung hinzufügen",
    "removeCondition": "Entfernen",
    "chooseKind": "Art wählen…",
    "choose": "Wählen…",
    "searchPerson": "Person suchen…",
    "includeSubtree": "Auch die Einheiten darunter",
    "unitWithSubtree": "{name} (und alles darunter)",
    "unitOnly": "nur {name}",
    "unknownReference": "unbekannt",
    "atom": {
      "org_unit": "Organisationseinheit",
      "user": "Person",
      "role": "Rolle"
    },
    "plain": {
      "label": "In einfachen Worten:",
      "nobody": "Niemand — es gibt noch keine einzige Bedingung, der man entsprechen könnte.",
      "except": "außer"
    },
    "broken": {
      "badge": "Defekt",
      "notice": "Diese Gruppe verweist auf etwas, das nicht mehr existiert ({count} Verweis(e)). Solange das so ist, umfasst die Gruppe niemanden — auch nicht über eine Ausschlussregel. Entfernen Sie den Verweis oder wählen Sie etwas anderes."
    },
    "references": {
      "title": "Das kommt in Zugriffsgruppen vor",
      "lead": "Wenn Sie es löschen, werden diese Gruppen defekt: Sie umfassen dann niemanden, bis Sie sie reparieren.",
      "excluding": "(schließt aus)"
    }
  },
  "ltiProviders": {
    "heading": "LTI-Verbindungen",
    "intro": "Anbieter, die Sie über LTI 1.1 oder 1.3 an Ihren Katalog anbinden können. Sie registrieren einen Anbieter hier einmalig; danach wählen Sie ihn bei einer Lernaktivität aus.",
    "new": "Anbieter hinzufügen",
    "editTitle": "Anbieter bearbeiten",
    "empty": "Es ist noch kein Anbieter registriert.",
    "active": "Aktiv",
    "inactive": "Nicht aktiv",
    "secretSet": "Hinterlegt",
    "secretUnset": "Nicht hinterlegt",
    "confirmDelete": "Anbieter löschen",
    "confirmDeleteBody": "Möchten Sie {name} wirklich löschen?",
    "confirmDeleteUnknown": "Schulungen, die diesen Lieferanten verwenden, werden archiviert — sie verschwinden aus dem Katalog, erzielte Ergebnisse bleiben jedoch erhalten.",
    "confirmDeleteNone": "Keine Schulung verwendet diesen Lieferanten.",
    "confirmDeleteAffected_one": "Eine Schulung wird archiviert — sie verschwindet aus dem Katalog, erzielte Ergebnisse bleiben jedoch erhalten.",
    "confirmDeleteAffected_other": "{count} Schulungen werden archiviert — sie verschwinden aus dem Katalog, erzielte Ergebnisse bleiben jedoch erhalten.",
    "confirmDeleteRest_one": "und eine weitere",
    "confirmDeleteRest_other": "und {count} weitere",
    "cols": {
      "name": "Name",
      "issuer": "Aussteller",
      "clientId": "Client-ID",
      "secret": "Geheimnis",
      "active": "Aktiv"
    },
    "fields": {
      "name": "Name",
      "issuer": "Aussteller (Issuer)",
      "issuerHint": "Die Adresse, die der Anbieter als Issuer angibt, zum Beispiel https://lti.beispiel.de",
      "clientId": "Client-ID",
      "deploymentId": "Deployment-ID",
      "authLoginUrl": "Anmeldeadresse (OIDC)",
      "redirectUris": "Redirect-Adressen",
      "redirectUrisHint": "Eine Adresse pro Zeile. Dorthin sendet das System den signierten Launch; nicht aufgeführte Adressen werden abgelehnt.",
      "jwksUrl": "JWKS-Adresse",
      "jwksUrlHint": "Hier holt das System die öffentlichen Schlüssel des Anbieters ab. Eine Adresse innerhalb unseres eigenen Netzwerks wird abgelehnt.",
      "supportsDeepLinking": "Bei diesem Anbieter können Sie einen Kurs auswählen",
      "supportsDeepLinkingHint": "Ist dies aktiviert, erscheint bei einer Schulung die Schaltfläche „Kurs auswählen“, mit der Sie den Kurs beim Anbieter bestimmen. Wir können nicht selbst feststellen, ob ein Anbieter das unterstützt — fragen Sie im Zweifel dort nach. Ist es deaktiviert, geben Sie die Adresse des Kurses von Hand ein.",
      "version": "LTI-Version",
      "version13": "LTI 1.3 (empfohlen)",
      "version11": "LTI 1.1",
      "consumerKey": "Schlüssel (Consumer Key)",
      "consumerKeyHint": "Der Schlüssel, den Sie vom Anbieter erhalten haben. Das zugehörige Kennwort geben Sie unten ein.",
      "clientSecret": "Client Secret",
      "clientSecretHint": "Wird verschlüsselt gespeichert und danach nie wieder angezeigt.",
      "clientSecretKeepHint": "Leer lassen, um das gespeicherte Geheimnis zu behalten. Etwas eingeben, um es zu ersetzen.",
      "active": "Aktiv"
    }
  },
  "digestSettings": {
    "heading": "Sammel-E-Mail",
    "intro": "Meldungen, die keine eigene Nachricht brauchen, werden pro Empfänger in einer periodischen E-Mail gebündelt. Hier legen Sie fest, wann sie versendet wird; welche Meldungen mitfahren, entscheiden Sie je Workflow.",
    "enabled": "Sammel-E-Mail versenden",
    "enabledHint": "Solange dies aus ist, warten gebündelte Meldungen und es wird nichts versendet. Es geht nichts verloren — schalten Sie es wieder ein, kommt alles nachträglich mit.",
    "willFallSilent_one": "Es gibt {count} Meldung, die über die Sammel-E-Mail läuft. Sie bleibt aus, solange dies ausgeschaltet ist.",
    "willFallSilent_other": "Es gibt {count} Meldungen, die über die Sammel-E-Mail laufen. Sie bleiben aus, solange dies ausgeschaltet ist.",
    "frequencyLabel": "Wie oft",
    "frequency": {
      "daily": "Täglich",
      "weekly": "Wöchentlich"
    },
    "weekdayLabel": "An welchem Tag",
    "timeLabel": "Um wie viel Uhr",
    "timeHint": "In der Zeitzone Ihrer Organisation. Die E-Mail wird in Viertelstunden-Blöcken versendet, wählen Sie daher eine Zeit zur :00, :15, :30 oder :45.",
    "saved": "Die Einstellungen wurden gespeichert.",
    "saveFailed": "Das Speichern ist fehlgeschlagen."
  },
  "combobox": {
    "noResults": "Keine Ergebnisse.",
    "loading": "Wird geladen…"
  },
  "aurora": {
    "modalClose": "Schließen",
    "alertDismiss": "Meldung schließen",
    "passwordShow": "Passwort anzeigen",
    "passwordHide": "Passwort verbergen",
    "comboboxRemove": "{label} entfernen"
  },
  "returnTrail": {
    "afterSave": {
      "form": "Nach dem Speichern wird dies am Ende des Formulars „{title}“ hinzugefügt, und Sie kehren dorthin zurück.",
      "form_test": "Nach dem Speichern wird dies am Ende des Tests „{title}“ hinzugefügt, und Sie kehren dorthin zurück.",
      "category": "Nach dem Speichern wird dies am Ende der Kategorie „{title}“ hinzugefügt, und Sie kehren dorthin zurück."
    },
    "fromParent": {
      "form": "Sie arbeiten hier ausgehend vom Formular „{title}“.",
      "form_test": "Sie arbeiten hier ausgehend vom Test „{title}“.",
      "category": "Sie arbeiten hier ausgehend von der Kategorie „{title}“."
    },
    "back": {
      "form": "Zurück zum Formular",
      "form_test": "Zurück zum Test",
      "category": "Zurück zur Kategorie"
    },
    "cancel": {
      "form": "Abbrechen, zurück zum Formular",
      "form_test": "Abbrechen, zurück zum Test",
      "category": "Abbrechen, zurück zur Kategorie"
    },
    "saveAndReturn": {
      "form": "Speichern und zurück zum Formular",
      "form_test": "Speichern und zurück zum Test",
      "category": "Speichern und zurück zur Kategorie"
    },
    "discard": {
      "title": "Änderungen verwerfen?",
      "body": "Was Sie hier eingegeben haben, ist noch nicht gespeichert und geht verloren, wenn Sie zurückgehen.",
      "keep": "Weiter bearbeiten",
      "confirm": "Verwerfen und zurück"
    },
    "added": {
      "category": "Die neue Kategorie wurde erstellt und am Ende des Formulars hinzugefügt.",
      "category_test": "Die neue Kategorie wurde angelegt und am Ende des Tests hinzugefügt.",
      "question": "Die neue Frage wurde erstellt und am Ende der Kategorie hinzugefügt."
    },
    "attachFailed": {
      "category": "Die neue Kategorie wurde gespeichert, konnte aber nicht zum Formular hinzugefügt werden. Passen Sie sie an und speichern Sie erneut, um es noch einmal zu versuchen, oder gehen Sie über die Schaltfläche oben zurück.",
      "category_test": "Die neue Kategorie wurde gespeichert, konnte aber dem Test nicht hinzugefügt werden. Passen Sie sie an und speichern Sie erneut, um es noch einmal zu versuchen, oder gehen Sie über die Schaltfläche oben zurück.",
      "question": "Die neue Frage wurde gespeichert, konnte aber nicht zur Kategorie hinzugefügt werden. Passen Sie sie an und speichern Sie erneut, um es noch einmal zu versuchen, oder gehen Sie über die Schaltfläche oben zurück."
    }
  },
  "answerReadout": {
    "notAnswered": "Nicht beantwortet",
    "scale": "{value} von {max}",
    "scaleLabelled": "{value} von {max}: {label}",
    "other": "Sonstiges: {text}"
  },
  "testGrading": {
    "retry": "Erneut versuchen",
    "outcome": {
      "passed": "Bestanden",
      "not_passed": "Nicht bestanden"
    },
    "queue": {
      "title": "Korrigieren",
      "description": "Abgeschickte Tests, die auf Sie warten, pro Durchführung. Klappen Sie eine Durchführung auf, um die Tests zu sehen.",
      "loading": "Tests werden geladen…",
      "loadError": "Die zu korrigierenden Tests konnten nicht geladen werden.",
      "emptyTitle": "Nichts zu korrigieren",
      "emptyBody": "Sobald ein Teilnehmer einen Test abschickt, für den Sie zuständig sind, erscheint er hier.",
      "noTitle": "Training ohne Namen",
      "noDate": "Kein Datum",
      "count_one": "{count} Test",
      "count_other": "{count} Tests",
      "column": {
        "training": "Training",
        "date": "Datum",
        "count": "Zu korrigieren"
      },
      "responsesOf": "Tests von {title}",
      "unknownRespondent": "Unbekannter Teilnehmer",
      "submittedAt": "Abgeschickt am {date}",
      "grade": "Korrigieren",
      "gradeNamed": "Test von {name} korrigieren",
      "expand": "Tests anzeigen",
      "collapse": "Tests ausblenden"
    },
    "grade": {
      "back": "Zurück zum Korrigieren",
      "title": "Test von {name}",
      "loading": "Test wird geladen…",
      "loadError": "Der Test konnte nicht geladen werden.",
      "notFoundTitle": "Dieser Test steht Ihnen nicht zur Verfügung",
      "notFoundBody": "Er existiert nicht, wurde noch nicht abgeschickt, oder Sie sind nicht für die Korrektur dieses Tests zuständig.",
      "refused": "Sie können diesen Test nicht korrigieren.",
      "answers": "Antworten",
      "answerComment": "Kommentar zu dieser Antwort (optional)",
      "answerCommentHintVisible": "Der Teilnehmer sieht diesen Kommentar bei seiner Antwort.",
      "answerCommentHintHidden": "Das Anzeigen der Antworten ist ausgeschaltet: Dieser Kommentar bleibt bei Ihnen und der Verwaltung.",
      "answerCommentGiven": "Kommentar der Korrektur",
      "respondentRemarks": "Anmerkung des Teilnehmers",
      "judgement": "Beurteilung",
      "outcome": "Ergebnis",
      "score": "Punktzahl (optional)",
      "scoreHint": "Nur zur Information: Die Punktzahl entscheidet nichts. Das Ergebnis wählen Sie selbst.",
      "scoreInvalid": "Geben Sie eine Zahl ab null ein.",
      "scoreGiven": "Punktzahl: {score} (nur zur Information)",
      "comment": "Kommentar zum Test (optional)",
      "commentHint": "Der Teilnehmer sieht diesen Kommentar immer bei seinem Ergebnis.",
      "save": "Korrektur speichern",
      "saving": "Wird gespeichert…",
      "saved": "Der Test von {name} wurde korrigiert.",
      "conflict": "Jemand anderes war schneller: Dieser Test wurde inzwischen korrigiert. Ihre Eingaben wurden nicht gespeichert. Unten sehen Sie die Beurteilung, wie sie jetzt vorliegt.",
      "saveError": "Das Speichern ist fehlgeschlagen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "gradedBy": "Korrigiert von {name} am {date}",
      "answersVisibleToRespondent": "Der Teilnehmer sieht dieses Ergebnis, mit seinen Antworten und den Kommentaren zu den Antworten.",
      "answersHiddenFromRespondent": "Der Teilnehmer sieht das Ergebnis, die Punktzahl und den allgemeinen Kommentar, aber nicht seine Antworten und die Kommentare zu den Antworten."
    }
  },
  "testResult": {
    "title": "Ergebnis von {title}",
    "loading": "Ergebnis wird geladen…",
    "loadError": "Das Ergebnis konnte nicht geladen werden.",
    "retry": "Erneut versuchen",
    "closedTitle": "Dieses Ergebnis ist nicht verfügbar",
    "closedBody": "Der Test wurde noch nicht korrigiert.",
    "gradedOn": "Korrigiert am {date}",
    "outcome": "Ergebnis",
    "score": "Punktzahl: {score}",
    "scoreNote": "(nur zur Information)",
    "graderComment": "Kommentar der Korrektur",
    "answers": "Ihre Antworten",
    "answerComment": "Kommentar der Korrektur",
    "answersHidden": "Bei diesem Test werden Ihre Antworten und die Kommentare zu den Fragen nicht angezeigt."
  },
  "questionnaireResults": {
    "anonymous": "Anonym",
    "retry": "Erneut versuchen",
    "backToList": "Zurück zu den Ergebnissen",
    "notFoundTitle": "Nicht gefunden",
    "notFoundBody": "Dieser Bericht existiert nicht, oder Sie dürfen ihn nicht einsehen.",
    "responses_one": "{count} Antwort",
    "responses_other": "{count} Antworten",
    "suppressed": "Zu wenige Rückmeldungen — {count} von mindestens {floor}",
    "suppressedWhy": "Unterhalb dieser Mindestanzahl zeigen wir kein Ergebnis, auch keinen Durchschnitt. So kann im Nachhinein niemand erkannt werden.",
    "list": {
      "title": "Ergebnisse",
      "description": "Das Ergebnis der Evaluationen Ihrer Durchführungen. Ein Ergebnis erscheint erst, wenn genügend Personen geantwortet haben.",
      "loading": "Ergebnisse werden geladen…",
      "loadError": "Die Durchführungen konnten nicht geladen werden.",
      "emptyTitle": "Noch keine Durchführungen mit Evaluationen",
      "emptyBody": "Sobald eine Ihrer Durchführungen eine Evaluation hat, erscheint sie hier.",
      "noTitle": "Ohne Namen",
      "noDate": "Kein Datum",
      "noRules": "Keine Evaluationen",
      "column": {
        "training": "Training",
        "date": "Datum",
        "rules": "Evaluationen"
      }
    },
    "occurrence": {
      "loading": "Bericht wird geladen…",
      "loadError": "Der Bericht konnte nicht geladen werden.",
      "emptyTitle": "Keine Evaluationen bei dieser Durchführung",
      "emptyBody": "Für diese Durchführung läuft keine Evaluation, es gibt also nichts zu lesen."
    },
    "rule": {
      "loading": "Bericht wird geladen…",
      "loadError": "Der Bericht konnte nicht geladen werden.",
      "subject": "{kind} · {training}",
      "kind": {
        "training": "Training",
        "elearning": "E-Learning",
        "survey": "Einzelne Umfrage"
      },
      "totalTitle": "Gesamt über alle Durchführungen",
      "totalComplementWhy": "Die Gesamtzahl bleibt verborgen, solange sie neben dem, was Sie pro Durchführung lesen können, eine kleine Durchführung preisgeben würde. Sie erscheint, sobald das nicht mehr möglich ist.",
      "textsPerOccurrence": "Die geschriebenen Texte lesen Sie pro Durchführung.",
      "byOccurrenceTitle": "Pro Durchführung",
      "byOccurrenceHint": "Hier stehen nur Anzahlen. Das Ergebnis einer Durchführung steht in ihrem eigenen Bericht.",
      "column": {
        "occurrence": "Durchführung",
        "counted": "Antworten",
        "status": "Bericht"
      },
      "occurrenceGone": "Durchführung nicht mehr verfügbar",
      "statusDisclosed": "Genügend Antworten"
    },
    "question": {
      "untitled": "Frage ohne Text",
      "answers_one": "{count} Antwort",
      "answers_other": "{count} Antworten",
      "mean": "Durchschnitt: {mean} (Skala {min} bis {max})",
      "distributionOf": "Verteilung der Antworten auf: {prompt}",
      "yes": "Ja",
      "no": "Nein",
      "other": "Sonstiges, nämlich",
      "multipleHint": "Es konnten mehrere Antworten gewählt werden; die Anteile ergeben deshalb zusammen nicht 100 %.",
      "divergedTitle": "Diese Frage wurde anders formuliert",
      "divergedBody": "Der Wortlaut dieser Frage wurde im Lauf der Zeit angepasst. Die Antworten wurden zusammengezählt. So wurde die Frage gestellt:",
      "formulation": "{prompt} — {count}×",
      "notAggregated": "Diese Frage wurde gezählt, aber nicht zusammengerechnet: Ihr Typ unterscheidet sich je Formular oder lässt sich noch nicht auswerten."
    },
    "table": {
      "value": "Wert",
      "answer": "Antwort",
      "count": "Anzahl",
      "share": "Anteil",
      "shareOf": "Anteil"
    },
    "remarks": {
      "title": "Anmerkungen"
    },
    "freeText": {
      "show": "Antworten zu {label} anzeigen ({count})",
      "hide": "Antworten zu {label} ausblenden",
      "loading": "Antworten werden geladen…",
      "loadError": "Die Antworten konnten nicht geladen werden.",
      "order": "Die Antworten stehen ohne Namen und in zufälliger Reihenfolge.",
      "listLabel": "Antworten zu {label}",
      "pagerLabel": "Seiten mit Antworten zu {label}",
      "previous": "Zurück",
      "next": "Weiter",
      "pageOf": "Seite {page} von {last}"
    }
  },
  "qualifications": {
    "heading": "Qualifikationen",
    "intro": "Die Qualifikationen, die Ihre Organisation nachhält, etwa Ersthelfer, VCA oder ein Staplerschein. Eine Schulung kann eine Qualifikation verleihen: Wer die Schulung abschließt, besitzt sie ab dann.",
    "tabs": {
      "definitions": "Definitionen",
      "held": "Wer was besitzt"
    },
    "new": "Neue Qualifikation",
    "newTitle": "Neue Qualifikation",
    "editTitle": "Qualifikation bearbeiten",
    "count_one": "{count} Qualifikation",
    "count_other": "{count} Qualifikationen",
    "empty": "Noch keine Qualifikationen. Legen Sie die erste an, um sie mit einer Schulung zu verknüpfen.",
    "emptyFiltered": "Keine Qualifikationen für diese Filter gefunden.",
    "loadError": "Die Qualifikationen konnten nicht geladen werden.",
    "filter": {
      "status": "Anzeigen",
      "active": "Aktiv",
      "archived": "Archiviert",
      "all": "Alle"
    },
    "cols": {
      "name": "Name",
      "validity": "Gültigkeit",
      "held": "Besessen von",
      "grants": "Schulungen"
    },
    "duration": {
      "none": "Läuft nicht ab",
      "day_one": "{count} Tag",
      "day_other": "{count} Tage",
      "month_one": "{count} Monat",
      "month_other": "{count} Monate",
      "year_one": "{count} Jahr",
      "year_other": "{count} Jahre"
    },
    "unit": {
      "day": "Tage",
      "month": "Monate",
      "year": "Jahre"
    },
    "status": {
      "archived": "Archiviert"
    },
    "fields": {
      "name": "Name",
      "description": "Beschreibung",
      "expires": "Diese Qualifikation läuft ab",
      "amount": "Zeitraum",
      "unit": "Einheit",
      "unitPlaceholder": "Einheit wählen",
      "durationHint": "Wie lange die Qualifikation nach der Verleihung gültig bleibt.",
      "durationChangeHint": "Eine Änderung betrifft bestehende Inhaber nicht: Ihr Enddatum stand bei der Verleihung fest.",
      "noEndHint": "Diese Qualifikation hat kein Enddatum. Inhaber behalten sie, bis jemand sie entzieht.",
      "active": "Aktiv",
      "activeHint": "Eine archivierte Qualifikation kann nicht mehr gewählt oder verliehen werden. Wer sie besitzt, behält sie."
    },
    "actions": {
      "editNamed": "{name} bearbeiten",
      "archive": "Archivieren",
      "archiveNamed": "{name} archivieren",
      "restore": "Wiederherstellen",
      "restoreNamed": "{name} wiederherstellen"
    },
    "archiveConfirm": {
      "title": "Diese Qualifikation archivieren?",
      "body": "{name} kann danach nicht mehr gewählt oder mit einer Schulung verknüpft werden. Sie können sie später wiederherstellen.",
      "bodyHeld_one": "{name} wird von {count} Person besessen. Sie behält sie, aber die Qualifikation kann nicht mehr gewählt oder mit einer Schulung verknüpft werden. Sie können sie später wiederherstellen.",
      "bodyHeld_other": "{name} wird von {count} Personen besessen. Sie behalten sie, aber die Qualifikation kann nicht mehr gewählt oder mit einer Schulung verknüpft werden. Sie können sie später wiederherstellen."
    },
    "discard": {
      "title": "Änderungen verwerfen?",
      "body": "Sie haben ungespeicherte Änderungen. Wenn Sie jetzt schließen, gehen sie verloren.",
      "confirm": "Verwerfen",
      "keep": "Weiter bearbeiten"
    },
    "notice": {
      "created": "Qualifikation angelegt.",
      "updated": "Qualifikation gespeichert.",
      "archived": "{name} archiviert.",
      "restored": "{name} wiederhergestellt."
    },
    "grantedBy": {
      "title": "Verliehen durch",
      "intro": "Die Schulungen, die diese Qualifikation verleihen. Eine Schulung verknüpfen Sie auf deren eigener Seite.",
      "empty": "Noch keine Schulung verleiht diese Qualifikation.",
      "loadError": "Die Schulungen konnten nicht geladen werden.",
      "noEnd": "kein Enddatum",
      "own": "eigener Zeitraum: {duration}",
      "inherited": "Standardzeitraum: {duration}"
    }
  },
  "heldQualifications": {
    "heading": "Wer was besitzt",
    "intro": "Jede Qualifikation, die jemand besitzt, mit Gültigkeit und Herkunft. Filtern Sie nach Person, Qualifikation und Ablauf.",
    "count_one": "{count} Ergebnis",
    "count_other": "{count} Ergebnisse",
    "empty": "Noch niemand besitzt eine Qualifikation. Zeilen erscheinen hier, sobald jemand eine Schulung abschließt, die eine Qualifikation verleiht.",
    "emptyFiltered": "Keine Zeilen für diese Filter gefunden.",
    "loadError": "Die besessenen Qualifikationen konnten nicht geladen werden.",
    "noEnd": "kein Enddatum",
    "daysLeft_one": "noch {count} Tag",
    "daysLeft_other": "noch {count} Tage",
    "renewalStopped": "Verlängerung gestoppt",
    "note": "Notiz (optional)",
    "filter": {
      "qualification": "Qualifikation",
      "person": "Person",
      "personPlaceholder": "Person suchen",
      "status": "Status",
      "expiring": "Läuft ab",
      "any": "Jederzeit",
      "expiringOption": "Innerhalb von {days} Tagen",
      "all": "Alle",
      "archivedName": "{name} (archiviert)",
      "clear": "Filter zurücksetzen"
    },
    "status": {
      "valid": "Gültig",
      "not_yet_valid": "Noch nicht gültig",
      "expired": "Abgelaufen",
      "ended_by_choice": "Beendet, nicht verlängert",
      "superseded": "Ersetzt",
      "corrected": "Korrigiert",
      "withdrawn": "Entzogen",
      "never_valid": "Nie gültig gewesen",
      "active": "Aktiv (gültig oder bevorstehend)",
      "ended": "Beendet (jeder Grund)"
    },
    "origin": {
      "completion": "Schulung abgeschlossen",
      "external_training": "Externe Schulung",
      "self_declared": "Selbst angegeben",
      "administrative": "Von einer Administratorin oder einem Administrator erfasst"
    },
    "evidence": {
      "trusted": "Vom System erfasst",
      "verifiable": "Überprüfbarer Nachweis",
      "declaration": "Erklärung, nicht überprüft"
    },
    "sourceType": {
      "completion_record": "Abschluss",
      "import_run": "Importlauf",
      "migration_run": "Migrationslauf"
    },
    "endReason": {
      "superseded": "Durch eine neuere ersetzt",
      "corrected": "Korrigiert",
      "withdrawn_from_now": "Ab sofort entzogen",
      "never_valid": "Als nie gültig erklärt"
    },
    "cols": {
      "person": "Person",
      "qualification": "Qualifikation",
      "window": "Gültig",
      "origin": "Herkunft",
      "ground": "Grundlage",
      "status": "Status"
    },
    "detail": {
      "window": "Gültigkeit",
      "origin": "Herkunft",
      "evidence": "Grundlage",
      "source": "Quelle",
      "noSource": "Kein Quellereignis (von Hand erfasst)",
      "run": "Lauf",
      "ended": "Beendet",
      "renewalStopped": "Verlängerung gestoppt",
      "recorded": "Erfasst am"
    },
    "actions": {
      "withdraw": "Entziehen",
      "withdrawNamed": "{name} entziehen",
      "stopRenewal": "Verlängerung stoppen",
      "stopRenewalNamed": "Verlängerung von {name} stoppen",
      "resumeRenewal": "Verlängerung fortsetzen",
      "resumeRenewalNamed": "Verlängerung von {name} fortsetzen"
    },
    "withdraw": {
      "title": "Diese Qualifikation entziehen?",
      "body": "{name}: Damit endet die Qualifikation. Das lässt sich nicht rückgängig machen.",
      "reason": "Grund",
      "reasonPlaceholder": "Grund wählen",
      "reasonRequired": "Wählen Sie einen Grund für den Entzug.",
      "reasons": {
        "withdrawn_from_now": "Ab sofort",
        "never_valid": "Nie gültig gewesen"
      },
      "reasonHints": {
        "withdrawn_from_now": "Die Person hatte sie bis jetzt. Berichte über die Vergangenheit zählen sie weiterhin mit.",
        "never_valid": "Sie hätte nie verliehen werden dürfen. Berichte über die Vergangenheit zählen sie nicht mehr mit."
      },
      "confirm": "Entziehen"
    },
    "stopRenewal": {
      "title": "Verlängerung stoppen?",
      "body": "{name}: Die Qualifikation wird nicht verlängert. Sobald sie ausläuft, erscheint sie als beendet, nicht als abgelaufen. Sie können dies rückgängig machen, solange sie noch gültig ist.",
      "confirm": "Verlängerung stoppen"
    },
    "resumeRenewal": {
      "title": "Verlängerung fortsetzen?",
      "body": "{name}: Die Qualifikation lässt sich wieder verlängern.",
      "confirm": "Verlängerung fortsetzen"
    },
    "notice": {
      "withdrawn": "{name} entzogen.",
      "stopped": "Verlängerung von {name} gestoppt.",
      "stoppedMany": "Verlängerung von {name} bei {count} Zeilen gestoppt.",
      "resumed": "Verlängerung von {name} fortgesetzt.",
      "resumedMany": "Verlängerung von {name} bei {count} Zeilen fortgesetzt."
    }
  },
  "activityQualifications": {
    "title": "Verleiht Qualifikation",
    "intro": "Wer diese Schulung abschließt, besitzt ab dann diese Qualifikationen.",
    "loadError": "Die verknüpften Qualifikationen konnten nicht geladen werden.",
    "empty": "Diese Schulung verleiht keine Qualifikation.",
    "emptyNew": "Noch keine Qualifikation gewählt. Die Verknüpfung wird beim Speichern der Aktivität angelegt.",
    "notForComposition": "Ein Bündel oder Lernpfad vergibt selbst keine Qualifikation; wählen Sie eine einzelne Aktivität, um eine zu verknüpfen.",
    "noEnd": "kein Enddatum",
    "own": "eigener Zeitraum: {duration}",
    "inherited": "Standardzeitraum: {duration}",
    "add": "Qualifikation verknüpfen",
    "addTitle": "Qualifikation verknüpfen",
    "editTitle": "Gültigkeit ändern",
    "qualification": "Qualifikation",
    "qualificationPlaceholder": "Qualifikation wählen",
    "qualificationRequired": "Wählen Sie eine Qualifikation.",
    "ownDurationHint": "Leer lassen, um den Standardzeitraum der Qualifikation zu verwenden.",
    "ownDurationHintWithDefault": "Leer lassen, um den Standard zu verwenden: {duration}.",
    "noEndHint": "Diese Qualifikation hat kein Enddatum, also gibt es keinen Zeitraum einzustellen.",
    "editNamed": "{name} bearbeiten",
    "removeNamed": "{name} entkoppeln",
    "remove": "Entkoppeln",
    "removeConfirm": {
      "title": "Diese Qualifikation entkoppeln?",
      "body": "{name} wird von dieser Schulung nicht mehr verliehen. Wer sie bereits besitzt, behält sie."
    },
    "notice": {
      "added": "Qualifikation verknüpft.",
      "updated": "Gültigkeit gespeichert.",
      "removed": "{name} entkoppelt."
    }
  },
  "externalRequestTypes": {
    "list": {
      "heading": "Antragsarten für externe Weiterbildungen",
      "intro": "Eine Antragsart ist zum Beispiel Training oder Coaching, mit eigenem Formular, eigenen Kostenzeilen und eigener Kette. Es gibt keine Standardart: Richten Sie zuerst eine ein und schalten Sie sie dann ein. Ohne live geschaltete Version haben Mitarbeitende nirgends einen Einstieg.",
      "new": "Neue Antragsart",
      "empty": "Es gibt noch keine Antragsarten. Legen Sie eine an, damit externe Weiterbildungen beantragt werden können.",
      "on": "Ein (v{number})",
      "off": "Aus",
      "open": "Öffnen",
      "cols": {
        "name": "Antragsart",
        "status": "Status",
        "versions": "Versionen"
      },
      "fields": {
        "name": "Name",
        "key": "Schlüssel",
        "keyHint": "Kleinbuchstaben, Ziffern und _. Den Schlüssel können Sie danach nicht mehr ändern."
      }
    },
    "detail": {
      "empty": "Diese Antragsart hat noch keine Versionen.",
      "cols": {
        "version": "Version",
        "status": "Status",
        "liveFrom": "Live ab"
      },
      "edit": "Bearbeiten",
      "view": "Ansehen",
      "goLive": "Live schalten",
      "schedule": "Einplanen",
      "unschedule": "Einplanung zurücknehmen",
      "discard": "Verwerfen",
      "newConceptFrom": "Neuer Entwurf hieraus",
      "newConcept": "Neuer leerer Entwurf",
      "conceptExists": "Es gibt bereits einen Entwurf; es kann nur einen gleichzeitig geben.",
      "notValid": "Diese Version kann noch nicht live gehen. Das muss zuerst stimmen:",
      "isOn": "Die Antragsart ist eingeschaltet: Mitarbeitende können sie beantragen.",
      "isOff": "Die Antragsart ist ausgeschaltet: Es gibt keine Live-Version, also keinen Einstieg für Mitarbeitende.",
      "rename": "Umbenennen",
      "scheduleTitle": "Version {number} einplanen",
      "liveFrom": "Live ab",
      "liveFromHint": "Zeitzone der Umgebung ({timezone}). Zu diesem Zeitpunkt wird die Version erneut geprüft; stimmt dann etwas nicht mehr, bleibt die aktuelle Version live.",
      "discardTitle": "Entwurf verwerfen?",
      "discardBody": "Version {number} wird gelöscht. Eine Live- oder abgeschlossene Version bleibt immer erhalten.",
      "catalogTile": {
        "heading": "Kachel im Katalog",
        "label": "Eine Kachel im Katalog anzeigen",
        "hintOn": "Mitarbeitende, die Anträge stellen dürfen, sehen im Katalog eine Kachel, mit der sie diese Art beantragen.",
        "hintOff": "Die Kachel erscheint erst, wenn diese Art aktiv ist (eine Live-Version hat)."
      }
    },
    "status": {
      "concept": "Entwurf",
      "scheduled": "Geplant",
      "live": "Live",
      "phasing_out": "Läuft aus",
      "archived": "Archiviert",
      "failed": "Fehlgeschlagen"
    },
    "transition": {
      "version_not_editable": "Nur ein Entwurf kann geändert werden. Erstellen Sie einen neuen Entwurf aus dieser Version.",
      "version_wrong_state": "Das ist bei einer Version in diesem Zustand nicht möglich.",
      "concept_exists": "Für diese Antragsart gibt es bereits einen Entwurf. Schließen Sie ihn ab oder verwerfen Sie ihn.",
      "schedule_exists": "Für diese Antragsart ist bereits eine Umschaltung geplant.",
      "moment_not_in_future": "Wählen Sie einen Zeitpunkt in der Zukunft."
    },
    "role": {
      "title": "Titel",
      "provider": "Anbieter",
      "cost": "Kosten",
      "period": "Zeitraum",
      "qualification": "Qualifikation"
    },
    "phase": {
      "request": "Antrag",
      "agreement": "Vereinbarung",
      "verification": "Verifizierung",
      "change": "Änderung"
    },
    "cost": {
      "kind": {
        "fixed": "Fester Betrag",
        "unit": "Preis × Anzahl"
      },
      "vat": {
        "none": "MwSt. unbekannt",
        "excl": "Betrag ohne MwSt.",
        "incl": "Betrag inkl. MwSt."
      },
      "empty": "Noch keine Kostenzeilen. Fügen Sie mindestens eine hinzu: Die Summe der Zeilen ist die Rolle Kosten.",
      "key": "Schlüssel",
      "type": "Typ",
      "vatLabel": "MwSt.",
      "rate": "Satz",
      "remove": "Entfernen",
      "add": "Kostenzeile hinzufügen"
    },
    "preview": {
      "heading": "Live-Vorschau",
      "language": "Sprache der Vorschau",
      "empty": "Fügen Sie Felder hinzu, um das Formular zu sehen.",
      "noCostLines": "Fügen Sie eine Kostenzeile hinzu, um die Kosten zu sehen.",
      "price": "{name} — Preis",
      "quantity": "{name} — Anzahl",
      "totalExcl": "Summe ohne MwSt.",
      "totalIncl": "Summe inkl. MwSt.",
      "vatUnknown": "unbekannt (nicht jede Zeile kennt ihre MwSt.)",
      "firstDay": "erster Tag",
      "lastDay": "letzter Tag",
      "allDays": "Die Mitarbeitenden geben hier alle Tage der Weiterbildung an.",
      "providerPlaceholder": "Anbieter wählen oder suchen…",
      "qualificationPlaceholder": "Qualifikation wählen…"
    },
    "editor": {
      "heading": "Version {number}",
      "introConcept": "Dieser Entwurf kann bearbeitet werden. Live schalten und Einplanen prüfen ihn zuerst.",
      "introReadOnly": "Diese Version ist unveränderlich. Zum Ändern erstellen Sie einen neuen Entwurf aus dieser Version.",
      "back": "Zurück zur Antragsart",
      "check": "Prüfen",
      "checkOk": "Alles stimmt: Diese Version kann live gehen.",
      "checkMissing_one": "Es stimmt noch {count} Punkt nicht:",
      "checkMissing_other": "Es stimmen noch {count} Punkte nicht:",
      "checkStale": "Sie haben seit der Prüfung etwas geändert. Speichern und erneut prüfen.",
      "saved": "Der Entwurf wurde gespeichert.",
      "saveFailed": "Der Entwurf konnte nicht gespeichert werden.",
      "failed": "Die Umschaltung auf diese Version wurde nicht durchgeführt; die alte Version blieb live. Das stimmte in diesem Moment nicht mehr:",
      "settings": "Einstellungen",
      "settingsHint": "Die Kosten werden auf der gewählten Basis gelesen, sodass nie umgerechnet wird. Die Regeln mit Bedingungen pro Phase kommen mit dem Prozessdiagramm; hier wählen Sie die Kette für den Antrag.",
      "costBasis": "Kosten lesen auf Basis von",
      "basis": {
        "excl": "Summe ohne MwSt.",
        "incl": "Summe inkl. MwSt."
      },
      "periodMode": "Zeitraum der Weiterbildung",
      "period": {
        "all_days": "Alle Tage",
        "first_last": "Erster und letzter Tag",
        "none": "Kein Datum"
      },
      "requestChain": "Genehmigungskette für den Antrag",
      "noChain": "Noch keine Kette gewählt",
      "learningForm": "Lernform der Weiterbildung",
      "learningFormHelp": "Ein genehmigter Antrag wird zu einer externen Weiterbildung auf den Namen des Mitarbeiters, mit dieser Lernform. Die Liste stammt aus den Lernformen der Katalogeinstellungen.",
      "learningFormDefault": "Standard ({name})",
      "agreementTemplate": "Vereinbarung",
      "noAgreement": "Keine Vereinbarung",
      "agreementUnavailable": "Verfügbar, sobald Vereinbarungen ausgestellt werden können",
      "moreRules": "Diese Version hat mehr als eine Regel für den Antrag (zum Beispiel aus einem Import). Sie bleiben bestehen; bearbeiten können Sie sie mit dem Prozessdiagramm.",
      "form": "Formular",
      "formHint": "Titel, Anbieter und Kosten sind immer Pflicht. Geben Sie jedem Feld einen Namen in jeder Sprache der Umgebung.",
      "costLines": "Kostenzeilen",
      "costHint": "Die Plattform berechnet die Summe und speichert die Zeilen und die Summe zusammen als Momentaufnahme im Antrag."
    },
    "violation": {
      "cost_basis_missing": "Wählen Sie, auf welcher Basis die Kosten gelesen werden (ohne oder inkl. MwSt.).",
      "period_mode_missing": "Wählen Sie, was die Antragsart an Daten verlangt.",
      "learning_form_unknown": "Die gewählte Lernform „{key}“ gehört nicht mehr zu den Lernformen dieser Umgebung. Wählen Sie eine andere oder lassen Sie das Feld leer.",
      "field_key_invalid": "Der Schlüssel „{key}“ ist ungültig: Verwenden Sie Kleinbuchstaben, Ziffern und _, beginnend mit einem Buchstaben.",
      "field_key_duplicate": "Der Schlüssel „{key}“ steht auf zwei Feldern.",
      "field_type_invalid": "Das Feld „{key}“ hat einen unbekannten Typ.",
      "field_label_missing": "Das Feld „{key}“ hat keine Beschriftung auf {locale}.",
      "role_duplicate": "Die Rolle {role} steht auf mehr als einem Feld.",
      "role_type_invalid": "Das Feld „{key}“ hat einen Typ, der nicht zur Rolle {role} passt.",
      "role_must_be_required": "Das Feld „{key}“ mit der Rolle {role} muss ein Pflichtfeld sein.",
      "role_missing": "Verknüpfen Sie ein Feld mit der Rolle {role}.",
      "period_role_without_period": "Es gibt ein Feld mit der Rolle Zeitraum, aber die Antragsart verlangt kein Datum.",
      "cost_lines_missing": "Fügen Sie mindestens eine Kostenzeile hinzu.",
      "cost_line_key_invalid": "Der Schlüssel „{key}“ einer Kostenzeile ist ungültig.",
      "cost_line_key_duplicate": "Der Schlüssel „{key}“ steht auf zwei Kostenzeilen.",
      "cost_line_kind_invalid": "Die Kostenzeile „{key}“ hat einen unbekannten Typ.",
      "cost_line_label_missing": "Die Kostenzeile „{key}“ hat keinen Namen auf {locale}.",
      "cost_line_vat_invalid": "Die Kostenzeile „{key}“ hat eine unbekannte MwSt.-Einstellung.",
      "cost_line_vat_rate_unknown": "Die Kostenzeile „{key}“ hat einen MwSt.-Satz, der nicht in der Liste steht.",
      "cost_basis_unavailable": "Die Antragsart liest die Kosten inkl. MwSt., aber die Kostenzeile „{key}“ kennt ihre MwSt. nicht.",
      "phase_request_missing": "Wählen Sie eine Genehmigungskette für den Antrag.",
      "phase_unknown": "Die Phase „{phase}“ gibt es nicht.",
      "rules_no_catch_all": "Die Regeln für die Phase {phase} enden nicht mit einer Regel ohne Bedingung.",
      "rules_catch_all_not_last": "Regel {index} für die Phase {phase} hat keine Bedingung, also werden die Regeln danach nie erreicht.",
      "rule_chain_missing": "Regel {index} für die Phase {phase} verweist auf keine Kette.",
      "chain_not_found": "Die Kette für die Phase {phase} gibt es nicht mehr.",
      "chain_empty": "Die Kette für die Phase {phase} hat keine Schritte.",
      "chain_unresolvable": "In der Kette für die Phase {phase} kann niemand entscheiden: Die gewählte Rolle oder Person existiert nicht oder ist leer.",
      "chain_all_of": "Die Kette für die Phase {phase} hat einen Schritt, in dem alle entscheiden müssen. Bei einem Antrag auf externe Weiterbildung ist nur \"eine Person davon\" möglich.",
      "agreement_not_available": "Regel {index} für die Phase {phase} wählt eine Vereinbarung. Das Ausstellen einer Vereinbarung ist noch nicht verfügbar; wählen Sie vorerst \"keine Vereinbarung\".",
      "rule_step_keys_invalid": "Regel {index} für die Phase {phase} hat einen ungültigen oder doppelten Schrittschlüssel.",
      "mail_template_missing": "Die E-Mail „{slug}“ für „{event}“ gibt es nicht."
    }
  },
  "themes": {
    "heading": "Kategorien",
    "intro": "Verwalten Sie die Kategorien, aus denen Sie bei einer Aktivität wählen und nach denen der Katalog filtert. Eine Kategorie kann als Unterkategorie unter einer Hauptkategorie stehen; den Namen können Sie pro Sprache eintragen.",
    "new": "Neue Kategorie",
    "editTitle": "Kategorie bearbeiten",
    "empty": "Es gibt noch keine Kategorien. Fügen Sie die erste hinzu, um sie bei einer Aktivität wählen zu können.",
    "fields": {
      "name": "Name ({language})",
      "parent": "Gehört unter",
      "noParent": "Keine (Hauptkategorie)",
      "parentHint": "Wählen Sie eine Hauptkategorie, um diese Kategorie darunter einzuordnen.",
      "parentLocked": "Diese Kategorie hat selbst Unterkategorien und bleibt daher eine Hauptkategorie."
    },
    "cols": {
      "name": "Kategorie",
      "usage": "Aktivitäten",
      "actions": "Aktionen"
    },
    "moveUp": "{name} nach oben",
    "moveDown": "{name} nach unten",
    "merge": "Zusammenführen",
    "mergeTitle": "Kategorie zusammenführen",
    "mergeBody": "Die {count} Aktivität(en) von „{name}“ wechseln zu der Kategorie, die Sie wählen. „{name}“ wird danach entfernt.",
    "mergeInto": "Zusammenführen mit",
    "mergeChoose": "Kategorie wählen",
    "deleteBlockedInUse": "Diese Kategorie wird verwendet. Führen Sie sie mit einer anderen Kategorie zusammen.",
    "deleteBlockedChildren": "Diese Kategorie hat Unterkategorien.",
    "confirmDelete": "Kategorie löschen?",
    "confirmDeleteBody": "„{name}“ wird gelöscht. Das kann nicht rückgängig gemacht werden."
  },
  "media": {
    "heading": "Medienbibliothek",
    "intro": "Die Bilder dieser Umgebung, zur Verwendung bei Katalogeinträgen. Bei jedem Bild sehen Sie, wie oft es verwendet wird, ob noch ein Alternativtext fehlt und ob bei der Quelle eine neuere Fassung bereitsteht. Klicken Sie ein Bild an, um alles damit zu tun. Nur PNG und JPG; mehrere auf einmal sind möglich.",
    "add": "Bilder hinzufügen",
    "addError": "Das Hinzufügen ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "removeError": "Das Entfernen ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "loadError": "Die Bibliothek konnte nicht geladen werden.",
    "usageError": "Es konnte nicht geladen werden, wo dieses Bild verwendet wird.",
    "empty": "In der Bibliothek ist noch kein Bild vorhanden.",
    "inUse": "In Verwendung",
    "notInUse": "Nicht verwendet",
    "altMissing": "Kein Alternativtext",
    "editAlt": "Alternativtext",
    "saveAlt": "Alternativtext speichern",
    "altError": "Der Alternativtext konnte nicht gespeichert werden.",
    "altFor": "Alternativtext ({language})",
    "altHint": "Beschreiben Sie, was auf dem Bild zu sehen ist — für alle, die es nicht sehen können. Lassen Sie eine Sprache leer, wenn Sie sie nicht verwenden.",
    "remove": "Entfernen",
    "removeFor": "{name} entfernen",
    "confirmRemove": "Sind Sie sicher? Das Bild verschwindet aus der Bibliothek.",
    "pagination": "Seitennavigation",
    "prev": "Zurück",
    "next": "Weiter",
    "pageOf": "Seite {page} von {total}",
    "defaultHeading": "Standardbild",
    "defaultNone": "Noch kein Standard festgelegt",
    "defaultElsewhere": "Festgelegt — auf einer anderen Seite",
    "defaultClear": "Standard entfernen",
    "defaultBadge": "Standard",
    "defaultError": "Das Standardbild konnte nicht festgelegt werden.",
    "setDefaultFor": "{name} als Standard festlegen",
    "deliveredHeading": "Von BCS bereitgestellt",
    "deliveredIntro": "Diese Bilder stammen von BCS und sind für alle gleich. Sie können sie aus Ihrer Bibliothek entfernen und ihnen einen eigenen Alternativtext geben; die Datei selbst bleibt bei BCS.",
    "removeDelivered": "Aus meiner Bibliothek entfernen",
    "removeDeliveredFor": "{name} aus meiner Bibliothek entfernen",
    "confirmRemoveDelivered": "Dieses Bild verschwindet aus Ihrer Bibliothek. Die Datei bleibt erhalten, und BCS kann sie erneut bereitstellen.",
    "addFromUrl": "Über eine Adresse",
    "addFromPexels": "Auf Pexels suchen",
    "fromUrlTitle": "Bild über eine Adresse hinzufügen",
    "fromUrlField": "Adresse des Bildes",
    "fromUrlHint": "Wir laden das Bild herunter und bewahren es hier auf. Ändert es sich später an der Quelle, holen Sie es mit einer Schaltfläche erneut.",
    "fromUrlSubmit": "Holen und hinzufügen",
    "fromUrlError": "Das Bild konnte nicht geholt werden.",
    "creditField": "Nennung (optional)",
    "creditHint": "Der Name, der beim Bild angezeigt werden soll, wenn die Quelle das verlangt.",
    "creditBy": "Foto: {name}",
    "fetching": "Wird geholt …",
    "sourceChanged": "Quelle geändert",
    "sourceCheck": "Quelle prüfen",
    "sourceChecking": "Wird geprüft …",
    "pexelsTitle": "Auf Pexels suchen",
    "pexelsField": "Wonach suchen Sie?",
    "pexelsSearch": "Suchen",
    "pexelsHint": "Pexels findet am meisten mit englischen Wörtern. Der Name der Fotografin oder des Fotografen wird beim Bild gespeichert — das verlangt Pexels.",
    "pexelsImport": "Zur Bibliothek hinzufügen",
    "pexelsPartial": "{count} Bilder konnten nicht abgerufen werden:",
    "pexelsImportCount": "Importieren ({count})",
    "pexelsEmpty": "Keine Ergebnisse für dieses Wort.",
    "pexelsError": "Die Suche auf Pexels hat nicht geklappt.",
    "pexelsImportError": "Das Bild konnte nicht hinzugefügt werden.",
    "pickerTitle": "Bild auswählen",
    "pickerSearch": "Nach Dateiname suchen",
    "pickerConfirm": "Dieses verwenden",
    "pickerAdd": "Nicht gefunden?",
    "pickerNoMatch": "Kein Bild mit diesem Wort im Namen.",
    "pickOrUpload": "Auswählen oder hochladen",
    "uploadFromComputer": "Von Ihrem Computer hochladen",
    "uploadField": "Bild hochladen",
    "uploadError": "Das Bild konnte nicht hochgeladen werden.",
    "packagePickerTitle": "E-Learning-Datei hochladen",
    "packageField": "ZIP-Datei",
    "packageUse": "Diese Datei verwenden",
    "shareWithLibrary": "Auch in der Medienbibliothek behalten",
    "shareWithLibraryHint": "Lassen Sie dies aus, wenn das Bild nur zu diesem Element gehört — dann verschwindet es mit ihm.",
    "detailTitle": "Bild",
    "openDetail": "{name} öffnen",
    "dimensions": "Abmessung",
    "pixels": "{width} × {height} Pixel",
    "fileSize": "Dateigröße",
    "fileType": "Typ",
    "credit": "Nennung",
    "source": "Quelle",
    "inUseCount": "{count}× verwendet",
    "setDefault": "Als Standard festlegen",
    "actionError": "Die Änderung hat nicht geklappt. Bitte versuchen Sie es erneut.",
    "dropHere": "Bilder hierher ziehen oder zum Auswählen klicken",
    "dropHint": "PNG oder JPG, mehrere gleichzeitig",
    "uploading": "Wird hochgeladen …",
    "uploadingPercent": "Wird hochgeladen… {percent}%",
    "sourceUnchanged": "Die Quelle ist unverändert.",
    "sourceChangedHint": "Das liegt jetzt bei der Quelle. Übernehmen Sie es, dann wird dies das Bild — überall, wo es verwendet wird.",
    "sourcePreviewAlt": "Das Bild, wie es derzeit bei der Quelle vorliegt",
    "sourcePreviewGone": "Die bereitgestellte Vorschau ist nicht mehr vorhanden. Prüfen Sie die Quelle erneut, um zu sehen, was dort jetzt steht.",
    "sourceUpdate": "Aktualisieren",
    "sourceCheckAgain": "Erneut prüfen",
    "usage": {
      "activity_image": "Bild einer Lernaktivität",
      "activity_source": "Quelle einer Lernaktivität",
      "occurrence_image": "Bild einer Durchführung",
      "elearning_package": "E-Learning-Paket",
      "external_request_attachment": "Anlage zu einem Antrag",
      "message_attachment": "Anlage zu einer Nachricht",
      "tenant_default": "Standardbild dieser Umgebung",
      "user_avatar": "Profilfoto eines Benutzers",
      "certificate": "Ausgestelltes Zertifikat",
      "document_template": "Logo einer Dokumentvorlage",
      "document_settings": "Logo der Umgebung auf Zertifikaten"
    }
  },
  "studyLoad": {
    "heading": "Lernaufwand",
    "durationLabel": "Dauer der Schulung",
    "durationDeviation": "Abweichende Dauer",
    "durationChoose": "Dauer wählen",
    "durationCustom": "Andere…",
    "studyLoadLabel": "Gesamter Lernaufwand",
    "hours": "Stunden",
    "minutes": "Minuten",
    "hoursShort": "Std.",
    "minutesShort": "Min.",
    "inherited": "Standard der Aktivität: {value}",
    "useInherited": "Zurück zum Standard der Aktivität ({value})",
    "inheritedFromPlanning": "Aus der Planung: {value}",
    "useInheritedFromPlanning": "Zurück zur Dauer aus der Planung ({value})",
    "belowDuration": "Der gesamte Lernaufwand ist kürzer als die Dauer. Bitte prüfen Sie, ob das stimmt."
  },
  "catalogs": {
    "references": {
      "deleteTitle": "{name} wird noch verwendet",
      "deleteBody": "Wenn Sie diesen Katalog löschen, passiert Folgendes:",
      "deleteConfirm": "Trotzdem löschen",
      "slugTitle": "Texte verlinken auf die aktuelle Adresse",
      "slugBody": "Wenn Sie die Adresse ändern, führen diese Links auf /catalog/{slug} nirgendwo mehr hin:",
      "slugConfirm": "Adresse trotzdem ändern",
      "isStart": "Wer /catalog öffnet, landet jetzt hier. Künftig ist das der nächste Katalog im Menü.",
      "inMenu": "Er verschwindet aus dem Menü.",
      "catalog": {
        "include": "Der Katalog ‚{name}‘ nimmt ihn auf. Dieser Katalog wird leer, mit einer Warnung.",
        "exclude": "Der Katalog ‚{name}‘ schließt ihn aus. Dieser Katalog wird leer, mit einer Warnung."
      },
      "activityLink": "Die Beschreibung der Schulung ‚{title}‘ verlinkt darauf.",
      "catalogText": "Die Beschreibung des Katalogs ‚{name}‘ verlinkt darauf.",
      "text": "Der eigene Text ‚{key}‘ ({locale}) verlinkt darauf.",
      "mailTemplate": "Mail: {name} ({locales}) verlinkt darauf.",
      "outside": "Links außerhalb des Systems, etwa Lesezeichen oder eine Intranetseite, können wir nicht sehen.",
      "unknown": "Wir konnten nicht prüfen, wo dieser Katalog verwendet wird. Bitte versuchen Sie es erneut."
    },
    "new": "Katalog hinzufügen",
    "newTitle": "Neuer Katalog",
    "untitled": "Katalog ohne Namen",
    "backToList": "Zurück zur Liste",
    "emptyAll": "Es gibt überhaupt keinen Katalog.",
    "emptyAllHint": "Ohne Katalog haben Lernende nichts zum Durchsuchen — nur direkte Links und zugewiesene Schulungen.",
    "itemCount_one": "{count} Schulung",
    "itemCount_other": "{count} Schulungen",
    "notInNav": "nicht im Menü",
    "broken": "Ein Verweis existiert nicht mehr; dieser Katalog zeigt nichts an.",
    "deleteAnyway": "Trotzdem löschen",
    "name": "Name ({language})",
    "slug": "Adresse",
    "slugHelp": "Der Teil nach /catalog/ im Link. Kleinbuchstaben, Ziffern und Bindestriche. Ändern Sie ihn, funktionieren geteilte Links auf diese Seite nicht mehr.",
    "statusLabel": "Status",
    "inMainNav": "Im Menü anzeigen",
    "inMainNavHelp": "Aus bedeutet: über einen Link erreichbar, aber nicht in der Seitenleiste.",
    "showWhenEmpty": "Anzeigen, wenn nichts darin ist",
    "showWhenEmptyHelp": "Standardmäßig verschwindet ein Katalog aus dem Menü, sobald für diese Person nichts darin ist. Leer ist also personenabhängig: was der eine sieht, muss der andere nicht sehen.",
    "visibilityMode": "Wer diese Seite öffnen darf",
    "accessGroup": "Zugriffsgruppe",
    "pickAccessGroup": "Gruppe wählen…",
    "viewMode": "Was die Liste zeigt",
    "defaultLayout": "Startansicht",
    "imageRatio": "Bildformat",
    "imageRatioHelp": "Bestimmt den Bildzuschnitt. Die Listenansicht behält dasselbe Format wie die Karten.",
    "status": {
      "concept": "Entwurf",
      "published": "Veröffentlicht",
      "inactive": "Inaktiv"
    },
    "visibility": {
      "everyone": "Alle",
      "ruleset": "Nur eine Zugriffsgruppe"
    },
    "view": {
      "activities": "Ein Eintrag je Schulung",
      "occurrences": "Jede geplante Durchführung"
    },
    "layout": {
      "cards": "Karten",
      "list": "Liste"
    },
    "sections": {
      "identity": "Name und Platz",
      "identityHelp": "Wie die Seite heißt und wo sie im Menü steht.",
      "content": "Was hineinkommt",
      "contentHelp": "Einschließen holt Schulungen herein, Ausschließen hält sie draußen. Ein von Hand gesetzter Ausschluss gewinnt immer; eine von Hand gewählte Schulung überlebt eine Regel, die sie herausfiltern würde.",
      "access": "Wer die Seite öffnen darf",
      "accessHelp": "Das betrifft die Seite, nicht die Schulungen darin. Wer eine Schulung über einen direkten Link öffnen darf, kann das auch, ohne diesen Katalog öffnen zu können.",
      "presentation": "Darstellung",
      "presentationHelp": "Wie die Seite aussieht. Lernende dürfen selbst zwischen Karten und Liste wechseln."
    },
    "membership": {
      "field": "Wonach",
      "values": "Welche Werte",
      "otherCatalog": "Welcher Katalog",
      "pickCatalog": "Katalog wählen…",
      "allHint": "Alles, was diese Umgebung hat.",
      "addCondition": "Kriterium hinzufügen",
      "removeCondition": "Kriterium entfernen",
      "removeTerm": "Entfernen",
      "kind": {
        "all": "Alles",
        "rule": "Regel",
        "catalog": "Ein anderer Katalog"
      },
      "branch": {
        "include": "Hier hinein",
        "exclude": "Hier gerade nicht hinein"
      },
      "branchHint": {
        "include": "Eine Schulung kommt hinein, wenn mindestens eines davon zutrifft.",
        "exclude": "Und fliegt wieder heraus, wenn eines davon sie trifft — es sei denn, Sie haben sie von Hand hinzugefügt."
      },
      "add": {
        "rule": "Regel",
        "catalog": "Katalog",
        "all": "Alles"
      }
    },
    "preview": {
      "title": "Was darin ist",
      "help": "Zwei Ansichten. Was darin ist zeigt die Auswahl unabhängig davon, wer schaut, und unabhängig vom Status — das ist, was Sie einstellen. Wie ein Lernender es sieht führt alles durch sämtliche Prüfungen mit Ihren Rechten, und als Administrator sehen Sie mehr als ein Lernender.",
      "holds": "Was darin ist",
      "asLearner": "Wie ein Lernender es sieht",
      "hint": {
        "holds": "Die Auswahl, unabhängig vom Status und davon, wer schaut.",
        "learner": "Durch alle Prüfungen, mit Ihren Rechten. Als Administrator sehen Sie mehr als ein Lernender."
      },
      "count_one": "{count} Schulung",
      "count_other": "{count} Schulungen",
      "empty": "Noch nichts. Fügen Sie eine Regel oder eine Schulung hinzu.",
      "broken": "Ein Verweis in der Auswahl existiert nicht mehr, daher zeigt dieser Katalog nichts an.",
      "saveFirst": "Speichern Sie den Katalog zuerst; danach sehen Sie hier, was darin ist.",
      "term": "Kriterium {n}",
      "rung": {
        "1": "von Hand entfernt",
        "2": "von Hand hinzugefügt",
        "3": "durch eine Regel ausgeschlossen",
        "4": "über eine Regel",
        "5": "keine Regel schließt sie ein"
      }
    },
    "fields": {
      "type": "Art",
      "composition": "Zusammensetzung",
      "tracking_mode": "Nachverfolgt",
      "learning_form_category": "Lernform",
      "language": "Sprache",
      "theme": "Kategorie"
    },
    "onActivity": {
      "heading": "In welchen Katalogen steht das?",
      "membershipOnly": "Dies betrifft nur die Auswahl. Ob ein Teilnehmer die Schulung auch sieht, hängt zusätzlich vom Status, von der Zielgruppe und davon ab, ob das Material verfügbar ist.",
      "noCatalogs": "Diese Umgebung hat noch keine Kataloge.",
      "inside": "Enthalten ({count})",
      "insideNone": "In keinem Katalog.",
      "outside": "Nicht enthalten ({count})",
      "outsideNone": "In jedem Katalog.",
      "brokenCatalog": "Dieser Katalog verweist auf etwas, das nicht mehr existiert."
    },
    "defaultSort": "Standardsortierung",
    "defaultSortHelp": "Womit die Liste beginnt. Wählen Besucher selbst eine andere Sortierung, gilt ihre — diese Einstellung ist ein Anfang, keine Vorgabe.",
    "shownFacets": "Welche Filter erscheinen",
    "shownFacetsHelp": "Dies legt fest, welche Filter sichtbar sind, nicht was der Katalog enthält. Ein ausgeblendeter Filter wirkt weiterhin über einen geteilten Link; was in den Katalog gehört, legen Sie beim Inhalt fest.",
    "shownFacetsEmpty": "Haken Sie alles an für die Vorgabe: alle Filter.",
    "facet": {
      "type": "Art",
      "composition": "Form",
      "tracking_mode": "Sorte",
      "category": "Kategorie (Freitext an der Schulung)",
      "theme": "Kategorie (verwaltet)",
      "language": "Sprache"
    }
  },
  "cancellationPolicies": {
    "heading": "Stornierungsbedingungen",
    "intro": "Wiederverwendbare Sätze für Stornierungen: eine Frist vor dem Beginn und für jede Seite, wer stornieren darf und was es kostet. Eine neue Aktivität erhält den Standard; ein Termin kann einen anderen wählen.",
    "new": "Neue Bedingungen",
    "editTitle": "Bedingungen bearbeiten",
    "view": "Ansehen",
    "empty": "Noch keine Stornierungsbedingungen. Die ersten, die Sie anlegen, werden zum Standard.",
    "makeDefault": "Als Standard festlegen",
    "defaultBadge": "Standard",
    "usage_one": "Gewählt für {count} Aktivität oder Termin",
    "usage_other": "Gewählt für {count} Aktivitäten und Termine",
    "confirmDelete": "Bedingungen löschen?",
    "confirmDeleteBody": "„{name}“ wird gelöscht. Die Bedingungen werden nirgends verwendet.",
    "summary": "{deadline} · davor: {before} · danach: {after}",
    "deadlineSameDay": "Frist bis zum Starttag",
    "deadlineDays_one": "Frist {count} Tag vorher",
    "deadlineDays_other": "Frist {count} Tage vorher",
    "cost": {
      "none": "kostenlos"
    },
    "costType": {
      "none": "Kostenlos",
      "fixed": "Fester Betrag"
    },
    "side": {
      "before": "Vor der Frist",
      "after": "Nach der Frist",
      "beforeHelp": "Was bis einschließlich des Tages der Stornierungsfrist gilt.",
      "afterHelp": "Was nach der Stornierungsfrist bis zum Beginn gilt. Ein Administrator kann immer stornieren, auch wenn es hier nicht erlaubt ist."
    },
    "section": {
      "general": "Allgemein",
      "texts": "Text für die Lernenden"
    },
    "textsHelp": "Die Lernenden lesen diesen Text bei der Aktivität, in ihrer eigenen Sprache. Eine Sprache ohne Text fällt auf die Sprache der Umgebung zurück.",
    "fields": {
      "name": "Name",
      "deadlineDays": "Stornierungsfrist (Tage vor dem ersten Tag)",
      "deadlineDaysHelp": "Die Stornierungsfrist eines Termins ist sein erster Tag minus diese Anzahl Kalendertage; 0 ist der Starttag selbst. Pro Termin kann das Datum von Hand gesetzt werden.",
      "isDefault": "Standard für neue Aktivitäten",
      "mode": "Wer storniert",
      "costType": "Kosten",
      "amount": "Betrag (€)",
      "textIn": "Text ({language})"
    }
  },
  "cancellationTerms": {
    "line": {
      "untilStart": {
        "selfFree": "Kostenlose Stornierung bis zum Beginn",
        "selfFixed": "Eine Stornierung kostet {amount}",
        "approvalFree": "Bis zum Beginn stornieren, mit Genehmigung",
        "approvalFixed": "Bis zum Beginn für {amount} stornieren, mit Genehmigung",
        "notAllowed": "Eine Stornierung durch Sie selbst ist nicht möglich"
      },
      "before": {
        "selfFree": "Kostenlose Stornierung bis einschließlich {date}",
        "selfFixed": "Stornierung bis einschließlich {date} kostet {amount}",
        "approvalFree": "Bis einschließlich {date} stornieren, mit Genehmigung",
        "approvalFixed": "Bis einschließlich {date} für {amount} stornieren, mit Genehmigung",
        "notAllowed": "Keine Stornierung bis einschließlich {date}"
      },
      "after": {
        "selfFree": "danach kostenlos",
        "selfFixed": "danach {amount}",
        "approvalFree": "danach stornieren, mit Genehmigung",
        "approvalFixed": "danach für {amount} stornieren, mit Genehmigung",
        "notAllowed": "danach keine Stornierung mehr"
      },
      "combined": "{before}, {after}"
    },
    "window": {
      "before": "Sie stornieren vor dem Stornodatum ({date}).",
      "after": "Das Stornodatum ({date}) ist überschritten.",
      "costNow": "Eine Stornierung kostet jetzt {amount}.",
      "free": "Eine Stornierung ist jetzt kostenlos.",
      "followsRequest": "Über Ihre Anfrage wird noch entschieden. Diese Kosten gelten auch, wenn das später geschieht."
    }
  },
  "contentLanguages": {
    "intro": "Die Sprachen, in denen Sie Schulungen, deren Material und Durchführungen anbieten können. Das ist unabhängig von den Sprachen des Systems selbst.",
    "legend": "Inhaltssprachen",
    "legendHelp": "Eine Schulung hat ihre Texte je Inhaltssprache, eine Durchführung findet in einer dieser Sprachen statt und das Material kann je Sprache unterschiedlich sein. Der Sprachfilter des Katalogs zeigt diese Sprachen.",
    "pick": "Sprachen",
    "pickPlaceholder": "Sprache suchen…",
    "default": "Standard-Inhaltssprache",
    "defaultHelp": "In dieser Sprache schreiben Sie eine Schulung zuerst; die anderen Sprachen sind Übersetzungen. Wer das System in einer Sprache nutzt, die keine Inhaltssprache ist, erhält diese Sprache. Wählen Sie einen anderen Standard, gelten die vorhandenen Texte in der Standardsprache fortan als Texte in der neuen.",
    "interface": "Sprachen des Systems, von BCS eingestellt: {languages}.",
    "required": "Wählen Sie mindestens eine Inhaltssprache.",
    "saved": "Die Inhaltssprachen wurden gespeichert.",
    "saveFailed": "Das Speichern ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "defaultCannotBeRemoved": "Die Standard-Inhaltssprache können Sie nicht entfernen. Wählen Sie zuerst einen anderen Standard und speichern Sie ihn.",
    "removeConfirm": {
      "title": "Inhaltssprache entfernen?",
      "body": "Nach dem Speichern verschwindet die Sprache aus den Textregisterkarten und dem Katalog.",
      "used": "{language}: {activities}, {occurrences} und {questionnaires}.",
      "unused": "{language}: In dieser Sprache gibt es noch keine Inhalte.",
      "activities_one": "{count} Aktivität",
      "activities_other": "{count} Aktivitäten",
      "occurrences_one": "{count} Durchführung",
      "occurrences_other": "{count} Durchführungen",
      "questionnaires_one": "{count} Fragebogen",
      "questionnaires_other": "{count} Fragebögen",
      "kept": "Die Texte bleiben erhalten: Wenn Sie die Sprache später wieder aktivieren, sind sie wieder da.",
      "countFailed": "Die Anzahl konnte nicht geladen werden. Sie können trotzdem fortfahren; die Texte bleiben erhalten.",
      "confirm": "Entfernen und speichern"
    }
  },
  "documentSettings": {
    "heading": "Zertifikate",
    "intro": "Wie die Zertifikatsnummer beginnt. Eine Aktivität erhält erst ein Zertifikat, wenn Sie eine Vorlage dafür wählen.",
    "saveFailed": "Speichern ist fehlgeschlagen.",
    "saved": "Gespeichert.",
    "prefix": "Präfix der Zertifikatsnummer",
    "prefixHelp": "Der Anfang jeder Zertifikatsnummer, zum Beispiel ACME in ACME-2026-000123. Leer bedeutet der Kurzname der Umgebung. Ein neues Präfix gilt nur für neue Zertifikate.",
    "prefixExample": "So sieht eine Nummer aus: {number}",
    "showPlatformTemplates": "BCS-Vorlagen anzeigen",
    "showPlatformTemplatesHelp": "BCS liefert Beispielvorlagen mit. Wenn Sie sie ausblenden, verschwinden sie aus den Auswahllisten; wo bereits eine gewählt ist, werden weiterhin Zertifikate damit erstellt.",
    "platformTemplatesOff": "BCS hat die BCS-Vorlagen für diese Umgebung ausgeschaltet: Es kommen keine neuen BCS-Kopien hinzu.",
    "toLibrary": "Vorlagen verwalten"
  },
  "certificates": {
    "failed": {
      "title": "Zertifikate, die nicht erstellt werden konnten",
      "intro": "Korrigieren Sie die Daten oder die Vorlage und klicken Sie dann auf Erneut versuchen. Der Abschluss selbst bleibt bestehen; der Teilnehmer sieht inzwischen, dass das Zertifikat noch erstellt wird.",
      "retry": "Erneut versuchen",
      "retried": "Das Zertifikat wird erneut erstellt.",
      "retryFailed": "Der erneute Versuch ist fehlgeschlagen.",
      "emptyTitle": "Alles erledigt",
      "emptyText": "Es gibt keine Zertifikate, die nicht erstellt werden konnten.",
      "fix": {
        "user": "Zur Person",
        "template": "Zur Vorlage",
        "activity": "Zur Schulung"
      }
    },
    "failure": {
      "renderer_unavailable": "Die PDF-Erstellung war nicht verfügbar.",
      "timed_out": "Die PDF-Erstellung hat zu lange gedauert.",
      "warnings": "Die Vorlage hat beim Erstellen eine Warnung ausgegeben.",
      "compile_error": "Die Vorlage konnte nicht verarbeitet werden.",
      "required_token_empty": "Eine Pflichtangabe fehlt, zum Beispiel der Name des Teilnehmers.",
      "unknown_field": "Die Vorlage verwendet eine Angabe, die es nicht mehr gibt, zum Beispiel eine entfernte Ebene der Organisation.",
      "does_not_fit": "Ein Text passt selbst in der kleinsten Schriftgröße nicht auf das Zertifikat.",
      "output_invalid": "Das erstellte PDF war nicht gültig.",
      "source_rejected": "Die Vorlage enthält etwas, das nicht erlaubt ist.",
      "workspace_unsafe": "Der Arbeitsordner für die Erstellung war nicht sicher."
    }
  },
  "documentTemplates": {
    "title": "Dokumentvorlagen",
    "intro": "Die Zertifikatsvorlagen dieser Umgebung, auch die BCS-Vorlagen: Davon hat die Umgebung eine eigene Kopie erhalten. Jedes Veröffentlichen erzeugt eine neue Version; ältere Versionen können Sie weiterhin ansehen und wiederherstellen.",
    "showArchived": "Archivierte anzeigen",
    "platformOff": "Die BCS-Vorlagen sind in dieser Umgebung ausgeschaltet.",
    "toSettings": "Zu den Einstellungen",
    "copyFailed": "Die Kopie konnte nicht erstellt werden.",
    "emptyTitle": "Noch keine Vorlagen",
    "emptyText": "Schalten Sie die BCS-Vorlagen unter Einstellungen ein, oder bitten Sie die Verwaltung um eine Vorlage.",
    "bcs": "BCS",
    "archived": "Archiviert",
    "archivedInUse": "Archiviert und noch gewählt: Es werden noch Zertifikate damit erstellt.",
    "view": "Ansehen",
    "adjust": "Anpassen",
    "edit": "Bearbeiten",
    "archive": "Archivieren",
    "restore": "Wiederherstellen",
    "archiveTitle": "{name} archivieren?",
    "archiveInUse": "{usage}. Dort erstellt sie weiterhin Zertifikate; nur für eine neue Wahl ist sie nicht mehr wählbar.",
    "archiveUnused": "Die Vorlage ist nirgends gewählt. Nach dem Archivieren ist sie nicht mehr wählbar; Sie können sie wiederherstellen.",
    "archiveFailed": "Archivieren ist fehlgeschlagen.",
    "copyName": "Kopie von {name}",
    "usage": {
      "none": "Nirgends gewählt",
      "activities_one": "{count} Schulung",
      "activities_other": "{count} Schulungen",
      "occurrences_one": "{count} Durchführung",
      "occurrences_other": "{count} Durchführungen",
      "line": "Gewählt bei {parts}",
      "paths_one": "{count} Lernpfad",
      "paths_other": "{count} Lernpfade"
    },
    "back": "Zurück zu den Vorlagen",
    "noPresetEditor": "Diese Vorlage hat kein fertiges Layout, das hier anzupassen ist.",
    "platformReadOnly": "Eine Vorlage von BCS. Sie können sie ansehen; anpassen tun Sie sie in einer eigenen Kopie.",
    "archivedNotice": "Diese Vorlage ist archiviert. Wo sie bereits gewählt ist, erstellt sie noch Zertifikate.",
    "section": {
      "general": "Allgemein",
      "logo": "Logo",
      "colors": "Farben",
      "texts": "Texte"
    },
    "name": "Name",
    "logo": {
      "label": "Logo",
      "bcs": "BCS-Bildmarke",
      "tenant": "Logo der Umgebung",
      "none": "Kein Logo",
      "noTenantLogo": "Diese Umgebung hat noch kein Logo in ihrem Erscheinungsbild.",
      "upload": "Eigenes Logo",
      "file": "Datei",
      "fileHint": "PNG oder JPG.",
      "uploaded": "Hochgeladenes Logo",
      "uploadFailed": "Das Logo konnte nicht hochgeladen werden."
    },
    "colors": {
      "ink": "Textfarbe",
      "accent": "Akzentfarbe",
      "hint": "Leer = die Farbe der Vorlage. Text braucht genügend Kontrast zu Weiß."
    },
    "texts": {
      "hint": "Leer = der Text der Vorlage (grau im Feld).",
      "tabWithErrors_one": "{locale} · {count} Fehler",
      "tabWithErrors_other": "{locale} · {count} Fehler"
    },
    "elements": {
      "heading": "Überschrift",
      "intro": "Einleitung",
      "holder": "Name der teilnehmenden Person",
      "between": "Zwischenzeile",
      "training": "Schulung",
      "date_line": "Datum und Nummer",
      "issuer": "Aussteller"
    },
    "preview": {
      "title": "Vorschau",
      "long": "Lange Werte",
      "loading": "Vorschau wird erstellt…",
      "updated": "Die Vorschau wurde aktualisiert.",
      "invalid": "Beheben Sie zuerst die Fehler im Formular.",
      "invalidListed": "Die Vorschau erscheint, sobald die Fehler in der Liste beim Formular behoben sind.",
      "frameTitle": "Vorschau: {title}",
      "download": "Vorschau herunterladen (PDF)",
      "fileName": "vorschau",
      "busy": "Gerade werden viele Vorschauen erstellt. Versuchen Sie es gleich erneut.",
      "concept": "Vorschau des Entwurfs",
      "version": "Vorschau von Version {version}",
      "notPdf": "Die Vorschau kam nicht als PDF zurück und wird nicht angezeigt."
    },
    "tags": {
      "title": "Tags einfügen"
    },
    "unpublished": "Nicht veröffentlicht",
    "concept": "Entwurf",
    "version": "Version {version}",
    "kind": {
      "label": "Art",
      "general": "Allgemein",
      "classroom": "Präsenz",
      "learning_path": "Lernpfad",
      "hint": "Steht nach dem Erstellen fest. Präsenz kann die Lehrkraft, den Ort und die Termine nennen (nur bei einer Schulung mit Durchführungen); Lernpfad die abgeschlossenen Teile (nur bei einem Lernpfad).",
      "help": "Präsenz kann die Lehrkraft, den Ort und die Termine nennen (nur bei einer Schulung mit Durchführungen); Lernpfad die abgeschlossenen Teile (nur bei einem Lernpfad)."
    },
    "orientation": {
      "landscape": "Querformat",
      "portrait": "Hochformat"
    },
    "adjustTitle": "{name} anpassen",
    "adjustBody": "Sie erstellen eine eigene Kopie auf der aktuellen Version. Die BCS-Vorlage selbst ändert sich nicht.",
    "adjustConfirm": "Kopie erstellen",
    "state": {
      "unpublished": "Noch nicht veröffentlicht: Diese Vorlage ist nirgends wählbar.",
      "concept": "Ein Entwurf liegt bereit. Zertifikate verwenden die veröffentlichte Version, bis Sie veröffentlichen.",
      "live": "Veröffentlicht. Eine neue Version erstellen Sie, indem Sie einen Entwurf veröffentlichen."
    },
    "notice": {
      "saved": "Entwurf gespeichert.",
      "published": "Veröffentlicht. Neue Zertifikate verwenden diese Version.",
      "discarded": "Entwurf verworfen.",
      "renamed": "Der Name wurde gespeichert.",
      "restored": "Version {version} steht im Entwurf. Die veröffentlichte Version ändert sich erst, wenn Sie veröffentlichen."
    },
    "failed": {
      "save": "Das Speichern ist fehlgeschlagen.",
      "publish": "Das Veröffentlichen ist fehlgeschlagen.",
      "upload": "Das Logo konnte nicht hochgeladen werden."
    },
    "publishBlocked": "Das kann noch nicht veröffentlicht werden:",
    "previewBlocked": "Die Vorschau kann noch nicht erstellt werden:",
    "saveConcept": "Entwurf speichern",
    "publish": "Veröffentlichen",
    "publishTitle": "{name} veröffentlichen?",
    "publishBody": "{usage}. Neue Zertifikate verwenden ab jetzt diese Version; bereits ausgestellte Zertifikate ändern sich nicht.",
    "discard": "Entwurf verwerfen",
    "discardTitle": "Entwurf verwerfen?",
    "discardBody": "Die Seite zeigt danach wieder die veröffentlichte Version. Das lässt sich nicht rückgängig machen.",
    "update": {
      "noneTitle": "Keine neue Version",
      "noneText": "Für diese Vorlage liegt keine neue Version bereit.",
      "templates_one": "{count} eigene Vorlage",
      "templates_other": "{count} eigene Vorlagen",
      "title": "Neue Version von {name}",
      "intro": "BCS hat Version {to} veröffentlicht. Bis Sie sie übernehmen, bleiben neue Zertifikate auf der alten Version.",
      "unchanged": "Bereits ausgestellte Zertifikate ändern sich nicht, egal was Sie wählen.",
      "failed": {
        "conflict": "Inzwischen gibt es eine neuere Version. Die Seite zeigt jetzt diese.",
        "busy": "Gerade werden viele Zertifikate geprüft. Versuchen Sie es gleich erneut.",
        "other": "Das hat nicht geklappt."
      },
      "old": "Jetzt: Version {version}",
      "new": "Neu: Version {version}",
      "dismiss": "Nicht jetzt",
      "accept": "Übernehmen",
      "appliesTo": "Gilt für {parts}.",
      "partial": "{moved} eigene Vorlagen übernommen, {skipped} nicht: Sie bestehen die Prüfungen auf der neuen Version nicht."
    },
    "logoUpdate": {
      "noneTitle": "Kein neues Logo",
      "noneText": "Das Logo auf den Zertifikaten ist das Logo im Erscheinungsbild.",
      "title": {
        "changed": "Neues Logo der Umgebung",
        "removed": "Logo der Umgebung entfernt"
      },
      "intro": {
        "changed": "Das Logo im Erscheinungsbild wurde ersetzt. Bis Sie es übernehmen, behalten neue Zertifikate das alte.",
        "removed": "Das Logo im Erscheinungsbild wurde entfernt. Zertifikate behalten das alte Logo, bis Sie „kein Logo“ wählen; ein anderes Logo wählen Sie in der Vorlage."
      },
      "appliesTo_one": "Gilt für {count} Vorlage mit dem Logo der Umgebung.",
      "appliesTo_other": "Gilt für {count} Vorlagen mit dem Logo der Umgebung.",
      "old": "Jetzt",
      "new": "Neu",
      "accept": {
        "changed": "Übernehmen",
        "removed": "Kein Logo mehr"
      }
    },
    "open": "Öffnen",
    "copy": "Kopieren",
    "fromBcs": "Von BCS",
    "rename": "Namen speichern",
    "copyTitle": "{name} kopieren",
    "copyBody": "Eine neue Vorlage mit demselben Inhalt. Sie ist noch nicht veröffentlicht; die Art liegt nach dem Erstellen fest.",
    "copyConfirm": "Kopie erstellen",
    "originLine": "Kopie von {name}, bereitgestellt von BCS.",
    "editorComing": "Den Inhalt einer Vorlage bearbeiten Sie künftig im neuen Editor. Bis dahin können Sie hier Versionen ansehen, wiederherstellen, veröffentlichen und kopieren.",
    "history": {
      "title": "Verlauf",
      "empty": "Noch keine Versionen: Diese Vorlage wurde noch nie veröffentlicht.",
      "caption": "Die Versionen von {name}",
      "version": "Version",
      "when": "Veröffentlicht",
      "who": "Von",
      "actions": "Aktionen",
      "live": "Aktiv",
      "bcs": "BCS (Version {version})",
      "unknown": "Unbekannt",
      "view": "Ansehen",
      "restore": "Wiederherstellen",
      "viewing": "Sie sehen Version {version}.",
      "restoreTitle": "Version {version} wiederherstellen?",
      "restoreBody": "Diese Version kommt in den Entwurf. Die veröffentlichte Version ändert sich erst, wenn Sie den Entwurf veröffentlichen.",
      "restoreOverConcept": "Diese Version ersetzt den aktuellen Entwurf. Die veröffentlichte Version ändert sich erst, wenn Sie veröffentlichen."
    },
    "bcsUpdate": {
      "acceptNotice": "BCS hat Version {to} dieser Vorlage veröffentlicht. Sie haben sie nicht angepasst, daher können Sie sie direkt übernehmen.",
      "review": "Ansehen und übernehmen",
      "fetchNotice": "BCS hat Version {to} dieser Vorlage veröffentlicht. Sie haben sie selbst angepasst: Mit Abholen kommt die neue Version in den Entwurf, und Sie entscheiden, was veröffentlicht wird.",
      "fetch": "Abholen",
      "fetchTitle": "Version {to} von BCS abholen?",
      "fetchOverConcept": "Die neue Version von BCS ersetzt den aktuellen Entwurf. Die veröffentlichte Version ändert sich erst, wenn Sie veröffentlichen.",
      "fetched": "Die neue Version von BCS steht im Entwurf. Die veröffentlichte Version ändert sich erst, wenn Sie veröffentlichen.",
      "dismissed": "Die Vorlage bleibt, wie sie ist. Bei der nächsten Version von BCS sehen Sie dies wieder.",
      "conceptFrom": "Der Entwurf enthält Version {version} von BCS.",
      "intro": "BCS hat Version {to} veröffentlicht. Bis Sie sie übernehmen, bleiben neue Zertifikate, wie sie jetzt sind.",
      "old": "Jetzt aktiv: Version {version}",
      "new": "Neu: Version {version} von BCS"
    },
    "types": {
      "certificate": "Zertifikate",
      "agreement": "Vereinbarungen"
    },
    "typeLabel": {
      "agreement": "Vereinbarung"
    },
    "agreementsEmptyTitle": "Noch keine Vereinbarungen",
    "agreementsEmptyText": "Eine Vorlage für eine Vereinbarung beginnen Sie, indem Sie das Beispiel von BCS kopieren.",
    "regenerate": {
      "count_one": "{count} Zertifikat mit dieser Version ausgestellt",
      "count_other": "{count} Zertifikate mit dieser Version ausgestellt",
      "button": "Neu erstellen",
      "title": "Zertifikate von Version {version} neu erstellen?",
      "body": "Jedes Zertifikat behält seine Nummer und erhält eine neue Version mit der aktuellen Vorlage und den aktuellen Daten. Die alte Version bleibt erhalten.",
      "confirm": "Neu erstellen",
      "fromTo_one": "Von Version {from} zu Version {to}: {count} Zertifikat.",
      "fromTo_other": "Von Version {from} zu Version {to}: {count} Zertifikate.",
      "unchanged": "An der Vorlage ändert sich nichts: Dies ist die aktive Version. Nur geänderte Daten (etwa ein Name) werden übernommen.",
      "sameFields": "Dieselben Felder; Layout oder Text der Vorlage können sich unterscheiden.",
      "fieldAdded": "Neu: {field}",
      "fieldRemoved": "Entfernt: {field}",
      "reason": "Grund",
      "reasonTooShort": "Mindestens {min} Zeichen.",
      "previewFailed": "Was sich ändert, konnte nicht geladen werden.",
      "failed": "Das Neu-Erstellen wurde nicht gestartet.",
      "throttled": "Zu viele Versuche: Versuchen Sie es in einer Minute erneut.",
      "nothingQueued": "Nichts neu zu erstellen: Für diese Zertifikate steht bereits etwas an.",
      "queued_one": "{count} Zertifikat wartet auf das Neu-Erstellen.",
      "queued_other": "{count} Zertifikate warten auf das Neu-Erstellen.",
      "progress": "Neu erstellen, {handled} von {total}: {counts}.",
      "done": "Fertig: {counts}.",
      "counts": {
        "regenerated_one": "{count} neu erstellt",
        "regenerated_other": "{count} neu erstellt",
        "unchanged_one": "{count} unverändert",
        "unchanged_other": "{count} unverändert",
        "failed_one": "{count} fehlgeschlagen",
        "failed_other": "{count} fehlgeschlagen",
        "skipped_one": "{count} übersprungen",
        "skipped_other": "{count} übersprungen"
      },
      "toFailed": "Zu den fehlgeschlagenen Zertifikaten"
    }
  },
  "documentEditor": {
    "title": "Vorlage bearbeiten",
    "back": "Zurück zur Vorlage",
    "loadError": "Die Vorlage konnte nicht geladen werden.",
    "name": "Name",
    "nameTooLong": "Höchstens {max} Zeichen.",
    "neverPublished": "Entwurf, noch nicht veröffentlicht",
    "liveVersion": "Live: Version {version}",
    "unsavedShort": "ungespeicherte Änderungen",
    "conceptSaved": "Entwurf gespeichert",
    "saveConcept": "Entwurf speichern",
    "publish": "Veröffentlichen",
    "saved": "Der Entwurf wurde gespeichert.",
    "published": "Als Version {version} veröffentlicht.",
    "unsaved": "Es gibt Änderungen, die noch nicht gespeichert sind. Trotzdem verlassen?",
    "busy": "Der Server ist gerade ausgelastet. Bitte versuchen Sie es gleich noch einmal.",
    "throttled_one": "Einen Moment: Es wurde kurz hintereinander oft gespeichert. In {count} Sekunde versucht der Editor es selbst erneut; Sie können einfach weiterarbeiten.",
    "throttled_other": "Einen Moment: Es wurde kurz hintereinander oft gespeichert. In {count} Sekunden versucht der Editor es selbst erneut; Sie können einfach weiterarbeiten.",
    "throttledFailed": "Speichern ist gerade nicht möglich: Es wurde zu oft hintereinander gespeichert. Ihre Änderungen sind noch da; versuchen Sie es in einer Minute erneut.",
    "failed": "Das hat nicht geklappt. Bitte versuchen Sie es erneut.",
    "errorsTitle_one": "Es gibt {count} Punkt zu beheben",
    "errorsTitle_other": "Es gibt {count} Punkte zu beheben",
    "publishConfirm": {
      "title": "Diesen Entwurf veröffentlichen?",
      "body": "Der Entwurf wird zur neuen Version. Neue Zertifikate verwenden ab jetzt diese Version; bereits ausgestellte Zertifikate ändern sich nicht."
    },
    "locale": {
      "nl": "Niederländisch",
      "en": "Englisch",
      "de": "Deutsch",
      "fr": "Französisch"
    },
    "page": {
      "landscape": "Seite, A4 quer",
      "portrait": "Seite, A4 hoch"
    },
    "flow": {
      "label": "Fließtext ({language})",
      "copyOfDutch": "Diese Sprache hat noch keinen eigenen Text und zeigt den niederländischen. Sobald Sie etwas ändern, erhält diese Sprache einen eigenen Text.",
      "rejected": "Der Fließtext in dieser Sprache enthält etwas, das der Editor nicht kennt, und wird deshalb weder angezeigt noch bearbeitet. Beim Speichern nennt der Server, was nicht stimmt."
    },
    "flowStart": {
      "label": "Beginn des Fließtexts (mm)",
      "valueText": "{mm} mm unter dem oberen Rand",
      "hint": "Unter dem oberen Rand, von 0 bis {max}."
    },
    "fields": {
      "heading": "Felder",
      "hint": "Ziehen Sie ein Feld in den Text, oder klicken Sie, um es an der Cursorposition einzufügen.",
      "error": "Die Felder konnten nicht geladen werden.",
      "empty": "Für diese Art gibt es keine Felder.",
      "kind": {
        "general": "Allgemein",
        "classroom": "Präsenz",
        "learning_path": "Lernpfad"
      },
      "scope": {
        "org": "Organisation",
        "context": "Abschluss",
        "global": "Allgemein",
        "link": "Links"
      }
    },
    "grid": {
      "group": "Raster",
      "show": "Raster",
      "snap": "Am Raster ausrichten",
      "snapHint": "Ziehen und Größenänderungen springen auf die 5-mm-Linien, Ränder und Mitte auch auf die Mittellinien. Mit Alt ziehen Sie frei."
    },
    "history": {
      "group": "Verlauf",
      "undo": "Rückgängig",
      "redo": "Wiederholen",
      "undoShortcut": "Rückgängig (Strg+Z)",
      "redoShortcut": "Wiederholen (Strg+Y)",
      "undone": "Rückgängig gemacht: {action}",
      "redone": "Wiederholt: {action}",
      "kind": {
        "move": "Verschieben",
        "resize": "Größe",
        "add": "Block hinzufügen",
        "remove": "Block entfernen",
        "style": "Formatierung",
        "text": "Text",
        "orientation": "Ausrichtung",
        "reading": "Lesereihenfolge",
        "flowStart": "Beginn des Fließtexts",
        "background": "Hintergrund",
        "title": "Dokumenttitel",
        "image": "Bild",
        "furniture": "Kopf- und Fußzeile",
        "numbering": "Nummerierung"
      }
    },
    "toolbar": {
      "label": "Formatierung",
      "blockType": "Textart",
      "paragraph": "Absatz",
      "heading": "Überschrift {level}",
      "bold": "Fett",
      "italic": "Kursiv",
      "underline": "Unterstrichen",
      "bulletList": "Aufzählung",
      "orderedList": "Nummerierte Liste",
      "alignLeft": "Linksbündig",
      "alignCenter": "Zentriert",
      "alignRight": "Rechtsbündig",
      "alignment": "Ausrichtung",
      "quick": "Schnellformatierung"
    },
    "table": {
      "insertTitle": "Tabelle einfügen",
      "rows": "Zeilen",
      "cols": "Spalten",
      "headerRow": "Kopfzeile",
      "insert": "Einfügen",
      "toolbar": "Tabelle",
      "rowBefore": "Zeile darüber",
      "rowAfter": "Zeile darunter",
      "colBefore": "Spalte links",
      "colAfter": "Spalte rechts",
      "toggleHeader": "Kopfzeile an/aus",
      "deleteRow": "Zeile löschen",
      "deleteCol": "Spalte löschen",
      "delete": "Tabelle löschen"
    },
    "blocks": {
      "kind": {
        "text": "Textblock {n}",
        "image": "Bild {n}",
        "rect": "Rechteck {n}",
        "line": "Linie {n}"
      },
      "textLabel": "{block}, Text ({language})",
      "movedTo": "{block}: {x} mm von links, {y} mm von oben.",
      "frameHint": "Die Pfeiltasten verschieben den Block um 1 mm, Umschalt+Pfeil um 10 mm. Entf entfernt ihn. Mit Tab gelangen Sie in den Text, um ihn zu bearbeiten.",
      "image": {
        "bcs-logo": "BCS-Logo",
        "tenant-logo": "Logo der Umgebung",
        "upload": "Eigenes Bild",
        "library": "Aus der Mediathek",
        "platform": "Aus dem mitgelieferten Set"
      },
      "removed": "Der Block wurde entfernt.",
      "addLabel": "Hinzufügen",
      "add_text": "Textblock",
      "add_image": "Bild",
      "add_rect": "Rechteck",
      "add_line": "Linie",
      "add_table": "Tabelle",
      "describe": {
        "text": "Ein Textfeld, das Sie frei auf der Seite platzieren, etwa für den Titel oder den Namen. Sie können Felder hineinziehen.",
        "image": "Ein Logo, eine Unterschrift oder ein anderes Bild aus der Mediathek, frei auf der Seite.",
        "rect": "Ein Rechteck, zum Beispiel als Rahmen um die Seite. Nur zur Dekoration.",
        "line": "Eine Linie, zum Beispiel zum Unterschreiben oder als Trennlinie. Nur zur Dekoration.",
        "table": "Eine Tabelle im Fließtext, an der Cursorposition, zum Beispiel für eine Reihe von Unterschriften.",
        "pageBreak": "Was nach dem Cursor kommt, beginnt auf einer neuen Seite.",
        "ref": "Ein Verweis auf eine nummerierte Überschrift; die Nummer passt sich an."
      },
      "rejected": "Dieser Text enthält etwas, das der Editor nicht kennt.",
      "add_pageBreak": "Seitenumbruch",
      "add_ref": "Verweis",
      "skipped_one": "{count} Block kann nicht angezeigt werden (er wurde beschädigt gespeichert) und wurde ausgelassen. Beim Speichern entfällt er.",
      "skipped_other": "{count} Blöcke können nicht angezeigt werden (sie wurden beschädigt gespeichert) und wurden ausgelassen. Beim Speichern entfallen sie."
    },
    "inspector": {
      "remove": "Entfernen",
      "position": "Position und Größe",
      "x": "Von links (mm)",
      "y": "Von oben (mm)",
      "width": "Breite (mm)",
      "height": "Höhe (mm)",
      "textStyle": "Text",
      "role": "Art",
      "size": "Größe (pt)",
      "weight": "Stärke",
      "regular": "Normal",
      "align": "Ausrichtung",
      "color": "Farbe",
      "colorFormat": "Eine Farbe als #RRGGBB.",
      "image": "Bild",
      "source": "Quelle",
      "layer": "Ebene",
      "layerOnlyDecorative": "Nur ein dekoratives Bild kann hinter dem Text liegen.",
      "front": "Vor dem Text",
      "back": "Hinter dem Text",
      "decorative": "Dekorativ (ein Screenreader überspringt es)",
      "alt": "Alternativtext ({language})",
      "shape": "Form",
      "direction": "Richtung",
      "horizontal": "Horizontal",
      "vertical": "Vertikal",
      "stroke": "Linienstärke (mm)",
      "strokeColor": "Linienfarbe",
      "fill": "Füllung",
      "fillColor": "Füllfarbe",
      "problems": "Bei diesem Block",
      "noneHeading": "Kein Block ausgewählt",
      "none": "Wählen Sie einen Block auf der Seite oder in der Lesereihenfolge, um Position, Größe und Stil zu sehen.",
      "pickImage": "Aus der Mediathek wählen…",
      "valign": "Vertikal",
      "valign_top": "Oben ausrichten",
      "valign_middle": "Mittig ausrichten",
      "valign_bottom": "Unten ausrichten"
    },
    "reading": {
      "hint": "In dieser Reihenfolge liest ein Screenreader die Seite.",
      "flow": "Fließtext",
      "up": "{name} nach oben",
      "down": "{name} nach unten",
      "reset": "Standardreihenfolge",
      "toggle": "Lesereihenfolge ({count})",
      "moved": "{name} steht jetzt an Position {position} von {count}."
    },
    "checks": {
      "heading": "Prüfungen",
      "none": "Keine Probleme gefunden. Die Vorschau prüft den Rest.",
      "severity": {
        "error": "Fehler",
        "warning": "Hinweis"
      },
      "outside_margin": "Liegt außerhalb des Rands von {margin} mm.",
      "text_too_small": "Der Text ist kleiner als {min} pt.",
      "text_small": "Der Text ist kleiner als {warn} pt und dadurch schlecht lesbar.",
      "overlap": "Überlappt mit {other}.",
      "low_contrast": "Die Textfarbe hat zu wenig Kontrast auf Weiß ({ratio}:1, mindestens 4,5:1).",
      "heading_first": "Die erste Überschrift muss Überschrift 1 sein, nicht Überschrift {level}.",
      "heading_skip": "Überschrift {level} überspringt eine Ebene; erwartet wird Überschrift {expected}.",
      "alt_missing": "Es gibt keinen Alternativtext auf Niederländisch.",
      "background_readability": "Prüfen Sie in der Vorschau, ob der gesamte Text auf dem Hintergrund gut lesbar ist.",
      "server": "Beim letzten Speichern",
      "ref_missing": "Ein Verweis zeigt auf eine Überschrift, die es nicht gibt oder die nicht nummeriert ist.",
      "image_low_resolution": "Dieses Bild ist für diese Größe zu klein: {dpi} dpi auf Papier, mindestens {min}. Verwenden Sie ein Bild mit mindestens {min_width} × {min_height} Pixeln.",
      "many_pages": "Die Vorschau hat {pages} Seiten; mehr als 20 ist für eine Vereinbarung lang."
    },
    "background": {
      "label": "Hintergrund",
      "placeholder": "Hintergrund",
      "none": "Kein Hintergrund.",
      "current": "Jetzt: {source}.",
      "pick": "Aus der Mediathek wählen…",
      "remove": "Kein Hintergrund"
    },
    "preview": {
      "heading": "Vorschau",
      "long": "Langer Name",
      "loading": "Die Vorschau wird erstellt…",
      "updated": "Die Vorschau wurde aktualisiert.",
      "updatedLong": "Die Vorschau wurde aktualisiert, mit einem langen Namen.",
      "failedStatus": "Die Vorschau konnte nicht erstellt werden.",
      "invalid": "Die Vorschau wartet auf die Punkte in der Liste oben.",
      "failed": "Die Vorschau konnte nicht erstellt werden.",
      "frameTitle": "Vorschau von {title} ({language})",
      "download": "Vorschau herunterladen (PDF)",
      "fileName": "vorschau",
      "notPdf": "Die Vorschau kam nicht als PDF zurück und wird nicht angezeigt."
    },
    "pdfTitle": {
      "label": "Dokumenttitel ({language})",
      "hint": "Steht in den Eigenschaften der PDF; ein Screenreader liest ihn vor."
    },
    "edit": "Bearbeiten",
    "orientation": {
      "label": "Ausrichtung",
      "landscape": "Quer",
      "portrait": "Hoch",
      "moved": "Prüfen Sie die Blöcke; sie wurden verschoben.",
      "undo": "Rückgängig (Strg+Z) stellt es wieder her. Es ändert nur den Entwurf."
    },
    "text": {
      "heading": "Text"
    },
    "pages": {
      "estimate": "{count} Seite(n). Die Seitenumbrüche sind eine Schätzung; die Vorschau darunter ist die echte.",
      "real": "Die Vorschau hat {count}."
    },
    "furniture": {
      "heading": "Kopf- und Fußzeile",
      "header": "Kopfzeile",
      "footer": "Fußzeile",
      "logo": "Logo",
      "logoNone": "Kein Logo",
      "logoPosition": "Position des Logos",
      "logoHeight": "Maximale Höhe (mm)",
      "logoHeightRange": "Zwischen {min} und {max} mm.",
      "headerText": "Text in der Kopfzeile ({language})",
      "footerText": "Text in der Fußzeile ({language})",
      "firstPageDifferent": "Erste Seite anders (die Kopfzeile beginnt auf Seite 2)",
      "pageNumbers": "Seite x von y steht immer daneben.",
      "pageOf": "Seite {page} von {pages}",
      "position": {
        "left": "Links",
        "center": "Mitte",
        "right": "Rechts"
      }
    },
    "pageBreaks": {
      "legend": "Seite",
      "breakBefore": "Auf einer neuen Seite beginnen",
      "keepTogether": "Zusammenhalten",
      "node": "Seitenumbruch",
      "nested": "Nicht in einer Liste oder Tabelle möglich; nur bei einem Block des Fließtexts selbst."
    },
    "numbering": {
      "heading": "Nummerierung",
      "style": "Stil der nummerierten Überschriften",
      "none": "Keine Nummerierung",
      "artikel": "Artikel 1, Artikel 1.1",
      "decimal": "1., 1.1",
      "hint": "Welche Überschriften mitzählen, legen Sie pro Überschrift mit Nummeriert im Bereich Text fest.",
      "article": "Artikel",
      "articleInText": "Artikel",
      "numbered": "Nummeriert",
      "refTitle": "Verweisen auf",
      "refNone": "Es gibt noch keine nummerierte Überschrift. Wählen Sie eine Nummerierung und aktivieren Sie Nummeriert bei einer Überschrift."
    }
  }
}
